var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};

// ../../gql/schema.ts
var GetArcreditByIdDocument, GetChargedArgroupsForSourceDocument, InsertArcreditDocument, MoveArcreditToArgroupDocument, VoidArcreditDocument, VoidArcreditForCleanupDocument, GetProductsDocument, GetProgramConfigDocument, UpsertInvoiceDocument, UpsertProgramInvoiceDocument, GetAmountDueChargesDocument, GetArchargesByArgroupsDocument, GetArcreditsForSourcesDocument, GetArpaymentForRefundDocument, GetCreditedSourcesChargesDocument, GetPaymentProcessingDataDocument, GetPendingBankMethodBySetupIntentDocument, GetPendingBankMethodsDocument, GetProcessingFeeReconciliationDocument, GetSettledPaymentsByTransactionDocument, GetUsableStripePrimaryDocument, InsertArpaymentWithDetailsDocument, InsertProcessingFeeDocument, MarkBankMethodVerifiedDocument, MarkBankMethodVerifiedAsPrimaryDocument, RetireUnverifiedBankMethodDocument, UpdateArpaymentDocument, GetContractEffectiveConfigDocument, GetGuestrideScenarioContextDocument, CheckScenarioReadinessDocument, GetProgramClaimDocument, GetReturnRideContractRulesDocument, GetReturnRideScenarioContextDocument, GetContractDocument, GetContractRulesDocument, GetLaneModifiersDocument, GetProgramContractDocument, GetRideGroupCountDocument, GetRideGroupIdDocument, GetGuestRideByIdDocument, GetScenarioGuestRideIdDocument, GetAccessorialMoveIdDocument, GetPriceOverrideMoveIdDocument, GetScenarioContextDocument, GetScenarioIdFromMoveDocument, GetActiveProgramsForCustomerDocument, GetProgramContractsByDateDocument, GetRideMoveProductFactsDocument, GetContractEventTriggersDocument, InsertArDispatchSkipDocument, ClaimPeriodDocument, FinalizeArgroupDocument, FindActiveProgramCustomerArgroupDocument, GetAllProgramBillingTriggersDocument, GetCustomerNameDocument, GetDueTimeTriggersDocument, SetProcessingDocument, GetActiveContractProductsForCustomersDocument, GetProgramActiveEnrolleesDocument, GetProgramBillingTriggersDocument, ApplyTemplatePersistDocument, EnsureArTemplateRowDocument, GetContractConfigForApplyDocument, GetContractForTriggerWriteDocument, GetLegacyContractForConversionDocument, GetProductForTriggerOwnerDocument, GetProductPricingConfigDocument, GetProductRemovabilityDocument, GetTriggerRemovabilityDocument, InsertContractTriggerDocument, ListArTemplatesDocument, RemoveProductPersistDocument, RemoveTriggerDocument, SaveArTemplateDocument, UpdateProductPricingConfigDocument, UpdateTriggerConfigDocument, GetActiveCreditsForCustomerScenarioDocument, GetActiveCreditsForProgramScenarioDocument, InsertArchargesDocument, InsertArgroupWithArchargesDocument, InsertArgroupWithArchargesSimpleDocument, InsertProgramArgroupWithArchargesDocument, InsertProgramScenarioArgroupWithArchargesDocument, InsertContractRuleDocument, SetContractRuleActiveDocument, UpdateContractRuleConfigDocument, UpdateContractRuleMetadataDocument, GetActiveCustomerContractsForProductDocument, GetContractEffectiveConfigForProductDocument;
var init_schema = __esm({
  "../../gql/schema.ts"() {
    GetArcreditByIdDocument = { "__text": "query GetArcreditById($id: bigint!) {\n  arcredits_by_pk(id: $id) {\n    id\n    argroup_id\n    amount\n    type\n    reason\n    source_type\n    source_id\n    active\n    billable_datetime\n    createdby\n    createdat\n    argroup {\n      id\n      status\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetArcreditById" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arcredits_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] };
    GetChargedArgroupsForSourceDocument = { "__text": 'query GetChargedArgroupsForSource($sourceType: String!, $sourceId: bigint!) {\n  archarges(\n    where: {source_type: {_eq: $sourceType}, source_id: {_eq: $sourceId}, active: {_eq: true}, argroup: {status: {_eq: "done"}}}\n  ) {\n    id\n    argroup_id\n    argroup {\n      id\n      status\n      customer_id\n      program_id\n      algorithm_key\n      scenario_id\n      arinvoice_id\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetChargedArgroupsForSource" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "source_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "done", "block": false } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }] } }] } }] };
    InsertArcreditDocument = { "__text": "mutation InsertArcredit($object: arcredits_insert_input!) {\n  insert_arcredits_one(object: $object) {\n    id\n    argroup_id\n    amount\n    type\n    reason\n    source_type\n    source_id\n    active\n    billable_datetime\n    createdby\n    createdat\n    argroup {\n      id\n      status\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArcredit" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arcredits_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_arcredits_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] };
    MoveArcreditToArgroupDocument = { "__text": "mutation MoveArcreditToArgroup($id: bigint!, $argroupId: bigint!) {\n  update_arcredits(where: {id: {_eq: $id}}, _set: {argroup_id: $argroupId}) {\n    affected_rows\n    returning {\n      id\n      argroup_id\n      argroup {\n        id\n        status\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "MoveArcreditToArgroup" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "argroupId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "argroupId" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] } }] };
    VoidArcreditDocument = { "__text": 'mutation VoidArcredit($id: bigint!) {\n  update_arcredits(\n    where: {id: {_eq: $id}, active: {_eq: true}, argroup: {status: {_eq: "done"}}}\n    _set: {active: false}\n  ) {\n    affected_rows\n    returning {\n      id\n      argroup_id\n      amount\n      type\n      reason\n      source_type\n      source_id\n      active\n      billable_datetime\n      createdby\n      createdat\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "VoidArcredit" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "done", "block": false } }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "BooleanValue", "value": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }] } }] } }] } }] };
    VoidArcreditForCleanupDocument = { "__text": "mutation VoidArcreditForCleanup($id: bigint!) {\n  update_arcredits(\n    where: {id: {_eq: $id}, active: {_eq: true}}\n    _set: {active: false}\n  ) {\n    affected_rows\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "VoidArcreditForCleanup" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "BooleanValue", "value": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };
    GetProductsDocument = { "__text": "query GetProducts {\n  products(where: {active: {_eq: true}}) {\n    id\n    key\n    name\n    accounting_id\n    description\n    salable\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProducts" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "products" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }] } }] };
    GetProgramConfigDocument = { "__text": "query GetProgramConfig($programId: bigint!) {\n  programs_by_pk(id: $programId) {\n    id\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "programs_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    UpsertInvoiceDocument = { "__text": 'mutation UpsertInvoice($customerId: bigint!, $startDatetime: timestamptz!, $endDatetime: timestamptz!, $invoiceType: String!, $areventId: String!) {\n  insert_arinvoices_one(\n    object: {customer_id: $customerId, start_datetime: $startDatetime, end_datetime: $endDatetime, invoice_type: $invoiceType, arevent_id: $areventId, status: "acquiring"}\n    on_conflict: {constraint: arinvoices_customer_id_start_datetime_key, update_columns: [invoice_type, updatedat], where: {_not: {_and: [{status: {_eq: "closed"}}, {invoice_type: {_in: ["standard", "rideshare"]}}]}}}\n  ) {\n    id\n    customer_id\n    start_datetime\n    end_datetime\n    invoice_type\n    status\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpsertInvoice" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "startDatetime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "endDatetime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "areventId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_arinvoices_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "start_datetime" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "startDatetime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "end_datetime" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "endDatetime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "invoice_type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceType" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arevent_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "areventId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "acquiring", "block": false } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "arinvoices_customer_id_start_datetime_key" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "invoice_type" }, { "kind": "EnumValue", "value": "updatedat" }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "closed", "block": false } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "invoice_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "standard", "block": false }, { "kind": "StringValue", "value": "rideshare", "block": false }] } }] } }] }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invoice_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] };
    UpsertProgramInvoiceDocument = { "__text": 'mutation UpsertProgramInvoice($programId: bigint!, $customerId: bigint!, $startDatetime: timestamptz!, $endDatetime: timestamptz!, $invoiceType: String!, $areventId: String!) {\n  insert_arinvoices_one(\n    object: {program_id: $programId, customer_id: $customerId, start_datetime: $startDatetime, end_datetime: $endDatetime, invoice_type: $invoiceType, arevent_id: $areventId, status: "acquiring"}\n    on_conflict: {constraint: arinvoices_program_id_start_datetime_key, update_columns: [updatedat, customer_id]}\n  ) {\n    id\n    program_id\n    customer_id\n    start_datetime\n    end_datetime\n    invoice_type\n    status\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpsertProgramInvoice" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "startDatetime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "endDatetime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "areventId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_arinvoices_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "start_datetime" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "startDatetime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "end_datetime" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "endDatetime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "invoice_type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceType" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arevent_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "areventId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "acquiring", "block": false } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "arinvoices_program_id_start_datetime_key" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "updatedat" }, { "kind": "EnumValue", "value": "customer_id" }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "start_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invoice_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] };
    GetAmountDueChargesDocument = { "__text": "query GetAmountDueCharges($archargeIds: [bigint!]!) {\n  archarges(\n    where: {id: {_in: $archargeIds}, active: {_eq: true}}\n    order_by: [{amount: desc}, {createdat: asc}]\n  ) {\n    id\n    argroup_id\n    amount\n    source_type\n    source_id\n    active\n    type\n    name\n    createdat\n    argroup {\n      program_id\n      customer_id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAmountDueCharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archargeIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archargeIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "amount" }, "value": { "kind": "EnumValue", "value": "desc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }] } }] } }] } }] };
    GetArchargesByArgroupsDocument = { "__text": "query GetArchargesByArgroups($argroupIds: [bigint!]!) {\n  archarges(where: {argroup_id: {_in: $argroupIds}, active: {_eq: true}}) {\n    id\n    argroup_id\n    amount\n    source_type\n    source_id\n    argroup {\n      program_id\n      customer_id\n      arinvoice_id\n    }\n    arpaymentdetails {\n      id\n      payment_id\n      archarge_id\n      amount\n      parent {\n        id\n        status\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetArchargesByArgroups" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "argroupIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "argroupIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "arpaymentdetails" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] } }] };
    GetArcreditsForSourcesDocument = { "__text": 'query GetArcreditsForSources($sourceType: String!, $sourceIds: [bigint!]!) {\n  arcredits(\n    where: {source_type: {_eq: $sourceType}, source_id: {_in: $sourceIds}, argroup: {status: {_eq: "done"}}, active: {_eq: true}}\n  ) {\n    id\n    argroup_id\n    amount\n    type\n    source_type\n    source_id\n    active\n    createdat\n    argroup {\n      program_id\n      customer_id\n      arinvoice_id\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetArcreditsForSources" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "source_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "done", "block": false } }] } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }] } }] } }] };
    GetArpaymentForRefundDocument = { "__text": "query GetArpaymentForRefund($paymentId: bigint!) {\n  arpayments_by_pk(id: $paymentId) {\n    id\n    amount\n    status\n    gateway_transaction_id\n    paymentmethod_id\n    invoice_id\n    method {\n      customer_id\n    }\n    details {\n      archarge_id\n      amount\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetArpaymentForRefund" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpayments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_transaction_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "paymentmethod_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invoice_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "method" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "details" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }] } }] } }] };
    GetCreditedSourcesChargesDocument = { "__text": 'query GetCreditedSourcesCharges($sourceType: String!, $sourceIds: [bigint!]!) {\n  archarges(\n    where: {source_type: {_eq: $sourceType}, source_id: {_in: $sourceIds}, active: {_eq: true}, argroup: {status: {_eq: "done"}}}\n  ) {\n    id\n    argroup_id\n    amount\n    source_type\n    source_id\n    argroup {\n      program_id\n      customer_id\n      arinvoice_id\n    }\n    arpaymentdetails {\n      id\n      payment_id\n      archarge_id\n      amount\n      parent {\n        id\n        status\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetCreditedSourcesCharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "source_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "sourceIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "done", "block": false } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "arpaymentdetails" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] } }] };
    GetPaymentProcessingDataDocument = { "__text": "query GetPaymentProcessingData($archargeIds: [bigint!]!, $customerId: bigint!, $paymentMethodId: bigint) {\n  archarges(\n    where: {id: {_in: $archargeIds}, active: {_eq: true}}\n    order_by: [{amount: desc}, {createdat: asc}]\n  ) {\n    id\n    argroup_id\n    amount\n    source_type\n    source_id\n    active\n    type\n    name\n    accounting_key\n    createdat\n    argroup {\n      program_id\n      customer_id\n    }\n  }\n  arpaymentdetails(where: {archarge_id: {_in: $archargeIds}}) {\n    id\n    payment_id\n    archarge_id\n    amount\n    parent {\n      id\n      status\n    }\n  }\n  paymentMethodById: arpaymentmethods(\n    where: {id: {_eq: $paymentMethodId}}\n    limit: 1\n  ) {\n    id\n    customer_id\n    type\n    active\n    primary\n    gateway_token\n    account_number\n    routing_number\n    account_type\n    card_type\n    expiration\n    name\n    source\n    gateway\n    pending_setup_intent_id\n    customer {\n      stripe_customer_id\n    }\n  }\n  primaryPaymentMethod: arpaymentmethods(\n    where: {customer_id: {_eq: $customerId}, primary: {_eq: true}, active: {_eq: true}}\n    limit: 1\n  ) {\n    id\n    customer_id\n    type\n    active\n    primary\n    gateway_token\n    account_number\n    routing_number\n    account_type\n    card_type\n    expiration\n    name\n    source\n    gateway\n    customer {\n      stripe_customer_id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetPaymentProcessingData" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archargeIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentMethodId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archargeIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "amount" }, "value": { "kind": "EnumValue", "value": "desc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "arpaymentdetails" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "archarge_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archargeIds" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parent" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "paymentMethodById" }, "name": { "kind": "Name", "value": "arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentMethodId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primary" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "routing_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "card_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "expiration" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pending_setup_intent_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "stripe_customer_id" } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "primaryPaymentMethod" }, "name": { "kind": "Name", "value": "arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "primary" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "primary" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "routing_number" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "card_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "expiration" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "stripe_customer_id" } }] } }] } }] } }] };
    GetPendingBankMethodBySetupIntentDocument = { "__text": "query GetPendingBankMethodBySetupIntent($setupIntentId: String!) {\n  arpaymentmethods(\n    where: {pending_setup_intent_id: {_eq: $setupIntentId}, active: {_eq: true}}\n    limit: 1\n  ) {\n    id\n    customer_id\n    gateway_token\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetPendingBankMethodBySetupIntent" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "setupIntentId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "setupIntentId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_token" } }] } }] } }] };
    GetPendingBankMethodsDocument = { "__text": "query GetPendingBankMethods($customerId: bigint!) {\n  arpaymentmethods(\n    where: {customer_id: {_eq: $customerId}, active: {_eq: true}, pending_setup_intent_id: {_is_null: false}}\n    order_by: {id: asc}\n  ) {\n    id\n    customer_id\n    gateway_token\n    pending_setup_intent_id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetPendingBankMethods" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": false } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pending_setup_intent_id" } }] } }] } }] };
    GetProcessingFeeReconciliationDocument = { "__text": "query GetProcessingFeeReconciliation($paymentId: bigint!, $feeSourceType: String!, $feeChargeType: String!) {\n  arpayments_by_pk(id: $paymentId) {\n    id\n    status\n    amount\n    invoice_id\n    method {\n      customer_id\n      type\n    }\n    details {\n      archarge_id\n      amount\n    }\n  }\n  archarges(\n    where: {source_type: {_eq: $feeSourceType}, source_id: {_eq: $paymentId}, type: {_eq: $feeChargeType}}\n    limit: 1\n  ) {\n    id\n    argroup_id\n    amount\n    active\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProcessingFeeReconciliation" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "feeSourceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "feeChargeType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpayments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "invoice_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "method" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "details" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "source_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "feeSourceType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "feeChargeType" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }] } }] } }] };
    GetSettledPaymentsByTransactionDocument = { "__text": "query GetSettledPaymentsByTransaction($gatewayTransactionId: String!, $settledStatuses: [String!]!) {\n  arpayments(\n    where: {gateway_transaction_id: {_eq: $gatewayTransactionId}, status: {_in: $settledStatuses}}\n    order_by: {id: asc}\n  ) {\n    id\n    amount\n    status\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetSettledPaymentsByTransaction" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "gatewayTransactionId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "settledStatuses" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpayments" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "gateway_transaction_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "gatewayTransactionId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "settledStatuses" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] };
    GetUsableStripePrimaryDocument = { "__text": 'query GetUsableStripePrimary($customerId: bigint!) {\n  arpaymentmethods(\n    where: {customer_id: {_eq: $customerId}, active: {_eq: true}, primary: {_eq: true}, gateway: {_eq: "stripe"}, pending_setup_intent_id: {_is_null: true}}\n    limit: 1\n  ) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetUsableStripePrimary" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "primary" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "gateway" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "stripe", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    InsertArpaymentWithDetailsDocument = { "__text": "mutation InsertArpaymentWithDetails($object: arpayments_insert_input!) {\n  insert_arpayments_one(object: $object) {\n    id\n    amount\n    status\n    gateway_transaction_id\n    notes\n    createdat\n    updatedat\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArpaymentWithDetails" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arpayments_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_arpayments_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_transaction_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }] } }] } }] };
    InsertProcessingFeeDocument = { "__text": 'mutation InsertProcessingFee($customerId: bigint!, $orgId: bigint, $invoiceId: bigint, $algorithmKey: String, $runMetadata: jsonb!, $createdby: String!, $updatedby: String!, $chargeType: String!, $chargeName: String!, $chargeAmount: numeric!, $chargeSourceType: String!, $chargeSourceId: bigint!, $chargeAccountingKey: String, $chargeBillableDatetime: timestamptz!, $paymentId: bigint!) {\n  insert_argroups_one(\n    object: {customer_id: $customerId, org_id: $orgId, arinvoice_id: $invoiceId, algorithm_key: $algorithmKey, run_metadata: $runMetadata, createdby: $createdby, updatedby: $updatedby, status: "done", archarges: {data: [{type: $chargeType, name: $chargeName, amount: $chargeAmount, source_type: $chargeSourceType, source_id: $chargeSourceId, accounting_key: $chargeAccountingKey, billable_datetime: $chargeBillableDatetime, createdby: $createdby, arpaymentdetails: {data: [{payment_id: $paymentId, amount: $chargeAmount}]}}]}}\n  ) {\n    id\n    customer_id\n    status\n    createdat\n    archarges {\n      id\n      type\n      name\n      amount\n      source_type\n      source_id\n      accounting_key\n      arpaymentdetails {\n        id\n        payment_id\n        archarge_id\n        amount\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertProcessingFee" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeName" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeAmount" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "numeric" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeSourceType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeSourceId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeAccountingKey" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeBillableDatetime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "org_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "invoiceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "archarges" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeType" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "name" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeName" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "amount" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeAmount" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_type" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeSourceType" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "source_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeSourceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "accounting_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeAccountingKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "billable_datetime" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeBillableDatetime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arpaymentdetails" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "payment_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "amount" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "chargeAmount" } } }] }] } }] } }] }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arpaymentdetails" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "payment_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarge_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }] } }] } }] } }] };
    MarkBankMethodVerifiedDocument = { "__text": "mutation MarkBankMethodVerified($id: bigint!) {\n  update_arpaymentmethods_by_pk(\n    pk_columns: {id: $id}\n    _set: {pending_setup_intent_id: null}\n  ) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "MarkBankMethodVerified" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arpaymentmethods_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "NullValue" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    MarkBankMethodVerifiedAsPrimaryDocument = { "__text": "mutation MarkBankMethodVerifiedAsPrimary($id: bigint!, $customerId: bigint!) {\n  setFalse: update_arpaymentmethods(\n    where: {customer_id: {_eq: $customerId}}\n    _set: {primary: false}\n  ) {\n    affected_rows\n  }\n  setTrue: update_arpaymentmethods_by_pk(\n    pk_columns: {id: $id}\n    _set: {pending_setup_intent_id: null, primary: true}\n  ) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "MarkBankMethodVerifiedAsPrimary" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "setFalse" }, "name": { "kind": "Name", "value": "update_arpaymentmethods" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "primary" }, "value": { "kind": "BooleanValue", "value": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "setTrue" }, "name": { "kind": "Name", "value": "update_arpaymentmethods_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "NullValue" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "primary" }, "value": { "kind": "BooleanValue", "value": true } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    RetireUnverifiedBankMethodDocument = { "__text": "mutation RetireUnverifiedBankMethod($id: bigint!) {\n  update_arpaymentmethods_by_pk(\n    pk_columns: {id: $id}\n    _set: {pending_setup_intent_id: null, active: false}\n  ) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "RetireUnverifiedBankMethod" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arpaymentmethods_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "pending_setup_intent_id" }, "value": { "kind": "NullValue" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "BooleanValue", "value": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    UpdateArpaymentDocument = { "__text": "mutation UpdateArpayment($paymentId: bigint!, $updates: arpayments_set_input!) {\n  update_arpayments_by_pk(pk_columns: {id: $paymentId}, _set: $updates) {\n    id\n    status\n    gateway_transaction_id\n    failure_reason\n    updatedat\n    updatedby\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateArpayment" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updates" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arpayments_set_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_arpayments_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "paymentId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updates" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "gateway_transaction_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "failure_reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedby" } }] } }] } }] };
    GetContractEffectiveConfigDocument = { "__text": "query GetContractEffectiveConfig($contractId: bigint!) {\n  contracts(where: {id: {_eq: $contractId}}, limit: 1) {\n    id\n    effective_config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractEffectiveConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }] } }] } }] };
    GetGuestrideScenarioContextDocument = { "__text": "query GetGuestrideScenarioContext($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    scenario_key\n    status\n    guestride_links {\n      id\n      guestride {\n        id\n        customer_id\n        workflowset_id\n        ridehails(order_by: [{attempt_number: asc}, {created_at: asc}]) {\n          id\n          status\n          actual_price\n          estimated_price\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetGuestrideScenarioContext" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "guestride_links" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "guestride" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ridehails" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "attempt_number" }, "value": { "kind": "EnumValue", "value": "asc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "created_at" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "actual_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "estimated_price" } }] } }] } }] } }] } }] } }] };
    CheckScenarioReadinessDocument = { "__text": "query CheckScenarioReadiness($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    moves {\n      move {\n        id\n        move_type\n        status\n        active\n        chargeable\n        appointment {\n          id\n        }\n        cancel_status\n      }\n    }\n    moves_aggregate {\n      aggregate {\n        count\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "CheckScenarioReadiness" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "chargeable" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves_aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }] } }] } }] };
    GetProgramClaimDocument = { "__text": "query GetProgramClaim($scenarioId: bigint!, $contractId: bigint!) {\n  program_claims(\n    where: {scenario_id: {_eq: $scenarioId}, contract_id: {_eq: $contractId}}\n    limit: 1\n  ) {\n    id\n    eligibility_status\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramClaim" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_claims" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "eligibility_status" } }] } }] } }] };
    GetReturnRideContractRulesDocument = { "__text": "query GetReturnRideContractRules($contractId: bigint!) {\n  contracts_by_pk(id: $contractId) {\n    id\n    contract_rules(where: {active: {_eq: true}}, order_by: {id: asc}) {\n      active\n      id\n      name\n      product_key\n      schema_key\n      config\n      raterules(where: {active: {_eq: 1}}, order_by: {id: asc}) {\n        id\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReturnRideContractRules" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] } }] };
    GetReturnRideScenarioContextDocument = { "__text": "query GetReturnRideScenarioContext($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    product_key\n    moves(order_by: {move_id: asc}) {\n      move {\n        id\n        active\n        move_type\n        lite\n        ridehails(order_by: [{attempt_number: asc}, {created_at: asc}]) {\n          id\n          provider\n          status\n          actual_price\n          estimated_price\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetReturnRideScenarioContext" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ridehails" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "attempt_number" }, "value": { "kind": "EnumValue", "value": "asc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "created_at" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "provider" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "actual_price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "estimated_price" } }] } }] } }] } }] } }] } }] };
    GetContractDocument = { "__text": "query GetContract($customerId: bigint!, $workflowsetId: bigint!, $billableDate: timestamptz!) {\n  contracts(\n    where: {customer_id: {_eq: $customerId}, workflowset_id: {_eq: $workflowsetId}, begin_date: {_lte: $billableDate}, _or: [{end_date: {_gte: $billableDate}}, {end_date: {_is_null: true}}]}\n    order_by: {createdat: desc}\n  ) {\n    id\n    customer_id\n    workflowset_id\n    begin_date\n    end_date\n    createdat\n    contract_rules(where: {active: {_eq: true}}, order_by: {id: asc}) {\n      active\n      id\n      name\n      product_key\n      schema_key\n      config\n      raterules(where: {active: {_eq: 1}}, order_by: {id: asc}) {\n        id\n        distance_start\n        distance_end\n        class\n        type\n        rate\n        flat_rate\n        class_3_rate\n        class_4_rate\n        class_5_rate\n        class_6_rate\n        class_3_flat_rate\n        class_4_flat_rate\n        class_5_flat_rate\n        class_6_flat_rate\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContract" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }] } }] } }] } }] } }] };
    GetContractRulesDocument = { "__text": "query GetContractRules($contractId: bigint!) {\n  contract_rules(\n    where: {contract_id: {_eq: $contractId}, active: {_eq: true}}\n    order_by: {id: asc}\n  ) {\n    id\n    active\n    contract_id\n    name\n    description\n    product_key\n    schema_key\n    config\n    raterules(where: {active: {_eq: 1}}, order_by: {id: asc}) {\n      id\n      distance_start\n      distance_end\n      class\n      type\n      rate\n      flat_rate\n      program_coverage_pct\n      class_3_rate\n      class_4_rate\n      class_5_rate\n      class_6_rate\n      class_3_flat_rate\n      class_4_flat_rate\n      class_5_flat_rate\n      class_6_flat_rate\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractRules" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_coverage_pct" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }] } }] } }] } }] };
    GetLaneModifiersDocument = { "__text": 'query GetLaneModifiers($customerId: bigint, $organizationId: bigint, $workflowsetId: bigint, $workflowsetType: String, $onDate: timestamptz!) {\n  lanemodifiers(\n    where: {apply_to: {_in: ["AR", "BOTH"]}, begin_date: {_lte: $onDate}, _and: [{_or: [{end_date: {_is_null: true}}, {end_date: {_gt: $onDate}}]}, {_or: [{workflowset_id: {_eq: $workflowsetId}}, {workflowset_type: {_eq: $workflowsetType}, workflowset_id: {_is_null: true}}, {customer_id: {_eq: $customerId}, workflowset_id: {_is_null: true}, workflowset_type: {_is_null: true}}, {organization_id: {_eq: $organizationId}, customer_id: {_is_null: true}, workflowset_id: {_is_null: true}, workflowset_type: {_is_null: true}}]}]}\n  ) {\n    id\n    apply_to\n    customer_id\n    organization_id\n    workflowset_id\n    workflowset_type\n    begin_date\n    end_date\n    distance_miles_modifier\n    drive_duration_sec_modifier\n    pickup_inspection_sec_modifier\n    delivery_inspection_sec_modifier\n    return_ride_wait_sec_modifier\n    createdat\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLaneModifiers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "organizationId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetType" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "onDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "lanemodifiers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "apply_to" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "AR", "block": false }, { "kind": "StringValue", "value": "BOTH", "block": false }] } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "onDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "onDate" } } }] } }] }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetId" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "workflowsetType" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "organization_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "organizationId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "workflowset_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "apply_to" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_miles_modifier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "drive_duration_sec_modifier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_inspection_sec_modifier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_inspection_sec_modifier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "return_ride_wait_sec_modifier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }] } }] } }] };
    GetProgramContractDocument = { "__text": "query GetProgramContract($contractId: bigint!) {\n  contracts(where: {id: {_eq: $contractId}}) {\n    id\n    config\n    contract_rules(where: {active: {_eq: true}}, order_by: {id: asc}) {\n      active\n      id\n      name\n      product_key\n      schema_key\n      config\n      raterules(where: {active: {_eq: 1}}, order_by: {id: asc}) {\n        id\n        distance_start\n        distance_end\n        class\n        type\n        rate\n        flat_rate\n        program_coverage_pct\n        class_3_rate\n        class_4_rate\n        class_5_rate\n        class_6_rate\n        class_3_flat_rate\n        class_4_flat_rate\n        class_5_flat_rate\n        class_6_flat_rate\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramContract" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_coverage_pct" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }] } }] } }] } }] } }] };
    GetRideGroupCountDocument = { "__text": "query GetRideGroupCount($groupId: uuid!) {\n  ridegroups_aggregate(where: {group_id: {_eq: $groupId}}) {\n    aggregate {\n      count\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetRideGroupCount" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "groupId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "uuid" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "ridegroups_aggregate" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "group_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "groupId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }] } }] };
    GetRideGroupIdDocument = { "__text": "query GetRideGroupId($moveId: bigint!) {\n  ridegroups(where: {move: {id: {_eq: $moveId}}}) {\n    group_id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetRideGroupId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "ridegroups" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "group_id" } }] } }] } }] };
    GetGuestRideByIdDocument = { "__text": "query GetGuestRideById($guestRideId: bigint!) {\n  guestrides_by_pk(id: $guestRideId) {\n    id\n    customer_id\n    workflowset_id\n    created_at\n    customer {\n      id\n      organization_id\n      billing_frequency\n      tier\n    }\n  }\n  scenarios(\n    where: {guestride_links: {guestride_id: {_eq: $guestRideId}}}\n    limit: 1\n  ) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetGuestRideById" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "guestRideId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "guestrides_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "guestRideId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "created_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billing_frequency" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenarios" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "guestride_links" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "guestride_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "guestRideId" } } }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    GetScenarioGuestRideIdDocument = { "__text": "query GetScenarioGuestRideId($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    guestride_links {\n      guestride_id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioGuestRideId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "guestride_links" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "guestride_id" } }] } }] } }] } }] };
    GetAccessorialMoveIdDocument = { "__text": "query GetAccessorialMoveId($accessorialId: bigint!) {\n  accessorials_by_pk(id: $accessorialId) {\n    move_id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAccessorialMoveId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "accessorialId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "accessorials_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "accessorialId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }] } }] } }] };
    GetPriceOverrideMoveIdDocument = { "__text": "query GetPriceOverrideMoveId($priceOverrideId: bigint!) {\n  arpriceoverrides_by_pk(id: $priceOverrideId) {\n    move_id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetPriceOverrideMoveId" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "priceOverrideId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arpriceoverrides_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "priceOverrideId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move_id" } }] } }] } }] };
    GetScenarioContextDocument = { "__text": "query GetScenarioContext($scenarioId: bigint!) {\n  scenarios_by_pk(id: $scenarioId) {\n    id\n    product_key\n    moves(order_by: {move_id: asc}) {\n      move {\n        id\n        active\n        move_type\n        status\n        appointment {\n          id\n        }\n        chargeable\n        consumer_type\n        lite\n        cancel_status\n        workflowset_id\n        workflowset {\n          type\n        }\n        class\n        vehicle_gross_weight_lbs\n        delivery_workflow_data\n        pickup_workflow_data\n        config\n        delivery_successful\n        delivery_arrived\n        delivery_started\n        pickup_successful\n        pickup_arrived\n        pickup_started\n        pickup_time\n        raterule {\n          id\n        }\n        customer {\n          id\n          organization_id\n          billing_frequency\n          tier\n          effective_config\n        }\n        lane {\n          distance_miles\n          dealer_stranded_discount\n          dealer_base_discount\n          tolls\n        }\n        price_override {\n          active\n          amount\n          config\n        }\n        ridehails {\n          id\n          archarges {\n            amount\n          }\n        }\n        accessorials {\n          id\n          code\n          status\n          ar_amount\n          notes\n          document_reference_id\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioContext" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenarios_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "move_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "appointment" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "chargeable" } }, { "kind": "Field", "name": { "kind": "Name", "value": "consumer_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "type" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "vehicle_gross_weight_lbs" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_workflow_data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_workflow_data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_successful" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_arrived" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_started" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_successful" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_arrived" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_started" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterule" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "organization_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billing_frequency" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "lane" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "distance_miles" } }, { "kind": "Field", "name": { "kind": "Name", "value": "dealer_stranded_discount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "dealer_base_discount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tolls" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "price_override" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "ridehails" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "archarges" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "accessorials" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "code" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ar_amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "document_reference_id" } }] } }] } }] } }] } }] } }] };
    GetScenarioIdFromMoveDocument = { "__text": "query GetScenarioIdFromMove($moveId: bigint!) {\n  scenariotomoves(\n    where: {move_id: {_eq: $moveId}}\n    order_by: {id: desc}\n    limit: 1\n  ) {\n    scenario_id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetScenarioIdFromMove" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenariotomoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }] } }] } }] };
    GetActiveProgramsForCustomerDocument = { "__text": 'query GetActiveProgramsForCustomer($customerId: bigint!) {\n  programtocustomer(\n    where: {customer_id: {_eq: $customerId}, status: {_eq: "active"}}\n  ) {\n    program_id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveProgramsForCustomer" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "programtocustomer" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "active", "block": false } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }] } }] } }] };
    GetProgramContractsByDateDocument = { "__text": "query GetProgramContractsByDate($programIds: [bigint!]!, $billableDate: timestamptz!) {\n  contracts(\n    where: {program_id: {_in: $programIds}, customer_id: {_is_null: true}, begin_date: {_lte: $billableDate}, _or: [{end_date: {_gte: $billableDate}}, {end_date: {_is_null: true}}]}\n  ) {\n    id\n    program_id\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramContractsByDate" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    GetRideMoveProductFactsDocument = { "__text": "query GetRideMoveProductFacts($moveId: bigint!) {\n  moves_by_pk(id: $moveId) {\n    id\n    lite\n  }\n  scenariotomoves(\n    where: {move_id: {_eq: $moveId}}\n    order_by: {id: desc}\n    limit: 1\n  ) {\n    scenario {\n      id\n      product_key\n      moves {\n        move {\n          id\n          lite\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetRideMoveProductFacts" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "moves_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenariotomoves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "move_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "desc" } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "scenario" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "moves" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "move" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "lite" } }] } }] } }] } }] } }] } }] };
    GetContractEventTriggersDocument = { "__text": 'query GetContractEventTriggers($contractId: bigint!) {\n  artriggers(\n    where: {contract_id: {_eq: $contractId}, trigger_type: {_eq: "event"}}\n    order_by: {id: asc}\n  ) {\n    id\n    contract_id\n    algorithm_key\n    product_key\n    config\n    contract {\n      id\n      effective_config\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractEventTriggers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "trigger_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "event", "block": false } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }] } }] } }] } }] };
    InsertArDispatchSkipDocument = { "__text": "mutation InsertArDispatchSkip($object: arevents_insert_input!) {\n  insert_arevents_one(object: $object) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArDispatchSkip" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arevents_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_arevents_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    ClaimPeriodDocument = { "__text": 'mutation ClaimPeriod($triggerId: bigint!, $customerId: bigint!, $orgId: bigint, $algorithmKey: String!, $arinvoiceId: bigint) {\n  insert_argroups_one(\n    object: {artrigger_id: $triggerId, customer_id: $customerId, org_id: $orgId, algorithm_key: $algorithmKey, status: "new", run_metadata: {}, createdby: "system", updatedby: "system", arinvoice_id: $arinvoiceId}\n  ) {\n    id\n    createdat\n    arinvoice_id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "ClaimPeriod" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "org_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "new", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "ObjectValue", "fields": [] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "StringValue", "value": "system", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "StringValue", "value": "system", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }] } }] };
    FinalizeArgroupDocument = { "__text": 'mutation FinalizeArgroup($id: bigint!, $metadata: jsonb!, $algorithmKey: String!) {\n  update_argroups_by_pk(\n    pk_columns: {id: $id}\n    _set: {status: "done", run_metadata: $metadata, algorithm_key: $algorithmKey}\n  ) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "FinalizeArgroup" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_argroups_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    FindActiveProgramCustomerArgroupDocument = { "__text": 'query FindActiveProgramCustomerArgroup($programId: bigint!, $customerId: bigint!, $triggerId: bigint!, $algorithmKey: String!, $periodStart: timestamptz!, $periodEnd: timestamptz!) {\n  argroups(\n    where: {program_id: {_eq: $programId}, customer_id: {_eq: $customerId}, artrigger_id: {_eq: $triggerId}, algorithm_key: {_eq: $algorithmKey}, status: {_in: ["new", "processing", "done"]}, createdat: {_gte: $periodStart, _lt: $periodEnd}}\n    limit: 1\n  ) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "FindActiveProgramCustomerArgroup" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "periodStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "periodEnd" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "argroups" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "periodStart" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "periodEnd" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    GetAllProgramBillingTriggersDocument = { "__text": 'query GetAllProgramBillingTriggers($billableDate: timestamptz!) {\n  artriggers(\n    where: {trigger_type: {_eq: "time"}, contract: {program_id: {_is_null: false}, customer_id: {_is_null: true}, begin_date: {_lte: $billableDate}, _or: [{end_date: {_gte: $billableDate}}, {end_date: {_is_null: true}}]}}\n  ) {\n    id\n    config\n    algorithm_key\n    product_key\n    product_by_key {\n      id\n      key\n      name\n      accounting_id\n      description\n      salable\n    }\n    contract {\n      id\n      program_id\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetAllProgramBillingTriggers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "trigger_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "time", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "contract" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_by_key" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }] } }] } }] } }] };
    GetCustomerNameDocument = { "__text": "query GetCustomerName($customerId: bigint!) {\n  customers_by_pk(id: $customerId) {\n    id\n    name\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetCustomerName" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customers_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] };
    GetDueTimeTriggersDocument = { "__text": 'query GetDueTimeTriggers($dailyConfigFilter: jsonb!, $weeklyConfigFilter: jsonb!, $monthlyConfigFilter: jsonb!, $oneTimeConfigFilter: jsonb!, $dailyStart: timestamptz!, $dailyEnd: timestamptz!, $weeklyStart: timestamptz!, $weeklyEnd: timestamptz!, $monthlyStart: timestamptz!, $monthlyEnd: timestamptz!, $oneTimeStart: timestamptz!) {\n  artriggers(\n    where: {trigger_type: {_eq: "time"}, _or: [{config: {_contains: $dailyConfigFilter}, _not: {argroups: {_and: [{status: {_in: ["new", "processing", "done"]}}, {createdat: {_gte: $dailyStart, _lt: $dailyEnd}}]}}}, {config: {_contains: $weeklyConfigFilter}, _not: {argroups: {_and: [{status: {_in: ["new", "processing", "done"]}}, {createdat: {_gte: $weeklyStart, _lt: $weeklyEnd}}]}}}, {config: {_contains: $monthlyConfigFilter}, _not: {argroups: {_and: [{status: {_in: ["new", "processing", "done"]}}, {createdat: {_gte: $monthlyStart, _lt: $monthlyEnd}}]}}}, {config: {_contains: $oneTimeConfigFilter}, _not: {argroups: {_and: [{status: {_in: ["new", "processing", "done"]}}, {createdat: {_gte: $oneTimeStart}}]}}}]}\n  ) {\n    id\n    contract_id\n    algorithm_key\n    trigger_type\n    config\n    product_key\n    product_by_key {\n      id\n      key\n      name\n      description\n      accounting_id\n      salable\n    }\n    contract {\n      begin_date\n      end_date\n      customer_id\n      program_id\n      effective_config\n      customer {\n        billing_frequency\n        tier\n      }\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetDueTimeTriggers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyConfigFilter" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyConfigFilter" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyConfigFilter" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "oneTimeConfigFilter" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyEnd" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyEnd" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyEnd" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "oneTimeStart" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "trigger_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "time", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_contains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyConfigFilter" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroups" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyStart" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "dailyEnd" } } }] } }] }] } }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_contains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyConfigFilter" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroups" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyStart" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "weeklyEnd" } } }] } }] }] } }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_contains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyConfigFilter" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroups" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyStart" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_lt" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyEnd" } } }] } }] }] } }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_contains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "oneTimeConfigFilter" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_not" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "argroups" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_and" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "createdat" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "oneTimeStart" } } }] } }] }] } }] } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "trigger_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_by_key" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "billing_frequency" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tier" } }] } }] } }] } }] } }] };
    SetProcessingDocument = { "__text": 'mutation SetProcessing($id: bigint!) {\n  update_argroups_by_pk(pk_columns: {id: $id}, _set: {status: "processing"}) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SetProcessing" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_argroups_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "processing", "block": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    GetActiveContractProductsForCustomersDocument = { "__text": "query GetActiveContractProductsForCustomers($customerIds: [bigint!]!, $today: timestamptz!) {\n  contracts(\n    where: {customer_id: {_in: $customerIds}, begin_date: {_lte: $today}, _or: [{end_date: {_gte: $today}}, {end_date: {_is_null: true}}]}\n  ) {\n    id\n    customer_id\n    artriggers {\n      id\n      product_key\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveContractProductsForCustomers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerIds" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerIds" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }] } }] } }] } }] };
    GetProgramActiveEnrolleesDocument = { "__text": 'query GetProgramActiveEnrollees($programId: bigint!) {\n  programtocustomer(\n    where: {program_id: {_eq: $programId}, status: {_eq: "active"}}\n  ) {\n    customer_id\n    customer {\n      id\n      name\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramActiveEnrollees" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "programtocustomer" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "active", "block": false } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }] } }] } }] };
    GetProgramBillingTriggersDocument = { "__text": 'query GetProgramBillingTriggers($programId: bigint!, $billableDate: timestamptz!) {\n  artriggers(\n    where: {trigger_type: {_eq: "time"}, contract: {program_id: {_eq: $programId}, customer_id: {_is_null: true}, begin_date: {_lte: $billableDate}, _or: [{end_date: {_gte: $billableDate}}, {end_date: {_is_null: true}}]}}\n  ) {\n    id\n    config\n    algorithm_key\n    product_key\n    product_by_key {\n      id\n      key\n      name\n      accounting_id\n      description\n      salable\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProgramBillingTriggers" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "trigger_type" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "StringValue", "value": "time", "block": false } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "contract" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "billableDate" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_by_key" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }] } }] } }] };
    ApplyTemplatePersistDocument = { "__text": "mutation ApplyTemplatePersist($templateId: bigint!, $templateKey: String!, $expectedUpdatedAt: timestamptz!, $contractId: bigint!, $configValue: jsonb!, $provenanceMatch: jsonb!, $newTriggers: [artriggers_insert_input!]!, $newContractRules: [contract_rules_insert_input!]!, $updatedBy: String!, $now: timestamptz!) {\n  guard_ar_template_apply(\n    args: {template_id: $templateId, template_key: $templateKey, expected_updatedat: $expectedUpdatedAt, target_contract_id: $contractId}\n  ) {\n    id\n  }\n  prepare_config: update_contracts(\n    where: {id: {_eq: $contractId}, config: {_is_null: true}}\n    _set: {config: {}, updatedby: $updatedBy, updatedat: $now}\n  ) {\n    affected_rows\n  }\n  update_contracts_by_pk(\n    pk_columns: {id: $contractId}\n    _append: {config: $configValue}\n    _set: {updatedby: $updatedBy, updatedat: $now}\n  ) {\n    id\n  }\n  delete_artriggers(\n    where: {contract_id: {_eq: $contractId}, config: {_contains: $provenanceMatch}}\n  ) {\n    affected_rows\n  }\n  insert_artriggers(objects: $newTriggers) {\n    affected_rows\n    returning {\n      id\n      config\n      contract_id\n      trigger_type\n      algorithm_key\n      product_key\n    }\n  }\n  insert_contract_rules(objects: $newContractRules) {\n    returning {\n      id\n      raterules {\n        id\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "ApplyTemplatePersist" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "templateId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "templateKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "expectedUpdatedAt" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "configValue" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "provenanceMatch" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "newTriggers" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "artriggers_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "newContractRules" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contract_rules_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "guard_ar_template_apply" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "args" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "template_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "templateId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "template_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "templateKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "expected_updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "expectedUpdatedAt" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "target_contract_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "prepare_config" }, "name": { "kind": "Name", "value": "update_contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "update_contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "configValue" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delete_artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_contains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "provenanceMatch" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "newTriggers" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "trigger_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "newContractRules" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] } }] };
    EnsureArTemplateRowDocument = { "__text": "mutation EnsureArTemplateRow($object: artemplates_insert_input!) {\n  insert_artemplates_one(\n    object: $object\n    on_conflict: {constraint: artemplates_key_key, update_columns: [updatedby]}\n  ) {\n    id\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "EnsureArTemplateRow" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "artemplates_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_artemplates_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "artemplates_key_key" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "updatedby" }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    GetContractConfigForApplyDocument = { "__text": "query GetContractConfigForApply($contractId: bigint!) {\n  contracts_by_pk(id: $contractId) {\n    id\n    begin_date\n    config\n    customer_id\n    contract_rules(where: {active: {_eq: true}}, order_by: {id: asc}) {\n      id\n      active\n      schema_key\n      product_key\n      config\n      raterules_aggregate(where: {active: {_eq: 1}}) {\n        aggregate {\n          count\n        }\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractConfigForApply" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules_aggregate" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }] } }] } }] } }] };
    GetContractForTriggerWriteDocument = { "__text": "query GetContractForTriggerWrite($contractId: bigint!, $productKey: String!) {\n  contracts_by_pk(id: $contractId) {\n    id\n    begin_date\n    artriggers(where: {product_key: {_eq: $productKey}}, limit: 1) {\n      id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractForTriggerWrite" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "product_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] };
    GetLegacyContractForConversionDocument = { "__text": "query GetLegacyContractForConversion($contractId: bigint!) {\n  contracts_by_pk(id: $contractId) {\n    id\n    customer_id\n    workflowset_id\n    begin_date\n    end_date\n    productfees(where: {active: {_eq: true}}) {\n      id\n      charge\n      cost\n      notes\n      billable_date\n      product {\n        id\n        name\n        term\n      }\n    }\n    contract_rules(where: {active: {_eq: true}}, order_by: {id: asc}) {\n      id\n      active\n      schema_key\n      product_key\n      config\n      raterules(where: {active: {_eq: 1}}, order_by: {id: asc}) {\n        id\n        type\n        distance_start\n        distance_end\n        rate\n        flat_rate\n        class\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetLegacyContractForConversion" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "customer_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "productfees" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "charge" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cost" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "term" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "IntValue", "value": "1" } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }] } }] } }] } }] } }] };
    GetProductForTriggerOwnerDocument = { "__text": "query GetProductForTriggerOwner($productKey: String!) {\n  products(where: {key: {_eq: $productKey}, active: {_eq: true}}, limit: 1) {\n    key\n    salable\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProductForTriggerOwner" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "products" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "limit" }, "value": { "kind": "IntValue", "value": "1" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }] } }] };
    GetProductPricingConfigDocument = { "__text": "query GetProductPricingConfig($id: bigint!) {\n  contracts_by_pk(id: $id) {\n    id\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProductPricingConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    GetProductRemovabilityDocument = { "__text": "query GetProductRemovability($contractId: bigint!, $productKey: String!) {\n  artriggers_aggregate(\n    where: {contract_id: {_eq: $contractId}, product_key: {_eq: $productKey}}\n  ) {\n    aggregate {\n      count\n    }\n  }\n  argroups_aggregate(\n    where: {artrigger: {contract_id: {_eq: $contractId}, product_key: {_eq: $productKey}}}\n  ) {\n    aggregate {\n      count\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetProductRemovability" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers_aggregate" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "product_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroups_aggregate" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "product_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }] } }] };
    GetTriggerRemovabilityDocument = { "__text": "query GetTriggerRemovability($contractId: bigint!, $triggerId: bigint!) {\n  artriggers(where: {contract_id: {_eq: $contractId}, id: {_eq: $triggerId}}) {\n    id\n    argroups_aggregate {\n      aggregate {\n        count\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetTriggerRemovability" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroups_aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "aggregate" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "count" } }] } }] } }] } }] } }] };
    InsertContractTriggerDocument = { "__text": "mutation InsertContractTrigger($object: artriggers_insert_input!) {\n  insert_artriggers_one(object: $object) {\n    id\n    contract_id\n    trigger_type\n    algorithm_key\n    product_key\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertContractTrigger" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "artriggers_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_artriggers_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "trigger_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    ListArTemplatesDocument = { "__text": "query ListArTemplates {\n  artemplates(order_by: {key: asc}) {\n    id\n    key\n    name\n    updatedat\n    description\n    scope\n    active\n    required_engine\n    parameters\n    artemplate_triggers(order_by: [{sort_order: asc}, {id: asc}]) {\n      id\n      trigger_type\n      algorithm_key\n      product_key\n      event_key\n      config\n      sort_order\n      product {\n        key\n        salable\n      }\n    }\n    artemplate_rules(order_by: [{sort_order: asc}, {id: asc}]) {\n      id\n      name\n      description\n      product_key\n      schema_key\n      config\n      sort_order\n    }\n    artemplate_raterules(order_by: [{sort_order: asc}, {id: asc}]) {\n      id\n      artemplate_rule_id\n      distance_start\n      distance_end\n      type\n      class\n      rate\n      flat_rate\n      class_3_rate\n      class_3_flat_rate\n      class_4_rate\n      class_4_flat_rate\n      class_5_rate\n      class_5_flat_rate\n      class_6_rate\n      class_6_flat_rate\n      program_coverage_pct\n      sort_order\n    }\n    artemplate_products(order_by: {product_key: asc}) {\n      id\n      product_key\n      settings\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "ListArTemplates" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "artemplates" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scope" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "required_engine" } }, { "kind": "Field", "name": { "kind": "Name", "value": "parameters" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_triggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "sort_order" }, "value": { "kind": "EnumValue", "value": "asc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "trigger_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "event_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sort_order" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "salable" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_rules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "sort_order" }, "value": { "kind": "EnumValue", "value": "asc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sort_order" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "sort_order" }, "value": { "kind": "EnumValue", "value": "asc" } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "EnumValue", "value": "asc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_rule_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_start" } }, { "kind": "Field", "name": { "kind": "Name", "value": "distance_end" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_3_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_4_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_5_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "class_6_flat_rate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "program_coverage_pct" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sort_order" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_products" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "product_key" }, "value": { "kind": "EnumValue", "value": "asc" } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "settings" } }] } }] } }] } }] };
    RemoveProductPersistDocument = { "__text": "mutation RemoveProductPersist($contractId: bigint!, $configValue: jsonb!, $productKey: String!, $updatedBy: String!, $now: timestamptz!) {\n  prepare_config: update_contracts(\n    where: {id: {_eq: $contractId}, config: {_is_null: true}}\n    _set: {config: {}, updatedby: $updatedBy, updatedat: $now}\n  ) {\n    affected_rows\n  }\n  update_contracts_by_pk(\n    pk_columns: {id: $contractId}\n    _append: {config: $configValue}\n    _set: {updatedby: $updatedBy, updatedat: $now}\n  ) {\n    id\n  }\n  delete_artriggers(\n    where: {contract_id: {_eq: $contractId}, product_key: {_eq: $productKey}}\n  ) {\n    affected_rows\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "RemoveProductPersist" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "configValue" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "prepare_config" }, "name": { "kind": "Name", "value": "update_contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "ObjectValue", "fields": [] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "update_contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "configValue" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delete_artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "product_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productKey" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };
    RemoveTriggerDocument = { "__text": "mutation RemoveTrigger($contractId: bigint!, $triggerId: bigint!) {\n  delete_artriggers(\n    where: {contract_id: {_eq: $contractId}, id: {_eq: $triggerId}}\n  ) {\n    returning {\n      id\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "RemoveTrigger" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "delete_artriggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "contract_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] };
    SaveArTemplateDocument = { "__text": "mutation SaveArTemplate($key: String!, $object: artemplates_insert_input!) {\n  delete_artemplate_raterules(where: {artemplate: {key: {_eq: $key}}}) {\n    affected_rows\n  }\n  delete_artemplate_triggers(where: {artemplate: {key: {_eq: $key}}}) {\n    affected_rows\n  }\n  insert_artemplates_one(\n    object: $object\n    on_conflict: {constraint: artemplates_key_key, update_columns: [name, description, scope, active, required_engine, parameters, updatedby]}\n  ) {\n    id\n    key\n    artemplate_triggers {\n      id\n    }\n    artemplate_raterules {\n      id\n    }\n    artemplate_rules {\n      id\n      artemplate_raterules {\n        id\n      }\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SaveArTemplate" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "key" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "artemplates_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "delete_artemplate_raterules" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "artemplate" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "key" } } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "delete_artemplate_triggers" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "artemplate" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "key" } } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_artemplates_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "artemplates_key_key" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "name" }, { "kind": "EnumValue", "value": "description" }, { "kind": "EnumValue", "value": "scope" }, { "kind": "EnumValue", "value": "active" }, { "kind": "EnumValue", "value": "required_engine" }, { "kind": "EnumValue", "value": "parameters" }, { "kind": "EnumValue", "value": "updatedby" }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_triggers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_raterules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_rules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artemplate_raterules" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] } }] };
    UpdateProductPricingConfigDocument = { "__text": "mutation UpdateProductPricingConfig($where: contracts_bool_exp!, $config: jsonb!, $updatedBy: String!, $now: timestamptz!) {\n  update_contracts(\n    where: $where\n    _set: {config: $config, updatedby: $updatedBy, updatedat: $now}\n  ) {\n    affected_rows\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateProductPricingConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contracts_bool_exp" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "config" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }] } }] };
    UpdateTriggerConfigDocument = { "__text": "mutation UpdateTriggerConfig($id: bigint!, $patch: jsonb!, $updatedBy: String!, $now: timestamptz!) {\n  update_artriggers_by_pk(\n    pk_columns: {id: $id}\n    _append: {config: $patch}\n    _set: {updatedby: $updatedBy, updatedat: $now}\n  ) {\n    id\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateTriggerConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "patch" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_artriggers_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_append" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "config" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "patch" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "now" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    GetActiveCreditsForCustomerScenarioDocument = { "__text": 'query GetActiveCreditsForCustomerScenario($scenarioId: bigint!, $algorithmKey: String!) {\n  arcredits(\n    where: {active: {_eq: true}, argroup: {scenario_id: {_eq: $scenarioId}, program_id: {_is_null: true}, algorithm_key: {_eq: $algorithmKey}, status: {_in: ["new", "processing", "done"]}}}\n  ) {\n    id\n    argroup_id\n    amount\n    type\n    reason\n    source_type\n    source_id\n    billable_datetime\n    createdby\n    createdat\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveCreditsForCustomerScenario" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }] } }] } }] };
    GetActiveCreditsForProgramScenarioDocument = { "__text": 'query GetActiveCreditsForProgramScenario($scenarioId: bigint!, $programId: bigint!, $algorithmKey: String!) {\n  arcredits(\n    where: {active: {_eq: true}, argroup: {scenario_id: {_eq: $scenarioId}, program_id: {_eq: $programId}, algorithm_key: {_eq: $algorithmKey}, status: {_in: ["new", "processing", "done"]}}}\n  ) {\n    id\n    argroup_id\n    amount\n    type\n    reason\n    source_type\n    source_id\n    billable_datetime\n    createdby\n    createdat\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveCreditsForProgramScenario" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "argroup" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "billable_datetime" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdby" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }] } }] } }] };
    InsertArchargesDocument = { "__text": "mutation InsertArcharges($charges: [archarges_insert_input!]!) {\n  insert_archarges(objects: $charges) {\n    affected_rows\n    returning {\n      id\n      argroup_id\n      type\n      name\n      notes\n      amount\n      source_type\n      source_id\n      accounting_key\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArcharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "charges" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "archarges_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_archarges" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "charges" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "argroup_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "notes" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "source_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accounting_key" } }] } }] } }] } }] };
    InsertArgroupWithArchargesDocument = { "__text": 'mutation InsertArgroupWithArcharges($scenarioId: bigint, $triggerId: bigint, $customerId: bigint!, $orgId: bigint, $algorithmKey: String!, $runMetadata: jsonb!, $createdby: String!, $updatedby: String!, $arinvoiceId: bigint, $archarges: [archarges_insert_input!]!, $snapshotCredits: [arcredits_insert_input!]!, $carryCredits: [arcredits_insert_input!]!) {\n  update_argroups(\n    where: {scenario_id: {_eq: $scenarioId}, program_id: {_is_null: true}, algorithm_key: {_eq: $algorithmKey}, status: {_in: ["new", "processing", "done"]}}\n    _set: {status: "historical"}\n  ) {\n    affected_rows\n    returning {\n      id\n      algorithm_key\n      createdat\n    }\n  }\n  insert_arcredits(objects: $snapshotCredits) {\n    affected_rows\n  }\n  insert_argroups_one(\n    object: {scenario_id: $scenarioId, artrigger_id: $triggerId, customer_id: $customerId, org_id: $orgId, algorithm_key: $algorithmKey, run_metadata: $runMetadata, createdby: $createdby, updatedby: $updatedby, status: "done", arinvoice_id: $arinvoiceId, archarges: {data: $archarges}, arcredits: {data: $carryCredits, on_conflict: {constraint: arcredits_pkey, update_columns: [argroup_id]}}}\n  ) {\n    id\n    scenario_id\n    artrigger_id\n    status\n    createdat\n    arinvoice_id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArgroupWithArcharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "archarges_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "snapshotCredits" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arcredits_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "carryCredits" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arcredits_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_argroups" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "historical", "block": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "algorithm_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "snapshotCredits" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "org_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "archarges" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arcredits" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "carryCredits" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "arcredits_pkey" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "argroup_id" }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artrigger_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }] } }] };
    InsertArgroupWithArchargesSimpleDocument = { "__text": 'mutation InsertArgroupWithArchargesSimple($scenarioId: bigint, $triggerId: bigint, $customerId: bigint!, $orgId: bigint, $algorithmKey: String!, $runMetadata: jsonb!, $createdby: String!, $updatedby: String!, $arinvoiceId: bigint, $archarges: [archarges_insert_input!]!) {\n  insert_argroups_one(\n    object: {scenario_id: $scenarioId, artrigger_id: $triggerId, customer_id: $customerId, org_id: $orgId, algorithm_key: $algorithmKey, run_metadata: $runMetadata, createdby: $createdby, updatedby: $updatedby, status: "done", arinvoice_id: $arinvoiceId, archarges: {data: $archarges}}\n  ) {\n    id\n    scenario_id\n    artrigger_id\n    status\n    createdat\n    arinvoice_id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertArgroupWithArchargesSimple" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "archarges_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "org_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orgId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "archarges" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "scenario_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "artrigger_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "arinvoice_id" } }] } }] } }] };
    InsertProgramArgroupWithArchargesDocument = { "__text": 'mutation InsertProgramArgroupWithArcharges($scenarioId: bigint, $triggerId: bigint, $programId: bigint!, $customerId: bigint!, $algorithmKey: String!, $runMetadata: jsonb!, $createdby: String!, $updatedby: String!, $arinvoiceId: bigint, $archarges: [archarges_insert_input!]!) {\n  insert_argroups_one(\n    object: {scenario_id: $scenarioId, artrigger_id: $triggerId, program_id: $programId, customer_id: $customerId, algorithm_key: $algorithmKey, run_metadata: $runMetadata, createdby: $createdby, updatedby: $updatedby, status: "done", arinvoice_id: $arinvoiceId, archarges: {data: $archarges}}\n  ) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertProgramArgroupWithArcharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "archarges_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "archarges" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    InsertProgramScenarioArgroupWithArchargesDocument = { "__text": 'mutation InsertProgramScenarioArgroupWithArcharges($scenarioId: bigint!, $triggerId: bigint, $programId: bigint!, $customerId: bigint!, $algorithmKey: String!, $runMetadata: jsonb!, $createdby: String!, $updatedby: String!, $arinvoiceId: bigint, $archarges: [archarges_insert_input!]!, $snapshotCredits: [arcredits_insert_input!]!, $carryCredits: [arcredits_insert_input!]!) {\n  update_argroups(\n    where: {scenario_id: {_eq: $scenarioId}, program_id: {_eq: $programId}, algorithm_key: {_eq: $algorithmKey}, status: {_in: ["new", "processing", "done"]}}\n    _set: {status: "historical"}\n  ) {\n    affected_rows\n    returning {\n      id\n    }\n  }\n  insert_arcredits(objects: $snapshotCredits) {\n    affected_rows\n  }\n  insert_argroups_one(\n    object: {scenario_id: $scenarioId, artrigger_id: $triggerId, program_id: $programId, customer_id: $customerId, algorithm_key: $algorithmKey, run_metadata: $runMetadata, createdby: $createdby, updatedby: $updatedby, status: "done", arinvoice_id: $arinvoiceId, archarges: {data: $archarges}, arcredits: {data: $carryCredits, on_conflict: {constraint: arcredits_pkey, update_columns: [argroup_id]}}}\n  ) {\n    id\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertProgramScenarioArgroupWithArcharges" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "jsonb" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "archarges_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "snapshotCredits" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arcredits_insert_input" } } } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "carryCredits" } }, "type": { "kind": "NonNullType", "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "arcredits_insert_input" } } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_argroups" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_in" }, "value": { "kind": "ListValue", "values": [{ "kind": "StringValue", "value": "new", "block": false }, { "kind": "StringValue", "value": "processing", "block": false }, { "kind": "StringValue", "value": "done", "block": false }] } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "historical", "block": false } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_arcredits" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "objects" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "snapshotCredits" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "insert_argroups_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "scenario_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "scenarioId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "artrigger_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "triggerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "program_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "programId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "algorithm_key" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "algorithmKey" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "run_metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "runMetadata" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "createdby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "createdby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "status" }, "value": { "kind": "StringValue", "value": "done", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arinvoice_id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "arinvoiceId" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "archarges" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "archarges" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "arcredits" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "data" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "carryCredits" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "on_conflict" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "constraint" }, "value": { "kind": "EnumValue", "value": "arcredits_pkey" } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "update_columns" }, "value": { "kind": "ListValue", "values": [{ "kind": "EnumValue", "value": "argroup_id" }] } }] } }] } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] };
    InsertContractRuleDocument = { "__text": "mutation InsertContractRule($object: contract_rules_insert_input!) {\n  insert_contract_rules_one(object: $object) {\n    id\n    active\n    contract_id\n    name\n    description\n    product_key\n    schema_key\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "InsertContractRule" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contract_rules_insert_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "insert_contract_rules_one" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "object" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "object" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    SetContractRuleActiveDocument = { "__text": "mutation SetContractRuleActive($id: bigint!, $active: Boolean!, $updatedat: timestamptz!, $updatedby: String!) {\n  update_contract_rules_by_pk(\n    pk_columns: {id: $id}\n    _set: {active: $active, updatedat: $updatedat, updatedby: $updatedby}\n  ) {\n    id\n    active\n    contract_id\n    name\n    description\n    product_key\n    schema_key\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SetContractRuleActive" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "active" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_contract_rules_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "active" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "active" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedat" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedby" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedby" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    UpdateContractRuleConfigDocument = { "__text": "mutation UpdateContractRuleConfig($id: bigint!, $set: contract_rules_set_input!) {\n  update_contract_rules_by_pk(pk_columns: {id: $id}, _set: $set) {\n    id\n    active\n    contract_id\n    name\n    description\n    product_key\n    schema_key\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateContractRuleConfig" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contract_rules_set_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_contract_rules_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    UpdateContractRuleMetadataDocument = { "__text": "mutation UpdateContractRuleMetadata($id: bigint!, $set: contract_rules_set_input!) {\n  update_contract_rules_by_pk(pk_columns: {id: $id}, _set: $set) {\n    id\n    active\n    contract_id\n    name\n    description\n    product_key\n    schema_key\n    config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "UpdateContractRuleMetadata" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "contract_rules_set_input" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_contract_rules_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "set" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "active" } }, { "kind": "Field", "name": { "kind": "Name", "value": "contract_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "description" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "schema_key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "config" } }] } }] } }] };
    GetActiveCustomerContractsForProductDocument = { "__text": "query GetActiveCustomerContractsForProduct($customerId: bigint!, $today: timestamptz!) {\n  contracts(\n    where: {customer_id: {_eq: $customerId}, begin_date: {_lte: $today}, _or: [{end_date: {_gte: $today}}, {end_date: {_is_null: true}}]}\n    order_by: [{begin_date: desc}]\n  ) {\n    id\n    name\n    begin_date\n    end_date\n    workflowset_id\n    workflowsets {\n      id\n      name\n    }\n    artriggers {\n      id\n      product_key\n    }\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetActiveCustomerContractsForProduct" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "customer_id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "customerId" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_lte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } } }] } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "_or" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_gte" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "today" } } }] } }] }, { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "end_date" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_is_null" }, "value": { "kind": "BooleanValue", "value": true } }] } }] }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "order_by" }, "value": { "kind": "ListValue", "values": [{ "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "begin_date" }, "value": { "kind": "EnumValue", "value": "desc" } }] }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "begin_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "end_date" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowset_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "workflowsets" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "artriggers" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "product_key" } }] } }] } }] } }] };
    GetContractEffectiveConfigForProductDocument = { "__text": "query GetContractEffectiveConfigForProduct($contractId: bigint!) {\n  contracts_by_pk(id: $contractId) {\n    id\n    effective_config\n  }\n}", "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetContractEffectiveConfigForProduct" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "contracts_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "contractId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "effective_config" } }] } }] } }] };
  }
});

// src/utils/accountingProductKeys.ts
var ACCOUNTING_KEY_MOVE, ACCOUNTING_KEY_RIDE, ACCOUNTING_KEY_PLATFORM, ACCOUNTING_KEY_PROCESSING_FEE, ACCOUNTING_KEY_MOVE_VALIDATION_FEE, ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE, ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE, ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE, ACCOUNTING_KEY_INTEGRATED_SOFTWARE_FEE, ACCOUNTING_KEY_ENTERPRISE_SOFTWARE_FEE, ACCOUNTING_KEY_ONBOARDING_FEE, ACCOUNTING_KEY_TOLL, ACCESSORIAL_ACCOUNTING_KEYS, AR_ACCOUNTING_PRODUCT_KEYS;
var init_accountingProductKeys = __esm({
  "src/utils/accountingProductKeys.ts"() {
    ACCOUNTING_KEY_MOVE = "move";
    ACCOUNTING_KEY_RIDE = "ride";
    ACCOUNTING_KEY_PLATFORM = "platform";
    ACCOUNTING_KEY_PROCESSING_FEE = "processing-fee";
    ACCOUNTING_KEY_MOVE_VALIDATION_FEE = "move-validation-fee";
    ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE = "valet-rooftop-software-fee";
    ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE = "mobile-service-rooftop-software-fee";
    ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE = "parts-delivery-rooftop-software-fee";
    ACCOUNTING_KEY_INTEGRATED_SOFTWARE_FEE = "integrated-software-fee";
    ACCOUNTING_KEY_ENTERPRISE_SOFTWARE_FEE = "enterprise-software-fee";
    ACCOUNTING_KEY_ONBOARDING_FEE = "onboarding-fee";
    ACCOUNTING_KEY_TOLL = "toll";
    ACCESSORIAL_ACCOUNTING_KEYS = [
      "fuel",
      "delay",
      "tow",
      "discount",
      "partial",
      "surge",
      ACCOUNTING_KEY_TOLL,
      "insurance",
      "roadside",
      "spoilage"
    ];
    AR_ACCOUNTING_PRODUCT_KEYS = [
      ACCOUNTING_KEY_MOVE,
      ACCOUNTING_KEY_RIDE,
      ACCOUNTING_KEY_PLATFORM,
      ACCOUNTING_KEY_PROCESSING_FEE,
      ACCOUNTING_KEY_MOVE_VALIDATION_FEE,
      ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE,
      ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE,
      ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE,
      ACCOUNTING_KEY_INTEGRATED_SOFTWARE_FEE,
      ACCOUNTING_KEY_ENTERPRISE_SOFTWARE_FEE,
      ACCOUNTING_KEY_ONBOARDING_FEE,
      ...ACCESSORIAL_ACCOUNTING_KEYS
    ];
  }
});

// src/features/ar-invoices/invoice-management/queries.ts
import { resolveExecutor as resolveExecutor6 } from "@hopdrive/sdk-core";
async function getProducts() {
  const executor = resolveExecutor6();
  const result = await executor.query(
    GetProductsDocument,
    {}
  );
  return result.products;
}
async function getProgramConfig(programId) {
  const executor = resolveExecutor6();
  const result = await executor.query(
    GetProgramConfigDocument,
    { programId }
  );
  return result.programs_by_pk?.config ?? null;
}
var init_queries = __esm({
  "src/features/ar-invoices/invoice-management/queries.ts"() {
    init_schema();
  }
});

// src/utils/productMapping.ts
async function loadProductMap() {
  const products = await getProducts();
  const map = /* @__PURE__ */ new Map();
  if (products && products.length > 0) {
    products.forEach((product) => {
      if (!product.key) return;
      map.set(product.key, {
        id: product.id,
        key: product.key,
        name: product.name,
        accounting_id: product.accounting_id,
        description: product.description,
        salable: product.salable
      });
    });
  }
  return map;
}
async function getProductMap() {
  if (!productMap) {
    productMap = await loadProductMap();
  }
  return productMap;
}
async function findProductByKey(key) {
  const map = await getProductMap();
  return map.get(key) ?? null;
}
async function getProductByKey(key) {
  const product = await findProductByKey(key);
  if (!product) throw new ProductKeyNotFoundError(key);
  return product;
}
async function resolveAccountingKey(productKey) {
  const product = await findProductByKey(productKey);
  if (!product || product.accounting_id === null) return void 0;
  return String(product.accounting_id);
}
var productMap, ProductKeyNotFoundError;
var init_productMapping = __esm({
  "src/utils/productMapping.ts"() {
    init_queries();
    productMap = null;
    ProductKeyNotFoundError = class extends Error {
      constructor(productKey) {
        super(`No active product with key '${productKey}'`);
        this.name = "ProductKeyNotFoundError";
        this.productKey = productKey;
      }
    };
  }
});

// ../../gql/operations.ts
import { resolveExecutor as resolveExecutor7 } from "@hopdrive/sdk-core";
async function getContractRules(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor7(executor).query(
    GetContractRulesDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.contract_rules;
}
async function getProgramClaim(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor7(executor).query(
    GetProgramClaimDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.program_claims;
}
async function getProgramContract(variables, options) {
  const { executor, raw, ...requestOptions } = options ?? {};
  const result = await resolveExecutor7(executor).query(
    GetProgramContractDocument,
    variables,
    requestOptions
  );
  if (raw) return result;
  return result.contracts;
}
var init_operations = __esm({
  "../../gql/operations.ts"() {
    init_schema();
  }
});

// src/features/ar-invoices/invoice-management/mutations.ts
import { resolveExecutor as resolveExecutor11 } from "@hopdrive/sdk-core";
async function upsertInvoice(input) {
  const executor = resolveExecutor11();
  const result = await executor.query(UpsertInvoiceDocument, {
    customerId: input.customerId,
    startDatetime: input.startDatetime,
    endDatetime: input.endDatetime,
    invoiceType: input.invoiceType,
    areventId: input.areventId
  });
  return result.insert_arinvoices_one;
}
var init_mutations = __esm({
  "src/features/ar-invoices/invoice-management/mutations.ts"() {
    init_schema();
  }
});

// src/features/ar-invoices/invoice-management/invoiceFrequency.ts
function resolveInvoiceFrequency(triggerConfig, customerFrequency) {
  const own = triggerConfig?.invoice_frequency;
  if (typeof own === "string" && BILLING_FREQUENCIES.includes(own)) {
    return own;
  }
  return customerFrequency ?? "monthly";
}
var BILLING_FREQUENCIES;
var init_invoiceFrequency = __esm({
  "src/features/ar-invoices/invoice-management/invoiceFrequency.ts"() {
    BILLING_FREQUENCIES = ["daily", "weekly", "monthly"];
  }
});

// src/features/ar-invoices/invoice-management/invoiceManager.ts
import { getLogger as getLogger7 } from "@hopdrive/sdk-core";
import { v4 as uuid } from "uuid";
function getInvoiceDateRange(billableDate, billingFrequency) {
  const date = new Date(billableDate);
  let start;
  let end;
  switch (billingFrequency) {
    case "daily":
      start = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
      end = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));
      break;
    case "weekly": {
      const dayOfWeek = date.getUTCDay();
      start = new Date(date);
      start.setUTCDate(date.getUTCDate() - dayOfWeek);
      start.setUTCHours(0, 0, 0, 0);
      end = new Date(start);
      end.setUTCDate(start.getUTCDate() + 6);
      end.setUTCHours(23, 59, 59, 999);
      break;
    }
    case "monthly":
    default:
      start = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
      end = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0, 23, 59, 59, 999));
      break;
  }
  return {
    start: start.toISOString(),
    end: end.toISOString()
  };
}
function getInvoiceType(customerTier) {
  return customerTier === "lite" ? "rideshare" : "standard";
}
function determineInvoiceType(customerTier) {
  return `${getInvoiceType(customerTier)}_charges`;
}
async function getOrCreateInvoice(customerId, billableDate, billingFrequency, customerTier) {
  const logger = getLogger7();
  const dateRange = getInvoiceDateRange(billableDate, billingFrequency);
  const invoiceType = determineInvoiceType(customerTier);
  const areventId = uuid();
  logger.debug("Getting or creating invoice", {
    customerId,
    billableDate,
    billingFrequency,
    dateRange,
    invoiceType
  });
  try {
    const invoice = await upsertInvoice({
      customerId,
      startDatetime: dateRange.start,
      endDatetime: dateRange.end,
      invoiceType,
      areventId
    });
    if (!invoice) {
      logger.warn(
        `[ar-locked-legacy-invoice] Customer ${customerId}'s invoice for the period starting ${dateRange.start} is a closed legacy invoice; skipping the AR run instead of retyping it to ${invoiceType}`,
        { customerId, attemptedInvoiceType: invoiceType, dateRange }
      );
      throw new LockedLegacyInvoiceError(customerId, dateRange.start);
    }
    logger.info("Invoice ready", {
      invoiceId: invoice.id,
      customerId,
      dateRange
    });
    return {
      invoiceId: invoice.id,
      dateRange,
      invoiceType,
      billingFrequency,
      customerId
    };
  } catch (error) {
    if (error instanceof LockedLegacyInvoiceError) throw error;
    logger.error("Failed to get or create invoice", {
      customerId,
      billableDate,
      billingFrequency,
      error
    });
    throw error;
  }
}
var LockedLegacyInvoiceError;
var init_invoiceManager = __esm({
  "src/features/ar-invoices/invoice-management/invoiceManager.ts"() {
    init_mutations();
    init_invoiceFrequency();
    LockedLegacyInvoiceError = class extends Error {
      constructor(customerId, periodStart) {
        super(`customer ${customerId}'s invoice for the period starting ${periodStart} is a closed legacy invoice`);
        this.customerId = customerId;
        this.periodStart = periodStart;
        this.name = "LockedLegacyInvoiceError";
      }
    };
  }
});

// src/features/ar-invoices/invoice-management/programInvoiceManager.ts
import { resolveExecutor as resolveExecutor12, getLogger as getLogger8 } from "@hopdrive/sdk-core";
import { v4 as uuid2 } from "uuid";
function readBillableCustomerId(config) {
  const raw = config?.billable_customer_id;
  if (typeof raw === "number" && Number.isFinite(raw)) return raw;
  if (typeof raw === "string" && raw.trim() !== "") {
    const n = Number(raw);
    if (Number.isFinite(n)) return n;
  }
  return null;
}
function readProgramBillingFrequency(config) {
  const raw = config?.billing_frequency;
  if (raw === "daily" || raw === "weekly" || raw === "monthly") return raw;
  return "monthly";
}
async function getProgramBillableCustomerId(programId) {
  return readBillableCustomerId(await getProgramConfig(programId));
}
async function getOrCreateProgramInvoice(programId, billableDate) {
  const executor = resolveExecutor12();
  const logger = getLogger8();
  const config = await getProgramConfig(programId);
  const billableCustomerId = readBillableCustomerId(config);
  if (billableCustomerId == null) {
    logger.warn(
      `Program ${programId} has no billable customer (config.billable_customer_id) \u2014 skipping invoice link`,
      { programId, billableDate }
    );
    throw new ProgramBillableCustomerMissingError(programId);
  }
  const billingFrequency = readProgramBillingFrequency(config);
  const dateRange = getInvoiceDateRange(billableDate, billingFrequency);
  const areventId = uuid2();
  logger.debug("Getting or creating program invoice", {
    programId,
    billableCustomerId,
    billableDate,
    billingFrequency,
    dateRange
  });
  const result = await executor.query(UpsertProgramInvoiceDocument, {
    programId,
    customerId: billableCustomerId,
    startDatetime: dateRange.start,
    endDatetime: dateRange.end,
    invoiceType: PROGRAM_INVOICE_TYPE,
    areventId
  });
  const invoice = result.insert_arinvoices_one;
  if (!invoice) {
    throw new Error(`Failed to create or retrieve program invoice for program ${programId}`);
  }
  logger.info("Program invoice ready", {
    invoiceId: invoice.id,
    programId,
    billableCustomerId,
    dateRange
  });
  return {
    invoiceId: invoice.id,
    dateRange,
    invoiceType: PROGRAM_INVOICE_TYPE,
    billingFrequency,
    programId,
    billableCustomerId
  };
}
var PROGRAM_INVOICE_TYPE, ProgramBillableCustomerMissingError;
var init_programInvoiceManager = __esm({
  "src/features/ar-invoices/invoice-management/programInvoiceManager.ts"() {
    init_schema();
    init_invoiceManager();
    init_queries();
    PROGRAM_INVOICE_TYPE = "program";
    ProgramBillableCustomerMissingError = class extends Error {
      constructor(programId) {
        super(
          `Program ${programId} has no config.billable_customer_id \u2014 cannot stamp the program invoice's customer. Set up a billable customer on the program. Committing without an invoice link.`
        );
        this.name = "ProgramBillableCustomerMissingError";
        this.programId = programId;
      }
    };
  }
});

// src/utils/paymentStatus.ts
function isSettledPaymentStatus(status) {
  return SETTLED_PAYMENT_STATUSES.includes(status ?? "");
}
function settledAllocationTotal(details) {
  let total = 0;
  for (const detail of details ?? []) {
    if (!detail.parent || !isSettledPaymentStatus(detail.parent.status)) continue;
    const amount = detail.amount === "" || detail.amount == null ? NaN : Number(detail.amount);
    if (Number.isFinite(amount)) total += amount;
  }
  return total;
}
function settledPaymentTotal(payments) {
  return (payments ?? []).filter((payment) => isSettledPaymentStatus(payment.status)).reduce((total, payment) => total + payment.amount, 0);
}
var SETTLED_PAYMENT_STATUSES;
var init_paymentStatus = __esm({
  "src/utils/paymentStatus.ts"() {
    SETTLED_PAYMENT_STATUSES = ["paid", "successful"];
  }
});

// src/utils/allocateSourceCredits.ts
function portionsByInvoice(credit) {
  if (typeof credit === "number") return [{ amount: credit, invoiceId: null }];
  const byInvoice = /* @__PURE__ */ new Map();
  for (const portion of credit) {
    const invoiceId = portion.invoiceId ?? null;
    byInvoice.set(invoiceId, (byInvoice.get(invoiceId) ?? 0) + portion.amount);
  }
  const portions = Array.from(byInvoice, ([invoiceId, amount]) => ({ invoiceId, amount }));
  return [...portions.filter((p) => p.invoiceId != null), ...portions.filter((p) => p.invoiceId == null)];
}
function allocateSourceCredits(charges, creditByKey) {
  const applied = new Array(charges.length).fill(0);
  const indicesByKey = /* @__PURE__ */ new Map();
  charges.forEach((charge, i) => {
    if (charge.key == null) return;
    if (!indicesByKey.has(charge.key)) indicesByKey.set(charge.key, []);
    indicesByKey.get(charge.key).push(i);
  });
  const creditable = (i) => Math.max(0, charges[i].amount - charges[i].paid);
  indicesByKey.forEach((indices, key) => {
    const credit = creditByKey.get(key);
    if (credit === void 0) return;
    for (const portion of portionsByInvoice(credit)) {
      let remaining = portion.amount;
      if (remaining <= 0) continue;
      const ownInvoice = (i) => portion.invoiceId != null && charges[i].invoiceId === portion.invoiceId ? 1 : 0;
      const ordered = [...indices].sort((a, b) => {
        if (ownInvoice(b) !== ownInvoice(a)) return ownInvoice(b) - ownInvoice(a);
        const reserveA = charges[a].reserveFirst ? 1 : 0;
        const reserveB = charges[b].reserveFirst ? 1 : 0;
        if (reserveB !== reserveA) return reserveB - reserveA;
        if (creditable(b) !== creditable(a)) return creditable(b) - creditable(a);
        return a - b;
      });
      for (const i of ordered) {
        if (remaining <= 0) break;
        const room = roundCents(creditable(i) - applied[i]);
        if (room <= 0) continue;
        const applyNow = roundCents(Math.min(remaining, room));
        applied[i] = roundCents(applied[i] + applyNow);
        remaining = roundCents(remaining - applyNow);
      }
    }
  });
  return applied;
}
var creditBucketKey, roundCents;
var init_allocateSourceCredits = __esm({
  "src/utils/allocateSourceCredits.ts"() {
    creditBucketKey = (unit, sourceType, sourceId) => `${unit.programId != null ? `program:${unit.programId}` : `customer:${unit.customerId ?? ""}`}|${sourceType}|${sourceId}`;
    roundCents = (amount) => Math.round(amount * 100) / 100;
  }
});

// src/features/ar-payments/business-logic/currency.ts
function roundCurrency(amount) {
  return Math.round(amount * 100) / 100;
}
function currencyEquals(a, b) {
  return Math.abs(a - b) < CURRENCY_TOLERANCE;
}
function currencyGreaterThan(a, b) {
  return a - b > CURRENCY_TOLERANCE;
}
function sumCurrency(amounts) {
  const sum2 = amounts.reduce((total, amount) => total + amount, 0);
  return roundCurrency(sum2);
}
var CURRENCY_TOLERANCE;
var init_currency = __esm({
  "src/features/ar-payments/business-logic/currency.ts"() {
    CURRENCY_TOLERANCE = 0.01;
  }
});

// src/features/ar-payments/business-logic/calculateNetDue.ts
function creditPortionsByKey(credits) {
  const portions = /* @__PURE__ */ new Map();
  credits.forEach((credit) => {
    const key = creditBucketKey(credit, credit.sourceType, credit.sourceId);
    if (!portions.has(key)) portions.set(key, []);
    portions.get(key).push({ amount: credit.amount, invoiceId: credit.invoiceId });
  });
  return portions;
}
function calculateNetDueBatch(archarges, allCredits, allPaymentDetails) {
  const bucketKey = creditBucketKey;
  const creditsByKey = /* @__PURE__ */ new Map();
  allCredits.forEach((credit) => {
    const key = bucketKey(credit, credit.sourceType, credit.sourceId);
    if (!creditsByKey.has(key)) creditsByKey.set(key, []);
    creditsByKey.get(key).push(credit);
  });
  const creditByKey = creditPortionsByKey(allCredits);
  const paymentsMap = /* @__PURE__ */ new Map();
  allPaymentDetails.forEach((detail) => {
    if (!paymentsMap.has(detail.archargeId)) paymentsMap.set(detail.archargeId, []);
    paymentsMap.get(detail.archargeId).push(detail);
  });
  const paidFor = (archargeId) => (paymentsMap.get(archargeId) || []).reduce(
    (sum2, detail) => isSettledPaymentStatus(detail.paymentStatus) ? sum2 + detail.amount : sum2,
    0
  );
  const chargeKeys = archarges.map((a) => bucketKey(a, a.sourceType, a.sourceId));
  const applied = allocateSourceCredits(
    archarges.map((a, i) => ({ key: chargeKeys[i], amount: a.amount, paid: paidFor(a.id), invoiceId: a.invoiceId })),
    creditByKey
  );
  return archarges.map((archarge, i) => {
    const appliedCredit = applied[i];
    const paidAmount = paidFor(archarge.id);
    const netDue = Math.max(0, roundCurrency(archarge.amount - appliedCredit - paidAmount));
    return {
      archargeId: archarge.id,
      grossAmount: archarge.amount,
      creditAmount: appliedCredit,
      netDue,
      credits: creditsByKey.get(chargeKeys[i]) || []
    };
  });
}
function calculateSelectedNetDue(allCharges, selectedIds, allCredits, allPaymentDetails) {
  const bucketKey = creditBucketKey;
  const creditByKey = creditPortionsByKey(allCredits);
  const paymentsMap = /* @__PURE__ */ new Map();
  allPaymentDetails.forEach((detail) => {
    if (!paymentsMap.has(detail.archargeId)) paymentsMap.set(detail.archargeId, []);
    paymentsMap.get(detail.archargeId).push(detail);
  });
  const paidFor = (archargeId) => (paymentsMap.get(archargeId) || []).reduce(
    (sum2, detail) => isSettledPaymentStatus(detail.paymentStatus) ? sum2 + detail.amount : sum2,
    0
  );
  const applied = allocateSourceCredits(
    allCharges.map((c) => ({
      key: bucketKey(c, c.sourceType, c.sourceId),
      amount: c.amount,
      paid: paidFor(c.id),
      reserveFirst: !selectedIds.has(c.id),
      invoiceId: c.invoiceId
    })),
    creditByKey
  );
  const results = [];
  allCharges.forEach((charge, i) => {
    if (!selectedIds.has(charge.id)) return;
    const appliedCredit = applied[i];
    const paidAmount = paidFor(charge.id);
    results.push({
      archargeId: charge.id,
      grossAmount: charge.amount,
      creditAmount: appliedCredit,
      netDue: Math.max(0, roundCurrency(charge.amount - appliedCredit - paidAmount)),
      credits: []
    });
  });
  return results;
}
var init_calculateNetDue = __esm({
  "src/features/ar-payments/business-logic/calculateNetDue.ts"() {
    init_paymentStatus();
    init_allocateSourceCredits();
    init_currency();
  }
});

// src/features/ar-payments/business-logic/constants.ts
var PROCESSING_FEE_PERCENTAGE, PROCESSING_FEE_CHARGE_TYPE, PROCESSING_FEE_SOURCE_TYPE;
var init_constants = __esm({
  "src/features/ar-payments/business-logic/constants.ts"() {
    PROCESSING_FEE_PERCENTAGE = 0.03;
    PROCESSING_FEE_CHARGE_TYPE = "processing_fee";
    PROCESSING_FEE_SOURCE_TYPE = "arpayment";
  }
});

// src/features/ar-payments/business-logic/amountDue.ts
function cardProcessingFee(amount) {
  return roundCurrency(amount * PROCESSING_FEE_PERCENTAGE);
}
function gatewayChargeTotal(amount, paymentMethodType) {
  if (paymentMethodType !== "card") return { processingFee: 0, total: amount };
  const processingFee = cardProcessingFee(amount);
  return { processingFee, total: roundCurrency(amount + processingFee) };
}
function calculateAmountDue(input) {
  const selectedIds = input.selectedIds instanceof Set ? input.selectedIds : new Set(input.selectedIds);
  const charges = calculateSelectedNetDue(input.charges, selectedIds, input.credits, input.paymentDetails);
  const netDue = roundCurrency(charges.reduce((sum2, r) => sum2 + r.netDue, 0));
  const requested = input.requestedAmount ?? netDue;
  const exceedsNetDue = input.strictAmount === true && requested - netDue > CURRENCY_TOLERANCE;
  const amountToCharge = Math.min(requested, netDue);
  const { processingFee, total } = amountToCharge > 0 ? gatewayChargeTotal(amountToCharge, input.paymentMethodType) : { processingFee: 0, total: 0 };
  return { charges, netDue, amountToCharge, processingFee, totalToCharge: total, exceedsNetDue };
}
var init_amountDue = __esm({
  "src/features/ar-payments/business-logic/amountDue.ts"() {
    init_calculateNetDue();
    init_currency();
    init_constants();
  }
});

// src/features/ar-payments/business-logic/generateProcessingFee.ts
import { resolveExecutor as resolveExecutor19, getLogger as getLogger16 } from "@hopdrive/sdk-core";
async function generateProcessingFee(input) {
  const executor = resolveExecutor19();
  const logger = getLogger16();
  try {
    const feeAmount = cardProcessingFee(input.paymentAmount);
    logger.info("Calculating processing fee", {
      paymentId: input.arpaymentId,
      paymentAmount: input.paymentAmount,
      percentage: PROCESSING_FEE_PERCENTAGE,
      feeAmount
    });
    const accountingKey = await resolveAccountingKey(ACCOUNTING_KEY_PROCESSING_FEE);
    if (!accountingKey) {
      logger.error("Processing fee product not found", {
        productName: "processing_fee"
      });
      return {
        success: false,
        error: "Processing fee product not found in products table"
      };
    }
    logger.info("Resolved accounting key for processing fee", {
      productName: "processing_fee",
      accountingKey
    });
    const runMetadata = {
      arpaymentId: input.arpaymentId,
      paymentAmount: input.paymentAmount,
      feePercentage: PROCESSING_FEE_PERCENTAGE,
      feeAmount,
      generatedAt: (/* @__PURE__ */ new Date()).toISOString()
    };
    const chargeName = `${PROCESSING_FEE_PERCENTAGE * 100}% fee for processing credit card payment`;
    logger.info("Inserting processing fee argroup + charge + payment detail", {
      paymentId: input.arpaymentId,
      feeAmount,
      chargeName
    });
    const result = await executor.mutate(InsertProcessingFeeDocument, {
      customerId: input.customerId,
      orgId: input.orgId || null,
      invoiceId: input.invoiceId || null,
      algorithmKey: null,
      runMetadata,
      createdby: input.createdBy,
      updatedby: "system",
      chargeType: PROCESSING_FEE_CHARGE_TYPE,
      chargeName,
      chargeAmount: feeAmount,
      chargeSourceType: PROCESSING_FEE_SOURCE_TYPE,
      chargeSourceId: input.arpaymentId,
      chargeAccountingKey: accountingKey,
      chargeBillableDatetime: (/* @__PURE__ */ new Date()).toISOString(),
      paymentId: input.arpaymentId
    });
    const argroup = result.insert_argroups_one;
    if (!argroup) {
      logger.error("Failed to insert processing fee argroup");
      return {
        success: false,
        error: "Failed to insert processing fee argroup"
      };
    }
    const archarge = argroup.archarges?.[0];
    if (!archarge) {
      logger.error("Failed to insert processing fee archarge");
      return {
        success: false,
        error: "Failed to insert processing fee archarge"
      };
    }
    const paymentDetail = archarge.arpaymentdetails?.[0];
    if (!paymentDetail) {
      logger.error("Failed to insert processing fee payment detail");
      return {
        success: false,
        error: "Failed to insert processing fee payment detail"
      };
    }
    logger.info("Processing fee generated successfully", {
      argroupId: argroup.id,
      archargeId: archarge.id,
      paymentDetailId: paymentDetail.id,
      feeAmount
    });
    return {
      success: true,
      argroupId: Number(argroup.id),
      archargeId: Number(archarge.id),
      feeAmount
    };
  } catch (error) {
    logger.error("Processing fee generation failed", { error });
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error"
    };
  }
}
var init_generateProcessingFee = __esm({
  "src/features/ar-payments/business-logic/generateProcessingFee.ts"() {
    init_schema();
    init_productMapping();
    init_accountingProductKeys();
    init_amountDue();
    init_constants();
  }
});

// src/features/ar-payments/orchestration/reconcileProcessingFee.ts
import { resolveExecutor as resolveExecutor20 } from "@hopdrive/sdk-core";
async function reconcileProcessingFee(arpaymentId, createdBy) {
  try {
    const { arpayments_by_pk: payment, archarges: recordedFees } = await resolveExecutor20().query(GetProcessingFeeReconciliationDocument, {
      paymentId: arpaymentId,
      feeSourceType: PROCESSING_FEE_SOURCE_TYPE,
      feeChargeType: PROCESSING_FEE_CHARGE_TYPE
    });
    if (!payment) return { success: false, error: `Payment ${arpaymentId} not found` };
    if (!isSettledPaymentStatus(payment.status)) {
      return { success: false, error: `Payment ${arpaymentId} is ${payment.status}, not settled; no processing fee recorded` };
    }
    if (payment.method.type !== CARD_PAYMENT_METHOD_TYPE) return { success: true, outcome: PROCESSING_FEE_OUTCOME.NOT_CARD };
    const [recorded] = recordedFees;
    if (recorded) {
      return { success: true, outcome: PROCESSING_FEE_OUTCOME.ALREADY_RECORDED, archargeId: Number(recorded.id) };
    }
    const paidOnCharges = roundCurrency(payment.details.reduce((sum2, detail) => sum2 + Number(detail.amount), 0));
    if (Number(payment.amount) - paidOnCharges <= CURRENCY_TOLERANCE) {
      return { success: true, outcome: PROCESSING_FEE_OUTCOME.NO_FEE_COLLECTED };
    }
    const fee = await generateProcessingFee({
      arpaymentId,
      paymentAmount: paidOnCharges,
      customerId: Number(payment.method.customer_id),
      invoiceId: payment.invoice_id != null ? Number(payment.invoice_id) : void 0,
      createdBy
    });
    if (!fee.success) return { success: false, error: fee.error ?? "Processing fee was not recorded" };
    return { success: true, outcome: PROCESSING_FEE_OUTCOME.RECORDED, archargeId: fee.archargeId };
  } catch (error) {
    return { success: false, error: error instanceof Error ? error.message : String(error) };
  }
}
var CARD_PAYMENT_METHOD_TYPE, PROCESSING_FEE_OUTCOME;
var init_reconcileProcessingFee = __esm({
  "src/features/ar-payments/orchestration/reconcileProcessingFee.ts"() {
    init_schema();
    init_generateProcessingFee();
    init_constants();
    init_currency();
    init_paymentStatus();
    CARD_PAYMENT_METHOD_TYPE = "card";
    PROCESSING_FEE_OUTCOME = {
      /** This run recorded the fee. */
      RECORDED: "recorded",
      /** A fee charge, active or voided, already existed. */
      ALREADY_RECORDED: "already_recorded",
      /** The payment was not by card, so it carries no fee. */
      NOT_CARD: "not_card",
      /** The card payment collected only what it paid on charges, so no fee was charged. */
      NO_FEE_COLLECTED: "no_fee_collected"
    };
  }
});

// src/features/ar-invoices/program-rollup/rollupByRooftop.ts
function describeRollupLine(line) {
  return `${line.label} (${line.count} charge${line.count === 1 ? "" : "s"})`;
}
function rooftopLineTitle(rooftop, line) {
  return `${rooftop.customerName}: ${describeRollupLine(line)}`;
}
function creditsByCharge(argroups) {
  const charges = [];
  const creditByKey = /* @__PURE__ */ new Map();
  for (const argroup of argroups) {
    for (const charge of argroup.archarges) charges.push({ charge, key: bucketKeyOf(argroup, charge) });
    for (const credit of argroup.arcredits ?? []) {
      const key = bucketKeyOf(argroup, credit);
      if (key) creditByKey.set(key, (creditByKey.get(key) ?? 0) + toNumber(credit.amount));
    }
  }
  if (creditByKey.size === 0) return () => 0;
  const applied = allocateSourceCredits(
    charges.map(({ charge, key }) => ({ key, amount: toNumber(charge.amount), paid: 0 })),
    creditByKey
  );
  const byCharge = new Map(charges.map(({ charge }, i) => [charge, applied[i]]));
  return (charge) => byCharge.get(charge) ?? 0;
}
function condenseIntoOneLine(charges) {
  if (charges.length === 0) return null;
  const line = startLine(charges[0]);
  for (const charge of charges) {
    line.count += 1;
    line.amount += toNumber(charge.amount);
    line.charges.push(charge);
  }
  return finishLine(line);
}
function rollupProgramInvoice(argroups) {
  const condensed = /* @__PURE__ */ new Map();
  const rooftops = /* @__PURE__ */ new Map();
  for (const argroup of argroups) {
    if (argroup.status == null) {
      throw new Error("rollupProgramInvoice: argroup has no status; select argroups.status so superseded groups can be left out");
    }
  }
  const current = argroups.filter((argroup) => argroup.status === CURRENT_ARGROUP_STATUS);
  const creditFor = creditsByCharge(current);
  for (const argroup of current) {
    const customerId = toId(argroup.customer?.id ?? argroup.customer_id);
    const rooftopKey = rooftopKeyFor(customerId);
    let rooftop = rooftops.get(rooftopKey);
    if (!rooftop) {
      rooftop = {
        customerId,
        customerName: rooftopNameFor(customerId, argroup.customer?.name),
        argroups: [],
        charges: [],
        moves: /* @__PURE__ */ new Set(),
        linesByKey: /* @__PURE__ */ new Map()
      };
      rooftops.set(rooftopKey, rooftop);
    }
    rooftop.argroups.push(argroup);
    for (const charge of argroup.archarges) {
      if (CONDENSED_CHARGE_TYPES.has(charge.type)) {
        addToLine(condensed, charge);
        continue;
      }
      addToLine(rooftop.linesByKey, charge);
      rooftop.charges.push(charge);
      if (charge.source_type === MOVE_SOURCE_TYPE && charge.source_id != null) {
        rooftop.moves.add(String(charge.source_id));
      }
    }
  }
  return {
    condensed: Array.from(condensed.values()).map((line) => finishLine(line, creditFor)),
    rooftops: Array.from(rooftops.values()).filter((rooftop) => rooftop.charges.length > 0).map((rooftop) => {
      const lines = Array.from(rooftop.linesByKey.values()).map((line) => finishLine(line, creditFor));
      return {
        customerId: rooftop.customerId,
        customerName: rooftop.customerName,
        moveCount: rooftop.moves.size,
        chargeCount: rooftop.charges.length,
        total: roundToCents(lines.reduce((sum2, line) => sum2 + line.amount, 0)),
        credit: roundToCents(lines.reduce((sum2, line) => sum2 + line.credit, 0)),
        lines,
        charges: rooftop.charges,
        argroups: rooftop.argroups
      };
    }).sort((a, b) => a.customerName.localeCompare(b.customerName) || (a.customerId ?? 0) - (b.customerId ?? 0))
  };
}
var CURRENT_ARGROUP_STATUS, MOVE_CHARGE_TYPE, PER_USE_CHARGE_TYPE, MOVE_SOURCE_TYPE, CONDENSED_CHARGE_TYPES, UNATTRIBUTED_ROOFTOP_NAME, rooftopNameFor, UNATTRIBUTED_ROOFTOP_KEY, ROLLUP_LINE_LABELS, toNumber, toId, roundToCents, accountingKeyOf, lineKeyFor, rooftopKeyFor, startLine, addToLine, finishLine, unitOf, bucketKeyOf;
var init_rollupByRooftop = __esm({
  "src/features/ar-invoices/program-rollup/rollupByRooftop.ts"() {
    init_accountingProductKeys();
    init_constants();
    init_allocateSourceCredits();
    CURRENT_ARGROUP_STATUS = "done";
    MOVE_CHARGE_TYPE = "move";
    PER_USE_CHARGE_TYPE = "per_use";
    MOVE_SOURCE_TYPE = "move";
    CONDENSED_CHARGE_TYPES = /* @__PURE__ */ new Set([
      PER_USE_CHARGE_TYPE,
      ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE,
      ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE,
      ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE
    ]);
    UNATTRIBUTED_ROOFTOP_NAME = "Program";
    rooftopNameFor = (customerId, customerName) => customerName?.trim() || (customerId == null ? UNATTRIBUTED_ROOFTOP_NAME : `Customer #${customerId}`);
    UNATTRIBUTED_ROOFTOP_KEY = "none";
    ROLLUP_LINE_LABELS = {
      [MOVE_CHARGE_TYPE]: "Move Coverage",
      [PER_USE_CHARGE_TYPE]: "Per Use Charges",
      [PROCESSING_FEE_CHARGE_TYPE]: "Processing Fee",
      [ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE]: "Activated Valet Retailer Rooftops",
      [ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE]: "Activated Mobile Service Retailer Rooftops",
      [ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE]: "Activated Parts Delivery Retailer Rooftops"
    };
    toNumber = (value) => Number(value ?? 0) || 0;
    toId = (value) => value == null ? null : Number(value);
    roundToCents = (amount) => Math.round(amount * 100) / 100;
    accountingKeyOf = (charge) => charge.accounting_key?.trim() ? charge.accounting_key : null;
    lineKeyFor = (charge) => {
      const accountingKey = accountingKeyOf(charge);
      return accountingKey ? `key:${accountingKey}` : `nokey:${charge.type}`;
    };
    rooftopKeyFor = (customerId) => customerId == null ? UNATTRIBUTED_ROOFTOP_KEY : String(customerId);
    startLine = (charge) => ({
      accountingKey: accountingKeyOf(charge),
      type: charge.type,
      label: ROLLUP_LINE_LABELS[charge.type] ?? charge.name ?? charge.type,
      count: 0,
      amount: 0,
      credit: 0,
      charges: []
    });
    addToLine = (lines, charge) => {
      const key = lineKeyFor(charge);
      let line = lines.get(key);
      if (!line) {
        line = startLine(charge);
        lines.set(key, line);
      }
      line.count += 1;
      line.amount += toNumber(charge.amount);
      line.charges.push(charge);
    };
    finishLine = (line, creditFor = () => 0) => ({
      ...line,
      amount: roundToCents(line.amount),
      credit: roundToCents(line.charges.reduce((sum2, charge) => sum2 + creditFor(charge), 0))
    });
    unitOf = (argroup) => ({
      programId: toId(argroup.program_id),
      customerId: toId(argroup.customer?.id ?? argroup.customer_id)
    });
    bucketKeyOf = (argroup, row) => row.source_type && row.source_id != null ? creditBucketKey(unitOf(argroup), row.source_type, String(row.source_id)) : null;
  }
});

// src/features/ar-invoices/invoice-lines/invoiceLines.ts
function getCurrentArgroups(argroups = []) {
  return argroups.filter((group) => group.status !== HISTORICAL_ARGROUP_STATUS);
}
function resolveChargeMove(charge) {
  const sourceType = charge?.source_type;
  if (sourceType === "move" && charge.move?.length > 0) return charge.move[0];
  if (sourceType === "accessorial" && charge.accessorial?.length > 0) return charge.accessorial[0]?.move || null;
  if (sourceType === "ridehail" && charge.ridehail?.length > 0) return charge.ridehail[0]?.move || null;
  return null;
}
function resolveChargeGuestride(charge) {
  if (charge?.source_type !== "guestride") return null;
  if (charge.guestride?.length > 0) return charge.guestride[0];
  return null;
}
function formatAddressShort(address) {
  if (!address) return "";
  return address.split(",").map((part) => part.trim()).slice(0, 2).join(", ");
}
function groupChargesByMove(argroups = []) {
  const groups = /* @__PURE__ */ new Map();
  const moveGroupById = (moveId, move, scenarioId) => {
    const key = `move-${moveId}`;
    let group = groups.get(key);
    if (!group) {
      group = { groupKey: key, sourceKind: "move", moveId, move, moves: [move], charges: [], credits: [], total: 0, scenarioId };
      groups.set(key, group);
    }
    return group;
  };
  const guestrideGroup = (guestride, scenarioId) => {
    const key = `guestride-${guestride.id}`;
    let group = groups.get(key);
    if (!group) {
      group = {
        groupKey: key,
        sourceKind: "guestride",
        moveId: guestride.id,
        move: null,
        moves: [],
        guestride,
        charges: [],
        credits: [],
        total: 0,
        scenarioId
      };
      groups.set(key, group);
    }
    return group;
  };
  const unplacedCharges = /* @__PURE__ */ new Map();
  const unplacedCredits = /* @__PURE__ */ new Map();
  const unplaced = (map, scenarioId, item) => {
    if (scenarioId == null) return;
    const key = String(scenarioId);
    map.set(key, [...map.get(key) ?? [], item]);
  };
  for (const argroup of getCurrentArgroups(argroups)) {
    const archarges = argroup.archarges ?? [];
    const ordered = [
      ...archarges.filter((charge) => charge.source_type === "move"),
      ...archarges.filter((charge) => charge.source_type !== "move")
    ];
    for (const rawCharge of ordered) {
      const charge = { ...rawCharge, algorithm_key: rawCharge.algorithm_key ?? argroup.algorithm_key };
      if (charge.source_type === PRODUCT_SOURCE_TYPE) continue;
      if (isPerUseCharge(charge)) continue;
      if (charge.argroup?.status === HISTORICAL_ARGROUP_STATUS) continue;
      if (charge.source_type === "accessorial") {
        const accessorial = charge.accessorial?.[0];
        if (accessorial?.move_id) {
          moveGroupById(accessorial.move_id, accessorial.move, argroup.scenario_id).charges.push(charge);
        }
        continue;
      }
      if (charge.source_type === "guestride") {
        const guestride = resolveChargeGuestride(charge);
        if (guestride) guestrideGroup(guestride, argroup.scenario_id).charges.push(charge);
        continue;
      }
      const move = resolveChargeMove(charge);
      if (!move) {
        unplaced(unplacedCharges, argroup.scenario_id, charge);
        continue;
      }
      const row = moveGroupById(move.id, move, argroup.scenario_id);
      row.charges.push(charge);
      if (charge.source_type === "move" && move.accessorials) {
        for (const accessorial of move.accessorials) {
          for (const accessorialCharge of accessorial.archarges ?? []) {
            if (accessorialCharge.argroup?.status !== HISTORICAL_ARGROUP_STATUS) row.charges.push(accessorialCharge);
          }
          for (const accessorialCredit of accessorial.arcredits ?? []) {
            if (accessorialCredit.argroup?.status !== HISTORICAL_ARGROUP_STATUS) row.credits.push(accessorialCredit);
          }
        }
      }
    }
    for (const credit of argroup.arcredits ?? []) {
      const sourceType = credit.source_type;
      if (sourceType === "guestride" && credit.guestride?.length > 0) {
        guestrideGroup(credit.guestride[0], argroup.scenario_id).credits.push(credit);
        continue;
      }
      if (sourceType === "accessorial" && credit.accessorial?.length > 0) {
        const accessorial = credit.accessorial[0];
        if (accessorial?.move_id) {
          moveGroupById(accessorial.move_id, accessorial.move, argroup.scenario_id).credits.push(credit);
        } else if (accessorial?.move) {
          moveGroupById(accessorial.move.id, accessorial.move, argroup.scenario_id).credits.push(credit);
        }
        continue;
      }
      let move = null;
      if (sourceType === "move" && credit.move?.length > 0) move = credit.move[0];
      else if (sourceType === "ridehail" && credit.ridehail?.length > 0) move = credit.ridehail[0]?.move;
      if (move) moveGroupById(move.id, move, argroup.scenario_id).credits.push(credit);
      else unplaced(unplacedCredits, argroup.scenario_id, credit);
    }
  }
  const rows = combineScenarioRows(Array.from(groups.values()), unplacedCharges, unplacedCredits);
  for (const group of rows) {
    const charged = group.charges.reduce((sum2, charge) => sum2 + toNumber2(charge.amount), 0);
    const credited = group.credits.reduce((sum2, credit) => sum2 + toNumber2(credit.amount), 0);
    group.total = charged - credited;
  }
  return rows;
}
function anchorScore(row) {
  return scenarioLegScore(row.move, row.charges.some((charge) => charge.source_type === "move"));
}
function scenarioLegScore(move, billedDirectly) {
  let score = 0;
  if (move?.move_type === "ride") score -= 4;
  if (move?.consumer_type === "customer") score += 2;
  if (billedDirectly) score += 1;
  return score;
}
function combineScenarioRows(rows, unplacedCharges, unplacedCredits) {
  const byScenario = /* @__PURE__ */ new Map();
  for (const row of rows) {
    if (row.sourceKind !== "move" || row.scenarioId == null) continue;
    const key = String(row.scenarioId);
    byScenario.set(key, [...byScenario.get(key) ?? [], row]);
  }
  const combined = /* @__PURE__ */ new Map();
  for (const [key, legs] of byScenario) {
    const anchor = legs.reduce((best, leg) => anchorScore(leg) > anchorScore(best) ? leg : best);
    const ordered = [anchor, ...legs.filter((leg) => leg !== anchor)];
    combined.set(key, {
      ...anchor,
      moves: ordered.map((leg) => leg.move),
      charges: [...ordered.flatMap((leg) => leg.charges), ...unplacedCharges.get(key) ?? []],
      credits: [...ordered.flatMap((leg) => leg.credits), ...unplacedCredits.get(key) ?? []]
    });
  }
  const out = [];
  const emitted = /* @__PURE__ */ new Set();
  for (const row of rows) {
    const key = row.sourceKind === "move" && row.scenarioId != null ? String(row.scenarioId) : null;
    if (key == null) {
      out.push(row);
    } else if (!emitted.has(key)) {
      emitted.add(key);
      out.push(combined.get(key));
    }
  }
  return out;
}
function invoiceVehicleMoves(rows) {
  const seen = /* @__PURE__ */ new Map();
  for (const row of rows) {
    if (row.sourceKind !== "move") continue;
    for (const move of row.moves ?? []) {
      if (!move || move.move_type === "ride") continue;
      const key = String(move.id);
      if (!seen.has(key)) seen.set(key, move);
    }
  }
  return Array.from(seen.values());
}
function getProductCharges(argroups = []) {
  return getCurrentArgroups(argroups).flatMap(
    (group) => (group.archarges ?? []).filter((charge) => charge.source_type === PRODUCT_SOURCE_TYPE)
  );
}
function getOtherCharges(argroups = []) {
  const placed = /* @__PURE__ */ new Set();
  for (const row of groupChargesByMove(argroups)) {
    for (const charge of row.charges) {
      const key = chargeKey(charge);
      if (key != null) placed.add(key);
    }
  }
  return getCurrentArgroups(argroups).flatMap(
    (group) => (group.archarges ?? []).filter((charge) => {
      const key = chargeKey(charge);
      if (key == null || placed.has(key)) return false;
      if (charge.source_type === PRODUCT_SOURCE_TYPE || isPerUseCharge(charge)) return false;
      if (charge.type === PROCESSING_FEE_TYPE || charge.source_type === PROCESSING_FEE_SOURCE_TYPE2) return false;
      if (charge.argroup?.status === HISTORICAL_ARGROUP_STATUS) return false;
      if (charge.source_type === "accessorial" && !charge.accessorial) return false;
      return true;
    })
  );
}
function condensePerUseCharges(argroups = []) {
  const charges = getCurrentArgroups(argroups).flatMap((group) => (group.archarges ?? []).filter(isPerUseCharge));
  const line = condenseIntoOneLine(charges);
  return line ? { ...line, unitAmount: toNumber2(charges[0].amount) } : null;
}
function describePerUseLine(line) {
  return `${line.count} per use charge${line.count === 1 ? "" : "s"} at ${usd.format(line.unitAmount)} each`;
}
var HISTORICAL_ARGROUP_STATUS, PRODUCT_SOURCE_TYPE, PROCESSING_FEE_TYPE, PROCESSING_FEE_SOURCE_TYPE2, toNumber2, isPerUseCharge, chargeKey, usd;
var init_invoiceLines = __esm({
  "src/features/ar-invoices/invoice-lines/invoiceLines.ts"() {
    init_rollupByRooftop();
    HISTORICAL_ARGROUP_STATUS = "historical";
    PRODUCT_SOURCE_TYPE = "product";
    PROCESSING_FEE_TYPE = "processing_fee";
    PROCESSING_FEE_SOURCE_TYPE2 = "arpayment";
    toNumber2 = (value) => Number(value ?? 0) || 0;
    isPerUseCharge = (charge) => charge.type === PER_USE_CHARGE_TYPE;
    chargeKey = (charge) => charge.id == null ? null : String(charge.id);
    usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 });
  }
});

// src/features/ar-invoices/invoice-lines/invoicePdfRows.ts
function movePdfRow(invoice, group) {
  const guestride = group.guestride;
  const move = group.sourceKind === "guestride" ? {
    // A guest ride has no move record, so the row gets the fields the layout reads.
    id: `R-#${guestride?.id}`,
    reference_num: guestride?.reference_num || null,
    vehicle_stock: null,
    vehicle_vin: null,
    lane: {
      description: (() => {
        const pickup = formatAddressShort(guestride?.pickup_address);
        const dropoff = formatAddressShort(guestride?.dropoff_address);
        return pickup && dropoff ? `${pickup} to ${dropoff}` : pickup || dropoff || "Unknown Lane";
      })()
    }
  } : group.move;
  return {
    type: "move",
    disputed: false,
    billable_datetime: earliestBillable(group.charges),
    due_amount: group.total,
    discount_amount: 0,
    invoice_id: invoice.id,
    move,
    details: group.charges.map((charge) => ({ name: charge.name, notes: charge.notes }))
  };
}
function buildInvoicePdfRows(invoice) {
  if (invoice.invoice_type === PROGRAM_INVOICE_TYPE) return programRows(invoice);
  const argroups = invoice.argroups ?? [];
  const moveRows = groupChargesByMove(argroups).map((group) => movePdfRow(invoice, group));
  const productRows = getProductCharges(argroups).map(
    (product) => productRow(invoice, product.name, product.notes, Number(product.amount || 0), product.billable_datetime)
  );
  const otherRows = getOtherCharges(argroups).map(
    (charge) => productRow(invoice, charge.name, charge.notes, Number(charge.amount || 0), charge.billable_datetime)
  );
  const perUse = condensePerUseCharges(argroups);
  const perUseRows = perUse ? [productRow(invoice, perUse.label, describePerUseLine(perUse), perUse.amount, null)] : [];
  return [...moveRows, ...productRows, ...otherRows, ...perUseRows];
}
var earliestBillable, hasStatus, productRow, programRows;
var init_invoicePdfRows = __esm({
  "src/features/ar-invoices/invoice-lines/invoicePdfRows.ts"() {
    init_programInvoiceManager();
    init_rollupByRooftop();
    init_invoiceLines();
    earliestBillable = (charges) => {
      const stamps = charges.map((charge) => charge.billable_datetime).filter((stamp) => Boolean(stamp));
      if (!stamps.length) return null;
      return stamps.reduce((min, stamp) => new Date(stamp) < new Date(min) ? stamp : min);
    };
    hasStatus = (group) => typeof group.status === "string";
    productRow = (invoice, name, notes, amount, billableDatetime) => ({
      type: "product",
      disputed: false,
      billable_datetime: billableDatetime,
      due_amount: amount,
      discount_amount: 0,
      invoice_id: invoice.id,
      details: [{ name, notes }]
    });
    programRows = (invoice) => {
      const argroups = invoice.argroups ?? [];
      if (!argroups.every(hasStatus)) {
        throw new Error("Program invoice PDF: an argroup has no status; select argroups.status so superseded groups can be left out");
      }
      const rollup = rollupProgramInvoice(argroups);
      return [
        ...rollup.rooftops.flatMap(
          (rooftop) => rooftop.lines.map(
            (line) => productRow(invoice, rooftop.customerName, describeRollupLine(line), line.amount, invoice.start_datetime)
          )
        ),
        ...rollup.condensed.map(
          (line) => productRow(invoice, line.label, `${line.count} charge${line.count === 1 ? "" : "s"}`, line.amount, invoice.start_datetime)
        )
      ];
    };
  }
});

// src/features/ar-payments/orchestration/batchedReads.ts
function chunk(items, size = READ_BATCH_SIZE) {
  const chunks = [];
  for (let i = 0; i < items.length; i += size) chunks.push(items.slice(i, i + size));
  return chunks;
}
async function limitedRead(read) {
  if (inFlight >= MAX_READS_IN_FLIGHT) {
    await new Promise((resolve) => waiting.push(resolve));
  } else {
    inFlight++;
  }
  try {
    return await read();
  } finally {
    const next = waiting.shift();
    if (next) next();
    else inFlight--;
  }
}
var READ_BATCH_SIZE, MAX_READS_IN_FLIGHT, inFlight, waiting;
var init_batchedReads = __esm({
  "src/features/ar-payments/orchestration/batchedReads.ts"() {
    READ_BATCH_SIZE = 500;
    MAX_READS_IN_FLIGHT = 6;
    inFlight = 0;
    waiting = [];
  }
});

// src/features/ar-payments/orchestration/loadAmountDueInputs.ts
function sourceBatches(keys) {
  const idsByType = /* @__PURE__ */ new Map();
  for (const key of keys) {
    const [sourceType, sourceId] = key.split("|");
    const ids = idsByType.get(sourceType) ?? [];
    ids.push(Number(sourceId));
    idsByType.set(sourceType, ids);
  }
  return Array.from(idsByType).flatMap(
    ([sourceType, ids]) => chunk(ids).map((sourceIds) => ({ sourceType, sourceIds }))
  );
}
function hasSource(charge) {
  return Boolean(charge.sourceType) && charge.sourceId != null && Number.isFinite(Number(charge.sourceId));
}
async function loadAmountDueInputs(executor, selected) {
  const creditBatches = sourceBatches(new Set(selected.filter(hasSource).map((c) => `${c.sourceType}|${c.sourceId}`)));
  const creditResults = await Promise.allSettled(
    creditBatches.map(
      (batch) => limitedRead(
        () => executor.query(
          GetArcreditsForSourcesDocument,
          batch
        )
      )
    )
  );
  const failures = creditResults.flatMap(
    (result, i) => result.status === "rejected" ? [{ sources: creditBatches[i].sourceIds.map((id) => `${creditBatches[i].sourceType}:${id}`), reason: result.reason }] : []
  );
  if (failures.length > 0) {
    throw new CreditReadError(failures.flatMap((f) => f.sources), failures[0].reason);
  }
  const loaded = creditResults.filter(
    (result) => result.status === "fulfilled"
  );
  const credits = loaded.flatMap(
    (result) => (result.value.arcredits || []).map((c) => ({
      id: Number(c.id),
      argroupId: Number(c.argroup_id),
      amount: Number(c.amount),
      type: c.type,
      sourceType: c.source_type,
      sourceId: String(c.source_id),
      active: c.active,
      notes: null,
      createdAt: c.createdat,
      customerId: c.argroup?.customer_id != null ? Number(c.argroup.customer_id) : null,
      programId: c.argroup?.program_id != null ? Number(c.argroup.program_id) : null,
      invoiceId: c.argroup?.arinvoice_id != null ? Number(c.argroup.arinvoice_id) : null
    }))
  );
  const argroupIds = Array.from(new Set(selected.map((c) => c.argroupId)));
  const creditedBatches = sourceBatches(new Set(credits.map((c) => `${c.sourceType}|${c.sourceId}`)));
  const [siblingResults, sourceResults] = await Promise.all([
    Promise.all(
      chunk(argroupIds).map(
        (ids) => limitedRead(
          () => executor.query(
            GetArchargesByArgroupsDocument,
            { argroupIds: ids }
          )
        )
      )
    ),
    Promise.all(
      creditedBatches.map(
        (batch) => limitedRead(
          () => executor.query(
            GetCreditedSourcesChargesDocument,
            batch
          )
        )
      )
    )
  ]);
  const rows = /* @__PURE__ */ new Map();
  for (const c of [...siblingResults.flatMap((r) => r.archarges || []), ...sourceResults.flatMap((r) => r.archarges || [])]) {
    if (!rows.has(Number(c.id))) rows.set(Number(c.id), c);
  }
  const charges = Array.from(rows.values()).map((c) => ({
    id: Number(c.id),
    argroupId: Number(c.argroup_id),
    amount: Number(c.amount),
    sourceType: c.source_type,
    sourceId: String(c.source_id),
    active: true,
    type: "",
    name: "",
    customerId: c.argroup?.customer_id != null ? Number(c.argroup.customer_id) : null,
    programId: c.argroup?.program_id != null ? Number(c.argroup.program_id) : null,
    invoiceId: c.argroup?.arinvoice_id != null ? Number(c.argroup.arinvoice_id) : null,
    createdAt: ""
  }));
  const paymentDetails = Array.from(rows.values()).flatMap(
    (c) => (c.arpaymentdetails || []).map((detail) => ({
      arpaymentId: Number(detail.payment_id),
      archargeId: Number(detail.archarge_id),
      amount: Number(detail.amount),
      paymentStatus: detail.parent?.status
    }))
  );
  return { charges, credits, paymentDetails };
}
var SOURCES_NAMED_IN_MESSAGE, CreditReadError;
var init_loadAmountDueInputs = __esm({
  "src/features/ar-payments/orchestration/loadAmountDueInputs.ts"() {
    init_schema();
    init_batchedReads();
    SOURCES_NAMED_IN_MESSAGE = 5;
    CreditReadError = class extends Error {
      constructor(sources, cause) {
        const named = sources.slice(0, SOURCES_NAMED_IN_MESSAGE).join(", ");
        const rest = sources.length - SOURCES_NAMED_IN_MESSAGE;
        super(
          `Could not read the credits for ${sources.length} source${sources.length === 1 ? "" : "s"}: ${named}` + (rest > 0 ? ` and ${rest} more` : "")
        );
        this.name = "CreditReadError";
        this.sources = sources;
        this.cause = cause;
      }
    };
  }
});

// src/features/ar-payments/orchestration/getAmountDue.ts
import { resolveExecutor as resolveExecutor23 } from "@hopdrive/sdk-core";
async function loadSelectedCharges(executor, archargeIds) {
  const results = await Promise.all(
    chunk(archargeIds).map(
      (ids) => limitedRead(
        () => executor.query(GetAmountDueChargesDocument, {
          archargeIds: ids
        })
      )
    )
  );
  return results.flatMap((result) => result.archarges || []).map((c) => ({
    id: Number(c.id),
    argroupId: Number(c.argroup_id),
    amount: Number(c.amount),
    sourceType: c.source_type,
    sourceId: String(c.source_id),
    active: c.active,
    type: c.type,
    name: c.name,
    createdAt: c.createdat,
    customerId: c.argroup?.customer_id != null ? Number(c.argroup.customer_id) : null,
    programId: c.argroup?.program_id != null ? Number(c.argroup.program_id) : null
  }));
}
async function getAmountDue(input, options = {}) {
  const archargeIds = input.archargeIds.map((id) => Number(id));
  if (archargeIds.length === 0) return NOTHING_DUE;
  const executor = resolveExecutor23(options.executor);
  const selected = await loadSelectedCharges(executor, archargeIds);
  if (selected.length === 0) return NOTHING_DUE;
  const inputs = await loadAmountDueInputs(executor, selected);
  return calculateAmountDue({
    ...inputs,
    selectedIds: selected.map((c) => c.id),
    requestedAmount: input.requestedAmount,
    strictAmount: input.strictAmount,
    paymentMethodType: input.paymentMethodType
  });
}
async function getNetDueForEach(sets, options = {}) {
  const idSets = sets.map((set) => set.map((id) => Number(id)));
  const archargeIds = Array.from(new Set(idSets.flat()));
  if (archargeIds.length === 0) return idSets.map(() => 0);
  const executor = resolveExecutor23(options.executor);
  const selected = await loadSelectedCharges(executor, archargeIds);
  if (selected.length === 0) return idSets.map(() => 0);
  const inputs = await loadAmountDueInputs(executor, selected);
  const loaded = new Set(selected.map((c) => c.id));
  const inputsFor = inputsBySet(inputs);
  return idSets.map((ids) => {
    const selectedIds = ids.filter((id) => loaded.has(id));
    return selectedIds.length === 0 ? 0 : calculateAmountDue({ ...inputsFor(selectedIds), selectedIds }).netDue;
  });
}
function inputsBySet(inputs) {
  const chargeKeys = inputs.charges.map((c) => creditBucketKey(c, c.sourceType, c.sourceId));
  const indexById = new Map(inputs.charges.map((c, i) => [c.id, i]));
  const indicesByKey = groupBy(chargeKeys.map((key, i) => ({ key, i })), (entry) => entry.key);
  const creditsByKey = groupBy(inputs.credits, (credit) => creditBucketKey(credit, credit.sourceType, credit.sourceId));
  const paymentsByCharge = groupBy(inputs.paymentDetails, (detail) => detail.archargeId);
  return (selectedIds) => {
    const keys = /* @__PURE__ */ new Set();
    for (const id of selectedIds) {
      const i = indexById.get(id);
      if (i !== void 0) keys.add(chargeKeys[i]);
    }
    const indices = Array.from(keys).flatMap((key) => (indicesByKey.get(key) ?? []).map((entry) => entry.i)).sort((a, b) => a - b);
    const charges = indices.map((i) => inputs.charges[i]);
    return {
      charges,
      credits: Array.from(keys).flatMap((key) => creditsByKey.get(key) ?? []),
      paymentDetails: charges.flatMap((c) => paymentsByCharge.get(c.id) ?? [])
    };
  };
}
function groupBy(items, keyOf) {
  const groups = /* @__PURE__ */ new Map();
  for (const item of items) {
    const key = keyOf(item);
    const group = groups.get(key);
    if (group) group.push(item);
    else groups.set(key, [item]);
  }
  return groups;
}
function getNetDueForEachBatched(sets, options = {}) {
  const ask = (resolve, reject) => ({
    sets: sets.map((set) => set.map((id) => Number(id))),
    resolve,
    reject
  });
  return new Promise((resolve, reject) => {
    const waiting2 = pendingAsks.get(options.executor);
    if (waiting2) {
      waiting2.push(ask(resolve, reject));
      return;
    }
    pendingAsks.set(options.executor, [ask(resolve, reject)]);
    setTimeout(() => void answerPendingAsks(options.executor), 0);
  });
}
async function answerPendingAsks(executor) {
  const asks = pendingAsks.get(executor) ?? [];
  pendingAsks.delete(executor);
  let amounts;
  try {
    amounts = await getNetDueForEach(asks.flatMap((ask) => ask.sets), { executor });
  } catch (error) {
    if (asks.length === 1) {
      asks[0].reject(error);
      return;
    }
    await Promise.all(asks.map((ask) => getNetDueForEach(ask.sets, { executor }).then(ask.resolve, ask.reject)));
    return;
  }
  let next = 0;
  for (const ask of asks) {
    ask.resolve(amounts.slice(next, next + ask.sets.length));
    next += ask.sets.length;
  }
}
var NOTHING_DUE, pendingAsks;
var init_getAmountDue = __esm({
  "src/features/ar-payments/orchestration/getAmountDue.ts"() {
    init_schema();
    init_amountDue();
    init_allocateSourceCredits();
    init_loadAmountDueInputs();
    init_batchedReads();
    NOTHING_DUE = {
      charges: [],
      netDue: 0,
      amountToCharge: 0,
      processingFee: 0,
      totalToCharge: 0,
      exceedsNetDue: false
    };
    pendingAsks = /* @__PURE__ */ new Map();
  }
});

// src/features/ar-invoices/invoice-lines/invoiceAmountDue.ts
function invoiceAmountDueChargeIds(argroups = []) {
  return amountDueChargeIds(getCurrentArgroups(argroups).flatMap((group) => group.archarges ?? []));
}
function amountDueChargeIds(charges = []) {
  return charges.filter((charge) => charge.active !== false && charge.type !== PROCESSING_FEE_CHARGE_TYPE).map((charge) => Number(charge.id));
}
async function getInvoiceAmountDue(argroups = []) {
  const answer = await getAmountDue({ archargeIds: invoiceAmountDueChargeIds(argroups) });
  return answer.netDue;
}
async function getChargesAmountDue(charges = []) {
  const answer = await getAmountDue({ archargeIds: amountDueChargeIds(charges) });
  return answer.netDue;
}
async function getChargeGroupsAmountDue(groups = []) {
  return getNetDueForEach(groups.map((group) => amountDueChargeIds(group)));
}
function listedInvoiceAmountDue(argroups = []) {
  const groups = getCurrentArgroups(argroups);
  const selectedIds = invoiceAmountDueChargeIds(groups);
  if (selectedIds.length === 0) return 0;
  const unitOf2 = (group) => ({
    customerId: group.customer_id != null ? Number(group.customer_id) : null,
    programId: group.program_id != null ? Number(group.program_id) : null
  });
  const credits = groups.flatMap(
    (group) => (group.arcredits ?? []).filter((credit) => credit.source_type && credit.source_id != null).map((credit) => ({
      id: Number(credit.id),
      argroupId: Number(group.id),
      amount: Number(credit.amount),
      type: "credit_memo",
      sourceType: String(credit.source_type),
      sourceId: String(credit.source_id),
      active: true,
      createdAt: "",
      ...unitOf2(group)
    }))
  );
  const selected = new Set(selectedIds);
  const creditedKeys = new Set(credits.map((credit) => creditBucketKey(credit, credit.sourceType, credit.sourceId)));
  const charges = [];
  for (const group of groups) {
    const rows = (group.archarges ?? []).filter((row) => row.active !== false);
    const groupHasSelected = rows.some((row) => selected.has(Number(row.id)));
    for (const row of rows) {
      const charge = {
        id: Number(row.id),
        argroupId: Number(group.id),
        amount: Number(row.amount),
        sourceType: String(row.source_type),
        sourceId: String(row.source_id),
        active: true,
        type: row.type ?? "",
        name: "",
        createdAt: "",
        ...unitOf2(group)
      };
      if (groupHasSelected || creditedKeys.has(creditBucketKey(charge, charge.sourceType, charge.sourceId))) {
        charges.push({ charge, row });
      }
    }
  }
  const paymentDetails = charges.flatMap(
    ({ charge, row }) => (row.arpaymentdetails ?? []).map((detail) => ({
      arpaymentId: 0,
      archargeId: charge.id,
      amount: Number(detail.amount),
      paymentStatus: detail.parent?.status
    }))
  );
  return calculateAmountDue({ charges: charges.map((c) => c.charge), credits, paymentDetails, selectedIds }).netDue;
}
var init_invoiceAmountDue = __esm({
  "src/features/ar-invoices/invoice-lines/invoiceAmountDue.ts"() {
    init_constants();
    init_amountDue();
    init_getAmountDue();
    init_allocateSourceCredits();
    init_invoiceLines();
  }
});

// src/features/ar-payments/validation/validatePaymentInput.ts
function validatePaymentInput(input) {
  const errors = [];
  if (!input.customerId || input.customerId <= 0) {
    errors.push("Customer ID is required and must be positive");
  }
  if (input.amount === void 0 || input.amount === null) {
    errors.push("Payment amount is required");
  } else if (input.amount < 0) {
    errors.push("Payment amount cannot be negative");
  } else if (input.amount === 0) {
    errors.push("Payment amount must be greater than zero");
  }
  if (!input.archargeIds || input.archargeIds.length === 0) {
    errors.push("At least one archarge ID is required");
  } else {
    const uniqueIds = new Set(input.archargeIds);
    if (uniqueIds.size !== input.archargeIds.length) {
      errors.push("Duplicate archarge IDs are not allowed");
    }
    if (input.archargeIds.some((id) => id <= 0)) {
      errors.push("All archarge IDs must be positive");
    }
  }
  if (!input.skipGateway && !input.requireGatewayMethod && !input.paymentMethod && !input.paymentMethodId) {
    errors.push("Payment method or payment method ID is required (unless skipGateway is true)");
  }
  if (input.manualAllocations && input.manualAllocations.length > 0) {
    const allocatedChargeIds = new Set(input.manualAllocations.map((a) => a.archargeId));
    for (const allocationChargeId of allocatedChargeIds) {
      if (!input.archargeIds.includes(allocationChargeId)) {
        errors.push(
          `Manual allocation references charge ${allocationChargeId} which is not in archargeIds`
        );
      }
    }
    if (input.manualAllocations.some((a) => a.amount < 0)) {
      errors.push("Manual allocation amounts cannot be negative");
    }
  }
  if (!input.createdBy || input.createdBy.trim().length === 0) {
    errors.push("createdBy is required");
  }
  return {
    valid: errors.length === 0,
    errors
  };
}
function validateChargesActive(archarges) {
  const errors = [];
  const inactiveCharges = archarges.filter((c) => !c.active);
  if (inactiveCharges.length > 0) {
    errors.push(
      `Cannot apply payment to inactive charges: ${inactiveCharges.map((c) => c.id).join(", ")}`
    );
  }
  return {
    valid: errors.length === 0,
    errors
  };
}
var init_validatePaymentInput = __esm({
  "src/features/ar-payments/validation/validatePaymentInput.ts"() {
  }
});

// src/features/ar-payments/utils/paymentLogger.ts
function createPaymentLogger() {
  return new PaymentLogger();
}
var PaymentLogger;
var init_paymentLogger = __esm({
  "src/features/ar-payments/utils/paymentLogger.ts"() {
    PaymentLogger = class {
      constructor() {
        this.notes = [];
      }
      /**
       * Add a note to the payment log
       */
      log(message) {
        const timestamp = (/* @__PURE__ */ new Date()).toISOString();
        this.notes.push(`[${timestamp}] ${message}`);
      }
      /**
       * Add a timestamped note with a label
       */
      logWithLabel(label, message) {
        const timestamp = (/* @__PURE__ */ new Date()).toISOString();
        this.notes.push(`[${timestamp}] [${label}] ${message}`);
      }
      /**
       * Log validation result
       */
      logValidation(valid, errors) {
        if (valid) {
          this.log("Validation: PASSED");
        } else {
          this.log(`Validation: FAILED - ${errors?.join(", ") || "Unknown error"}`);
        }
      }
      /**
       * Log gateway processing
       */
      logGateway(gatewayName, success, transactionId, error) {
        if (success) {
          this.log(`Gateway: ${gatewayName} - SUCCESS - Transaction ID: ${transactionId}`);
        } else {
          this.log(`Gateway: ${gatewayName} - FAILED - ${error || "Unknown error"}`);
        }
      }
      /**
       * Log payment allocation
       */
      logAllocation(archargeId, amount, netDue) {
        this.log(`Allocated $${amount.toFixed(2)} to charge ${archargeId} (net due: $${netDue.toFixed(2)})`);
      }
      /**
       * Log payment method
       */
      logPaymentMethod(paymentMethodId, type) {
        this.log(`Payment method: ${type} (ID: ${paymentMethodId})`);
      }
      /**
       * Get all notes as a single formatted string
       */
      getNotes() {
        return this.notes.join("\n");
      }
      /**
       * Check if logger has any notes
       */
      hasNotes() {
        return this.notes.length > 0;
      }
      /**
       * Clear all notes (useful for testing)
       */
      clear() {
        this.notes = [];
      }
    };
  }
});

// src/features/ar-payments/business-logic/allocatePayment.ts
function allocatePayment(paymentAmount, charges) {
  const roundedPayment = roundCurrency(paymentAmount);
  if (roundedPayment < 0) {
    throw new Error("Payment amount cannot be negative");
  }
  if (charges.length === 0) {
    return {
      allocations: [],
      unallocatedAmount: roundedPayment
    };
  }
  const sortedCharges = [...charges].sort((a, b) => {
    if (!currencyEquals(a.netDue, b.netDue)) {
      return b.netDue - a.netDue;
    }
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
  });
  const allocations = [];
  let remainingPayment = roundedPayment;
  for (const charge of sortedCharges) {
    if (remainingPayment <= 0) {
      break;
    }
    if (charge.netDue <= 0) {
      continue;
    }
    const amountToAllocate = roundCurrency(Math.min(remainingPayment, charge.netDue));
    if (amountToAllocate > 0) {
      allocations.push({
        archargeId: charge.archargeId,
        amount: amountToAllocate,
        netDue: charge.netDue
      });
      remainingPayment = roundCurrency(remainingPayment - amountToAllocate);
    }
  }
  return {
    allocations,
    unallocatedAmount: roundCurrency(remainingPayment)
  };
}
function validateManualAllocations(paymentAmount, allocations, charges) {
  const errors = [];
  const netDueMap = new Map(charges.map((c) => [c.archargeId, c.netDue]));
  const totalAllocated = sumCurrency(allocations.map((a) => a.amount));
  if (!currencyEquals(totalAllocated, paymentAmount)) {
    errors.push(
      `Allocations sum to $${totalAllocated.toFixed(2)}, but payment amount is $${paymentAmount.toFixed(2)}`
    );
  }
  for (const allocation of allocations) {
    const netDue = netDueMap.get(allocation.archargeId);
    if (netDue === void 0) {
      errors.push(`Charge ${allocation.archargeId} does not exist in the provided charges list`);
      continue;
    }
    if (allocation.amount < 0) {
      errors.push(`Allocation amount for charge ${allocation.archargeId} cannot be negative`);
    }
    if (currencyGreaterThan(allocation.amount, netDue)) {
      errors.push(
        `Allocation of $${allocation.amount.toFixed(2)} for charge ${allocation.archargeId} exceeds net due of $${netDue.toFixed(2)}`
      );
    }
  }
  return {
    valid: errors.length === 0,
    errors
  };
}
var init_allocatePayment = __esm({
  "src/features/ar-payments/business-logic/allocatePayment.ts"() {
    init_currency();
  }
});

// src/features/ar-payments/orchestration/helpers.ts
import { resolveExecutor as resolveExecutor40, getLogger as getLogger39 } from "@hopdrive/sdk-core";
async function processGatewayPayment(gateway, input) {
  const logger = getLogger39();
  const gatewayResult = await gateway.charge(input);
  if (!gatewayResult.success) {
    logger.error("Gateway charge failed", {
      gateway: gateway.getName(),
      error: gatewayResult.errorMessage
    });
    return {
      success: false,
      errorMessage: gatewayResult.errorMessage || "Gateway charge failed"
    };
  }
  return {
    success: true,
    transactionId: gatewayResult.transactionId,
    settlement: gatewayResult.settlement ?? "settled"
  };
}
async function processManualPayment(input, data, paymentLogger) {
  const executor = resolveExecutor40();
  const logger = getLogger39();
  let allocations;
  if (input.manualAllocations) {
    paymentLogger.log("Using manual allocations");
    const manualValidation = validateManualAllocations(
      input.amount,
      input.manualAllocations,
      data.netDueResults.map((r) => ({
        archargeId: r.archargeId,
        netDue: r.netDue,
        createdAt: data.archarges.find((c) => c.id === r.archargeId)?.createdAt || ""
      }))
    );
    if (!manualValidation.valid) {
      paymentLogger.logValidation(false, manualValidation.errors);
      logger.error("Manual allocation validation failed", {
        errors: manualValidation.errors
      });
      return {
        success: false,
        error: manualValidation.errors.join("; "),
        message: "Manual allocation validation failed"
      };
    }
    allocations = input.manualAllocations.map((a) => ({
      archargeId: a.archargeId,
      amount: a.amount,
      netDue: data.netDueResults.find((r) => r.archargeId === a.archargeId)?.netDue || 0
    }));
  } else {
    paymentLogger.log("Auto-allocating payment using largest-first strategy");
    const allocationResult = allocatePayment(
      input.amount,
      data.netDueResults.map((r) => ({
        archargeId: r.archargeId,
        netDue: r.netDue,
        createdAt: data.archarges.find((c) => c.id === r.archargeId)?.createdAt || ""
      }))
    );
    allocations = allocationResult.allocations;
    if (allocationResult.unallocatedAmount > 0) {
      paymentLogger.log(
        `WARNING: Unallocated amount: $${allocationResult.unallocatedAmount.toFixed(2)}`
      );
    }
  }
  allocations.forEach((a) => {
    paymentLogger.logAllocation(a.archargeId, a.amount, a.netDue);
  });
  paymentLogger.log(`Creating manual payment with ${allocations.length} allocations`);
  const paymentInsertResult = await executor.mutate(InsertArpaymentWithDetailsDocument, {
    object: {
      paymentmethod_id: input.paymentMethodId,
      invoice_id: input.invoiceId || null,
      amount: input.amount,
      gateway_transaction_id: input.gatewayTransactionId ?? null,
      status: "paid",
      failure_reason: null,
      notes: paymentLogger.getNotes(),
      createdby: input.createdBy || "system",
      // A new row was last updated by whoever created it.
      updatedby: input.createdBy || "system",
      details: {
        data: allocations.map((a) => ({
          archarge_id: a.archargeId,
          amount: a.amount
        }))
      }
    }
    // Type workaround: arpayments_insert_input not exposed in Hasura schema
  });
  const arpayment = paymentInsertResult.insert_arpayments_one;
  if (!arpayment) {
    logger.error("Failed to create manual payment record");
    return {
      success: false,
      error: "Failed to create payment record",
      message: "Payment processing failed"
    };
  }
  const arpaymentId = Number(arpayment.id);
  paymentLogger.log(`Created manual payment ${arpaymentId}`);
  logger.info("Manual payment processed successfully", {
    arpaymentId,
    amount: input.amount,
    allocations: allocations.length,
    customerId: input.customerId
  });
  return {
    success: true,
    arpaymentId,
    gatewayTransactionId: input.gatewayTransactionId,
    allocations,
    message: "Payment processed successfully"
  };
}
async function processGatewayPaymentFull(input, data, paymentMethod, gateway, paymentLogger) {
  const executor = resolveExecutor40();
  const logger = getLogger39();
  let allocations;
  if (input.manualAllocations) {
    paymentLogger.log("Using manual allocations");
    const manualValidation = validateManualAllocations(
      input.amount,
      input.manualAllocations,
      data.netDueResults.map((r) => ({
        archargeId: r.archargeId,
        netDue: r.netDue,
        createdAt: data.archarges.find((c) => c.id === r.archargeId)?.createdAt || ""
      }))
    );
    if (!manualValidation.valid) {
      paymentLogger.logValidation(false, manualValidation.errors);
      logger.error("Manual allocation validation failed", {
        errors: manualValidation.errors
      });
      return {
        success: false,
        error: manualValidation.errors.join("; "),
        message: "Manual allocation validation failed"
      };
    }
    allocations = input.manualAllocations.map((a) => ({
      archargeId: a.archargeId,
      amount: a.amount,
      netDue: data.netDueResults.find((r) => r.archargeId === a.archargeId)?.netDue || 0
    }));
  } else {
    paymentLogger.log("Auto-allocating payment using largest-first strategy");
    const allocationResult = allocatePayment(
      input.amount,
      data.netDueResults.map((r) => ({
        archargeId: r.archargeId,
        netDue: r.netDue,
        createdAt: data.archarges.find((c) => c.id === r.archargeId)?.createdAt || ""
      }))
    );
    allocations = allocationResult.allocations;
    if (allocationResult.unallocatedAmount > 0) {
      paymentLogger.log(
        `WARNING: Unallocated amount: $${allocationResult.unallocatedAmount.toFixed(2)}`
      );
    }
  }
  allocations.forEach((a) => {
    paymentLogger.logAllocation(a.archargeId, a.amount, a.netDue);
  });
  const isCardPayment = paymentMethod.type === "card";
  const { processingFee: processingFeeAmount, total: totalAmountToCharge } = gatewayChargeTotal(
    input.amount,
    paymentMethod.type
  );
  if (isCardPayment) {
    paymentLogger.log(
      `Card payment detected: base=$${input.amount.toFixed(2)}, fee=$${processingFeeAmount.toFixed(2)}, total=$${totalAmountToCharge.toFixed(2)}`
    );
  }
  paymentLogger.log(`Creating pending payment with ${allocations.length} allocations`);
  const paymentInsertResult = await executor.mutate(InsertArpaymentWithDetailsDocument, {
    object: {
      paymentmethod_id: input.paymentMethodId,
      invoice_id: input.invoiceId || null,
      amount: totalAmountToCharge,
      gateway_transaction_id: null,
      status: "pending",
      failure_reason: null,
      notes: paymentLogger.getNotes(),
      createdby: input.createdBy || "system",
      // A new row was last updated by whoever created it.
      updatedby: input.createdBy || "system",
      details: {
        data: allocations.map((a) => ({
          archarge_id: a.archargeId,
          amount: a.amount
        }))
      }
    }
    // Type workaround: arpayments_insert_input not exposed in Hasura schema
  });
  const arpayment = paymentInsertResult.insert_arpayments_one;
  if (!arpayment) {
    logger.error("Failed to create payment record");
    return {
      success: false,
      error: "Failed to create payment record",
      message: "Payment processing failed"
    };
  }
  const arpaymentId = Number(arpayment.id);
  paymentLogger.log(`Created pending payment ${arpaymentId}`);
  paymentLogger.log(`Processing gateway charge via ${gateway.getName()}`);
  const gatewayResult = await processGatewayPayment(gateway, {
    paymentMethod,
    amount: totalAmountToCharge,
    customerId: input.customerId,
    reference: input.notes,
    callMethod: input.callMethod,
    // The arpayment row already exists, so it is the one key a retried charge must share:
    // the gateway returns the same transaction instead of taking the money twice.
    idempotencyKey: `arpayment-${arpaymentId}`,
    // Rides on the gateway transaction so the settlement webhook can find this payment.
    metadata: {
      arpayment_id: String(arpaymentId),
      ...input.invoiceId ? { invoice_id: String(input.invoiceId) } : {}
    }
  });
  paymentLogger.logGateway(
    gateway.getName(),
    gatewayResult.success,
    gatewayResult.transactionId,
    gatewayResult.errorMessage
  );
  if (gatewayResult.success) {
    const settled = gatewayResult.settlement !== "pending";
    const status = "paid";
    await executor.mutate(
      UpdateArpaymentDocument,
      {
        paymentId: arpaymentId,
        updates: {
          status,
          gateway_transaction_id: gatewayResult.transactionId || null,
          updatedby: gateway.getName()
        }
      }
    );
    paymentLogger.log(`Updated payment ${arpaymentId} to ${status}`);
    let processingFeeError;
    if (isCardPayment) {
      const feeResult = await reconcileProcessingFee(arpaymentId, input.createdBy || "system");
      if (feeResult.success) {
        paymentLogger.log(`Recorded processing fee: archarge=${feeResult.archargeId}`);
      } else {
        processingFeeError = feeResult.error;
        paymentLogger.log(`ERROR: Processing fee not recorded: ${feeResult.error}`);
        logger.error("Card payment collected but its processing fee was not recorded", {
          arpaymentId,
          transactionId: gatewayResult.transactionId,
          error: feeResult.error
        });
      }
    }
    logger.info("Gateway payment processed successfully", {
      arpaymentId,
      amount: input.amount,
      allocations: allocations.length,
      customerId: input.customerId,
      transactionId: gatewayResult.transactionId,
      settlement: gatewayResult.settlement ?? "settled",
      processingFeeGenerated: isCardPayment && !processingFeeError
    });
    return {
      success: true,
      arpaymentId,
      gatewayTransactionId: gatewayResult.transactionId,
      settlement: gatewayResult.settlement ?? "settled",
      allocations,
      message: settled ? "Payment processed successfully" : "Bank payment submitted; it settles over the next few business days",
      processingFeeError
    };
  } else {
    await executor.mutate(
      UpdateArpaymentDocument,
      {
        paymentId: arpaymentId,
        updates: {
          status: "failed",
          failure_reason: gatewayResult.errorMessage || "Gateway charge failed",
          updatedby: gateway.getName()
        }
      }
    );
    paymentLogger.log(`Updated payment ${arpaymentId} to failed`);
    return {
      success: false,
      error: gatewayResult.errorMessage || "Gateway charge failed",
      message: "Payment processing failed"
    };
  }
}
var unverifiedBankAccountError;
var init_helpers = __esm({
  "src/features/ar-payments/orchestration/helpers.ts"() {
    init_schema();
    init_allocatePayment();
    init_reconcileProcessingFee();
    init_amountDue();
    unverifiedBankAccountError = (paymentMethodId) => `Payment method ${paymentMethodId} is a bank account still waiting on micro-deposit verification`;
  }
});

// src/features/ar-payments/orchestration/applyPayment.ts
import { resolveExecutor as resolveExecutor41, getLogger as getLogger40 } from "@hopdrive/sdk-core";
async function applyPayment(input, gateway) {
  const executor = resolveExecutor41();
  const logger = getLogger40();
  const paymentLogger = createPaymentLogger();
  try {
    paymentLogger.log("Payment processing started");
    const validation = validatePaymentInput(input);
    paymentLogger.logValidation(validation.valid, validation.errors);
    if (!validation.valid) {
      return {
        success: false,
        error: validation.errors.join("; "),
        message: "Payment input validation failed"
      };
    }
    paymentLogger.log("Fetching charges, payment details, and payment method");
    const dataResult = await executor.query(GetPaymentProcessingDataDocument, {
      archargeIds: input.archargeIds,
      customerId: input.customerId,
      paymentMethodId: input.paymentMethodId || -1
      // set this as a non-null value to avoid GraphQL validation error when fetching payment data later
    });
    const archarges = (dataResult.archarges || []).map((c) => ({
      id: Number(c.id),
      argroupId: Number(c.argroup_id),
      amount: Number(c.amount),
      sourceType: c.source_type,
      sourceId: String(c.source_id),
      active: c.active,
      type: c.type,
      name: c.name,
      accountingKey: c.accounting_key || null,
      createdAt: c.createdat,
      customerId: c.argroup?.customer_id != null ? Number(c.argroup.customer_id) : null,
      programId: c.argroup?.program_id != null ? Number(c.argroup.program_id) : null
    }));
    if (archarges.length === 0) {
      paymentLogger.log("ERROR: No charges found");
      return {
        success: false,
        error: "No charges found for the provided archarge IDs",
        message: "Payment processing failed"
      };
    }
    if (archarges.length !== input.archargeIds.length) {
      paymentLogger.log(
        `WARNING: Found ${archarges.length} charges but expected ${input.archargeIds.length}`
      );
    }
    const activeValidation = validateChargesActive(archarges);
    if (!activeValidation.valid) {
      paymentLogger.logValidation(false, activeValidation.errors);
      return {
        success: false,
        error: activeValidation.errors.join("; "),
        message: "Payment processing failed"
      };
    }
    let paymentMethod;
    if (input.paymentMethod) {
      paymentMethod = input.paymentMethod;
      paymentLogger.logPaymentMethod(paymentMethod.id, paymentMethod.type);
    } else if (input.paymentMethodId && dataResult.paymentMethodById.length > 0) {
      const pm = dataResult.paymentMethodById[0];
      if (pm.pending_setup_intent_id) {
        const error = unverifiedBankAccountError(Number(pm.id));
        paymentLogger.log(`ERROR: ${error}`);
        return { success: false, error, message: "Payment processing failed" };
      }
      paymentMethod = {
        id: Number(pm.id),
        customerId: Number(pm.customer_id),
        type: pm.type,
        active: pm.active,
        primary: pm.primary,
        gatewayToken: pm.gateway_token,
        accountNumber: pm.account_number ? Number(pm.account_number) : void 0,
        routingNumber: pm.routing_number ? Number(pm.routing_number) : void 0,
        accountType: pm.account_type || void 0,
        cardType: pm.card_type || void 0,
        expiration: pm.expiration ? Number(pm.expiration) : void 0,
        name: pm.name,
        source: pm.source,
        // The Stripe gateway charges with this customer, so Stripe refuses a method attached to
        // another customer instead of resolving the customer from the method.
        gateway: pm.gateway,
        stripeCustomerId: pm.customer?.stripe_customer_id ?? null
      };
      paymentLogger.logPaymentMethod(paymentMethod.id, paymentMethod.type);
    } else if (!input.skipGateway && dataResult.primaryPaymentMethod.length > 0) {
      const pm = dataResult.primaryPaymentMethod[0];
      paymentMethod = {
        id: Number(pm.id),
        customerId: Number(pm.customer_id),
        type: pm.type,
        active: pm.active,
        primary: pm.primary,
        gatewayToken: pm.gateway_token,
        accountNumber: pm.account_number ? Number(pm.account_number) : void 0,
        routingNumber: pm.routing_number ? Number(pm.routing_number) : void 0,
        accountType: pm.account_type || void 0,
        cardType: pm.card_type || void 0,
        expiration: pm.expiration ? Number(pm.expiration) : void 0,
        name: pm.name,
        source: pm.source,
        // The Stripe gateway charges with this customer, so Stripe refuses a method attached to
        // another customer instead of resolving the customer from the method.
        gateway: pm.gateway,
        stripeCustomerId: pm.customer?.stripe_customer_id ?? null
      };
      paymentLogger.logPaymentMethod(paymentMethod.id, paymentMethod.type);
    }
    if (!paymentMethod && !input.skipGateway) {
      paymentLogger.log("ERROR: Payment method not found");
      return {
        success: false,
        error: "Payment method not found",
        message: "Payment processing failed"
      };
    }
    if (input.requireGatewayMethod && (!paymentMethod || paymentMethod.type === "manual")) {
      paymentLogger.log("ERROR: No non-manual (gateway) payment method on record");
      return {
        success: false,
        error: "No non-manual payment method on record",
        message: "Payment processing failed"
      };
    }
    const { charges: sourceCharges, credits: allCredits, paymentDetails: sourcePaymentDetails } = await loadAmountDueInputs(executor, archarges);
    const amountDue = calculateAmountDue({
      charges: sourceCharges,
      selectedIds: archarges.map((c) => c.id),
      credits: allCredits,
      paymentDetails: sourcePaymentDetails,
      requestedAmount: input.amount,
      strictAmount: input.strictAmount
    });
    const netDueResults = amountDue.charges;
    paymentLogger.log(`Net due calculated for ${netDueResults.length} charges`);
    const totalNetDue = amountDue.netDue;
    paymentLogger.log(`Total net due: $${totalNetDue.toFixed(2)}`);
    if (amountDue.exceedsNetDue) {
      const message = `Amount $${input.amount.toFixed(2)} exceeds the amount due $${totalNetDue.toFixed(2)}`;
      paymentLogger.log(message);
      return { success: false, error: message, message: "Payment amount exceeds amount due" };
    }
    const amountToCharge = amountDue.amountToCharge;
    if (amountToCharge <= 0) {
      paymentLogger.log("Net due is zero after credits/prior payments \u2014 nothing to charge");
      return {
        success: true,
        allocations: [],
        message: "No balance due (net due is zero)"
      };
    }
    const processInput = {
      paymentMethodId: paymentMethod.id,
      invoiceId: input.invoiceId || null,
      amount: amountToCharge,
      archargeIds: input.archargeIds,
      customerId: input.customerId,
      createdBy: input.createdBy || "system",
      manualAllocations: input.manualAllocations,
      notes: input.notes,
      callMethod: input.callMethod,
      gatewayTransactionId: input.gatewayTransactionId
    };
    const processData = {
      archarges,
      credits: allCredits,
      netDueResults
    };
    let result;
    const skipGateway = input.skipGateway || paymentMethod.type === "manual";
    if (skipGateway) {
      paymentLogger.log("Manual payment - skipping gateway");
      result = await processManualPayment(processInput, processData, paymentLogger);
    } else {
      if (!gateway) {
        paymentLogger.log("ERROR: Gateway required but not provided");
        return {
          success: false,
          error: "Gateway is required for non-manual payments",
          message: "Payment processing failed"
        };
      }
      paymentLogger.log(`Processing gateway charge via ${gateway.getName()}`);
      result = await processGatewayPaymentFull(
        processInput,
        processData,
        paymentMethod,
        gateway,
        paymentLogger
      );
    }
    if (!result.success) {
      return {
        success: false,
        error: result.error,
        message: "Payment processing failed"
      };
    }
    logger.info("Payment processed successfully", {
      arpaymentId: result.arpaymentId,
      amount: input.amount,
      allocations: result.allocations.length,
      customerId: input.customerId
    });
    return {
      success: true,
      arpaymentId: result.arpaymentId,
      gatewayTransactionId: result.gatewayTransactionId,
      settlement: result.settlement,
      allocations: result.allocations,
      message: result.message ?? "Payment processed successfully",
      processingFeeError: result.processingFeeError
    };
  } catch (error) {
    logger.error("Payment processing error", { error });
    paymentLogger.log(`ERROR: ${error instanceof Error ? error.message : "Unknown error"}`);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
      message: "Payment processing failed"
    };
  }
}
var init_applyPayment = __esm({
  "src/features/ar-payments/orchestration/applyPayment.ts"() {
    init_schema();
    init_validatePaymentInput();
    init_amountDue();
    init_paymentLogger();
    init_loadAmountDueInputs();
    init_helpers();
  }
});

// src/features/ar-payments/business-logic/legacyArmoveFigures.ts
function legacyArmoveLine(armove) {
  const net = armove.due_amount - armove.discount_amount;
  return { net, paid: armove.paid_amount, remaining: net - armove.paid_amount };
}
function legacySingleMoveStatement(armoves) {
  const onStatement = armoves.filter((a) => a.due_amount > 0);
  const discounted = onStatement.filter(
    (a) => a.disputed === false && a.due_amount >= a.discount_amount && a.discount_amount > 0
  );
  const disputed = onStatement.filter((a) => a.disputed === true);
  const paid = onStatement.filter((a) => a.paid_amount > 0);
  const statement = {
    subtotal: roundCurrency(sum(onStatement.map((a) => a.due_amount))),
    discounted: roundCurrency(sum(discounted.map((a) => a.discount_amount))),
    disputed: roundCurrency(sum(disputed.map((a) => a.due_amount))),
    paid: roundCurrency(sum(paid.map((a) => a.paid_amount)))
  };
  const total = noLessThanZero2(statement.subtotal - statement.discounted - statement.disputed);
  const dueSans = noLessThanZero2(total - statement.paid);
  const processingFee = 0;
  return {
    ...statement,
    paymentAmount: statement.paid,
    total,
    moveDueTotal: total,
    dueSans,
    processingFee,
    due: noLessThanZero2(dueSans + processingFee)
  };
}
var noLessThanZero2, sum;
var init_legacyArmoveFigures = __esm({
  "src/features/ar-payments/business-logic/legacyArmoveFigures.ts"() {
    init_currency();
    noLessThanZero2 = (amount) => amount > 0 ? amount : 0;
    sum = (amounts) => amounts.length > 0 ? amounts.reduce((total, current) => total + current) : 0;
  }
});

// src/init.ts
import { init as initCore } from "@hopdrive/sdk-core";
function init(options) {
  initCore(options);
}

// src/features/products/getActiveCustomerContracts.ts
init_schema();
import { resolveExecutor, getLogger } from "@hopdrive/sdk-core";
function summarizeContract(c) {
  const serviceKeys = /* @__PURE__ */ new Set();
  let triggersWithoutProductKey = 0;
  for (const t of c.artriggers) {
    const productKey = t.product_key;
    if (typeof productKey !== "string" || productKey.length === 0) {
      triggersWithoutProductKey += 1;
      continue;
    }
    serviceKeys.add(productKey);
  }
  return {
    id: c.id,
    name: c.name,
    startDate: c.begin_date,
    endDate: c.end_date,
    workflowset: c.workflowsets ? { id: c.workflowsets.id, name: c.workflowsets.name } : null,
    serviceKeys: Array.from(serviceKeys).sort(),
    triggerCount: c.artriggers.length,
    triggersWithoutProductKey
  };
}
async function getActiveCustomerContracts(customerId, options) {
  const executor = resolveExecutor(options?.executor);
  const logger = getLogger();
  const evaluatedAt = options?.now ?? (/* @__PURE__ */ new Date()).toISOString();
  const variables = {
    customerId,
    today: evaluatedAt
  };
  const data = await executor.query(GetActiveCustomerContractsForProductDocument, variables);
  const rawContracts = data.contracts ?? [];
  const contracts = rawContracts.map(summarizeContract);
  const unownedByContract = contracts.filter((c) => c.triggersWithoutProductKey > 0).map((c) => ({ contractId: c.id, triggers: c.triggersWithoutProductKey }));
  if (unownedByContract.length > 0) {
    logger.info(
      `[getActiveCustomerContracts] customer ${customerId} has active-contract triggers with no product_key`,
      { customerId, evaluatedAt, unownedByContract }
    );
  }
  const contractsByProductKey = /* @__PURE__ */ new Map();
  for (const c of contracts) {
    for (const pk of c.serviceKeys) {
      const existing = contractsByProductKey.get(pk);
      if (existing) existing.push(c);
      else contractsByProductKey.set(pk, [c]);
    }
  }
  return {
    customerId,
    evaluatedAt,
    contracts,
    isServiceEnabled(productKey) {
      return contractsByProductKey.has(productKey);
    },
    getContractsForService(productKey) {
      return [...contractsByProductKey.get(productKey) ?? []];
    },
    getAllServiceKeys() {
      return Array.from(contractsByProductKey.keys()).sort();
    },
    getActiveServices() {
      const productKeys = Array.from(contractsByProductKey.keys()).sort();
      return productKeys.map((serviceKey) => {
        const matches = contractsByProductKey.get(serviceKey) ?? [];
        const [first, ...rest] = matches;
        return {
          serviceKey,
          // Strip down to the public ServiceContractSummary shape. Same
          // policy as isServiceEnabled's result, to keep the product-
          // centric surface narrow. callers who want serviceKeys /
          // triggerCount / triggersWithoutProductKey per contract read
          // the richer `.contracts` array directly.
          contract: {
            id: first.id,
            name: first.name,
            startDate: first.startDate,
            endDate: first.endDate,
            workflowset: first.workflowset
          },
          additionalContracts: rest.map((c) => ({
            id: c.id,
            name: c.name,
            startDate: c.startDate,
            endDate: c.endDate,
            workflowset: c.workflowset
          }))
        };
      });
    }
  };
}
async function getActiveServices(customerId, options) {
  const snapshot = await getActiveCustomerContracts(customerId, options);
  return snapshot.getActiveServices();
}

// src/features/products/isServiceEnabled.ts
function toPublicSummary(c) {
  return {
    id: c.id,
    name: c.name,
    startDate: c.startDate,
    endDate: c.endDate,
    workflowset: c.workflowset
  };
}
async function isServiceEnabled(customerId, productKey, options) {
  const snapshot = await getActiveCustomerContracts(customerId, options);
  const matches = snapshot.getContractsForService(productKey);
  if (matches.length === 0) return { enabled: false };
  const [first, ...rest] = matches;
  return {
    enabled: true,
    contract: toPublicSummary(first),
    additionalContracts: rest.map(toPublicSummary)
  };
}
async function getContractForService(customerId, productKey, options) {
  const result = await isServiceEnabled(customerId, productKey, options);
  return result.enabled ? result.contract : null;
}

// src/features/products/getService.ts
init_schema();
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";
async function getService(contractId, productKey) {
  const executor = resolveExecutor2();
  const result = await executor.query(GetContractEffectiveConfigForProductDocument, { contractId });
  const effectiveConfig = result.contracts_by_pk?.effective_config;
  const entry = effectiveConfig?.ar?.products?.[productKey];
  if (!entry || typeof entry !== "object") return null;
  return entry;
}

// src/features/contract-live/contractLive.ts
var DAY_ONLY = /^\d{4}-\d{2}-\d{2}$/;
function boundMs(value, edge) {
  if (DAY_ONLY.test(value)) {
    return Date.parse(`${value}T${edge === "begin" ? "00:00:00.000" : "23:59:59.999"}Z`);
  }
  return Date.parse(value);
}
function asOfMs(asOf) {
  const ms = typeof asOf === "string" ? Date.parse(asOf) : asOf.getTime();
  if (Number.isNaN(ms)) throw new Error(`contractLive: as-of "${String(asOf)}" is not an instant`);
  return ms;
}
function contractBegunBy(beginDate, asOf) {
  if (!beginDate) return false;
  const begin = boundMs(beginDate, "begin");
  return !Number.isNaN(begin) && begin <= asOfMs(asOf);
}
function contractLiveState(bounds, asOf) {
  const at = asOfMs(asOf);
  if (!contractBegunBy(bounds.begin_date, new Date(at))) return "not-started";
  if (bounds.end_date == null) return "live";
  const end = boundMs(bounds.end_date, "end");
  if (Number.isNaN(end)) return "not-started";
  return at <= end ? "live" : "ended";
}
function isContractLive(bounds, asOf) {
  return contractLiveState(bounds, asOf) === "live";
}
function contractLiveWhere(asOf) {
  const iso = new Date(asOfMs(asOf)).toISOString();
  return {
    begin_date: { _lte: iso },
    _or: [{ end_date: { _gte: iso } }, { end_date: { _is_null: true } }]
  };
}
function contractLiveWhereGql(operand) {
  const shape = contractLiveWhere(/* @__PURE__ */ new Date(0));
  const iso = shape.begin_date._lte;
  const render = (value) => {
    if (value === iso) return operand;
    if (Array.isArray(value)) return `[${value.map(render).join(", ")}]`;
    if (value !== null && typeof value === "object") {
      return `{ ${Object.entries(value).map(([k, v]) => `${k}: ${render(v)}`).join(", ")} }`;
    }
    return String(value);
  };
  const body = render(shape);
  return body.slice(2, -2);
}

// src/index.ts
init_accountingProductKeys();

// src/features/ar-triggers/algorithms/contractRuleSchemas/registry.ts
import { z } from "zod";

// src/features/ar-triggers/algorithms/constants.ts
var RATE_TYPES = {
  FLAT: "flat",
  PER: "per",
  FLAT_PLUS_PER: "flatPlusPer"
};
var ALGORITHM_STATUS_COMPLETED = "completed";
var ALGORITHM_STATUS_SKIPPED = "skipped";
var ALGORITHM_STATUS_ERROR = "error";
var ALGORITHM_MOVE_SCENARIO_V1 = "move_scenario_v1";
var ALGORITHM_STATIC_PRODUCT_CHARGE_V1 = "static_product_charge_v1";
var ALGORITHM_MOVE_FLAT_FEE_V1 = "move_flat_fee_v1";
var ALGORITHM_APPLY_PERUNIT_PRICING = "apply_perunit_pricing";
var ALGORITHM_PREPAID_PRODUCT_V1 = "prepaid_product_v1";
var ALGORITHM_GUESTRIDE_SCENARIO_V1 = "guestride_scenario_v1";
var ALGORITHM_MOBILE_SERVICE_V1 = "mobile_service_v1";
var ALGORITHM_RETURN_RIDE_SCENARIO_V1 = "return_ride_scenario_v1";
var ALGORITHM_PROGRAM_MOVE_SCENARIO_V1 = "program_move_scenario_v1";
var ALGORITHM_PROGRAM_MOVE_COVERAGE_V1 = "program_move_coverage_v1";
var ALGORITHM_PROGRAM_TIME_CHARGE = "program_time_charge";
var PROGRAM_TRIGGER_MODE_PROGRAM = "program";
var PROGRAM_TRIGGER_MODE_PER_CUSTOMER = "perCustomer";
var PROGRAM_TRIGGER_MODE_PER_SERVICE = "perService";
var PRODUCT_KEY_GUEST_RIDES = "guest-rides";
var PRODUCT_KEY_VALET_LITE = "valet-lite";
var PRODUCT_KEY_VALET_FULL_SERVICE = "valet-full-service";
var PRODUCT_KEY_RETURN_RIDES = "return-rides";
var AR_ALGORITHM_KEYS = [
  ALGORITHM_MOVE_SCENARIO_V1,
  ALGORITHM_STATIC_PRODUCT_CHARGE_V1,
  ALGORITHM_MOVE_FLAT_FEE_V1,
  ALGORITHM_APPLY_PERUNIT_PRICING,
  ALGORITHM_PREPAID_PRODUCT_V1,
  ALGORITHM_GUESTRIDE_SCENARIO_V1,
  ALGORITHM_MOBILE_SERVICE_V1,
  ALGORITHM_RETURN_RIDE_SCENARIO_V1,
  ALGORITHM_PROGRAM_MOVE_SCENARIO_V1,
  ALGORITHM_PROGRAM_MOVE_COVERAGE_V1
];

// src/features/ar-triggers/algorithms/shared/rates.ts
init_schema();
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";
var DEFAULT_RATE_TYPE = "flat";
async function getContract(customerId, workflowsetId, billableDate) {
  const executor = resolveExecutor3();
  const result = await executor.query(GetContractDocument, {
    customerId,
    workflowsetId,
    billableDate
  });
  return result.contracts?.[0] ?? null;
}
function getMileageBand(laneDistance, rateClass, rateRules) {
  const matchingClassRates = rateRules.filter((rule) => rule.class === rateClass);
  if (matchingClassRates.length === 0) {
    return null;
  }
  const matchedRate = matchingClassRates.find(
    (rule) => laneDistance > rule.distance_start && laneDistance <= rule.distance_end
  );
  return matchedRate || null;
}
async function getVolumeRateClass(moveId, nonStandardRates) {
  const executor = resolveExecutor3();
  const groupIdResult = await executor.query(GetRideGroupIdDocument, { moveId });
  const groupId = groupIdResult.ridegroups[0]?.group_id;
  if (!groupId) {
    return "stranded";
  }
  const countResult = await executor.query(GetRideGroupCountDocument, { groupId });
  const moveGroupCount = countResult.ridegroups_aggregate.aggregate.count;
  if (!moveGroupCount || moveGroupCount === 0) {
    return "stranded";
  }
  for (let i = moveGroupCount; i >= 1; i--) {
    const rateClass = i === 1 ? "stranded" : `stranded_x${i}`;
    if (nonStandardRates.some((rate) => rate.class === rateClass)) {
      return rateClass;
    }
  }
  return "stranded";
}
function toBandRaterules(rows) {
  return rows.filter((r) => r.distance_start != null && r.distance_end != null && r.class != null).map((r) => ({
    id: r.id,
    distance_start: r.distance_start,
    distance_end: r.distance_end,
    class: r.class,
    type: r.type ?? DEFAULT_RATE_TYPE,
    rate: r.rate,
    flat_rate: r.flat_rate,
    class_3_rate: r.class_3_rate,
    class_4_rate: r.class_4_rate,
    class_5_rate: r.class_5_rate,
    class_6_rate: r.class_6_rate,
    class_3_flat_rate: r.class_3_flat_rate,
    class_4_flat_rate: r.class_4_flat_rate,
    class_5_flat_rate: r.class_5_flat_rate,
    class_6_flat_rate: r.class_6_flat_rate
  }));
}

// src/features/ar-triggers/algorithms/shared/pricing.ts
function determineVehicleWeight(move) {
  const dispatcherWeightOverride = move?.config?.dispatcherProvidedWeight;
  const driverWeightDelivery = move?.deliveryWorkflowData?.["vehicle-weight"];
  const driverWeightPickup = move?.pickupWorkflowData?.["vehicle-weight"];
  const customerWeight = move.vehicleGrossWeightLbs;
  const toNumber5 = (value) => {
    if (value == null || value === "") return 0;
    const num = typeof value === "string" ? Number(value.trim()) : Number(value);
    return isNaN(num) ? 0 : num;
  };
  if (dispatcherWeightOverride != null) {
    const weight = toNumber5(dispatcherWeightOverride);
    if (weight > 0) {
      return {
        weight,
        source: "dispatcher input"
      };
    }
  }
  if (driverWeightDelivery != null) {
    const weight = toNumber5(driverWeightDelivery);
    if (weight > 0) {
      return {
        weight,
        source: "driver input at delivery"
      };
    }
  }
  if (driverWeightPickup != null) {
    const weight = toNumber5(driverWeightPickup);
    if (weight > 0) {
      return {
        weight,
        source: "driver input at pickup"
      };
    }
  }
  if (customerWeight != null) {
    const weight = toNumber5(customerWeight);
    if (weight > 0) {
      return {
        weight,
        source: "customer input"
      };
    }
  }
  return {
    weight: 0,
    source: "no weight provided"
  };
}
function getVehicleClassFromWeight(weight = 0) {
  if (weight <= 6e3) return 1;
  else if (weight <= 1e4) return 2;
  else if (weight <= 14e3) return 3;
  else if (weight <= 16e3) return 4;
  else if (weight <= 19500) return 5;
  else if (weight <= 26e3) return 6;
  else if (weight <= 33e3) return 7;
  else return 8;
}
function getRatesForWeightClass(weightClass, rateRule) {
  const defaultRates = { flat: 0, per: 0 };
  if (!weightClass || !rateRule || typeof weightClass !== "number" || weightClass < 1 || weightClass > 6) {
    return defaultRates;
  }
  const rateMap = {
    1: { flat: rateRule.flat_rate ?? 0, per: rateRule.rate ?? 0 },
    2: { flat: rateRule.flat_rate ?? 0, per: rateRule.rate ?? 0 },
    3: { flat: rateRule.class_3_flat_rate ?? 0, per: rateRule.class_3_rate ?? 0 },
    4: { flat: rateRule.class_4_flat_rate ?? 0, per: rateRule.class_4_rate ?? 0 },
    5: { flat: rateRule.class_5_flat_rate ?? 0, per: rateRule.class_5_rate ?? 0 },
    6: { flat: rateRule.class_6_flat_rate ?? 0, per: rateRule.class_6_rate ?? 0 }
  };
  return rateMap[weightClass] || defaultRates;
}
function calculatePrice(distance = 0, flatRate = 0, perMileRate2 = 0, rateType, dealerDiscount = 0, tolls = 0, minimumDistance = 0) {
  if (distance <= 0) return 0;
  if (flatRate <= 0 && perMileRate2 <= 0) return 0;
  if (!(rateType === RATE_TYPES.PER || rateType === RATE_TYPES.FLAT || rateType === RATE_TYPES.FLAT_PLUS_PER)) {
    return 0;
  }
  if (tolls < 0) return 0;
  let price = 0;
  if (rateType === RATE_TYPES.FLAT) {
    price = flatRate;
  } else if (rateType === RATE_TYPES.PER) {
    price = perMileRate2 * distance;
  } else if (rateType === RATE_TYPES.FLAT_PLUS_PER) {
    price = flatRate + perMileRate2 * (distance - minimumDistance);
  }
  price = price + tolls - dealerDiscount;
  price = Math.max(0, price);
  return Math.round(price * 100) / 100;
}

// src/features/ar-triggers/algorithms/shared/laneModifiers.ts
init_schema();
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
function scopeTier(row, scope) {
  if (row.workflowset_id != null && scope.workflowsetId != null && row.workflowset_id === scope.workflowsetId) {
    return 1;
  }
  if (row.workflowset_id == null && row.workflowset_type != null && scope.workflowsetType != null && row.workflowset_type === scope.workflowsetType) {
    return 2;
  }
  if (row.workflowset_id == null && row.workflowset_type == null && row.customer_id != null && scope.customerId != null && row.customer_id === scope.customerId) {
    return 3;
  }
  if (row.workflowset_id == null && row.workflowset_type == null && row.customer_id == null && row.organization_id != null && scope.organizationId != null && row.organization_id === scope.organizationId) {
    return 4;
  }
  return null;
}
function inDateWindow(row, onDate) {
  const t = new Date(onDate).getTime();
  const begin = row.begin_date ? new Date(row.begin_date).getTime() : -Infinity;
  const end = row.end_date ? new Date(row.end_date).getTime() : Infinity;
  return begin <= t && t < end;
}
function selectApplicableLaneModifier(candidates, scope, options = {}) {
  const { applyTo, onDate } = options;
  const matches = candidates.filter((row) => applyTo ? applyTo.includes(row.apply_to ?? "") : true).filter((row) => onDate ? inDateWindow(row, onDate) : true).map((row) => ({ row, tier: scopeTier(row, scope) })).filter((m) => m.tier != null);
  if (matches.length === 0) return null;
  matches.sort((a, b) => {
    if (a.tier !== b.tier) return a.tier - b.tier;
    const at = a.row.createdat ? new Date(a.row.createdat).getTime() : 0;
    const bt = b.row.createdat ? new Date(b.row.createdat).getTime() : 0;
    return bt - at;
  });
  return matches[0].row;
}
function laneModifierDistanceMiles(modifier) {
  return modifier?.distance_miles_modifier ?? 0;
}
function modifiedDistanceMiles(distanceMiles, modifier) {
  const adjustment = laneModifierDistanceMiles(modifier);
  return adjustment !== 0 ? Math.max(0, distanceMiles + adjustment) : distanceMiles;
}
var SENTINEL_ID = -1;
var SENTINEL_TYPE = "__no_workflowset_type__";
async function getApplicableArLaneModifier(scope, onDate) {
  const executor = resolveExecutor4();
  const result = await executor.query(GetLaneModifiersDocument, {
    customerId: scope.customerId ?? SENTINEL_ID,
    organizationId: scope.organizationId ?? SENTINEL_ID,
    workflowsetId: scope.workflowsetId ?? SENTINEL_ID,
    workflowsetType: scope.workflowsetType ?? SENTINEL_TYPE,
    onDate
  });
  return selectApplicableLaneModifier(result.lanemodifiers ?? [], scope, {
    applyTo: ["AR", "BOTH"],
    onDate
  });
}

// src/features/ar-triggers/algorithms/shared/laneTolls.ts
var TOLL_ACCESSORIAL_CODE = "toll";
var LANE_TOLL_ACCESSORIAL_ID = 0;
var LANE_TOLL_CHARGE_TYPE = "toll";
var LANE_TOLL_CHARGE_NAME = "Tolls";
function resolveLaneTolls(laneTolls, effectiveConfig) {
  if (effectiveConfig?.routing?.no_toll_charges === true) return 0;
  return laneTolls ?? void 0;
}
function laneTollAccessorial(tolls) {
  if (tolls == null || tolls <= 0) return null;
  return { accessorialId: LANE_TOLL_ACCESSORIAL_ID, code: TOLL_ACCESSORIAL_CODE, amount: tolls };
}
var LANE_TOLLS_WAIVED = {
  /** Valet Lite moves bill no lane tolls. */
  VALET_LITE: "valet_lite"
};
function billableLaneTolls(args) {
  const laneTolls = args.laneTolls ?? 0;
  const isLite = args.productKey != null ? args.productKey === PRODUCT_KEY_VALET_LITE : args.lite === true;
  if (isLite && laneTolls > 0) return { tolls: 0, laneTolls, waived: LANE_TOLLS_WAIVED.VALET_LITE };
  return { tolls: laneTolls, laneTolls, waived: null };
}

// src/features/ar-triggers/algorithms/shared/charges/moveCostPipeline.ts
var MAX_VEHICLE_WEIGHT_LBS = 19999;
var CANCEL_STATUS = { CANCELED: "canceled", STARTED: "started", RESCHEDULED: "rescheduled" };
var CANCEL_BILLING = {
  /** Not cancelled: the move cost and its accessorials. */
  FULL: "full",
  /**
   * Cancelled after the move started: its accessorials, but no transport cost.
   * A reschedule after start bills the same way, because outcomes writes
   * `rescheduled` over `started` and the work moves to the replacement drive.
   */
  ACCESSORIALS_ONLY: "accessorials_only",
  /** Cancelled outright: nothing. */
  NOTHING: "nothing"
};
function cancelBilling(cancelStatus) {
  if (cancelStatus === CANCEL_STATUS.CANCELED) return CANCEL_BILLING.NOTHING;
  if (cancelStatus === CANCEL_STATUS.STARTED || cancelStatus === CANCEL_STATUS.RESCHEDULED) {
    return CANCEL_BILLING.ACCESSORIALS_ONLY;
  }
  return CANCEL_BILLING.FULL;
}
var DEFAULT_RATE_CLASS = "base";
var NO_WEIGHT_SOURCE = "none";
var STRANDED_RATE_CLASS = "stranded";
function isStrandedRateClass(rateClass) {
  return rateClass === STRANDED_RATE_CLASS || /^stranded_x\d+$/.test(rateClass);
}
var round2 = (n) => Math.round(n * 100) / 100;
var KNOWN_RATE_TYPES = new Set(Object.values(RATE_TYPES));
var BAND_STRATEGY = {
  /** One band wins, `[start, end)`. The customer path. */
  MATCH_ONE: "matchOne",
  /** Every band the move spans contributes its slice. Full-service program coverage. */
  STACK: "stack",
  /**
   * One rung wins, `distance <= end`. A program's Lite reimbursement schedule.
   *
   * The bound is inclusive because an OEM publishes "up to 25 mi pays $50", and
   * a `[0,25)` reading pays the next rung at exactly 25.0, a common lane
   * distance. The rung's `flat_rate` is the amount owed, not a rate, because
   * HopDrive did not perform the move and there is no cost to derive.
   */
  SCHEDULE: "schedule"
};
var OVERRIDE_BANDS = {
  /** No distance, no class, no band lookup. */
  IGNORE: "ignore",
  /** So the caller can split the agreed amount across the bands. */
  RESOLVE: "resolve"
};
var MOVE_COST_OUTCOME = {
  PRICED: "priced",
  PRICE_OVERRIDE: "price_override",
  /** Canceled after start. No transport cost, but the move's accessorials still bill. */
  NO_TRANSPORT: "no_transport",
  /** Inactive, non-chargeable, canceled, wrong status, no distance, or no band. */
  SKIPPED: "skipped"
};
var MOVE_COST_SKIP = {
  NOT_BILLABLE: "not_billable",
  NO_DISTANCE: "no_distance",
  NO_BANDS: "no_bands",
  NO_BAND_MATCH: "no_band_match",
  /**
   * The matched band's rate type is missing or unknown, so `calculatePrice`
   * would return 0. A $0 charge from a broken band looks legitimate
   * downstream, so it is a skip that names the band (#2372 D5).
   */
  UNKNOWN_RATE_TYPE: "unknown_rate_type"
};
function skipped(reason, code) {
  return {
    outcome: MOVE_COST_OUTCOME.SKIPPED,
    skipReason: reason,
    skipCode: code,
    contributions: [],
    bandTotal: 0,
    total: 0,
    effectiveMileage: 0,
    rateClass: DEFAULT_RATE_CLASS,
    weightClass: 0,
    weightSource: NO_WEIGHT_SOURCE,
    discount: 0,
    tolls: 0,
    laneTolls: 0
  };
}
function isBillableMove(move) {
  if (!move.active) return { billable: false, reason: "move is inactive (soft deleted)" };
  if (!move.chargeable) return { billable: false, reason: "not chargeable" };
  if (cancelBilling(move.cancelStatus) === CANCEL_BILLING.NOTHING) return { billable: false, reason: "canceled" };
  if (!move.isAppointment) {
    const status = move.status;
    if (status == null || status === "draft" || status === "dispatched") {
      return { billable: false, reason: `move status is ${status ?? "null"}` };
    }
  }
  return { billable: true };
}
function resolveDiscount(move, rateClass) {
  return (isStrandedRateClass(rateClass) ? move.dealerStrandedDiscount : move.dealerBaseDiscount) ?? 0;
}
async function resolveRateClass(move, bands) {
  const rateClass = move.moveClass ?? DEFAULT_RATE_CLASS;
  if (rateClass !== STRANDED_RATE_CLASS) return rateClass;
  const nonStandard = bands.filter(
    (b) => b.class !== DEFAULT_RATE_CLASS && b.class !== STRANDED_RATE_CLASS
  );
  return nonStandard.length > 0 ? getVolumeRateClass(move.moveId, nonStandard) : rateClass;
}
function bandSliceCost(band, rates, distance) {
  if (distance <= band.distance_start) return 0;
  const flat = rates.flat;
  const per = rates.per;
  const slice = Math.max(0, Math.min(distance, band.distance_end) - band.distance_start);
  if (band.type === RATE_TYPES.FLAT) return flat;
  if (band.type === RATE_TYPES.PER) return per * slice;
  if (band.type === RATE_TYPES.FLAT_PLUS_PER) return flat + per * slice;
  return 0;
}
function priceBands(options) {
  const { distance, rateClass, weightClass, bands, strategy, discount = 0 } = options;
  const classBands = bands.filter((b) => b.class === rateClass);
  if (classBands.length === 0) return null;
  if (strategy === BAND_STRATEGY.SCHEDULE) {
    const rung = [...classBands].sort((a, b) => a.distance_end - b.distance_end).find((b) => distance <= b.distance_end);
    if (!rung) return null;
    const amount = round2(rung.flat_rate ?? 0);
    return {
      contributions: [{ bandId: rung.id, band: rung, cost: amount }],
      bandTotal: amount,
      total: amount
    };
  }
  if (strategy === BAND_STRATEGY.MATCH_ONE) {
    const band = getMileageBand(distance, rateClass, classBands);
    if (!band) return null;
    const rates = getRatesForWeightClass(weightClass, band);
    const bandTotal2 = calculatePrice(distance, rates.flat, rates.per, band.type, 0, 0, band.distance_start);
    const total = calculatePrice(distance, rates.flat, rates.per, band.type, discount, 0, band.distance_start);
    return { contributions: [{ bandId: band.id, band, cost: bandTotal2 }], bandTotal: bandTotal2, total, rates };
  }
  const contributions = [];
  for (const band of classBands) {
    const cost = round2(bandSliceCost(band, getRatesForWeightClass(weightClass, band), distance));
    if (cost <= 0) continue;
    contributions.push({ bandId: band.id, band, cost });
  }
  if (contributions.length === 0) return null;
  const bandTotal = round2(contributions.reduce((sum2, c) => sum2 + c.cost, 0));
  const discounted = Math.max(0, round2(bandTotal - discount));
  if (discount > 0 && bandTotal > 0 && discounted !== bandTotal) {
    const factor = discounted / bandTotal;
    let running = 0;
    contributions.forEach((c, i) => {
      c.cost = i === contributions.length - 1 ? round2(discounted - running) : round2(c.cost * factor);
      running = round2(running + c.cost);
    });
  }
  return { contributions, bandTotal, total: discounted };
}
async function priceMoveCost({
  move,
  bands: bandsInput,
  strategy,
  laneModifier = null,
  overrideBands = OVERRIDE_BANDS.IGNORE,
  productKey = null
}) {
  const billable = isBillableMove(move);
  if (!billable.billable) return skipped(billable.reason, MOVE_COST_SKIP.NOT_BILLABLE);
  if (cancelBilling(move.cancelStatus) === CANCEL_BILLING.ACCESSORIALS_ONLY) {
    return {
      ...skipped("canceled after start", MOVE_COST_SKIP.NOT_BILLABLE),
      outcome: MOVE_COST_OUTCOME.NO_TRANSPORT,
      skipReason: void 0,
      skipCode: void 0
    };
  }
  const override = move.priceOverrideActive && move.priceOverride !== void 0 ? move.priceOverride : void 0;
  if (override !== void 0 && overrideBands === OVERRIDE_BANDS.IGNORE) return overridden(override, null);
  if (!move.mileage) {
    return override !== void 0 ? overridden(override, null) : skipped("no mileage data (lane distance is null)", MOVE_COST_SKIP.NO_DISTANCE);
  }
  const bands = typeof bandsInput === "function" ? bandsInput() : bandsInput;
  if (bands.length === 0) {
    return override !== void 0 ? overridden(override, null) : skipped("no rate rules available for pricing calculation", MOVE_COST_SKIP.NO_BANDS);
  }
  const effectiveMileage = modifiedDistanceMiles(move.mileage, laneModifier);
  const rateClass = await resolveRateClass(move, bands);
  const { weight, source: weightSource } = determineVehicleWeight(move);
  if (weight > MAX_VEHICLE_WEIGHT_LBS) {
    throw new Error(
      `Vehicle weight exceeds limit for move ${move.moveId}: vehicle_weight=${weight} lbs (limit: ${MAX_VEHICLE_WEIGHT_LBS} lbs), weight_source=${weightSource}`
    );
  }
  const weightClass = getVehicleClassFromWeight(weight);
  if (weightClass === 0 || weightClass > 6) {
    throw new Error(
      `Invalid weight class for move ${move.moveId}: weight_class=${weightClass}, vehicle_weight=${weight} lbs`
    );
  }
  const discount = resolveDiscount(move, rateClass);
  const lane = billableLaneTolls({ laneTolls: move.tolls, productKey, lite: move.lite });
  const priced = priceBands({ distance: effectiveMileage, rateClass, weightClass, bands, discount, strategy });
  if (override !== void 0) {
    return overridden(override, priced && { ...priced, effectiveMileage, rateClass, weightClass, weightSource, discount });
  }
  if (!priced) {
    return skipped(
      `no rate rule found: class=${rateClass}, distance=${effectiveMileage} miles`,
      MOVE_COST_SKIP.NO_BAND_MATCH
    );
  }
  if (strategy === BAND_STRATEGY.MATCH_ONE) {
    const band = priced.contributions[0].band;
    if (!KNOWN_RATE_TYPES.has(band.type)) {
      return skipped(
        `rate rule ${band.id} has unusable rate type ${JSON.stringify(band.type ?? null)}: class=${rateClass}, distance=${effectiveMileage} miles`,
        MOVE_COST_SKIP.UNKNOWN_RATE_TYPE
      );
    }
  }
  return {
    outcome: MOVE_COST_OUTCOME.PRICED,
    contributions: priced.contributions,
    bandTotal: priced.bandTotal,
    total: priced.total,
    effectiveMileage,
    rateClass,
    weightClass,
    weightSource,
    discount,
    tolls: lane.tolls,
    laneTolls: lane.laneTolls,
    ...lane.waived ? { tollsWaived: lane.waived } : {}
  };
}
function overridden(price, banded) {
  return {
    ...skipped("price override", MOVE_COST_SKIP.NOT_BILLABLE),
    outcome: MOVE_COST_OUTCOME.PRICE_OVERRIDE,
    skipReason: void 0,
    skipCode: void 0,
    total: price,
    bandTotal: price,
    contributions: banded?.contributions ?? [],
    effectiveMileage: banded?.effectiveMileage ?? 0,
    rateClass: banded?.rateClass ?? DEFAULT_RATE_CLASS,
    weightClass: banded?.weightClass ?? 0,
    weightSource: banded?.weightSource ?? NO_WEIGHT_SOURCE,
    discount: banded?.discount ?? 0
  };
}

// src/features/ar-triggers/templates/predicates.ts
var MOVE_DELIVERY_SUCCESSFUL_EVENT_KEY = "move.delivery_successful";
var MOVE_PICKUP_STARTED_EVENT_KEY = "move.pickup_started";
var MOVE_CANCEL_FAILED_EVENT_KEY = "move.cancel_failed";
var MOVE_CANCEL_PARTIAL_EVENT_KEY = "move.cancel_partial";
var MOVE_CANCEL_SUCCEEDED_EVENT_KEY = "move.cancel_succeeded";
var MOVE_RESCHEDULED_EVENT_KEY = "move.rescheduled";
var MOVE_CHARGEABLE_CHANGED_EVENT_KEY = "move.chargeable_changed";
var MOVE_WEIGHT_CHANGED_EVENT_KEY = "move.weight_changed";
var MOVE_ACTIVE_CHANGED_EVENT_KEY = "move.active_changed";
var MOVE_CLASS_CHANGED_EVENT_KEY = "move.class_changed";
var MOVE_DISPUTED_CHANGED_EVENT_KEY = "move.disputed_changed";
var MOVE_UNDISPATCHED_EVENT_KEY = "move.undispatched";
var MOVE_UNPLANNED_EVENT_KEY = "move.unplanned";
var ACCESSORIAL_AR_ADDED_EVENT_KEY = "accessorial.ar_added";
var ACCESSORIAL_AR_CHANGED_EVENT_KEY = "accessorial.ar_changed";
var ACCESSORIAL_AR_REMOVED_EVENT_KEY = "accessorial.ar_removed";
var ACCESSORIAL_REMOVED_EVENT_KEY = "accessorial.removed";
var ACCESSORIAL_STATUS_CHANGED_EVENT_KEY = "accessorial.status_changed";
var PRICEOVERRIDE_ADDED_EVENT_KEY = "priceoverride.added";
var PRICEOVERRIDE_CHANGED_EVENT_KEY = "priceoverride.changed";
var RIDEHAIL_ACTUAL_PRICE_UPDATED_EVENT_KEY = "ridehail.actual_price.updated";
var RIDEHAIL_ESTIMATED_PRICE_UPDATED_EVENT_KEY = "ridehail.estimated_price.updated";
var MOVE_MANUAL_EVENT_KEY = "move.manual";
var MOVE_AR_PREDICATES = [
  MOVE_DELIVERY_SUCCESSFUL_EVENT_KEY,
  MOVE_PICKUP_STARTED_EVENT_KEY,
  MOVE_CANCEL_FAILED_EVENT_KEY,
  MOVE_CANCEL_PARTIAL_EVENT_KEY,
  MOVE_CANCEL_SUCCEEDED_EVENT_KEY,
  MOVE_RESCHEDULED_EVENT_KEY,
  MOVE_CHARGEABLE_CHANGED_EVENT_KEY,
  MOVE_WEIGHT_CHANGED_EVENT_KEY,
  MOVE_ACTIVE_CHANGED_EVENT_KEY,
  MOVE_CLASS_CHANGED_EVENT_KEY,
  MOVE_DISPUTED_CHANGED_EVENT_KEY,
  MOVE_UNDISPATCHED_EVENT_KEY,
  MOVE_UNPLANNED_EVENT_KEY
];
var ACCESSORIAL_AR_PREDICATES = [
  ACCESSORIAL_AR_ADDED_EVENT_KEY,
  ACCESSORIAL_AR_CHANGED_EVENT_KEY,
  ACCESSORIAL_AR_REMOVED_EVENT_KEY,
  ACCESSORIAL_REMOVED_EVENT_KEY,
  ACCESSORIAL_STATUS_CHANGED_EVENT_KEY
];
var PRICEOVERRIDE_AR_PREDICATES = [
  PRICEOVERRIDE_ADDED_EVENT_KEY,
  PRICEOVERRIDE_CHANGED_EVENT_KEY
];
var RIDEHAIL_AR_PREDICATES = [
  RIDEHAIL_ESTIMATED_PRICE_UPDATED_EVENT_KEY,
  RIDEHAIL_ACTUAL_PRICE_UPDATED_EVENT_KEY
];
var PROGRAM_MOVE_LIFECYCLE_EVENT_KEYS = [
  MOVE_DELIVERY_SUCCESSFUL_EVENT_KEY,
  MOVE_PICKUP_STARTED_EVENT_KEY,
  MOVE_CANCEL_FAILED_EVENT_KEY,
  MOVE_CANCEL_SUCCEEDED_EVENT_KEY,
  MOVE_RESCHEDULED_EVENT_KEY,
  MOVE_CHARGEABLE_CHANGED_EVENT_KEY,
  MOVE_ACTIVE_CHANGED_EVENT_KEY
];
var PROGRAM_COVERAGE_PRICING_EVENT_KEYS = [
  MOVE_CANCEL_PARTIAL_EVENT_KEY,
  MOVE_WEIGHT_CHANGED_EVENT_KEY,
  MOVE_CLASS_CHANGED_EVENT_KEY,
  MOVE_UNDISPATCHED_EVENT_KEY,
  MOVE_UNPLANNED_EVENT_KEY
];
var PROGRAM_COVERAGE_EVENT_KEYS = [
  ...PROGRAM_MOVE_LIFECYCLE_EVENT_KEYS,
  ...ACCESSORIAL_AR_PREDICATES,
  ...PROGRAM_COVERAGE_PRICING_EVENT_KEYS,
  ...PRICEOVERRIDE_AR_PREDICATES
];
var SERVICE_LINE = {
  FULL_SERVICE: "full_service",
  LITE: "lite"
};
var SERVICE_LINES = [SERVICE_LINE.FULL_SERVICE, SERVICE_LINE.LITE];
function serviceLineForMove(move) {
  return move?.lite === true ? SERVICE_LINE.LITE : SERVICE_LINE.FULL_SERVICE;
}
function serviceLineForScenario(moves) {
  return moves.some((move) => serviceLineForMove(move) === SERVICE_LINE.LITE) ? SERVICE_LINE.LITE : SERVICE_LINE.FULL_SERVICE;
}
var ALL_AR_PREDICATES = [
  ...MOVE_AR_PREDICATES,
  ...ACCESSORIAL_AR_PREDICATES,
  ...PRICEOVERRIDE_AR_PREDICATES,
  ...RIDEHAIL_AR_PREDICATES
];
var ALL_AR_PREDICATES_SET = new Set(ALL_AR_PREDICATES);
function isKnownPredicate(key) {
  return ALL_AR_PREDICATES_SET.has(key);
}
var EVENT_KEY_SHAPE = /^[a-z]+(\.[a-z][a-z_]*)+$/;

// src/features/ar-triggers/algorithms/shared/programCoverage.ts
var SETTLEMENT_MODE = {
  /** Program pays HD the full cost; customer invoice $0; customer share is an informational recoup. */
  PROGRAM_FRONTS: "program_fronts",
  /** Program pays HD its covered share; customer pays HD the remainder (split at source). */
  SPLIT: "split",
  /**
  * Lite. The dealer performed the move, so HopDrive invoices no one. The
  * program owes the dealer the banded amount, recorded as a program→customer
  * `reimbursement` ledger row ($0 when the move is ineligible). Declared
  * on the Lite coverage contract, and its default; see `resolveSettlementMode`.
  */
  REIMBURSEMENT: "reimbursement"
};
var round22 = (n) => Math.round(n * 100) / 100;
var clampPct = (pct) => {
  if (pct == null || Number.isNaN(pct)) return 0;
  return Math.min(100, Math.max(0, pct));
};
function coverageSplitFromContributions(contributions, eligible = true) {
  const out = [];
  for (const c of contributions) {
    const cost = round22(c.cost);
    if (cost <= 0) continue;
    const programCoveragePct = eligible ? clampPct(c.band.program_coverage_pct) : 0;
    const programAmount = round22(cost * programCoveragePct / 100);
    out.push({
      bandId: c.bandId,
      cost,
      programCoveragePct,
      programAmount,
      customerAmount: round22(cost - programAmount)
    });
  }
  return {
    totalCost: round22(out.reduce((sum2, c) => sum2 + c.cost, 0)),
    programAmount: round22(out.reduce((sum2, c) => sum2 + c.programAmount, 0)),
    customerAmount: round22(out.reduce((sum2, c) => sum2 + c.customerAmount, 0)),
    contributions: out
  };
}
function scaleSplitToTotal(split, total) {
  const amount = round22(total);
  const blendedPct = split.totalCost > 0 ? split.programAmount / split.totalCost * 100 : 0;
  const programAmount = round22(amount * blendedPct / 100);
  return {
    totalCost: amount,
    programAmount,
    customerAmount: round22(amount - programAmount),
    contributions: split.contributions
  };
}
function settleSplit(split, settlement) {
  if (settlement === SETTLEMENT_MODE.REIMBURSEMENT) {
    return { totalCost: split.totalCost, programCharge: 0, customerCharge: 0, recoup: 0, reimbursement: split.programAmount };
  }
  if (settlement === SETTLEMENT_MODE.SPLIT) {
    return { totalCost: split.totalCost, programCharge: split.programAmount, customerCharge: split.customerAmount, recoup: 0, reimbursement: 0 };
  }
  return { totalCost: split.totalCost, programCharge: split.totalCost, customerCharge: 0, recoup: split.customerAmount, reimbursement: 0 };
}
function applySettlement(moveId, split, settlement) {
  return { moveId, ...settleSplit(split, settlement), split };
}
var ACCESSORIAL_PAYER = {
  PROGRAM: "program",
  CUSTOMER: "customer"
};
var DEFAULT_ACCESSORIAL_PAYER = ACCESSORIAL_PAYER.CUSTOMER;
function isAccessorialPayer(value) {
  return value === ACCESSORIAL_PAYER.PROGRAM || value === ACCESSORIAL_PAYER.CUSTOMER;
}
function resolveAccessorialPayer(config, code) {
  const coverage = config?.accessorialCoverage;
  const perType = coverage?.byType?.[code.toLowerCase()];
  if (isAccessorialPayer(perType)) return perType;
  return isAccessorialPayer(coverage?.default) ? coverage.default : DEFAULT_ACCESSORIAL_PAYER;
}
function accessorialCoverageSplit(amount, payer, eligible = true) {
  const cost = round22(amount);
  const programCoveragePct = eligible && payer === ACCESSORIAL_PAYER.PROGRAM ? 100 : 0;
  const programAmount = round22(cost * programCoveragePct / 100);
  const customerAmount = round22(cost - programAmount);
  return { totalCost: cost, programAmount, customerAmount, contributions: [] };
}
function settleAccessorial(amount, payer, settlement, eligible = true) {
  return settleSplit(accessorialCoverageSplit(amount, payer, eligible), settlement);
}
var SETTLEMENT_MODES = Object.values(SETTLEMENT_MODE);
function defaultSettlementFor(serviceLine) {
  return serviceLine === SERVICE_LINE.LITE ? SETTLEMENT_MODE.REIMBURSEMENT : SETTLEMENT_MODE.PROGRAM_FRONTS;
}
function resolveSettlementMode(config, fallback) {
  const settlement = config?.settlement;
  return typeof settlement === "string" && SETTLEMENT_MODES.includes(settlement) ? settlement : fallback;
}
var COVERAGE_BAND_STRATEGY = {
  STACK: BAND_STRATEGY.STACK,
  SCHEDULE: BAND_STRATEGY.SCHEDULE
};
var COVERAGE_BAND_STRATEGIES = Object.values(COVERAGE_BAND_STRATEGY);
function defaultBandStrategyFor(serviceLine) {
  return serviceLine === SERVICE_LINE.LITE ? COVERAGE_BAND_STRATEGY.SCHEDULE : COVERAGE_BAND_STRATEGY.STACK;
}
function resolveBandStrategy(config, fallback) {
  const declared = config?.bandStrategy;
  return typeof declared === "string" && COVERAGE_BAND_STRATEGIES.includes(declared) ? declared : fallback;
}
function accessorialSettlementFor(settlement) {
  return settlement === SETTLEMENT_MODE.REIMBURSEMENT ? SETTLEMENT_MODE.SPLIT : settlement;
}
function toCoverageBands(rows) {
  const pctById = new Map(rows.map((r) => [r.id, r.program_coverage_pct ?? null]));
  return toBandRaterules(rows).map((band) => ({
    ...band,
    program_coverage_pct: pctById.get(band.id) ?? null
  }));
}

// src/features/program-eligibility/evaluate-program-move-eligibility.ts
var RULE_OUTCOMES = {
  PASS: "pass",
  FAIL: "fail",
  ASSUME: "assume"
};
var ELIGIBILITY_STATUS = {
  ELIGIBLE: "eligible",
  INELIGIBLE: "ineligible"
};
var ELIGIBILITY_RULE_TYPES = {
  /** `vehicleMake` ∈ `makes` (case-insensitive). */
  MAKE_IN: "make_in",
  /** `currentYear - vehicleYear <= maxModelYearAge`. */
  MODEL_YEAR_MAX_AGE: "model_year_max_age",
  /** `vehicleOdometer < max` (exclusive). */
  ODOMETER_MAX: "odometer_max",
  /** A complete 17-char VIN is present (order VIN or driver-scanned VIN). */
  VIN_COMPLETE: "vin_complete",
  /**
   * The driver's pickup VIN verified the vehicle: captured without a dispatch
   * override, and agreeing with the order's VIN.
   */
  VIN_VERIFIED: "vin_verified",
  /** The named string fact is present/non-empty (e.g. `referenceNum`). */
  FIELD_PRESENT: "field_present",
  /** A true/false/null signal fact (e.g. an audit flag); false makes the move ineligible, null assumes. */
  BOOLEAN_SIGNAL: "boolean_signal"
};
var RULE_TIMING = {
  AT_CREATE: "at_create",
  AT_PICKUP: "at_pickup",
  AT_DELIVERY: "at_delivery",
  MANUAL: "manual"
};
var RULE_POLICY = {
  ALWAYS_ASSUME: "always_assume",
  ASSUME_WHEN_UNKNOWN: "assume_when_unknown",
  FAIL_WHEN_UNKNOWN: "fail_when_unknown"
};
var NOT_EVALUATED_SOURCE = "no_data_feed";
var ODOMETER_SOURCE = {
  PICKUP_INSPECTION: "pickup_inspection",
  DELIVERY_INSPECTION: "delivery_inspection"
};
var ODOMETER_SOURCE_UNSPECIFIED = "vehicle_odometer";
var LEGACY_ALWAYS_ASSUME_TYPE = "always_assume";
var LIFECYCLE_STAGE_ORDER = {
  [RULE_TIMING.AT_CREATE]: 0,
  [RULE_TIMING.AT_PICKUP]: 1,
  [RULE_TIMING.AT_DELIVERY]: 2
};
var FULL_VIN_LENGTH = 17;
var VEHICLE_FACT_SOURCE = {
  VIN_DECODE: "vin_decode",
  ENTERED: "entered"
};
var VIN_DECODED_SOURCE = {
  MAKE: "vehicle_make_from_vin",
  YEAR: "vehicle_year_from_vin"
};
var PICKUP_VIN_SOURCE = {
  VERIFIED: "pickup_vin",
  MISSING: "pickup_vin_missing",
  OVERRIDE: "pickup_vin_override",
  MISMATCH: "pickup_vin_mismatch"
};
var TYPE_DEFAULT_TIMING = {
  [ELIGIBILITY_RULE_TYPES.MAKE_IN]: RULE_TIMING.AT_CREATE,
  [ELIGIBILITY_RULE_TYPES.MODEL_YEAR_MAX_AGE]: RULE_TIMING.AT_CREATE,
  [ELIGIBILITY_RULE_TYPES.ODOMETER_MAX]: RULE_TIMING.AT_PICKUP,
  [ELIGIBILITY_RULE_TYPES.VIN_COMPLETE]: RULE_TIMING.AT_PICKUP,
  [ELIGIBILITY_RULE_TYPES.VIN_VERIFIED]: RULE_TIMING.AT_PICKUP,
  [ELIGIBILITY_RULE_TYPES.FIELD_PRESENT]: RULE_TIMING.MANUAL,
  [ELIGIBILITY_RULE_TYPES.BOOLEAN_SIGNAL]: RULE_TIMING.AT_DELIVERY
};
function evalResult(rule, outcome, source) {
  return {
    ruleKey: rule.key,
    outcome,
    source: rule.source ?? source,
    timing: rule.timing ?? TYPE_DEFAULT_TIMING[rule.type]
  };
}
function isFullVin(vin) {
  return vin != null && vin.trim().length === FULL_VIN_LENGTH;
}
function normalizeVin(vin) {
  return (vin ?? "").toUpperCase().replace(/[^A-Z0-9]/g, "");
}
var MIN_COMPARABLE_VIN_LENGTH = 4;
function vinsAgree(orderVin, capturedVin) {
  if (orderVin.length < MIN_COMPARABLE_VIN_LENGTH) return true;
  return orderVin.length === FULL_VIN_LENGTH ? orderVin === capturedVin : capturedVin.endsWith(orderVin);
}
var fromVin = (facts) => facts.vehicleFactSource === VEHICLE_FACT_SOURCE.VIN_DECODE;
var RULE_EVALUATORS = {
  [ELIGIBILITY_RULE_TYPES.MAKE_IN]: (rule, facts) => {
    if (facts.vehicleMake == null || facts.vehicleMake === "") {
      return evalResult(rule, RULE_OUTCOMES.ASSUME, "vehicle_make_missing");
    }
    const target = facts.vehicleMake.toLowerCase();
    const makes = rule.makes ?? [];
    const matches = makes.some((make) => typeof make === "string" && make.toLowerCase() === target);
    return evalResult(rule, matches ? RULE_OUTCOMES.PASS : RULE_OUTCOMES.FAIL, fromVin(facts) ? VIN_DECODED_SOURCE.MAKE : "vehicle_make");
  },
  [ELIGIBILITY_RULE_TYPES.MODEL_YEAR_MAX_AGE]: (rule, facts) => {
    if (facts.vehicleYear == null || rule.maxModelYearAge == null) {
      return evalResult(rule, RULE_OUTCOMES.ASSUME, "vehicle_year_missing");
    }
    const age = facts.currentYear - facts.vehicleYear;
    return evalResult(
      rule,
      age <= rule.maxModelYearAge ? RULE_OUTCOMES.PASS : RULE_OUTCOMES.FAIL,
      fromVin(facts) ? VIN_DECODED_SOURCE.YEAR : "vehicle_year"
    );
  },
  [ELIGIBILITY_RULE_TYPES.ODOMETER_MAX]: (rule, facts) => {
    if (facts.vehicleOdometer == null || rule.maxOdometer == null) {
      return evalResult(rule, RULE_OUTCOMES.ASSUME, "odometer_unavailable");
    }
    return evalResult(
      rule,
      facts.vehicleOdometer < rule.maxOdometer ? RULE_OUTCOMES.PASS : RULE_OUTCOMES.FAIL,
      facts.vehicleOdometerSource ?? ODOMETER_SOURCE_UNSPECIFIED
    );
  },
  [ELIGIBILITY_RULE_TYPES.VIN_COMPLETE]: (rule, facts) => {
    if (isFullVin(facts.vehicleVin)) return evalResult(rule, RULE_OUTCOMES.PASS, "vehicle_vin");
    if (isFullVin(facts.scannedVin)) return evalResult(rule, RULE_OUTCOMES.PASS, "pickup_scanned_vin");
    return evalResult(rule, RULE_OUTCOMES.ASSUME, "vin_incomplete");
  },
  [ELIGIBILITY_RULE_TYPES.VIN_VERIFIED]: (rule, facts) => {
    const captured = normalizeVin(facts.scannedVin);
    if (captured.length !== FULL_VIN_LENGTH) return evalResult(rule, RULE_OUTCOMES.ASSUME, PICKUP_VIN_SOURCE.MISSING);
    if (facts.vinOverride === true) return evalResult(rule, RULE_OUTCOMES.FAIL, PICKUP_VIN_SOURCE.OVERRIDE);
    if (!vinsAgree(normalizeVin(facts.vehicleVin), captured)) {
      return evalResult(rule, RULE_OUTCOMES.FAIL, PICKUP_VIN_SOURCE.MISMATCH);
    }
    return evalResult(rule, RULE_OUTCOMES.PASS, PICKUP_VIN_SOURCE.VERIFIED);
  },
  [ELIGIBILITY_RULE_TYPES.FIELD_PRESENT]: (rule, facts) => {
    const value = rule.field ? facts[rule.field] : void 0;
    const present = typeof value === "string" ? value.trim() !== "" : value != null;
    return evalResult(rule, present ? RULE_OUTCOMES.PASS : RULE_OUTCOMES.ASSUME, rule.field ?? "field");
  },
  [ELIGIBILITY_RULE_TYPES.BOOLEAN_SIGNAL]: (rule, facts) => {
    const value = rule.field ? facts[rule.field] : void 0;
    if (value == null) return evalResult(rule, RULE_OUTCOMES.ASSUME, `${rule.field ?? "signal"}_unavailable`);
    return evalResult(rule, value ? RULE_OUTCOMES.PASS : RULE_OUTCOMES.FAIL, rule.field ?? "signal");
  }
};
function dueStage(timing) {
  return timing === RULE_TIMING.MANUAL ? RULE_TIMING.AT_DELIVERY : timing;
}
function stageReachedFor(timing, stageReached) {
  const required = LIFECYCLE_STAGE_ORDER[dueStage(timing)];
  const reached = stageReached == null ? void 0 : LIFECYCLE_STAGE_ORDER[stageReached];
  return required !== void 0 && reached !== void 0 && reached >= required;
}
function isAlwaysAssumed(rule) {
  return rule.policy === RULE_POLICY.ALWAYS_ASSUME || rule.type === LEGACY_ALWAYS_ASSUME_TYPE;
}
function notEvaluated(rule) {
  return {
    ruleKey: rule.key,
    outcome: RULE_OUTCOMES.ASSUME,
    source: rule.source ?? NOT_EVALUATED_SOURCE,
    timing: rule.timing ?? TYPE_DEFAULT_TIMING[rule.type] ?? RULE_TIMING.AT_CREATE
  };
}
function applyRulePolicy(rule, evaluation, stageReached) {
  if (evaluation.outcome !== RULE_OUTCOMES.ASSUME) return evaluation;
  if (rule.policy !== RULE_POLICY.FAIL_WHEN_UNKNOWN) return evaluation;
  if (!stageReachedFor(evaluation.timing, stageReached)) return evaluation;
  return { ...evaluation, outcome: RULE_OUTCOMES.FAIL };
}
function evaluateProgramMoveEligibility(config, facts) {
  const eligibility = config?.eligibility;
  const rules = eligibility?.rules ?? [];
  const evaluationResult = [];
  for (const rule of rules) {
    if (isAlwaysAssumed(rule)) {
      evaluationResult.push(notEvaluated(rule));
      continue;
    }
    const evaluate = RULE_EVALUATORS[rule.type];
    if (evaluate) evaluationResult.push(applyRulePolicy(rule, evaluate(rule, facts), facts.stageReached));
  }
  const eligibilityStatus = evaluationResult.some((rule) => rule.outcome === RULE_OUTCOMES.FAIL) ? ELIGIBILITY_STATUS.INELIGIBLE : ELIGIBILITY_STATUS.ELIGIBLE;
  return { eligibilityStatus, evaluationResult };
}

// src/features/ar-triggers/algorithms/contractRuleSchemas/registry.ts
var CONTRACT_RULE_SCHEMA_KEYS = [
  "mileage-bands",
  "per-use-fee",
  "program-coverage",
  "program-settlement"
];
function define(def) {
  return def;
}
var CONTRACT_SETTLEMENT_MODES = [SETTLEMENT_MODE.PROGRAM_FRONTS, SETTLEMENT_MODE.SPLIT, SETTLEMENT_MODE.REIMBURSEMENT];
var CONTRACT_BAND_STRATEGIES = [COVERAGE_BAND_STRATEGY.STACK, COVERAGE_BAND_STRATEGY.SCHEDULE];
var ACCESSORIAL_PAYERS = [ACCESSORIAL_PAYER.PROGRAM, ACCESSORIAL_PAYER.CUSTOMER];
var ACCESSORIAL_CODE = z.string().regex(/^[a-z0-9_]+$/, "accessorial codes are lowercase type codes");
var MILEAGE_BANDS = define({
  key: "mileage-bands",
  identityProductKey: true,
  status: "active",
  description: "Distance-banded rates carried as child raterules rows. The config fragment is empty; every input is a band.",
  schema: z.object({}).strict(),
  example: {},
  consumers: [ALGORITHM_MOVE_SCENARIO_V1, ALGORITHM_PROGRAM_MOVE_COVERAGE_V1],
  fields: {}
});
var COVERAGE_SERVICE_LINES = SERVICE_LINES;
var SERVICE_LINE_CONFIG_KEY = "service_line";
var PER_USE_FEE = define({
  key: "per-use-fee",
  status: "active",
  description: "One flat dollar amount charged per use (per ride, per move). Zero means no fee.",
  schema: z.object({
    amount: z.number().finite().nonnegative()
  }).strict(),
  example: { amount: 0.75 },
  consumers: [ALGORITHM_GUESTRIDE_SCENARIO_V1, ALGORITHM_MOVE_FLAT_FEE_V1, ALGORITHM_RETURN_RIDE_SCENARIO_V1],
  fields: {
    amount: { type: "currency", label: "Amount per use", optional: false, min: 0 }
  }
});
var PROGRAM_SETTLEMENT = define({
  key: "program-settlement",
  status: "deprecated",
  description: "How a program contract settles covered moves (program fronts the cost, the split is invoiced at source, or the program reimburses a Lite dealer), how its bands combine into a move cost, and which party pays each accessorial type. Anything left out falls to the default for the contract service line. Optional service_line scopes the rule to one line on a multi-coverage contract.",
  schema: z.object({
    settlement: z.enum(CONTRACT_SETTLEMENT_MODES).optional(),
    bandStrategy: z.enum(CONTRACT_BAND_STRATEGIES).optional(),
    service_line: z.enum(COVERAGE_SERVICE_LINES).optional(),
    accessorialCoverage: z.object({
      default: z.enum(ACCESSORIAL_PAYERS).optional(),
      byType: z.record(ACCESSORIAL_CODE, z.enum(ACCESSORIAL_PAYERS)).optional()
    }).strict().optional()
  }).strict(),
  example: { settlement: "program_fronts", accessorialCoverage: { default: "customer", byType: { fuel: "program" } } },
  consumers: [ALGORITHM_PROGRAM_MOVE_COVERAGE_V1]
  // Nested, so no flat field descriptor. Admin renders this with a structured editor.
});
var ELIGIBILITY_RULE_TYPE_VALUES = Object.values(ELIGIBILITY_RULE_TYPES);
var RULE_TIMING_VALUES = Object.values(RULE_TIMING);
var RULE_POLICY_VALUES = Object.values(RULE_POLICY);
var ELIGIBILITY_RULE = z.object({
  key: z.string().min(1),
  type: z.enum(ELIGIBILITY_RULE_TYPE_VALUES),
  timing: z.enum(RULE_TIMING_VALUES).optional(),
  source: z.string().optional(),
  makes: z.array(z.string()).optional(),
  maxModelYearAge: z.number().int().nonnegative().optional(),
  maxOdometer: z.number().nonnegative().optional(),
  field: z.string().optional(),
  policy: z.enum(RULE_POLICY_VALUES).optional()
}).strict();
var PROGRAM_COVERAGE = define({
  key: "program-coverage",
  status: "active",
  description: "One program coverage line: the service line it prices, how the program settles a covered move (program fronts the cost, the split is invoiced at source, or the program reimburses a Lite dealer), how its bands combine into a move cost, which party pays each accessorial type, and the eligibility rules a move must pass. The bands are the rule's own rate rules. Anything left out falls to the default for the service line.",
  schema: z.object({
    service_line: z.enum(COVERAGE_SERVICE_LINES),
    settlement: z.enum(CONTRACT_SETTLEMENT_MODES).optional(),
    bandStrategy: z.enum(CONTRACT_BAND_STRATEGIES).optional(),
    accessorialCoverage: z.object({
      default: z.enum(ACCESSORIAL_PAYERS).optional(),
      byType: z.record(ACCESSORIAL_CODE, z.enum(ACCESSORIAL_PAYERS)).optional()
    }).strict().optional(),
    eligibility: z.object({
      rules: z.array(ELIGIBILITY_RULE).optional()
    }).strict().optional()
  }).strict(),
  example: {
    service_line: "full_service",
    settlement: "program_fronts",
    bandStrategy: "stack",
    accessorialCoverage: { default: "customer", byType: { fuel: "program" } },
    eligibility: { rules: [{ key: "gm-makes", type: "make_in", makes: ["Chevrolet", "GMC", "Buick", "Cadillac"] }] }
  },
  consumers: [ALGORITHM_PROGRAM_MOVE_COVERAGE_V1],
  // One rule per service line, which is also how the algorithm selects one.
  identityKeys: [SERVICE_LINE_CONFIG_KEY]
  // Nested, so no flat field descriptor. Admin renders this with the coverage form.
});
var CONTRACT_RULE_SCHEMAS = {
  "mileage-bands": MILEAGE_BANDS,
  "per-use-fee": PER_USE_FEE,
  "program-coverage": PROGRAM_COVERAGE,
  "program-settlement": PROGRAM_SETTLEMENT
};
function isContractRuleSchemaKey(value) {
  return typeof value === "string" && CONTRACT_RULE_SCHEMA_KEYS.includes(value);
}
function getContractRuleSchema(key) {
  return isContractRuleSchemaKey(key) ? CONTRACT_RULE_SCHEMAS[key] : void 0;
}
function contractRuleIdentity(schemaKey, config, productKey) {
  const schema = getContractRuleSchema(schemaKey);
  if (schema?.identityProductKey) return productKey == null ? null : JSON.stringify([productKey]);
  const keys = schema?.identityKeys;
  if (keys === void 0 || keys.length === 0) return null;
  if (typeof config !== "object" || config === null || Array.isArray(config)) return null;
  const values = keys.map((key) => config[key]);
  if (values.some((value) => typeof value !== "string")) return null;
  return JSON.stringify(values);
}
function contractRuleBandsCoexist(a, b) {
  if (a.schema_key !== b.schema_key) return false;
  const identityA = contractRuleIdentity(a.schema_key, a.config, a.product_key);
  const identityB = contractRuleIdentity(b.schema_key, b.config, b.product_key);
  return identityA !== null && identityB !== null && identityA !== identityB;
}
function listContractRuleSchemas() {
  return [...CONTRACT_RULE_SCHEMA_KEYS].sort().map((key) => CONTRACT_RULE_SCHEMAS[key]);
}

// src/features/ar-triggers/algorithms/contractRuleSchemas/validate.ts
var CONTRACT_RULE_CONFIG_FAILURE = {
  UNKNOWN_SCHEMA_KEY: "unknown-schema-key",
  INVALID_CONFIG: "invalid-config",
  UNSCHEMATIZED_CONFIG: "unschematized-config"
};
function validateContractRuleConfig(schemaKey, config) {
  return validate(schemaKey, config);
}
function validate(schemaKey, config) {
  if (schemaKey === null || schemaKey === void 0) return validateUnschematized(config);
  if (!isContractRuleSchemaKey(schemaKey)) {
    return {
      ok: false,
      schemaKey,
      code: CONTRACT_RULE_CONFIG_FAILURE.UNKNOWN_SCHEMA_KEY,
      issues: [
        {
          path: "schema_key",
          code: CONTRACT_RULE_CONFIG_FAILURE.UNKNOWN_SCHEMA_KEY,
          message: `"${schemaKey}" is not a registered contract-rule schema key. Registered: ${CONTRACT_RULE_SCHEMA_KEYS.join(", ")}.`
        }
      ]
    };
  }
  if (!isPlainObject(config)) {
    return {
      ok: false,
      schemaKey,
      code: CONTRACT_RULE_CONFIG_FAILURE.INVALID_CONFIG,
      issues: [{ path: "", code: "invalid_type", message: `config must be a JSON object, received ${describe(config)}` }]
    };
  }
  const parsed = CONTRACT_RULE_SCHEMAS[schemaKey].schema.safeParse(config);
  if (parsed.success) {
    return { ok: true, schemaKey, config: parsed.data };
  }
  return {
    ok: false,
    schemaKey,
    code: CONTRACT_RULE_CONFIG_FAILURE.INVALID_CONFIG,
    issues: parsed.error.issues.flatMap(toIssues)
  };
}
function validateUnschematized(config) {
  if (!isPlainObject(config)) {
    return {
      ok: false,
      schemaKey: null,
      code: CONTRACT_RULE_CONFIG_FAILURE.UNSCHEMATIZED_CONFIG,
      issues: [{ path: "", code: "invalid_type", message: `config must be a JSON object, received ${describe(config)}` }]
    };
  }
  const keys = Object.keys(config);
  if (keys.length === 0) return { ok: true, schemaKey: null, config: {} };
  return {
    ok: false,
    schemaKey: null,
    code: CONTRACT_RULE_CONFIG_FAILURE.UNSCHEMATIZED_CONFIG,
    issues: keys.map((key) => ({
      path: key,
      code: CONTRACT_RULE_CONFIG_FAILURE.UNSCHEMATIZED_CONFIG,
      message: `a rule with no schema_key may not carry config; set schema_key before writing "${key}"`
    }))
  };
}
function toIssues(issue) {
  const base = issue.path.map(String).join(".");
  if (issue.code === "unrecognized_keys") {
    return issue.keys.map((key) => ({
      path: base ? `${base}.${key}` : key,
      code: issue.code,
      message: `"${key}" is not an input of this schema`
    }));
  }
  return [{ path: base, code: issue.code, message: issue.message }];
}
function isPlainObject(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function describe(value) {
  if (value === null) return "null";
  if (Array.isArray(value)) return "an array";
  return typeof value;
}
function formatContractRuleConfigIssues(issues) {
  return issues.map((issue) => issue.path ? `${issue.path}: ${issue.message}` : issue.message).join("; ");
}
var ContractRuleConfigError = class extends Error {
  constructor(schemaKey, code, issues) {
    super(
      `Contract rule config rejected (${code}) under schema "${schemaKey ?? "none"}": ${formatContractRuleConfigIssues(issues)}`
    );
    this.name = "ContractRuleConfigError";
    this.schemaKey = schemaKey;
    this.code = code;
    this.issues = issues;
  }
};
function assertContractRuleConfig(schemaKey, config) {
  const result = validateContractRuleConfig(schemaKey, config);
  if (result.ok === false) throw new ContractRuleConfigError(result.schemaKey, result.code, result.issues);
  return result.config;
}

// src/features/contract-rules/prepareWrite.ts
var ContractRuleWriteError = class extends Error {
  constructor(field, message) {
    super(message);
    this.name = "ContractRuleWriteError";
    this.field = field;
  }
};
function prepareContractRuleInsert(input) {
  if (!Number.isInteger(input.contractId) || input.contractId <= 0) {
    throw new ContractRuleWriteError("contract_id", `contract_id must be a positive integer, received ${String(input.contractId)}`);
  }
  const { name, description, product_key } = prepareContractRuleMetadataUpdate(input);
  const { schema_key, config } = prepareContractRuleConfigUpdate({ schemaKey: input.schemaKey, config: input.config });
  return {
    contract_id: input.contractId,
    name,
    description,
    product_key,
    schema_key,
    config
  };
}
function prepareContractRuleMetadataUpdate(input) {
  const name = input.name?.trim() ?? "";
  if (name.length === 0) {
    throw new ContractRuleWriteError("name", "a contract rule needs a non-blank name so an operator can say what it is for");
  }
  const description = input.description?.trim() ?? "";
  return {
    name,
    description: description.length > 0 ? description : null,
    product_key: input.productKey ?? null
  };
}
function prepareContractRuleConfigUpdate(input) {
  const config = assertContractRuleConfig(input.schemaKey, input.config ?? {});
  return { schema_key: input.schemaKey ?? null, config };
}

// src/features/contract-rules/writeContractRule.ts
init_schema();
import { resolveExecutor as resolveExecutor5, getLogger as getLogger2 } from "@hopdrive/sdk-core";
var DEFAULT_UPDATED_BY = "sdk-ar";
function normalize(row) {
  return {
    id: Number(row.id),
    contract_id: Number(row.contract_id),
    name: String(row.name),
    description: row.description ?? null,
    product_key: row.product_key ?? null,
    schema_key: row.schema_key ?? null,
    config: row.config ?? {},
    active: row.active === void 0 ? true : row.active !== false
  };
}
async function setContractRuleActive(ruleId, active, options, verb) {
  if (!Number.isInteger(ruleId) || ruleId <= 0) {
    throw new ContractRuleWriteError("id", `a contract rule id must be a positive integer, received ${String(ruleId)}`);
  }
  const executor = resolveExecutor5();
  const logger = getLogger2();
  const result = await executor.mutate(SetContractRuleActiveDocument, {
    id: ruleId,
    active,
    updatedat: (/* @__PURE__ */ new Date()).toISOString(),
    updatedby: options.updatedBy ?? DEFAULT_UPDATED_BY
  });
  const updated = result.update_contract_rules_by_pk;
  if (!updated) throw new Error(`contract rule ${ruleId} not found`);
  const row = normalize(updated);
  logger.info(`[setContractRuleActive] ${verb}`, {
    contractRuleId: row.id,
    contractId: row.contract_id,
    active: row.active
  });
  return row;
}
async function deleteContractRule(ruleId, options = {}) {
  return setContractRuleActive(ruleId, false, options, "deleted");
}
async function restoreContractRule(ruleId, options = {}) {
  return setContractRuleActive(ruleId, true, options, "restored");
}
async function createContractRule(input, options = {}) {
  const payload = prepareContractRuleInsert(input);
  const executor = resolveExecutor5();
  const logger = getLogger2();
  const actor = options.updatedBy ?? DEFAULT_UPDATED_BY;
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const result = await executor.mutate(
    InsertContractRuleDocument,
    {
      object: {
        ...payload,
        createdat: now,
        createdby: actor,
        updatedat: now,
        updatedby: actor
      }
    }
  );
  const inserted = result.insert_contract_rules_one;
  if (!inserted) throw new Error("insert_contract_rules_one returned no row");
  const row = normalize(inserted);
  logger.info("[createContractRule] inserted", {
    contractRuleId: row.id,
    contractId: row.contract_id,
    schemaKey: row.schema_key,
    productKey: row.product_key
  });
  return row;
}
async function updateContractRule(ruleId, input, options = {}) {
  if (!Number.isInteger(ruleId) || ruleId <= 0) {
    throw new ContractRuleWriteError("id", `a contract rule id must be a positive integer, received ${String(ruleId)}`);
  }
  const payload = prepareContractRuleConfigUpdate(input);
  const executor = resolveExecutor5();
  const logger = getLogger2();
  const result = await executor.mutate(
    UpdateContractRuleConfigDocument,
    {
      id: ruleId,
      set: {
        ...payload,
        updatedat: (/* @__PURE__ */ new Date()).toISOString(),
        updatedby: options.updatedBy ?? DEFAULT_UPDATED_BY
      }
    }
  );
  const updated = result.update_contract_rules_by_pk;
  if (!updated) throw new Error(`contract rule ${ruleId} not found`);
  const row = normalize(updated);
  logger.info("[updateContractRule] config replaced", {
    contractRuleId: row.id,
    contractId: row.contract_id,
    schemaKey: row.schema_key
  });
  return row;
}
async function updateContractRuleMetadata(ruleId, input, options = {}) {
  if (!Number.isInteger(ruleId) || ruleId <= 0) {
    throw new ContractRuleWriteError("id", `a contract rule id must be a positive integer, received ${String(ruleId)}`);
  }
  const payload = prepareContractRuleMetadataUpdate(input);
  const executor = resolveExecutor5();
  const logger = getLogger2();
  const result = await executor.mutate(
    UpdateContractRuleMetadataDocument,
    {
      id: ruleId,
      set: {
        ...payload,
        updatedat: (/* @__PURE__ */ new Date()).toISOString(),
        updatedby: options.updatedBy ?? DEFAULT_UPDATED_BY
      }
    }
  );
  const updated = result.update_contract_rules_by_pk;
  if (!updated) throw new Error(`contract rule ${ruleId} not found`);
  const row = normalize(updated);
  logger.info("[updateContractRuleMetadata] updated", {
    contractRuleId: row.id,
    contractId: row.contract_id,
    productKey: row.product_key
  });
  return row;
}

// src/features/ar-triggers/algorithms/shared/runner.ts
import { getLogger as getLogger3 } from "@hopdrive/sdk-core";

// src/utils/metadataLogger.ts
var MetadataLogger = class {
  constructor(initialContext) {
    this.logs = [];
    this.context = {};
    this.summary = {
      itemsProcessed: 0,
      itemsSkipped: 0,
      errors: 0,
      warnings: 0
    };
    if (initialContext) {
      this.context = initialContext;
    }
  }
  // ─── Context Management ──────────────────────────────────────────────────
  /**
   * Update execution context (useful for adding contractId after it's resolved)
   */
  setContext(context) {
    this.context = { ...this.context, ...context };
  }
  /**
   * Set rerun context (if this run replaced a previous argroup)
   */
  setRerun(rerun) {
    this.rerun = rerun;
  }
  // ─── Core Logging Methods ────────────────────────────────────────────────
  /**
   * Log a message with structured data
   */
  log(level, category, message, data) {
    this.logs.push({
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      level,
      category,
      message,
      data
    });
    if (level === "error") this.summary.errors = (this.summary.errors ?? 0) + 1;
    if (level === "warning") this.summary.warnings = (this.summary.warnings ?? 0) + 1;
  }
  /**
   * Log info message
   */
  info(category, message, data) {
    this.log("info", category, message, data);
  }
  /**
   * Log warning message
   */
  warning(category, message, data) {
    this.log("warning", category, message, data);
  }
  /**
   * Log error message
   */
  error(category, message, data) {
    this.log("error", category, message, data);
  }
  // ─── Summary Tracking ────────────────────────────────────────────────────
  /**
   * Increment count of items processed
   */
  incrementProcessed() {
    this.summary.itemsProcessed = (this.summary.itemsProcessed ?? 0) + 1;
  }
  /**
   * Increment count of items skipped
   */
  incrementSkipped() {
    this.summary.itemsSkipped = (this.summary.itemsSkipped ?? 0) + 1;
  }
  /**
   * Set summary fields (e.g., chargesCreated, totalAmount)
   */
  setSummary(partial) {
    this.summary = { ...this.summary, ...partial };
  }
  // ─── High-Level Logging Helpers ──────────────────────────────────────────
  /**
   * Log readiness check result
   */
  logReadinessCheck(result) {
    const message = result.ready ? `Readiness check passed: ${result.settledMoves}/${result.totalMoves} moves settled` : `Readiness check failed: ${result.settledMoves}/${result.totalMoves} moves settled`;
    this.log(result.ready ? "info" : "warning", "readiness", message, {
      scenarioId: result.scenarioId,
      ready: result.ready,
      totalMoves: result.totalMoves,
      settledMoves: result.settledMoves
    });
  }
  /**
   * Log contract loaded
   */
  logContractLoaded(contractId, customerId, rateRuleId) {
    this.info("contract", `Loaded contract #${contractId} for customer #${customerId}`, {
      contractId,
      customerId,
      rateRuleId
    });
    this.setContext({ contractId });
  }
  /**
   * Log move input data (standardized format)
   */
  logMoveInput(move) {
    this.info("input", `Processing move ${move.moveId}`, {
      moveId: move.moveId,
      active: move.active,
      chargeable: move.chargeable,
      mileage: move.mileage,
      moveClass: move.moveClass,
      weightClass: move.vehicleGrossWeightLbs,
      cancelStatus: move.cancelStatus,
      priceOverride: move.priceOverrideActive ? { active: true, amount: move.priceOverride } : void 0
    });
  }
  /**
   * Log price override calculation
   */
  logPriceOverride(moveId, amount) {
    this.info("calculation", `Using price override for move ${moveId}`, {
      moveId,
      method: "price_override",
      amount
    });
  }
  /**
   * Log rate table lookup
   */
  logRateLookup(params) {
    this.info("rate_lookup", `Rate lookup for move ${params.moveId}`, params);
  }
  /**
   * Log rate table calculation
   */
  logRateTableCalculation(params) {
    this.info("calculation", `Calculated transport charge for move ${params.moveId}`, {
      ...params,
      method: "rate_table"
    });
  }
  /**
   * Log accessorial input
   */
  logAccessorialInput(moveId, accessorial) {
    this.info("input", `Found accessorial for move ${moveId}`, {
      moveId,
      accessorialId: accessorial.accessorialId,
      code: accessorial.code,
      status: accessorial.status,
      arAmount: accessorial.arAmount,
      notes: accessorial.notes
    });
  }
  /**
   * Log accessorial calculation
   */
  logAccessorialCalculation(moveId, accessorial) {
    this.info("calculation", "Calculated accessorial charge", {
      moveId,
      method: "accessorial",
      accessorialId: accessorial.accessorialId,
      code: accessorial.code,
      amount: accessorial.arAmount
    });
  }
  /**
   * Log ridehail input
   */
  logRidehailInput(moveId, ridehailId, customerCharge, upcharge) {
    this.info("input", `Found ridehail for move ${moveId}`, {
      moveId,
      ridehailId,
      customerCharge,
      upcharge
    });
  }
  /**
   * Log ridehail calculation
   */
  logRidehailCalculation(moveId, ridehailId, amount) {
    this.info("calculation", "Calculated ridehail charge", {
      moveId,
      method: "ridehail",
      ridehailId,
      amount
    });
  }
  /**
   * Log charge creation (generic)
   */
  logChargeCreated(params) {
    this.info("charge", `Created ${params.chargeType} charge`, params);
  }
  /**
   * Log skip with reason
   */
  logSkip(itemId, reason, context) {
    this.warning("skip", `Skipped item ${itemId}: ${reason}`, {
      itemId,
      reason,
      ...context
    });
    this.incrementSkipped();
  }
  /**
   * Log fixed fee calculation (time-based algorithms)
   */
  logFixedFee(params) {
    this.info("calculation", `Calculated ${params.method}`, {
      method: "fixed_fee",
      ...params
    });
  }
  // ─── Build Final Metadata ────────────────────────────────────────────────
  /**
   * Build final metadata object for storage in argroup.run_metadata
   */
  toMetadata() {
    let status = "completed";
    if ((this.summary.errors ?? 0) > 0) {
      status = this.summary.chargesCreated ? "partial" : "failed";
    }
    const metadata = {
      execution: {
        triggerId: this.context.triggerId,
        triggerType: this.context.triggerType,
        eventKey: this.context.eventKey,
        executionDate: this.context.executionDate ?? (/* @__PURE__ */ new Date()).toISOString(),
        algorithmKey: this.context.algorithmKey,
        contractId: this.context.contractId,
        customerId: this.context.customerId,
        orgId: this.context.orgId,
        scenarioId: this.context.scenarioId
      },
      summary: {
        ...this.summary,
        status
      },
      logs: this.logs
    };
    if (this.rerun) {
      metadata.rerun = this.rerun;
    }
    return metadata;
  }
};
function createAlgorithmLogger(trigger) {
  return new MetadataLogger({
    triggerId: trigger.id,
    triggerType: trigger.scenarioId ? "event" : "time",
    eventKey: trigger.eventKey,
    executionDate: trigger.executionDate?.toISOString() ?? (/* @__PURE__ */ new Date()).toISOString(),
    algorithmKey: trigger.algorithmKey,
    contractId: trigger.contractId,
    customerId: trigger.customerId,
    orgId: trigger.orgId,
    scenarioId: trigger.scenarioId
  });
}

// src/features/ar-triggers/algorithms/shared/runner.ts
init_productMapping();
function algorithmSkip(reason, extras = {}) {
  return { skip: true, reason, ...extras };
}
function isAlgorithmSkip(value) {
  return typeof value === "object" && value !== null && value.skip === true;
}
function buildShell(triggerContext) {
  return { triggerContext, logger: getLogger3(), metadataLogger: createAlgorithmLogger(triggerContext) };
}
function skippedResult(key, shell, skip) {
  shell.logger.info(`${key}: skipped trigger ${shell.triggerContext.id} \u2014 ${skip.reason}`, {
    triggerId: shell.triggerContext.id,
    algorithmKey: key,
    contractId: shell.triggerContext.contractId,
    scenarioId: shell.triggerContext.scenarioId,
    skipReason: skip.reason,
    ...skip.logFields
  });
  return {
    status: ALGORITHM_STATUS_SKIPPED,
    skipReason: skip.reason,
    ...skip.metadata && { metadata: skip.metadata },
    ...skip.customerId !== void 0 && { customerId: skip.customerId },
    ...skip.orgId !== void 0 && { orgId: skip.orgId }
  };
}
async function attachAccountingKeys(accountingProductKey, charges) {
  if (!accountingProductKey || charges.length === 0) return;
  const accountingKey = await resolveAccountingKey(accountingProductKey);
  for (const charge of charges) charge.accountingKey = accountingKey;
}
function runScenarioAlgorithm(spec) {
  return async (trigger) => {
    const shell = buildShell(trigger);
    const scenarioId = trigger.scenarioId;
    if (!scenarioId) {
      return skippedResult(spec.key, shell, algorithmSkip(`No scenario ID provided for ${spec.key}`));
    }
    shell.logger.info(
      `${spec.key} start: trigger ${trigger.id} scenario ${scenarioId} (event ${trigger.eventKey ?? "n/a"})`,
      { triggerId: trigger.id, scenarioId, customerId: trigger.customerId, eventKey: trigger.eventKey }
    );
    const notReady = await spec.checkReadiness({ scenarioId, shell });
    if (notReady) return skippedResult(spec.key, shell, notReady);
    const context = await spec.loadContext({ scenarioId, shell });
    if (isAlgorithmSkip(context)) return skippedResult(spec.key, shell, context);
    const contract = await spec.loadContract({ scenarioId, context, shell });
    if (isAlgorithmSkip(contract)) return skippedResult(spec.key, shell, contract);
    const priced = await spec.price({ scenarioId, context, contract, shell });
    await attachAccountingKeys(spec.accountingProductKey, [
      ...priced.charges,
      ...priced.customerCharges ?? []
    ]);
    shell.logger.info(
      `${spec.key} complete: scenario ${scenarioId} trigger ${trigger.id} produced ${priced.charges.length} charge${priced.charges.length === 1 ? "" : "s"}${priced.customerCharges ? ` + ${priced.customerCharges.length} customer-leg` : ""}`,
      {
        triggerId: trigger.id,
        scenarioId,
        chargeCount: priced.charges.length,
        customerChargeCount: priced.customerCharges?.length
      }
    );
    return {
      status: ALGORITHM_STATUS_COMPLETED,
      charges: priced.charges,
      ...priced.customerCharges && { customerCharges: priced.customerCharges },
      metadata: priced.metadata,
      customerId: context.customerId,
      orgId: context.orgId
    };
  };
}
function runTimeAlgorithm(spec) {
  return async (trigger) => {
    const shell = buildShell(trigger);
    shell.logger.info(`${spec.key} start: trigger ${trigger.id} for customer ${trigger.customerId ?? "n/a"}`, {
      triggerId: trigger.id,
      customerId: trigger.customerId,
      productKey: trigger.product_key
    });
    const priced = await spec.price({ shell });
    if (isAlgorithmSkip(priced)) return skippedResult(spec.key, shell, priced);
    shell.logger.info(
      `${spec.key} complete: trigger ${trigger.id} produced ${priced.charges.length} charge${priced.charges.length === 1 ? "" : "s"}`,
      { triggerId: trigger.id, customerId: trigger.customerId, chargeCount: priced.charges.length }
    );
    return {
      status: ALGORITHM_STATUS_COMPLETED,
      charges: priced.charges,
      metadata: priced.metadata,
      customerId: trigger.customerId,
      orgId: trigger.orgId
    };
  };
}

// src/features/ar-triggers/algorithms/shared/contractRuleInputs.ts
var CONTRACT_RULE_SKIP_SCHEMA_KEY_MISMATCH = "schema-key-mismatch";
function readContractRuleConfig(rule, expectedSchemaKey) {
  const label = rule.name ? `contract rule ${rule.id} ("${rule.name}")` : `contract rule ${rule.id}`;
  if (rule.schema_key !== expectedSchemaKey) {
    return algorithmSkip(
      `${label} carries schema "${rule.schema_key ?? "none"}" but the algorithm expects "${expectedSchemaKey}"; not pricing on it`,
      {
        metadata: {
          contractRuleId: rule.id,
          schemaKey: rule.schema_key,
          expectedSchemaKey,
          code: CONTRACT_RULE_SKIP_SCHEMA_KEY_MISMATCH
        }
      }
    );
  }
  const result = validateContractRuleConfig(expectedSchemaKey, rule.config);
  if (result.ok === true) return result.config;
  const where = result.issues.map((i) => i.path || "(root)").join(", ");
  return algorithmSkip(
    `${label} config fails schema "${expectedSchemaKey}" at ${where}; not pricing on it`,
    {
      metadata: {
        contractRuleId: rule.id,
        schemaKey: rule.schema_key,
        code: result.code,
        issues: result.issues
      }
    }
  );
}

// src/features/ar-triggers/algorithms/shared/contractRuleSelection.ts
import { getLogger as getLogger4 } from "@hopdrive/sdk-core";
function ruleContextFrom(shell, contractId, purpose) {
  const trigger = shell.triggerContext;
  return {
    triggerId: trigger.id,
    algorithmKey: trigger.algorithmKey,
    contractId,
    scenarioId: trigger.scenarioId,
    purpose
  };
}
var CONTRACT_RULE_NOT_FOUND = "contract-rule-not-found";
var CONTRACT_RULE_AMBIGUOUS = "contract-rule-ambiguous";
var CONTRACT_RULE_NO_BANDS = "contract-rule-no-bands";
function describeCriteria(criteria) {
  const parts = [];
  if (criteria.ruleId !== void 0) parts.push(`id=${criteria.ruleId}`);
  if (criteria.name !== void 0) parts.push(`name="${criteria.name}"`);
  if ("productKey" in criteria && criteria.productKey !== void 0)
    parts.push(`product_key=${criteria.productKey === null ? "none" : criteria.productKey}`);
  if ("schemaKey" in criteria && criteria.schemaKey !== void 0)
    parts.push(`schema_key=${criteria.schemaKey === null ? "none" : criteria.schemaKey}`);
  if (criteria.carriesBands !== void 0) parts.push(criteria.carriesBands ? "carries bands" : "no bands");
  if (criteria.where !== void 0) parts.push(criteria.where.label);
  return parts.join(", ");
}
function assertHasCriteria(criteria) {
  const described = describeCriteria(criteria);
  if (described.length > 0) return;
  throw new Error(
    'selectContractRules needs at least one criterion (ruleId, name, productKey, schemaKey, carriesBands or where). With none it would match every rule on the contract and hand back "the first rule for the product", which is not a selection. Pass the criteria that identify the rule this algorithm prices from.'
  );
}
function selectContractRules(rules, criteria) {
  assertHasCriteria(criteria);
  return rules.filter((rule) => {
    if (rule.active === false) return false;
    if (criteria.ruleId !== void 0 && rule.id !== criteria.ruleId) return false;
    if (criteria.name !== void 0 && rule.name !== criteria.name) return false;
    if ("productKey" in criteria && criteria.productKey !== void 0) {
      if ((rule.product_key ?? null) !== criteria.productKey) return false;
    }
    if ("schemaKey" in criteria && criteria.schemaKey !== void 0) {
      if ((rule.schema_key ?? null) !== criteria.schemaKey) return false;
    }
    if (criteria.carriesBands !== void 0) {
      if (rule.raterules.length > 0 !== criteria.carriesBands) return false;
    }
    if (criteria.where !== void 0 && !criteria.where.match(rule)) return false;
    return true;
  });
}
function skipWithLog(context, code, reason, extra) {
  const fields = {
    triggerId: context.triggerId,
    algorithmKey: context.algorithmKey,
    contractId: context.contractId,
    scenarioId: context.scenarioId,
    purpose: context.purpose,
    code,
    ...extra
  };
  getLogger4().warn(`contract-rule selection (${context.purpose}): ${reason}`, fields);
  return algorithmSkip(reason, { metadata: fields, logFields: fields });
}
function relogConfigSkip(context, skip, criteria, expectedSchemaKey) {
  const fields = {
    triggerId: context.triggerId,
    algorithmKey: context.algorithmKey,
    contractId: context.contractId,
    scenarioId: context.scenarioId,
    purpose: context.purpose,
    criteria,
    expectedSchemaKey,
    ...skip.metadata ?? {}
  };
  getLogger4().warn(`contract-rule selection (${context.purpose}): ${skip.reason}`, fields);
  return { ...skip, metadata: fields, logFields: fields };
}
function requireOneContractRule(args) {
  const { rules, criteria, context } = args;
  const described = describeCriteria(criteria);
  const matches = selectContractRules(rules, criteria);
  if (matches.length === 0) {
    return skipWithLog(
      context,
      CONTRACT_RULE_NOT_FOUND,
      `no contract rule on contract ${context.contractId} matches ${described}; not pricing on a rule that is not there`,
      { criteria: described, availableContractRuleIds: rules.map((r) => r.id) }
    );
  }
  if (matches.length > 1) {
    const ids = matches.map((r) => r.id);
    return skipWithLog(
      context,
      CONTRACT_RULE_AMBIGUOUS,
      `${matches.length} contract rules on contract ${context.contractId} match ${described} (ids ${ids.join(", ")}); the algorithm must disambiguate rather than take one of them`,
      { criteria: described, candidateContractRuleIds: ids }
    );
  }
  return matches[0];
}
function requireContractRuleConfig(args) {
  const { rules, criteria, schemaKey, context } = args;
  const rule = requireOneContractRule({ rules, criteria, context });
  if (isSkip(rule)) return rule;
  const config = readContractRuleConfig(rule, schemaKey);
  if (isSkip(config)) return relogConfigSkip(context, config, describeCriteria(criteria), schemaKey);
  return { rule, config, bands: rule.raterules };
}
var CONTRACT_RULE_SELECTION = {
  MATCHED_SCOPE: "matched-scope",
  /** The scope matched nothing, or none was given, and exactly one relevant rule exists. */
  SINGLE_CANDIDATE: "single-candidate"
};
function productKeyScope(productKey) {
  if (productKey == null) return void 0;
  return {
    label: `product_key=${productKey}`,
    match: (rule) => (rule.product_key ?? null) === productKey
  };
}
function configFieldScope(field, value) {
  if (value == null) return void 0;
  return {
    label: `config.${field}=${value}`,
    match: (rule) => {
      const config = rule.config;
      return config != null && typeof config === "object" && config[field] === value;
    }
  };
}
function resolveContractRule(args) {
  const { rules, criteria, scope, context } = args;
  const described = describeCriteria(criteria);
  const relevant = selectContractRules(rules, criteria);
  if (relevant.length === 0) {
    return skipWithLog(
      context,
      CONTRACT_RULE_NOT_FOUND,
      `no contract rule on contract ${context.contractId} matches ${described}; not pricing on a rule that is not there`,
      { criteria: described, availableContractRuleIds: rules.map((r) => r.id) }
    );
  }
  const scoped = scope === void 0 ? [] : relevant.filter((rule) => scope.match(rule));
  if (scoped.length === 1) {
    return selectedWithLog(context, scoped[0], CONTRACT_RULE_SELECTION.MATCHED_SCOPE, described, scope?.label ?? null, relevant);
  }
  if (scoped.length > 1) {
    const ids2 = scoped.map((r) => r.id);
    return skipWithLog(
      context,
      CONTRACT_RULE_AMBIGUOUS,
      `${scoped.length} contract rules on contract ${context.contractId} match ${described} and ${scope?.label} (ids ${ids2.join(", ")}); the algorithm must disambiguate rather than take one of them`,
      { criteria: described, scope: scope?.label ?? null, candidateContractRuleIds: ids2 }
    );
  }
  if (relevant.length === 1) {
    return selectedWithLog(context, relevant[0], CONTRACT_RULE_SELECTION.SINGLE_CANDIDATE, described, scope?.label ?? null, relevant);
  }
  const ids = relevant.map((r) => r.id);
  return skipWithLog(
    context,
    CONTRACT_RULE_AMBIGUOUS,
    `${relevant.length} contract rules on contract ${context.contractId} match ${described} and none matches ${scope === void 0 ? "a scope (none given)" : scope.label} (ids ${ids.join(", ")}); the algorithm must disambiguate rather than take one of them`,
    { criteria: described, scope: scope?.label ?? null, candidateContractRuleIds: ids }
  );
}
function selectedWithLog(context, rule, selection, criteria, scope, relevant) {
  getLogger4().info(
    `contract-rule selection (${context.purpose}): rule ${rule.id} ("${rule.name ?? ""}") on contract ${context.contractId} selected by ${selection}`,
    {
      triggerId: context.triggerId,
      algorithmKey: context.algorithmKey,
      contractId: context.contractId,
      scenarioId: context.scenarioId,
      purpose: context.purpose,
      criteria,
      scope,
      contractRuleId: rule.id,
      selection,
      candidateContractRuleIds: relevant.map((r) => r.id)
    }
  );
  return { rule, selection };
}
function isSkip(value) {
  return typeof value === "object" && value !== null && value.skip === true;
}

// src/features/ar-triggers/algorithms/shared/programCoverageRule.ts
import { getLogger as getLogger5 } from "@hopdrive/sdk-core";
var PROGRAM_COVERAGE_SCHEMA_KEY = "program-coverage";
function serviceLineOf(rule) {
  const value = rule.config?.[SERVICE_LINE_CONFIG_KEY];
  return typeof value === "string" ? value : null;
}
function programCoverageRuleCriteria(serviceLine) {
  return {
    schemaKey: PROGRAM_COVERAGE_SCHEMA_KEY,
    where: {
      label: `${PROGRAM_COVERAGE_SCHEMA_KEY} ${SERVICE_LINE_CONFIG_KEY}=${serviceLine}`,
      match: (rule) => serviceLineOf(rule) === serviceLine
    }
  };
}
function selectProgramCoverageRule(rules, serviceLine, context) {
  const criteria = programCoverageRuleCriteria(serviceLine);
  const candidates = selectContractRules(rules, criteria);
  if (candidates.length === 0) return null;
  if (candidates.length === 1) return candidates[0];
  const refused = requireOneContractRule({ rules, criteria, context });
  if (isAlgorithmSkip(refused)) return refused;
  throw new Error("requireOneContractRule returned a rule for a set it had already called ambiguous");
}
function selectProgramCoverageRulesForLine(rules, serviceLine) {
  return selectContractRules(rules, programCoverageRuleCriteria(serviceLine));
}
var PROGRAM_COVERAGE_RULE_NOT_CONFIGURED = "program-coverage-rule-not-configured";
function requireProgramCoverageRule(args) {
  const { rules, serviceLine, context } = args;
  const candidates = selectProgramCoverageRulesForLine(rules, serviceLine);
  if (candidates.length === 1) return candidates[0];
  if (candidates.length > 1) {
    const refused = requireOneContractRule({
      rules: candidates,
      criteria: programCoverageRuleCriteria(serviceLine),
      context
    });
    if (isAlgorithmSkip(refused)) return refused;
    throw new Error("requireOneContractRule returned a rule for a set it had already called ambiguous");
  }
  const fields = {
    triggerId: context.triggerId,
    algorithmKey: context.algorithmKey,
    contractId: context.contractId,
    scenarioId: context.scenarioId,
    purpose: context.purpose,
    code: PROGRAM_COVERAGE_RULE_NOT_CONFIGURED,
    serviceLine,
    availableContractRuleIds: rules.map((r) => r.id),
    coverageServiceLines: selectContractRules(rules, { schemaKey: PROGRAM_COVERAGE_SCHEMA_KEY }).map(
      (r) => serviceLineOf(r)
    )
  };
  const reason = `contract ${context.contractId} carries no ${PROGRAM_COVERAGE_SCHEMA_KEY} rule for ${serviceLine}, so its ${serviceLine} rate rules are not configured; not pricing this line off another line's rule`;
  getLogger5().warn(`contract-rule selection (${context.purpose}): ${reason}`, fields);
  return algorithmSkip(reason, { metadata: fields, logFields: fields });
}
function readProgramCoverageFragment(rule) {
  const config = readContractRuleConfig(rule, PROGRAM_COVERAGE_SCHEMA_KEY);
  if (isAlgorithmSkip(config)) return config;
  return config;
}
var ELIGIBILITY_SOURCE = {
  CONTRACT_RULE: "contract-rule",
  /** The parent contract's `config.eligibility`, used when the line's coverage rule is missing or declares none. */
  CONTRACT_CONFIG: "contract-config",
  /** Nothing declared rules, so every move is eligible. */
  NONE: "none"
};
function resolveProgramEligibilityConfig(args) {
  const rule = selectProgramCoverageRule(args.rules, args.serviceLine, args.context);
  if (isAlgorithmSkip(rule)) return rule;
  if (rule) {
    const fragment = readProgramCoverageFragment(rule);
    if (isAlgorithmSkip(fragment)) return fragment;
    if (fragment.eligibility) {
      return { eligibility: fragment.eligibility, source: ELIGIBILITY_SOURCE.CONTRACT_RULE, contractRuleId: rule.id };
    }
  }
  const declared = args.contractConfig?.eligibility;
  if (declared) return { eligibility: declared, source: ELIGIBILITY_SOURCE.CONTRACT_CONFIG, contractRuleId: null };
  return { eligibility: null, source: ELIGIBILITY_SOURCE.NONE, contractRuleId: null };
}

// src/features/ar-triggers/algorithms/shared/programSettlementPolicy.ts
var PROGRAM_SETTLEMENT_SCHEMA_KEY = "program-settlement";
var POLICY_SOURCE = {
  /** The line's `program-coverage` rule, or a `program-settlement` rule. */
  CONTRACT_RULE: "contract-rule",
  SERVICE_LINE_DEFAULT: "service-line-default"
};
function readSettlementRule(rule, serviceLine) {
  const config = readContractRuleConfig(rule, PROGRAM_SETTLEMENT_SCHEMA_KEY);
  if (isAlgorithmSkip(config)) return config;
  const fragment = config;
  return {
    settlement: fragment.settlement ?? defaultSettlementFor(serviceLine),
    bandStrategy: fragment.bandStrategy ?? defaultBandStrategyFor(serviceLine),
    accessorialCoverage: fragment.accessorialCoverage ?? null,
    source: POLICY_SOURCE.CONTRACT_RULE,
    contractRuleId: rule.id
  };
}
function resolveProgramSettlementPolicy(args) {
  const { rules, serviceLine, context } = args;
  const coverageRule = selectProgramCoverageRule(rules, serviceLine, context);
  if (isAlgorithmSkip(coverageRule)) return coverageRule;
  if (coverageRule) {
    const fragment = readProgramCoverageFragment(coverageRule);
    if (isAlgorithmSkip(fragment)) return fragment;
    return {
      settlement: fragment.settlement ?? defaultSettlementFor(serviceLine),
      bandStrategy: fragment.bandStrategy ?? defaultBandStrategyFor(serviceLine),
      accessorialCoverage: fragment.accessorialCoverage ?? null,
      source: POLICY_SOURCE.CONTRACT_RULE,
      contractRuleId: coverageRule.id
    };
  }
  const criteria = { schemaKey: PROGRAM_SETTLEMENT_SCHEMA_KEY };
  const candidates = selectContractRules(rules, criteria);
  if (candidates.length > 0) {
    const resolved = resolveContractRule({
      rules,
      criteria,
      scope: configFieldScope("service_line", serviceLine),
      context
    });
    if (isAlgorithmSkip(resolved)) return resolved;
    return readSettlementRule(resolved.rule, serviceLine);
  }
  return {
    settlement: defaultSettlementFor(serviceLine),
    bandStrategy: defaultBandStrategyFor(serviceLine),
    accessorialCoverage: null,
    source: POLICY_SOURCE.SERVICE_LINE_DEFAULT,
    contractRuleId: null
  };
}
function resolveAccessorialPayerFor(policy, code) {
  return policy.accessorialCoverage == null ? ACCESSORIAL_PAYER.CUSTOMER : resolveAccessorialPayer({ accessorialCoverage: policy.accessorialCoverage }, code);
}

// src/features/ar-triggers/algorithms/shared/contractRules.ts
init_operations();
async function loadContractRules(contractId) {
  const rules = await getContractRules({ contractId });
  return rules ?? [];
}

// src/features/ar-triggers/orchestrators/processEvent.ts
import { getLogger as getLogger19 } from "@hopdrive/sdk-core";

// src/utils/contextBuilders.ts
import { getLogger as getLogger6 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/writer/mutations.ts
init_schema();
import { resolveExecutor as resolveExecutor8 } from "@hopdrive/sdk-core";
async function insertArgroupWithArcharges(input) {
  const executor = resolveExecutor8();
  const result = await executor.query(InsertArgroupWithArchargesDocument, {
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    customerId: input.customerId,
    // org_id is now null unless the group is directly assigned to an organization
    orgId: null,
    algorithmKey: input.algorithmKey,
    runMetadata: input.runMetadata,
    createdby: input.createdby,
    updatedby: input.updatedby,
    arinvoiceId: input.arinvoiceId,
    archarges: input.archarges,
    snapshotCredits: input.snapshotCredits ?? [],
    carryCredits: input.carryCredits ?? []
  });
  const deactivatedArgroups = result.update_argroups?.returning ?? [];
  const newArgroup = result.insert_argroups_one;
  return {
    argroup: newArgroup,
    deactivatedArgroups,
    rerunOf: deactivatedArgroups.length > 0 ? deactivatedArgroups[0].id : void 0
  };
}
async function insertArgroupWithArchargesSimple(input) {
  const executor = resolveExecutor8();
  const result = await executor.query(InsertArgroupWithArchargesSimpleDocument, {
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    customerId: input.customerId,
    // org_id is now null unless the group is directly assigned to an organization
    orgId: null,
    algorithmKey: input.algorithmKey,
    runMetadata: input.runMetadata,
    createdby: input.createdby,
    updatedby: input.updatedby,
    arinvoiceId: input.arinvoiceId,
    archarges: input.archarges
  });
  return {
    argroup: result.insert_argroups_one
  };
}
async function insertProgramScenarioArgroupWithArcharges(input) {
  const executor = resolveExecutor8();
  const result = await executor.query(InsertProgramScenarioArgroupWithArchargesDocument, {
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    programId: input.programId,
    customerId: input.customerId,
    algorithmKey: input.algorithmKey,
    runMetadata: input.runMetadata,
    createdby: input.createdby,
    updatedby: input.updatedby,
    arinvoiceId: input.arinvoiceId,
    archarges: input.archarges,
    snapshotCredits: input.snapshotCredits ?? [],
    carryCredits: input.carryCredits ?? []
  });
  return {
    argroupId: result.insert_argroups_one?.id,
    deactivatedArgroupIds: result.update_argroups?.returning.map((r) => r.id) ?? []
  };
}
async function insertProgramArgroupWithArcharges(input) {
  const executor = resolveExecutor8();
  const result = await executor.query(InsertProgramArgroupWithArchargesDocument, {
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    programId: input.programId,
    customerId: input.customerId,
    algorithmKey: input.algorithmKey,
    runMetadata: input.runMetadata,
    createdby: input.createdby,
    updatedby: input.updatedby,
    arinvoiceId: input.arinvoiceId,
    archarges: input.archarges
  });
  return { argroup: result.insert_argroups_one };
}

// src/features/ar-triggers/writer/carryForwardCredits.ts
init_schema();
import { resolveExecutor as resolveExecutor9 } from "@hopdrive/sdk-core";
var EMPTY_PLAN = {
  snapshotCredits: [],
  carryCredits: [],
  carriedForwardCreditIds: []
};
function buildCarryForwardPlan(credits) {
  if (credits.length === 0) return EMPTY_PLAN;
  const snapshotCredits = credits.map((credit) => ({
    argroup_id: credit.argroup_id,
    amount: credit.amount,
    type: credit.type,
    reason: credit.reason,
    source_type: credit.source_type,
    source_id: credit.source_id,
    billable_datetime: credit.billable_datetime,
    createdby: credit.createdby,
    createdat: credit.createdat,
    active: true
  }));
  const carryCredits = credits.map((credit) => ({
    id: credit.id,
    amount: credit.amount,
    type: credit.type,
    reason: credit.reason,
    source_type: credit.source_type,
    source_id: credit.source_id,
    billable_datetime: credit.billable_datetime,
    createdby: credit.createdby,
    createdat: credit.createdat,
    active: true
  }));
  return {
    snapshotCredits,
    carryCredits,
    carriedForwardCreditIds: credits.map((credit) => credit.id)
  };
}
async function planCustomerScenarioCarryForward(scenarioId, algorithmKey) {
  const executor = resolveExecutor9();
  const result = await executor.query(GetActiveCreditsForCustomerScenarioDocument, { scenarioId, algorithmKey });
  return buildCarryForwardPlan(result.arcredits ?? []);
}
async function planProgramScenarioCarryForward(scenarioId, programId, algorithmKey) {
  const executor = resolveExecutor9();
  const result = await executor.query(GetActiveCreditsForProgramScenarioDocument, { scenarioId, programId, algorithmKey });
  return buildCarryForwardPlan(result.arcredits ?? []);
}

// src/features/ar-triggers/writer/commitRun.ts
function carryMetadata(plan) {
  return plan.carriedForwardCreditIds.length > 0 ? { carriedForwardCreditIds: plan.carriedForwardCreditIds } : {};
}
async function commitRun(argroupInsert, result, billableDate) {
  const archarges = result.charges.map((charge) => ({
    type: charge.type,
    name: charge.name,
    notes: charge.notes ?? null,
    amount: charge.amount,
    source_type: charge.sourceType,
    source_id: charge.sourceId,
    accounting_key: charge.accountingKey ?? null,
    document_reference_id: charge.documentReferenceId ?? null,
    billable_datetime: billableDate,
    createdby: argroupInsert.createdBy
  }));
  const isTimeBased = !argroupInsert.scenarioId;
  const carryPlan = isTimeBased ? null : await planCustomerScenarioCarryForward(argroupInsert.scenarioId, String(argroupInsert.algorithmKey));
  const argroupData = {
    scenarioId: argroupInsert.scenarioId,
    triggerId: argroupInsert.triggerId,
    customerId: argroupInsert.customerId,
    orgId: argroupInsert.orgId,
    algorithmKey: String(argroupInsert.algorithmKey),
    runMetadata: {
      ...result.metadata,
      algorithmKey: argroupInsert.algorithmKey,
      scenarioId: argroupInsert.scenarioId,
      ...carryPlan ? carryMetadata(carryPlan) : {}
    },
    createdby: argroupInsert.createdBy,
    updatedby: argroupInsert.createdBy,
    arinvoiceId: argroupInsert.arinvoiceId,
    archarges
  };
  const { argroup: newArgroup } = isTimeBased ? await insertArgroupWithArchargesSimple(argroupData) : await insertArgroupWithArcharges({
    ...argroupData,
    snapshotCredits: carryPlan.snapshotCredits,
    carryCredits: carryPlan.carryCredits
  });
  if (!newArgroup) {
    throw new Error("Failed to insert argroup");
  }
  return newArgroup.id;
}
async function commitProgramRun(input, result, billableDate) {
  const archarges = result.charges.map((charge) => ({
    type: charge.type,
    name: charge.name,
    notes: charge.notes ?? null,
    amount: charge.amount,
    source_type: charge.sourceType,
    source_id: charge.sourceId,
    accounting_key: charge.accountingKey ?? null,
    document_reference_id: charge.documentReferenceId ?? null,
    billable_datetime: billableDate,
    createdby: input.createdBy
  }));
  const { argroup: newArgroup } = await insertProgramArgroupWithArcharges({
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    programId: input.programId,
    customerId: input.customerId,
    algorithmKey: String(input.algorithmKey),
    runMetadata: {
      ...result.metadata,
      algorithmKey: input.algorithmKey,
      scenarioId: input.scenarioId,
      programId: input.programId
    },
    createdby: input.createdBy,
    updatedby: input.createdBy,
    arinvoiceId: input.arinvoiceId,
    archarges
  });
  if (!newArgroup) {
    throw new Error("Failed to insert program argroup");
  }
  return newArgroup.id;
}
async function commitProgramScenarioRun(input, result, billableDate) {
  const archarges = result.charges.map((charge) => ({
    type: charge.type,
    name: charge.name,
    notes: charge.notes ?? null,
    amount: charge.amount,
    source_type: charge.sourceType,
    source_id: charge.sourceId,
    accounting_key: charge.accountingKey ?? null,
    document_reference_id: charge.documentReferenceId ?? null,
    billable_datetime: billableDate,
    createdby: input.createdBy
  }));
  const carryPlan = await planProgramScenarioCarryForward(
    input.scenarioId,
    input.programId,
    String(input.algorithmKey)
  );
  const { argroupId, deactivatedArgroupIds } = await insertProgramScenarioArgroupWithArcharges({
    scenarioId: input.scenarioId,
    triggerId: input.triggerId,
    programId: input.programId,
    customerId: input.customerId,
    algorithmKey: String(input.algorithmKey),
    runMetadata: {
      ...result.metadata,
      algorithmKey: input.algorithmKey,
      scenarioId: input.scenarioId,
      programId: input.programId,
      ...carryMetadata(carryPlan)
    },
    createdby: input.createdBy,
    updatedby: input.createdBy,
    arinvoiceId: input.arinvoiceId,
    archarges,
    snapshotCredits: carryPlan.snapshotCredits,
    carryCredits: carryPlan.carryCredits
  });
  if (argroupId == null) {
    throw new Error("Failed to insert program scenario argroup");
  }
  return {
    action: archarges.length > 0 ? "charged" : "empty",
    argroupId,
    deactivatedArgroupIds
  };
}

// src/utils/triggerMatching.ts
function shouldFireMonthly(config, date) {
  if (config.frequency !== "monthly" || config.day_of_month === void 0) {
    return false;
  }
  const dayOfMonth = date.getUTCDate();
  const targetDay = config.day_of_month;
  if (dayOfMonth === targetDay) {
    return true;
  }
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  return targetDay > lastDayOfMonth && dayOfMonth === lastDayOfMonth;
}
function shouldFireWeekly(config, date) {
  if (config.frequency !== "weekly" || config.day_of_week === void 0) {
    return false;
  }
  const dayOfWeek = date.getUTCDay();
  return dayOfWeek === config.day_of_week;
}
function shouldFireDaily(config, _date) {
  return config.frequency === "daily";
}
function shouldFireOnce(config, date) {
  if (config.frequency !== "once" || !config.scheduled_date) {
    return false;
  }
  const scheduledStr = config.scheduled_date.split("T")[0];
  const scheduledDate = /* @__PURE__ */ new Date(`${scheduledStr}T00:00:00Z`);
  const checkDate = new Date(date);
  checkDate.setUTCHours(0, 0, 0, 0);
  return scheduledDate <= checkDate;
}
function shouldTriggerFire(config, date = /* @__PURE__ */ new Date()) {
  switch (config.frequency) {
    case "monthly":
      return shouldFireMonthly(config, date);
    case "weekly":
      return shouldFireWeekly(config, date);
    case "daily":
      return shouldFireDaily(config, date);
    case "once":
      return shouldFireOnce(config, date);
    default:
      return false;
  }
}
function isWholeNumberBetween(value, min, max) {
  return typeof value === "number" && Number.isInteger(value) && value >= min && value <= max;
}
function isTriggerScheduleMisconfigured(config) {
  if (config.frequency === "monthly") return !isWholeNumberBetween(config.day_of_month, 1, 31);
  if (config.frequency === "weekly") return !isWholeNumberBetween(config.day_of_week, 0, 6);
  return false;
}
function getNextFireDate(config, fromDate = /* @__PURE__ */ new Date()) {
  if (isTriggerScheduleMisconfigured(config)) return null;
  const testDate = new Date(fromDate);
  testDate.setUTCHours(0, 0, 0, 0);
  if (config.frequency === "once" && config.scheduled_date) {
    const scheduledDate = new Date(config.scheduled_date);
    scheduledDate.setUTCHours(0, 0, 0, 0);
    return scheduledDate >= testDate ? scheduledDate : null;
  }
  const maxDaysToCheck = config.frequency === "monthly" ? 31 : config.frequency === "weekly" ? 7 : 1;
  for (let i = 0; i <= maxDaysToCheck; i++) {
    if (shouldTriggerFire(config, testDate)) {
      return testDate;
    }
    testDate.setUTCDate(testDate.getUTCDate() + 1);
  }
  return null;
}

// src/utils/periodCalculation.ts
function currentPeriodBounds(frequency, fireTime, config) {
  const utc2 = new Date(fireTime.toISOString());
  switch (frequency) {
    case "monthly": {
      const start = new Date(Date.UTC(utc2.getUTCFullYear(), utc2.getUTCMonth(), 1));
      const end = new Date(Date.UTC(utc2.getUTCFullYear(), utc2.getUTCMonth() + 1, 1));
      return { start, end };
    }
    case "weekly": {
      const day = utc2.getUTCDay() || 7;
      const start = new Date(utc2);
      start.setUTCDate(utc2.getUTCDate() - (day - 1));
      start.setUTCHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setUTCDate(start.getUTCDate() + 7);
      return { start, end };
    }
    case "daily": {
      const start = new Date(
        Date.UTC(utc2.getUTCFullYear(), utc2.getUTCMonth(), utc2.getUTCDate())
      );
      const end = new Date(start);
      end.setUTCDate(start.getUTCDate() + 1);
      return { start, end };
    }
    case "once": {
      if (!config?.scheduled_date) {
        throw new Error("Once trigger missing scheduled_date in config");
      }
      const scheduledDate = config.scheduled_date.split("T")[0];
      const start = /* @__PURE__ */ new Date(`${scheduledDate}T00:00:00Z`);
      const end = /* @__PURE__ */ new Date("9999-12-31T00:00:00Z");
      return { start, end };
    }
    default:
      throw new Error(`Unknown frequency for period bounds: ${frequency}`);
  }
}
function derivePeriodKey(frequency, fireTime, config) {
  const bounds = currentPeriodBounds(frequency, fireTime, config);
  const dateStr = bounds.start.toISOString().split("T")[0];
  switch (frequency) {
    case "monthly":
      return `month_${dateStr.substring(0, 7)}`;
    case "weekly":
      return `week_${dateStr}`;
    case "daily":
      return `day_${dateStr}`;
    case "once":
      return `once_${dateStr}`;
    default:
      throw new Error(`Unknown frequency for period key: ${frequency}`);
  }
}

// src/features/ar-triggers/algorithms/moveScenarioV1/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor10 } from "@hopdrive/sdk-core";
async function checkScenarioReadiness(scenarioId) {
  const executor = resolveExecutor10();
  const result = await executor.query(CheckScenarioReadinessDocument, {
    scenarioId
  });
  return result.scenarios_by_pk;
}

// src/features/ar-invoices/invoice-management/index.ts
init_invoiceManager();
init_programInvoiceManager();
init_queries();
init_mutations();

// src/features/ar-triggers/context/move/billableDate.ts
function normalizeToBillableDate(timestamp) {
  const dateString = new Date(timestamp).toISOString().split("T")[0];
  return `${dateString}T00:00:00.000Z`;
}
function calculateBillableDateFromMove(move) {
  const timestamp = move.delivery_successful || move.delivery_arrived || move.delivery_started || move.pickup_successful || move.pickup_arrived || move.pickup_started || move.pickup_time;
  if (!timestamp) {
    throw new Error("No usable timestamp on move: cannot set billable_datetime");
  }
  return normalizeToBillableDate(timestamp);
}
function defaultBillableDate() {
  return normalizeToBillableDate((/* @__PURE__ */ new Date()).toISOString());
}
function calculateChargeBillableDate(moveBillableDate) {
  return moveBillableDate;
}
function isValidBillableDate(billableDate) {
  try {
    const date = new Date(billableDate);
    return !isNaN(date.getTime()) && billableDate === date.toISOString();
  } catch {
    return false;
  }
}

// src/features/ar-triggers/algorithms/shared/scenarioUtils.ts
function shouldSkipMove(move) {
  const { billable, reason } = isBillableMove(move);
  return billable ? { skip: false } : { skip: true, reason };
}
async function getBillableDateAndContract(move) {
  const errors = [];
  let billableDate = null;
  if (move) {
    try {
      billableDate = calculateBillableDateFromMove({
        delivery_successful: move.deliverySuccessful,
        delivery_arrived: move.deliveryArrived,
        delivery_started: move.deliveryStarted,
        pickup_successful: move.pickupSuccessful,
        pickup_arrived: move.pickupArrived,
        pickup_started: move.pickupStarted,
        pickup_time: move.pickupTime
      });
    } catch {
      billableDate = (/* @__PURE__ */ new Date()).toISOString().split("T")[0] + "T00:00:00.000Z";
    }
  }
  const contract = move?.workflowsetId && move?.customerId && billableDate ? await getContract(move.customerId, move.workflowsetId, billableDate) : null;
  if (!contract && move?.customerId && move?.workflowsetId) {
    errors.push(
      `No contract found for customer_id=${move.customerId}, workflowset_id=${move.workflowsetId}, billable_date=${billableDate}`
    );
  }
  return { contract, billableDate, errors };
}

// src/features/ar-triggers/algorithms/shared/effectiveRates.ts
import { getLogger as getLogger9 } from "@hopdrive/sdk-core";
function resolveEffectiveRaterules(contract, _move, context, scope) {
  const criteria = { carriesBands: true };
  const banded = selectContractRules(contract.contract_rules, criteria);
  if (banded.length === 0) {
    const fields = {
      triggerId: context.triggerId,
      algorithmKey: context.algorithmKey,
      contractId: context.contractId,
      scenarioId: context.scenarioId,
      purpose: context.purpose,
      code: CONTRACT_RULE_NO_BANDS,
      criteria: "carries bands",
      availableContractRuleIds: contract.contract_rules.map((rule) => rule.id)
    };
    const reason = `no contract rule on contract ${context.contractId} carries a mileage band; not pricing a distance without one`;
    getLogger9().warn(`contract-rule selection (${context.purpose}): ${reason}`, fields);
    return algorithmSkip(reason, { metadata: fields, logFields: fields });
  }
  let ruleScope;
  if (typeof scope === "string") ruleScope = productKeyScope(scope);
  else if (scope != null) ruleScope = scope;
  const resolved = resolveContractRule({
    rules: contract.contract_rules,
    criteria,
    scope: ruleScope,
    context
  });
  if (isAlgorithmSkip(resolved)) return resolved;
  return { rule: resolved.rule, bands: resolved.rule.raterules, selection: resolved.selection };
}

// src/features/ar-triggers/algorithms/shared/charges/moveCharges.ts
init_productMapping();
init_accountingProductKeys();
var TRANSPORT_CHARGE_NAME = "Transport";
async function processPriceOverrideCharge(move) {
  const accountingKey = await resolveAccountingKey(ACCOUNTING_KEY_MOVE);
  return {
    type: "move",
    name: TRANSPORT_CHARGE_NAME,
    amount: move.priceOverride,
    sourceType: "move",
    sourceId: String(move.moveId),
    notes: `Price override applied: $${move.priceOverride.toFixed(2)}`,
    accountingKey
  };
}
async function processBaseMoveCharge(move, contract, ruleContext, metadataLogger, laneModifier, productKey) {
  const charges = [];
  if (!contract) {
    metadataLogger.logSkip(move.moveId, "no contract available for pricing calculation");
    return { charges, skip: { reason: "no contract available for pricing calculation" } };
  }
  let refusal = null;
  const result = await priceMoveCost({
    move,
    bands: () => {
      const selected = resolveEffectiveRaterules(contract, { moveId: move.moveId }, ruleContext, productKey);
      if (isAlgorithmSkip(selected)) {
        refusal = selected;
        return [];
      }
      metadataLogger.info(
        "contract",
        `Move ${move.moveId} prices from contract rule ${selected.rule.id} on contract ${contract.id} (${selected.selection})`,
        {
          moveId: move.moveId,
          contractId: contract.id,
          contractRuleId: selected.rule.id,
          contractRuleSelection: selected.selection,
          productKey: productKey ?? null
        }
      );
      return selected.bands;
    },
    strategy: BAND_STRATEGY.MATCH_ONE,
    laneModifier,
    productKey
  });
  if (refusal && result.outcome === MOVE_COST_OUTCOME.SKIPPED && result.skipCode === MOVE_COST_SKIP.NO_BANDS) {
    metadataLogger.logSkip(move.moveId, refusal.reason);
    return { charges, skip: { reason: refusal.reason } };
  }
  if (result.outcome === MOVE_COST_OUTCOME.NO_TRANSPORT) {
    metadataLogger.info("skip", `Move ${move.moveId} canceled after start - skipping transport charge`, {
      moveId: move.moveId,
      cancelStatus: move.cancelStatus
    });
    return { charges };
  }
  if (result.outcome === MOVE_COST_OUTCOME.PRICE_OVERRIDE) {
    metadataLogger.logPriceOverride(move.moveId, result.total);
    const charge = await processPriceOverrideCharge(move);
    charges.push(charge);
    metadataLogger.logChargeCreated({
      chargeType: "move",
      amount: charge.amount,
      sourceId: String(move.moveId),
      moveId: move.moveId
    });
    return { charges };
  }
  if (result.outcome === MOVE_COST_OUTCOME.SKIPPED) {
    if (result.skipCode === MOVE_COST_SKIP.NO_BAND_MATCH) {
      throw new Error(
        `No rate rule found for move ${move.moveId}: ${result.skipReason}, contract_id=${contract.id}`
      );
    }
    metadataLogger.logSkip(move.moveId, result.skipReason);
    return { charges, skip: { reason: result.skipReason } };
  }
  const band = result.contributions[0].band;
  if (result.effectiveMileage !== move.mileage) {
    metadataLogger.info(
      "calculation",
      `Lane modifier ${laneModifier.id} applied to move ${move.moveId}: ${move.mileage} -> ${result.effectiveMileage} mi`,
      { moveId: move.moveId, laneModifierId: laneModifier.id, effectiveMileage: result.effectiveMileage }
    );
  }
  const rates = getRatesForWeightClass(result.weightClass, band);
  metadataLogger.logRateLookup({
    moveId: move.moveId,
    rateRuleId: band.id,
    mileage: result.effectiveMileage,
    mileageBand: `${band.distance_start}-${band.distance_end ?? "\u221E"}`,
    moveClass: result.rateClass,
    weight: 0,
    weightSource: result.weightSource,
    weightClass: result.weightClass,
    flatRate: rates.flat,
    perMileRate: rates.per
  });
  metadataLogger.logRateTableCalculation({
    moveId: move.moveId,
    baseAmount: result.total,
    discounts: result.discount > 0 ? { [isStrandedRateClass(result.rateClass) ? "dealerStrandedDiscount" : "dealerBaseDiscount"]: result.discount } : void 0,
    tolls: result.tolls,
    finalAmount: result.total
  });
  const notesDetails = [
    `Class ${result.weightClass}`,
    `${band.distance_start}-${band.distance_end ?? "\u221E"} mile band`,
    describeRate(band.type, rates.flat, rates.per)
  ];
  if (result.discount > 0) notesDetails.push(`$${result.discount.toFixed(2)} discount`);
  charges.push({
    type: "move",
    name: TRANSPORT_CHARGE_NAME,
    amount: result.total,
    sourceType: "move",
    sourceId: String(move.moveId),
    notes: notesDetails.join(", "),
    accountingKey: await resolveAccountingKey(ACCOUNTING_KEY_MOVE)
  });
  if (result.tollsWaived) {
    metadataLogger.info("calculation", `Lane tolls not billed for Valet Lite move ${move.moveId}`, {
      moveId: move.moveId,
      tolls: result.laneTolls,
      reason: result.tollsWaived
    });
  }
  if (result.tolls > 0) {
    charges.push({
      type: LANE_TOLL_CHARGE_TYPE,
      name: LANE_TOLL_CHARGE_NAME,
      amount: result.tolls,
      sourceType: "move",
      sourceId: String(move.moveId),
      notes: `Lane tolls for move ${move.moveId}`,
      accountingKey: await resolveAccountingKey(ACCOUNTING_KEY_TOLL)
    });
  }
  return { charges };
}
function describeRate(type, flat, per) {
  const flatStr = flat ? `$${flat.toFixed(2)} flat` : "";
  const perStr = per ? `$${per.toFixed(2)}/mile` : "";
  if (type === RATE_TYPES.FLAT) return flatStr;
  if (type === RATE_TYPES.PER) return perStr;
  return `${flatStr} + ${perStr}`;
}

// src/features/ar-triggers/algorithms/shared/charges/accessorialCharges.ts
init_productMapping();

// src/features/ar-triggers/context/returnRide/classifyRidehailProduct.ts
var RIDEHAIL_PRODUCT = {
  GUEST_RIDES: PRODUCT_KEY_GUEST_RIDES,
  RETURN_RIDES: PRODUCT_KEY_RETURN_RIDES
};
function classifyRidehailProduct(facts) {
  if (facts.guestrideId != null) return RIDEHAIL_PRODUCT.GUEST_RIDES;
  if (facts.moveId == null) return null;
  const isLite = facts.scenarioProductKey != null ? facts.scenarioProductKey === PRODUCT_KEY_VALET_LITE : (facts.liteFlags ?? []).some((flag) => flag === true);
  return isLite ? RIDEHAIL_PRODUCT.RETURN_RIDES : null;
}
function triggersForRidehailProduct(triggers, eventKey, product) {
  return (triggers ?? []).filter((trigger) => {
    if (trigger?.event_key !== eventKey) return false;
    const isReturnRide = trigger.product_key === RIDEHAIL_PRODUCT.RETURN_RIDES;
    return product === RIDEHAIL_PRODUCT.RETURN_RIDES ? isReturnRide : !isReturnRide;
  });
}

// src/features/ar-triggers/algorithms/shared/charges/accessorialCharges.ts
var ACCESSORIAL_APPROVED_STATUS = "approved";
var PRICE_OVERRIDE_ALLOW_ALL = "all";
var RETURN_RIDE_ACCESSORIAL_CODES = /* @__PURE__ */ new Set(["ride", "platform"]);
function returnRidesOwnRideCharges(ctx) {
  return classifyRidehailProduct({
    moveId: ctx.moves[0]?.moveId ?? null,
    scenarioProductKey: ctx.productKey ?? null,
    liteFlags: ctx.moves.map((m) => m.lite)
  }) === RIDEHAIL_PRODUCT.RETURN_RIDES;
}
function accessorialsBilledByReturnRides(move, opts = {}) {
  if (!opts.rideChargesOwnedByReturnRides) return [];
  return (move.accessorials ?? []).filter((acc) => RETURN_RIDE_ACCESSORIAL_CODES.has(acc.code.toLowerCase()));
}
function selectBillableAccessorials(move, opts = {}) {
  const billedByReturnRides = new Set(accessorialsBilledByReturnRides(move, opts));
  let valid = (move.accessorials ?? []).filter(
    (acc) => !billedByReturnRides.has(acc) && acc.status === ACCESSORIAL_APPROVED_STATUS && acc.arAmount > 0
  );
  if (move.priceOverrideActive && move.priceOverrideConfig) {
    const allowedCharges = move.priceOverrideConfig.allowed_charges;
    if (Array.isArray(allowedCharges) && !allowedCharges.includes(PRICE_OVERRIDE_ALLOW_ALL)) {
      valid = valid.filter((acc) => allowedCharges.includes(acc.code));
    }
  }
  return valid;
}
async function processAccessorialCharges(move, metadataLogger, opts = {}) {
  const charges = [];
  for (const acc of accessorialsBilledByReturnRides(move, opts)) {
    metadataLogger.info(
      "input",
      `${acc.code} accessorial ${acc.accessorialId} on move ${move.moveId} not billed: Return Rides bills this scenario's rides from the ride-hail record`,
      { moveId: move.moveId, accessorialId: acc.accessorialId, code: acc.code, arAmount: acc.arAmount }
    );
  }
  const validAccessorials = selectBillableAccessorials(move, opts);
  for (const accessorial of validAccessorials) {
    metadataLogger.logAccessorialInput(move.moveId, accessorial);
    metadataLogger.logAccessorialCalculation(move.moveId, accessorial);
    const accountingKey = await resolveAccountingKey(accessorial.code.toLowerCase());
    const charge = {
      type: accessorial.code.toLowerCase(),
      // The code exactly as stored, as AR v1 named it; customers and Super
      // Dispatch match on it (#3149).
      name: accessorial.code,
      amount: accessorial.arAmount,
      sourceType: "accessorial",
      sourceId: String(accessorial.accessorialId),
      notes: accessorial.notes ?? void 0,
      accountingKey,
      documentReferenceId: accessorial.documentReferenceId ?? null
    };
    charges.push(charge);
    metadataLogger.logChargeCreated({
      chargeType: "accessorial",
      amount: charge.amount,
      sourceId: String(accessorial.accessorialId),
      moveId: move.moveId
    });
  }
  return charges;
}

// src/features/ar-triggers/algorithms/moveScenarioV1/index.ts
var CONSUMER_TYPE_CUSTOMER = "customer";
var CONSUMER_TYPE_LOANER = "loaner";
async function moveScenarioV1(ctx, shell) {
  const { metadataLogger } = shell;
  const charges = [];
  const hasLoanerLeg = ctx.moves.some((m) => m.consumerType === CONSUMER_TYPE_LOANER);
  const conciergeLeg = hasLoanerLeg ? ctx.moves.find((m) => m.consumerType === CONSUMER_TYPE_CUSTOMER) : void 0;
  const scenarioAnchor = conciergeLeg ? await getBillableDateAndContract(conciergeLeg) : null;
  const rideChargesOwnedByReturnRides = returnRidesOwnRideCharges(ctx);
  for (const move of ctx.moves) {
    metadataLogger.logMoveInput(move);
    const skipResult = shouldSkipMove(move);
    if (skipResult.skip) {
      metadataLogger.logSkip(move.moveId, skipResult.reason);
      continue;
    }
    const { contract, billableDate, errors: contractErrors } = scenarioAnchor ?? await getBillableDateAndContract(move);
    if (!contract) {
      contractErrors.forEach((err) => metadataLogger.error("system", err));
      metadataLogger.logSkip(move.moveId, "no contract for move workflowset");
      continue;
    }
    const ruleContext = ruleContextFrom(shell, contract.id, "move mileage bands");
    metadataLogger.logContractLoaded(contract.id, ctx.customerId);
    metadataLogger.info(
      "contract",
      `Contract ${contract.id} carries ${contract.contract_rules.length} contract rule(s) for move ${move.moveId}`,
      {
        moveId: move.moveId,
        contractId: contract.id,
        contractRuleIds: contract.contract_rules.map((rule) => rule.id)
      }
    );
    const laneModifier = billableDate ? await getApplicableArLaneModifier(
      {
        workflowsetId: move.workflowsetId,
        workflowsetType: move.workflowsetType,
        customerId: ctx.customerId,
        organizationId: ctx.orgId
      },
      billableDate
    ) : null;
    if (laneModifier) {
      metadataLogger.info("contract", `Lane modifier ${laneModifier.id} resolved for move ${move.moveId}`, {
        laneModifierId: laneModifier.id,
        applyTo: laneModifier.apply_to,
        distanceMilesModifier: laneModifier.distance_miles_modifier
      });
    }
    const baseMoveResult = await processBaseMoveCharge(
      move,
      contract,
      ruleContext,
      metadataLogger,
      laneModifier,
      ctx.productKey
    );
    charges.push(...baseMoveResult.charges);
    if (baseMoveResult.skip) {
      continue;
    }
    const accessorialCharges = await processAccessorialCharges(move, metadataLogger, { rideChargesOwnedByReturnRides });
    charges.push(...accessorialCharges);
    metadataLogger.incrementProcessed();
  }
  return {
    charges,
    metadata: {}
    // Metadata now built by metadataLogger.toMetadata() in execute()
  };
}

// src/features/ar-triggers/algorithms/moveScenarioV1/readiness.ts
async function checkReadiness(scenarioId) {
  const scenario = await checkScenarioReadiness(scenarioId);
  if (!scenario) {
    throw new Error(`Scenario ${scenarioId} not found`);
  }
  const driveMoves = scenario.moves.filter((stm) => stm.move.move_type === "drive");
  const totalMoves = driveMoves.length;
  const settledMoves = driveMoves.filter((stm) => {
    const move = stm.move;
    if (!move.active || !move.chargeable || move.cancel_status === "canceled") {
      return true;
    }
    const isAppointment = move.appointment != null;
    if (isAppointment) {
      return true;
    }
    const status = move.status;
    const isNotReady = status == null || status === "draft" || status === "dispatched";
    return !isNotReady;
  }).length;
  return {
    ready: totalMoves > 0 && totalMoves === settledMoves,
    scenarioId,
    totalMoves,
    settledMoves
  };
}

// src/features/ar-triggers/context/move/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor13 } from "@hopdrive/sdk-core";
async function getScenarioIdFromMove(moveId) {
  const executor = resolveExecutor13();
  const result = await executor.query(GetScenarioIdFromMoveDocument, { moveId });
  return result.scenariotomoves?.[0]?.scenario_id ?? null;
}
async function getScenarioContext(scenarioId) {
  const executor = resolveExecutor13();
  const result = await executor.query(GetScenarioContextDocument, {
    scenarioId
  });
  return result.scenarios_by_pk;
}
async function getAccessorialMoveId(accessorialId) {
  const executor = resolveExecutor13();
  const result = await executor.query(GetAccessorialMoveIdDocument, { accessorialId });
  return result.accessorials_by_pk?.move_id ?? null;
}
async function getPriceOverrideMoveId(priceOverrideId) {
  const executor = resolveExecutor13();
  const result = await executor.query(GetPriceOverrideMoveIdDocument, { priceOverrideId });
  return result.arpriceoverrides_by_pk?.move_id ?? null;
}

// src/features/ar-triggers/algorithms/moveScenarioV1/buildContext.ts
import { getLogger as getLogger10 } from "@hopdrive/sdk-core";
async function buildScenarioContext(scenarioId, paramOverrides) {
  const logger = getLogger10();
  const scenarioData = await getScenarioContext(scenarioId);
  if (!scenarioData) {
    throw new Error(`Scenario ${scenarioId} not found`);
  }
  if (scenarioData.moves.length === 0) {
    throw new Error(`Scenario ${scenarioId} has no moves`);
  }
  const driveMoveData = scenarioData.moves.filter((stm) => stm.move.move_type === "drive");
  if (driveMoveData.length === 0) {
    logger.warn(
      `moveScenarioV1.buildContext: scenario ${scenarioId} has no drive moves (only ${scenarioData.moves.length} ride move${scenarioData.moves.length === 1 ? "" : "s"})`,
      {
        scenarioId,
        totalMoves: scenarioData.moves.length
      }
    );
    throw new Error("Scenario contains no drive moves (only ride moves)");
  }
  const firstMoveData = driveMoveData[0].move;
  const customerId = firstMoveData.customer.id;
  const orgId = firstMoveData.customer.organization_id ?? void 0;
  const customerTier = firstMoveData.customer.tier ?? void 0;
  const moves = driveMoveData.map((stm) => {
    const move = stm.move;
    const effectiveConfig = move.customer.effective_config;
    return {
      moveId: move.id,
      active: Boolean(move.active ?? true),
      chargeable: move.chargeable,
      mileage: move.lane?.distance_miles ?? void 0,
      rateRuleId: move.raterule?.id ?? void 0,
      status: move.status ?? void 0,
      isAppointment: move.appointment != null,
      cancelStatus: move.cancel_status ?? void 0,
      consumerType: move.consumer_type ?? void 0,
      lite: move.lite ?? null,
      ridehail: move.ridehails[0] ? {
        ridehailId: move.ridehails[0].id,
        customerCharge: move.ridehails[0].archarges[0]?.amount ?? 0,
        upcharge: 0
        // TODO: Add upcharge field to GraphQL query when implemented
      } : void 0,
      accessorials: move.accessorials.map((acc) => ({
        accessorialId: acc.id,
        code: acc.code,
        status: acc.status,
        arAmount: acc.ar_amount,
        notes: acc.notes,
        documentReferenceId: acc.document_reference_id
      })),
      priceOverride: move.price_override?.amount ?? void 0,
      priceOverrideConfig: move.price_override?.config ?? void 0,
      workflowsetId: move.workflowset_id ?? void 0,
      workflowsetType: move.workflowset?.type ?? void 0,
      moveClass: move.class ?? void 0,
      vehicleGrossWeightLbs: move.vehicle_gross_weight_lbs ?? void 0,
      deliveryWorkflowData: move.delivery_workflow_data ?? void 0,
      pickupWorkflowData: move.pickup_workflow_data ?? void 0,
      config: move.config ?? void 0,
      customerId: move.customer.id,
      customerBillingFrequency: move.customer.billing_frequency ?? void 0,
      dealerStrandedDiscount: move.lane?.dealer_stranded_discount ?? void 0,
      dealerBaseDiscount: move.lane?.dealer_base_discount ?? void 0,
      tolls: resolveLaneTolls(move.lane?.tolls, effectiveConfig),
      priceOverrideActive: move.price_override?.active ?? false,
      deliverySuccessful: move.delivery_successful ?? void 0,
      deliveryArrived: move.delivery_arrived ?? void 0,
      deliveryStarted: move.delivery_started ?? void 0,
      pickupSuccessful: move.pickup_successful ?? void 0,
      pickupArrived: move.pickup_arrived ?? void 0,
      pickupStarted: move.pickup_started ?? void 0,
      pickupTime: move.pickup_time ?? void 0
    };
  });
  logger.info(
    `moveScenarioV1.buildContext: assembled context for scenario ${scenarioId} customer ${customerId} (${moves.length} drive move${moves.length === 1 ? "" : "s"})`,
    {
      scenarioId,
      moveCount: moves.length,
      customerId,
      orgId
    }
  );
  return {
    scenarioId,
    customerId,
    orgId,
    customerTier,
    // The scenario's own commercial identity, carried through so algorithms
    // route on what was bought rather than re-deriving it from the legs.
    productKey: scenarioData.product_key ?? null,
    moves,
    paramOverrides
  };
}

// src/features/ar-triggers/context/program/resolveBillingContract.ts
import { getLogger as getLogger14 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/context/program/getProgramContractsForMove.ts
init_schema();
import { resolveExecutor as resolveExecutor14, getLogger as getLogger11 } from "@hopdrive/sdk-core";
async function getProgramContractsForMove(customerId, billableDate) {
  const executor = resolveExecutor14();
  const logger = getLogger11();
  const programsResult = await executor.query(GetActiveProgramsForCustomerDocument, { customerId });
  const programIds = Array.from(
    new Set(
      programsResult.programtocustomer.map((r) => r.program_id).filter((id) => typeof id === "number")
    )
  );
  if (programIds.length === 0) {
    return [];
  }
  const contractsResult = await executor.query(GetProgramContractsByDateDocument, { programIds, billableDate });
  const contracts = contractsResult.contracts.filter((c) => typeof c.program_id === "number").map((c) => ({
    contractId: c.id,
    programId: c.program_id,
    config: c.config ?? null
  }));
  logger.info(
    `getProgramContractsForMove: customer ${customerId} \u2192 ${programIds.length} active program(s), ${contracts.length} active program contract(s) on ${billableDate}`,
    { customerId, billableDate, programIds, contractCount: contracts.length }
  );
  return contracts;
}

// src/features/ar-triggers/context/program/getProgramCoverageContract.ts
import { getLogger as getLogger13 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/dispatch/getContractEventTriggers.ts
init_schema();
import { resolveExecutor as resolveExecutor15 } from "@hopdrive/sdk-core";
async function getContractEventTriggers(contractId) {
  const executor = resolveExecutor15();
  const result = await executor.query(GetContractEventTriggersDocument, { contractId });
  const triggers = result.artriggers.map((row) => {
    const config = row.config ?? {};
    const eventKey = typeof config.event_key === "string" ? config.event_key : "";
    return {
      id: row.id,
      algorithm_key: row.algorithm_key,
      event_key: eventKey,
      product_key: row.product_key,
      config,
      contract: row.contract ? {
        id: row.contract.id,
        effective_config: row.contract.effective_config ?? null
      } : void 0
    };
  });
  const eventKeys = Array.from(
    new Set(triggers.map((t) => t.event_key).filter((k) => k.length > 0))
  ).sort();
  return {
    contractId,
    eventKeys,
    triggers
  };
}

// src/features/ar-triggers/program-billing/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor16, getLogger as getLogger12 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/orchestrators/time-triggers/programTriggerMode.ts
var KNOWN_MODES = [
  PROGRAM_TRIGGER_MODE_PROGRAM,
  PROGRAM_TRIGGER_MODE_PER_CUSTOMER,
  PROGRAM_TRIGGER_MODE_PER_SERVICE
];
function deriveProgramTriggerMode(config) {
  const mode = config ?? {};
  if (typeof mode.mode === "string" && KNOWN_MODES.includes(mode.mode)) {
    return mode.mode;
  }
  return null;
}

// src/features/ar-triggers/program-billing/queries.ts
async function getActiveContractProductKeys(customerIds, billableDate) {
  const byCustomer = /* @__PURE__ */ new Map();
  if (customerIds.length === 0) return byCustomer;
  const executor = resolveExecutor16();
  const result = await executor.query(GetActiveContractProductsForCustomersDocument, {
    customerIds,
    today: billableDate
  });
  const sets = /* @__PURE__ */ new Map();
  for (const row of result.contracts) {
    if (typeof row.customer_id !== "number") continue;
    const set = sets.get(row.customer_id) ?? /* @__PURE__ */ new Set();
    for (const trigger of row.artriggers) {
      if (typeof trigger.product_key === "string" && trigger.product_key.length > 0) {
        set.add(trigger.product_key);
      }
    }
    sets.set(row.customer_id, set);
  }
  for (const [id, set] of sets) byCustomer.set(id, Array.from(set));
  return byCustomer;
}
async function getProgramActiveEnrollees(programId, billableDate) {
  const executor = resolveExecutor16();
  const logger = getLogger12();
  const enrolleesResult = await executor.query(GetProgramActiveEnrolleesDocument, { programId });
  const customerIds = Array.from(
    new Set(
      enrolleesResult.programtocustomer.map((r) => r.customer_id).filter((id) => typeof id === "number")
    )
  );
  if (customerIds.length === 0) {
    logger.info(`Program ${programId} has no active enrollees`, { programId });
    return [];
  }
  const keysByCustomer = await getActiveContractProductKeys(customerIds, billableDate);
  const namesByCustomer = /* @__PURE__ */ new Map();
  for (const enrollee of enrolleesResult.programtocustomer) {
    if (typeof enrollee.customer_id === "number" && enrollee.customer?.name) {
      namesByCustomer.set(enrollee.customer_id, enrollee.customer.name);
    }
  }
  return customerIds.map((customerId) => ({
    customerId,
    customerName: namesByCustomer.get(customerId),
    productKeys: keysByCustomer.get(customerId) ?? []
  }));
}
async function getDueProgramBillingTriggers(programId, date) {
  const executor = resolveExecutor16();
  const result = await executor.query(GetProgramBillingTriggersDocument, { programId, billableDate: date.toISOString() });
  return result.artriggers.filter((t) => shouldTriggerFire(t.config, date)).map((t) => ({
    id: t.id,
    config: t.config ?? {},
    algorithmKey: t.algorithm_key,
    productKey: t.product_key ?? null,
    productByKey: t.product_by_key ?? null,
    mode: deriveProgramTriggerMode(t.config)
  }));
}

// src/features/ar-triggers/program-billing/productGate.ts
var REQUIRE_ANY_PRODUCT_KEYS_FIELD = "requireAnyProductKeys";
function logMissingProductGate(logger, identity) {
  logger.error(
    `Program trigger ${identity.triggerId} has no usable config.${REQUIRE_ANY_PRODUCT_KEYS_FIELD}, so its charge is skipped. Set config.${REQUIRE_ANY_PRODUCT_KEYS_FIELD} on the trigger to the product keys it bills for. There is no default.`,
    { ...identity, missingField: REQUIRE_ANY_PRODUCT_KEYS_FIELD }
  );
}
function readRequireAnyProductKeys(config) {
  const raw = config?.requireAnyProductKeys;
  if (!Array.isArray(raw)) return [];
  const keys = raw.filter((key) => typeof key === "string" && key.trim().length > 0);
  return Array.from(new Set(keys));
}
function qualifiesForProductGate(productKeys, requireAnyProductKeys) {
  if (requireAnyProductKeys.length === 0) return false;
  if (!productKeys || productKeys.length === 0) return false;
  const held = new Set(productKeys);
  return requireAnyProductKeys.some((key) => held.has(key));
}

// src/features/ar-triggers/program-billing/coverageServiceLine.ts
var COVERAGE_PRODUCT_KEY = {
  [SERVICE_LINE.FULL_SERVICE]: PRODUCT_KEY_VALET_FULL_SERVICE,
  [SERVICE_LINE.LITE]: PRODUCT_KEY_VALET_LITE
};
var LINE_BY_PRODUCT_KEY = new Map(
  Object.entries(COVERAGE_PRODUCT_KEY).map(([line, key]) => [key, line])
);
function coverageGateFor(serviceLine) {
  return [COVERAGE_PRODUCT_KEY[serviceLine]];
}
function coverageServiceLineForProduct(productKey) {
  return productKey ? LINE_BY_PRODUCT_KEY.get(productKey) ?? null : null;
}
var HELD_PRODUCTS_AMBIGUOUS = "ambiguous";
function resolveHeldValetLine(productKeys) {
  const held = [...new Set(productKeys)].filter((key) => LINE_BY_PRODUCT_KEY.has(key));
  if (held.length > 1) return HELD_PRODUCTS_AMBIGUOUS;
  return (held[0] != null ? LINE_BY_PRODUCT_KEY.get(held[0]) : void 0) ?? SERVICE_LINE.FULL_SERVICE;
}

// src/features/ar-triggers/context/program/getProgramCoverageContract.ts
function coverageLinesFor(contractId, triggers) {
  const triggerByLine = /* @__PURE__ */ new Map();
  const unowned = [];
  for (const trigger of triggers) {
    const line = coverageServiceLineForProduct(trigger.product_key);
    if (line == null) unowned.push(trigger.id);
    else if (!triggerByLine.has(line)) triggerByLine.set(line, trigger.id);
  }
  if (unowned.length > 0) {
    getLogger13().warn(
      `getProgramCoverageContracts: program contract ${contractId} has coverage trigger(s) [${unowned.join(", ")}] owned by no Valet product \u2014 they price nothing until a Move Coverage template is re-applied`,
      { contractId, triggerIds: unowned }
    );
  }
  return triggerByLine;
}
var coversLine = (contractLine, moveLine) => moveLine == null || contractLine === moveLine;
async function getProgramCoverageContracts(customerId, billableDate, serviceLine) {
  const logger = getLogger13();
  const contracts = await getProgramContractsForMove(customerId, billableDate);
  if (contracts.length === 0) return [];
  const productKeys = (await getActiveContractProductKeys([customerId], billableDate)).get(customerId) ?? [];
  const covering = [];
  for (const contract of contracts) {
    const { triggers } = await getContractEventTriggers(contract.contractId);
    const coverageTriggers = triggers.filter(
      (trigger) => trigger.algorithm_key === ALGORITHM_PROGRAM_MOVE_COVERAGE_V1
    );
    if (coverageTriggers.length === 0) continue;
    for (const [contractLine, triggerId] of coverageLinesFor(contract.contractId, coverageTriggers)) {
      if (!coversLine(contractLine, serviceLine)) continue;
      if (!qualifiesForProductGate(productKeys, coverageGateFor(contractLine))) {
        logger.info(
          `getProgramCoverageContracts: customer ${customerId} does not carry the product program contract ${contract.contractId}'s ${contractLine} coverage gates on \u2014 it does not cover them`,
          { customerId, contractId: contract.contractId, serviceLine: contractLine, productKeys }
        );
        continue;
      }
      covering.push({ contract, triggerId, serviceLine: contractLine });
    }
  }
  if (covering.length === 0) {
    logger.info(
      `getProgramCoverageContracts: customer ${customerId} is enrolled (${contracts.length} active program contract(s) on ${billableDate}) but none carries ${serviceLine ?? "any"} program coverage \u2014 the customer keeps move-cost billing`,
      {
        customerId,
        billableDate,
        serviceLine,
        contractIds: contracts.map((c) => c.contractId),
        programIds: contracts.map((c) => c.programId)
      }
    );
  }
  return covering;
}
async function getProgramCoverageContract(customerId, billableDate, serviceLine) {
  const [first] = await getProgramCoverageContracts(customerId, billableDate, serviceLine);
  return first ?? null;
}

// src/features/ar-triggers/program-billing/scenarioServiceLine.ts
var SCENARIO_LINE_SOURCE = {
  PRODUCT_KEY: "product_key",
  /** `moves.lite`, for a scenario with no `product_key`. See the legacy branch note above. */
  LEGACY_LITE: "legacy_lite"
};
var VALET_COVERAGE_PRODUCT_KEYS = Object.values(COVERAGE_PRODUCT_KEY);
var LINE_BY_PRODUCT_KEY2 = new Map(
  Object.entries(COVERAGE_PRODUCT_KEY).map(([line, key]) => [key, line])
);
function serviceLineForProductKey(productKey) {
  if (productKey == null) return null;
  return LINE_BY_PRODUCT_KEY2.get(productKey) ?? null;
}
function isUnrecognizedScenarioProduct(resolution) {
  return resolution.serviceLine === null;
}
function resolveScenarioServiceLine(params) {
  const { productKey } = params;
  if (productKey != null) {
    const serviceLine = serviceLineForProductKey(productKey);
    if (serviceLine == null) return { serviceLine: null, unrecognizedProductKey: productKey };
    return { serviceLine, source: SCENARIO_LINE_SOURCE.PRODUCT_KEY };
  }
  return {
    serviceLine: serviceLineForScenario(params.moves),
    source: SCENARIO_LINE_SOURCE.LEGACY_LITE
  };
}

// src/features/ar-triggers/context/program/resolveBillingContract.ts
var BILLING_AUTHORITY = {
  PROGRAM: "program",
  CUSTOMER: "customer",
  /**
   * Nobody, yet. The Valet product is not knowable from what the caller
   * supplied. Assuming Full Service would show an estimate for a move that
   * might bill as Lite. `selectOwnedProduct` refuses the same input.
   */
  UNRESOLVED: "unresolved"
};
var CUSTOMER_BILLING_REASON = {
  NOT_ENROLLED: "not_enrolled",
  /** Enrolled, but no program contract sells coverage for this move's service line. */
  NO_COVERAGE_FOR_LINE: "no_coverage_for_line"
};
async function serviceLineForCustomer(customerId, asOf) {
  const productKeys = (await getActiveContractProductKeys([customerId], asOf)).get(customerId) ?? [];
  const line = resolveHeldValetLine(productKeys);
  if (line !== HELD_PRODUCTS_AMBIGUOUS) return line;
  return { ambiguous: [...new Set(productKeys)].filter((key) => serviceLineForProductKey(key) != null) };
}
async function resolveBillingContract(input) {
  const logger = getLogger14();
  const asOf = input.asOf ?? (/* @__PURE__ */ new Date()).toISOString();
  if (Number.isNaN(new Date(asOf).getTime())) {
    throw new Error(`resolveBillingContract: invalid asOf date '${asOf}'`);
  }
  let serviceLine;
  if (input.productKey != null) {
    const declared = serviceLineForProductKey(input.productKey);
    if (declared == null) {
      logger.info(
        `resolveBillingContract: customer ${input.customerId} declared product "${input.productKey}", which no Valet coverage contract sells; no contract prices this move`,
        { customerId: input.customerId, productKey: input.productKey }
      );
      return {
        authority: BILLING_AUTHORITY.UNRESOLVED,
        serviceLine: null,
        candidateProductKeys: [input.productKey]
      };
    }
    serviceLine = declared;
  } else if (input.serviceLine != null) {
    serviceLine = input.serviceLine;
  } else if (input.lite != null) {
    serviceLine = serviceLineForMove({ lite: input.lite });
  } else {
    const held = await serviceLineForCustomer(input.customerId, asOf);
    if (typeof held !== "string") {
      logger.info(
        `resolveBillingContract: customer ${input.customerId} holds [${held.ambiguous.join(", ")}] and nothing says which this move is; refusing to pick one`,
        { customerId: input.customerId, candidateProductKeys: held.ambiguous }
      );
      return {
        authority: BILLING_AUTHORITY.UNRESOLVED,
        serviceLine: null,
        candidateProductKeys: held.ambiguous
      };
    }
    serviceLine = held;
  }
  const covering = await getProgramCoverageContracts(input.customerId, asOf, serviceLine);
  const covered = input.programId != null ? covering.find((c) => c.contract.programId === input.programId) : covering[0];
  if (!covered) {
    const enrolled = await getProgramContractsForMove(input.customerId, asOf);
    return {
      authority: BILLING_AUTHORITY.CUSTOMER,
      serviceLine,
      reason: enrolled.length === 0 ? CUSTOMER_BILLING_REASON.NOT_ENROLLED : CUSTOMER_BILLING_REASON.NO_COVERAGE_FOR_LINE
    };
  }
  if (input.programId == null && covering.length > 1) {
    logger.warn(
      `resolveBillingContract: customer ${input.customerId} has ${covering.length} ${serviceLine} coverage contracts; using program ${covered.contract.programId}. Pass programId to disambiguate.`,
      { customerId: input.customerId, programId: covered.contract.programId, contractCount: covering.length }
    );
  }
  const { contractId, programId, config } = covered.contract;
  return {
    authority: BILLING_AUTHORITY.PROGRAM,
    serviceLine,
    contractId,
    programId,
    triggerId: covered.triggerId,
    config
  };
}

// src/features/ar-triggers/algorithms/moveScenarioV1/hooks.ts
var PULL_BACK_EVENT_KEYS = /* @__PURE__ */ new Set([
  MOVE_UNPLANNED_EVENT_KEY,
  MOVE_UNDISPATCHED_EVENT_KEY
]);
async function driveMoveReadiness(args) {
  const readiness = await checkReadiness(args.scenarioId);
  args.shell.metadataLogger.logReadinessCheck(readiness);
  if (readiness.ready) return null;
  if (PULL_BACK_EVENT_KEYS.has(args.shell.triggerContext.eventKey ?? "")) return null;
  return algorithmSkip(
    `Scenario not ready: ${readiness.settledMoves}/${readiness.totalMoves} moves settled`,
    { metadata: args.shell.metadataLogger.toMetadata() }
  );
}
async function driveMoveContext(args) {
  try {
    return await buildScenarioContext(args.scenarioId, args.shell.triggerContext.config);
  } catch (error) {
    if (error instanceof Error && error.message.includes("no drive moves")) {
      args.shell.metadataLogger.warning("system", "Scenario contains no drive moves");
      return algorithmSkip("Scenario contains no drive moves", {
        metadata: args.shell.metadataLogger.toMetadata()
      });
    }
    throw error;
  }
}
async function programCoverageGate(args) {
  const { triggerContext, logger } = args.shell;
  const asOf = triggerContext.billableDate;
  if (!asOf) {
    throw new Error(
      `move_scenario_v1 program-coverage gate: missing billableDate for scenario ${args.context.scenarioId} customer ${args.context.customerId} \u2014 cannot resolve the program contract for the move's date window`
    );
  }
  const billing = await resolveBillingContract({
    customerId: args.context.customerId,
    asOf,
    productKey: args.context.productKey,
    serviceLine: serviceLineForScenario(args.context.moves)
  });
  if (billing.authority !== BILLING_AUTHORITY.PROGRAM) return null;
  const contract = { programId: billing.programId, contractId: billing.contractId };
  const coverageTriggerId = billing.triggerId;
  logger.info(
    `move_scenario_v1: scenario ${args.context.scenarioId} customer ${args.context.customerId} is covered by program ${contract.programId} coverage contract ${contract.contractId} \u2014 yielding move-cost billing to it`,
    {
      scenarioId: args.context.scenarioId,
      customerId: args.context.customerId,
      programId: contract.programId,
      programContractId: contract.contractId,
      coverageTriggerId,
      triggerId: triggerContext.id
    }
  );
  return algorithmSkip(
    `Scenario covered by program ${contract.programId} (contract ${contract.contractId}) \u2014 the program contract is the move-cost billing authority`
  );
}

// src/features/ar-triggers/algorithms/moveScenarioV1/execute.ts
var moveScenarioV1Spec = {
  key: ALGORITHM_MOVE_SCENARIO_V1,
  checkReadiness: driveMoveReadiness,
  loadContext: driveMoveContext,
  loadContract: programCoverageGate,
  price: async ({ context, shell }) => {
    const result = await moveScenarioV1(context, shell);
    shell.metadataLogger.setSummary({
      chargesCreated: result.charges.length,
      totalAmount: result.charges.reduce((sum2, c) => sum2 + c.amount, 0)
    });
    return { charges: result.charges, metadata: shell.metadataLogger.toMetadata() };
  }
};
var execute = runScenarioAlgorithm(moveScenarioV1Spec);

// src/features/ar-triggers/algorithms/staticProductChargeV1/execute.ts
init_productMapping();
var staticProductChargeV1Spec = {
  key: ALGORITHM_STATIC_PRODUCT_CHARGE_V1,
  price: async ({ shell }) => {
    const { triggerContext, logger, metadataLogger } = shell;
    if (!triggerContext.config || typeof triggerContext.config !== "object") {
      logger.error("static_product_charge_v1 config is missing or invalid", {
        triggerId: triggerContext.id,
        customerId: triggerContext.customerId,
        config: triggerContext.config
      });
      metadataLogger.logSkip("time-based-charge", "Invalid config - expected object", {
        configType: typeof triggerContext.config
      });
      return algorithmSkip("Invalid config - expected object with amount field", {
        metadata: metadataLogger.toMetadata()
      });
    }
    const rawAccountingKey = triggerContext.config.accounting_product_key;
    if (rawAccountingKey !== void 0 && typeof rawAccountingKey !== "string") {
      logger.error("static_product_charge_v1 config.accounting_product_key is not a string", {
        triggerId: triggerContext.id,
        customerId: triggerContext.customerId,
        accountingProductKey: rawAccountingKey
      });
      metadataLogger.logSkip(
        "time-based-charge",
        "Invalid accounting_product_key - expected string",
        { accountingProductKeyType: typeof rawAccountingKey }
      );
      return algorithmSkip("Invalid accounting_product_key - expected string", {
        metadata: metadataLogger.toMetadata()
      });
    }
    const configuredAccountingKey = typeof rawAccountingKey === "string" ? rawAccountingKey : void 0;
    const accountingProductKey = configuredAccountingKey ?? triggerContext.product_key;
    if (!accountingProductKey) {
      logger.error("static_product_charge_v1 requires a product key", {
        triggerId: triggerContext.id,
        customerId: triggerContext.customerId
      });
      metadataLogger.logSkip(
        "time-based-charge",
        "Missing product_key - static_product_charge_v1 needs an owning product or config.accounting_product_key",
        { productKey: triggerContext.product_key }
      );
      return algorithmSkip(
        "Missing product_key - static_product_charge_v1 needs an owning product or config.accounting_product_key",
        { metadata: metadataLogger.toMetadata() }
      );
    }
    const amount = triggerContext.config.amount ?? 0;
    if (triggerContext.config.amount !== void 0 && (typeof triggerContext.config.amount !== "number" || Number.isNaN(triggerContext.config.amount))) {
      logger.error("static_product_charge_v1 config.amount is not a valid number", {
        triggerId: triggerContext.id,
        customerId: triggerContext.customerId,
        configAmount: triggerContext.config.amount,
        amountType: typeof triggerContext.config.amount
      });
      metadataLogger.logSkip("time-based-charge", "Invalid amount - expected number", {
        configAmount: triggerContext.config.amount,
        amountType: typeof triggerContext.config.amount
      });
      return algorithmSkip("Invalid amount - expected number", {
        metadata: metadataLogger.toMetadata()
      });
    }
    metadataLogger.logContractLoaded(triggerContext.contractId, triggerContext.customerId);
    if (amount <= 0) {
      logger.warn("Charge amount is zero or negative, skipping charge", {
        amount,
        triggerId: triggerContext.id,
        customerId: triggerContext.customerId,
        productKey: triggerContext.product_key
      });
      metadataLogger.logSkip("time-based-charge", "Amount is zero or negative", {
        amount,
        productKey: triggerContext.product_key
      });
      return algorithmSkip("Amount is zero or negative", {
        metadata: metadataLogger.toMetadata()
      });
    }
    const accountingProduct = await getProductByKey(accountingProductKey);
    const description = triggerContext.config.description || accountingProduct.description || triggerContext.productByKey?.description || accountingProduct.key;
    const frequency = triggerContext.config.frequency;
    const accountingKey = accountingProduct.accounting_id ? String(accountingProduct.accounting_id) : void 0;
    const billingDate = (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
    metadataLogger.logFixedFee({
      method: ALGORITHM_STATIC_PRODUCT_CHARGE_V1,
      configuredAmount: amount,
      description,
      billingPeriod: billingDate,
      frequency
    });
    metadataLogger.info("calculation", "Using product for charge metadata", {
      owningProductKey: triggerContext.product_key,
      accountingProductKey: accountingProduct.key,
      accountingProductId: accountingProduct.id,
      configFrequency: triggerContext.config.frequency,
      accountingId: accountingProduct.accounting_id
    });
    const charge = {
      type: accountingProduct.key,
      name: triggerContext.customerName ? `${triggerContext.customerName} \u2014 ${description}` : description,
      amount,
      sourceType: "product",
      sourceId: String(accountingProduct.id),
      notes: triggerContext.customerName ? description : `Charge date: ${billingDate}`,
      accountingKey
    };
    metadataLogger.logChargeCreated({
      chargeType: accountingProduct.key,
      amount,
      sourceId: String(accountingProduct.id)
    });
    metadataLogger.setSummary({
      chargesCreated: 1,
      totalAmount: amount,
      itemsProcessed: 1
    });
    const metadata = metadataLogger.toMetadata();
    if (frequency) {
      metadata.frequency = frequency;
    }
    return { charges: [charge], metadata };
  }
};
var execute2 = runTimeAlgorithm(staticProductChargeV1Spec);

// src/features/ar-triggers/algorithms/prepaidProductV1/execute.ts
import { getLogger as getLogger15 } from "@hopdrive/sdk-core";
async function execute3(trigger) {
  const logger = getLogger15();
  const metadataLogger = createAlgorithmLogger(trigger);
  logger.warn("prepaid_product_v1 algorithm not yet implemented", {
    triggerId: trigger.id,
    customerId: trigger.customerId,
    productKey: trigger.product_key
  });
  metadataLogger.logSkip(
    "prepaid-product",
    "Algorithm not yet implemented (TBI)",
    { productKey: trigger.product_key }
  );
  return {
    status: ALGORITHM_STATUS_SKIPPED,
    skipReason: "prepaid_product_v1 algorithm not yet implemented (TBI)",
    metadata: metadataLogger.toMetadata()
  };
}

// src/features/ar-triggers/algorithms/guestRideScenarioV1/index.ts
init_productMapping();
init_accountingProductKeys();
var TERMINAL_RIDEHAIL_STATUSES = /* @__PURE__ */ new Set(["cancelled", "failed", "retry"]);
function isTerminalRidehailStatus(status) {
  return status != null && TERMINAL_RIDEHAIL_STATUSES.has(status.trim().toLowerCase());
}
function resolveRideCost(ride) {
  if (ride.actualPrice != null) {
    return { amount: ride.actualPrice, source: "actual" };
  }
  if (isTerminalRidehailStatus(ride.status)) return null;
  if (ride.estimatedPrice != null) {
    return { amount: ride.estimatedPrice, source: "estimated" };
  }
  return null;
}
function unbillableReason(ride) {
  if (isTerminalRidehailStatus(ride.status)) {
    return `ridehail ended as '${ride.status}' with no actual_price \u2014 the ride never ran, so there is nothing to bill`;
  }
  return "ridehail has neither actual_price nor estimated_price";
}
function readGuestRidesPerUseFee(effectiveConfig) {
  const products = effectiveConfig?.ar?.products;
  const guestRides = products?.[PRODUCT_KEY_GUEST_RIDES];
  const raw = guestRides?.perUseFee;
  if (typeof raw !== "number" || Number.isNaN(raw) || raw <= 0) return null;
  return raw;
}
async function guestRideScenarioV1(ctx, effectiveConfig, metadataLogger) {
  const charges = [];
  const platformChargeAmount = readGuestRidesPerUseFee(effectiveConfig);
  metadataLogger.info("contract", "Loaded contract effective_config for guestride pricing", {
    contractId: ctx.contractId,
    platformChargeAmount
  });
  if (platformChargeAmount == null) {
    metadataLogger.warning(
      "contract",
      "Contract effective_config is missing ar.products['guest-rides'].perUseFee (or it is zero/negative)",
      { contractId: ctx.contractId }
    );
  }
  const rideAccountingKey = await resolveAccountingKey(ACCOUNTING_KEY_RIDE);
  const platformAccountingKey = await resolveAccountingKey(ACCOUNTING_KEY_PLATFORM);
  const feeBearingGuestrideIds = /* @__PURE__ */ new Set();
  for (const ride of ctx.guestrides) {
    metadataLogger.info("input", `Processing guestride ${ride.guestrideId}`, {
      guestrideId: ride.guestrideId,
      ridehailId: ride.ridehailId,
      status: ride.status,
      actualPrice: ride.actualPrice,
      estimatedPrice: ride.estimatedPrice
    });
    const rideCost = resolveRideCost(ride);
    if (!rideCost) {
      metadataLogger.logSkip(ride.ridehailId, unbillableReason(ride), {
        guestrideId: ride.guestrideId,
        status: ride.status
      });
      continue;
    }
    metadataLogger.info("calculation", "Resolved ride cost from ridehail", {
      guestrideId: ride.guestrideId,
      ridehailId: ride.ridehailId,
      amount: rideCost.amount,
      priceSource: rideCost.source
    });
    const rideHailNotes = (source) => {
      const prefix = source === "actual" ? "" : "Estimated ";
      return `${prefix}Price for ridehail service`;
    };
    const rideCharge = {
      type: "ride",
      name: `Ridehail`,
      amount: rideCost.amount,
      sourceType: "guestride",
      sourceId: String(ride.guestrideId),
      notes: rideHailNotes(rideCost.source),
      accountingKey: rideAccountingKey
    };
    charges.push(rideCharge);
    metadataLogger.logChargeCreated({
      chargeType: "ridehail",
      amount: rideCharge.amount,
      sourceId: rideCharge.sourceId
    });
    if (rideCost.amount > 0) {
      feeBearingGuestrideIds.add(ride.guestrideId);
    }
    metadataLogger.incrementProcessed();
  }
  if (platformChargeAmount != null) {
    for (const guestrideId of feeBearingGuestrideIds) {
      const platformCharge = {
        type: "platform",
        name: `Platform Fee`,
        amount: platformChargeAmount,
        sourceType: "guestride",
        sourceId: String(guestrideId),
        notes: `Per use fee for ridehail`,
        accountingKey: platformAccountingKey
      };
      charges.push(platformCharge);
      metadataLogger.logChargeCreated({
        chargeType: "platform",
        amount: platformCharge.amount,
        sourceId: platformCharge.sourceId
      });
    }
  }
  return {
    charges,
    metadata: {}
  };
}

// src/features/ar-triggers/algorithms/guestRideScenarioV1/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor17 } from "@hopdrive/sdk-core";
async function getGuestrideScenarioContext(scenarioId) {
  const executor = resolveExecutor17();
  const result = await executor.query(GetGuestrideScenarioContextDocument, { scenarioId });
  return result.scenarios_by_pk;
}
async function getContractEffectiveConfig(contractId) {
  const executor = resolveExecutor17();
  const result = await executor.query(GetContractEffectiveConfigDocument, { contractId });
  return result.contracts?.[0];
}

// src/features/ar-triggers/algorithms/guestRideScenarioV1/execute.ts
function partiesOf(triggerContext) {
  return { customerId: triggerContext.customerId, orgId: triggerContext.orgId };
}
var guestRideScenarioV1Spec = {
  key: ALGORITHM_GUESTRIDE_SCENARIO_V1,
  // Readiness is inherent to the context load: the scenario must exist and
  // have linked ridehails, both checked in `loadContext` off the same query.
  checkReadiness: async () => null,
  loadContext: async ({ scenarioId, shell }) => {
    const { triggerContext, metadataLogger } = shell;
    if (!triggerContext.contractId) {
      metadataLogger.warning("system", "No contractId on trigger for guestride_scenario_v1");
      return algorithmSkip("No contractId on trigger", { metadata: metadataLogger.toMetadata() });
    }
    const scenario = await getGuestrideScenarioContext(scenarioId);
    if (!scenario) {
      metadataLogger.error("system", `Scenario ${scenarioId} not found`);
      return algorithmSkip(`Scenario ${scenarioId} not found`, {
        metadata: metadataLogger.toMetadata()
      });
    }
    const rides = [];
    for (const link of scenario.guestride_links ?? []) {
      const guestride = link.guestride;
      if (!guestride) continue;
      for (const ridehail of guestride.ridehails ?? []) {
        rides.push({
          guestrideId: guestride.id,
          ridehailId: ridehail.id,
          status: ridehail.status ?? null,
          actualPrice: ridehail.actual_price ?? null,
          estimatedPrice: ridehail.estimated_price ?? null
        });
      }
    }
    if (rides.length === 0) {
      metadataLogger.warning("input", "Guestride scenario has no linked ridehails", { scenarioId });
      return algorithmSkip("Guestride scenario has no linked ridehails", {
        metadata: metadataLogger.toMetadata(),
        ...partiesOf(triggerContext)
      });
    }
    return { ...partiesOf(triggerContext), rides };
  },
  loadContract: async ({ shell }) => {
    const { triggerContext, metadataLogger } = shell;
    const contract = await getContractEffectiveConfig(triggerContext.contractId);
    if (!contract) {
      metadataLogger.error("contract", `Contract ${triggerContext.contractId} not found for guestride_scenario_v1`);
      return algorithmSkip(`Contract ${triggerContext.contractId} not found`, {
        metadata: metadataLogger.toMetadata(),
        ...partiesOf(triggerContext)
      });
    }
    metadataLogger.logContractLoaded(contract.id, triggerContext.customerId);
    return contract;
  },
  price: async ({ scenarioId, context, contract, shell }) => {
    const ctx = {
      scenarioId,
      customerId: context.customerId,
      orgId: context.orgId,
      contractId: contract.id,
      guestrides: context.rides
    };
    const result = await guestRideScenarioV1(
      ctx,
      contract.effective_config,
      shell.metadataLogger
    );
    shell.metadataLogger.setSummary({
      chargesCreated: result.charges.length,
      totalAmount: result.charges.reduce((sum2, c) => sum2 + c.amount, 0)
    });
    return { charges: result.charges, metadata: shell.metadataLogger.toMetadata() };
  }
};
var execute4 = runScenarioAlgorithm(guestRideScenarioV1Spec);

// src/features/ar-triggers/algorithms/mobileServiceV1/execute.ts
async function execute5(_trigger) {
  throw new Error(
    "NotImplementedError: mobileServiceV1 is a placeholder algorithm. Build a ScenarioAlgorithmSpec on runScenarioAlgorithm (see packages/ar/src/features/ar-triggers/algorithms/shared/runner.ts and docs/ALGORITHM_PIPELINE.md); packages/ar/docs/INTEGRATING_NEW_PRODUCT.md has the integration guide."
  );
}

// src/features/ar-triggers/algorithms/returnRideScenarioV1/index.ts
init_productMapping();
init_accountingProductKeys();
var RETURN_RIDE_FEE_SCHEMA_KEY = "per-use-fee";
function readReturnRidePlatformFee(rules, context) {
  const resolved = requireContractRuleConfig({
    rules,
    criteria: { productKey: PRODUCT_KEY_RETURN_RIDES, schemaKey: RETURN_RIDE_FEE_SCHEMA_KEY },
    schemaKey: RETURN_RIDE_FEE_SCHEMA_KEY,
    context
  });
  if ("skip" in resolved) return { amount: null, missingReason: resolved.reason };
  const amount = resolved.config.amount;
  if (amount <= 0) return { amount: null, ruleId: resolved.rule.id, waived: true };
  return { amount, ruleId: resolved.rule.id };
}
async function returnRideScenarioV1(ctx, platformFee, metadataLogger) {
  const charges = [];
  const rideAccountingKey = await resolveAccountingKey(ACCOUNTING_KEY_RIDE);
  const platformAccountingKey = await resolveAccountingKey(ACCOUNTING_KEY_PLATFORM);
  const feeBearing = /* @__PURE__ */ new Map();
  for (const ride of ctx.rides) {
    metadataLogger.info("input", `Processing return ride ${ride.rideMoveId}`, {
      rideMoveId: ride.rideMoveId,
      ridehailId: ride.ridehailId,
      provider: ride.provider ?? null,
      status: ride.status ?? null,
      actualPrice: ride.actualPrice,
      estimatedPrice: ride.estimatedPrice
    });
    const rideCost = resolveRideCost(ride);
    if (!rideCost) {
      metadataLogger.logSkip(ride.ridehailId, unbillableReason(ride), {
        rideMoveId: ride.rideMoveId,
        status: ride.status
      });
      continue;
    }
    const rideCharge = {
      type: "ride",
      name: "Ridehail",
      amount: rideCost.amount,
      sourceType: "ridehail",
      sourceId: String(ride.ridehailId),
      notes: `${rideCost.source === "actual" ? "" : "Estimated "}Price for ridehail service`,
      accountingKey: rideAccountingKey
    };
    charges.push(rideCharge);
    metadataLogger.logChargeCreated({
      chargeType: "ridehail",
      amount: rideCharge.amount,
      sourceId: rideCharge.sourceId
    });
    if (rideCost.amount > 0 && !feeBearing.has(ride.rideMoveId)) {
      feeBearing.set(ride.rideMoveId, ride.ridehailId);
    }
    metadataLogger.incrementProcessed();
  }
  if (platformFee != null) {
    for (const ridehailId of feeBearing.values()) {
      const platformCharge = {
        type: "platform",
        name: "Platform Fee",
        amount: platformFee,
        sourceType: "ridehail",
        sourceId: String(ridehailId),
        notes: "Per use fee for ridehail",
        accountingKey: platformAccountingKey
      };
      charges.push(platformCharge);
      metadataLogger.logChargeCreated({
        chargeType: "platform",
        amount: platformCharge.amount,
        sourceId: platformCharge.sourceId
      });
    }
  }
  return { charges, metadata: {} };
}

// src/features/ar-triggers/algorithms/returnRideScenarioV1/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor18 } from "@hopdrive/sdk-core";
async function getReturnRideScenarioContext(scenarioId) {
  const result = await resolveExecutor18().query(GetReturnRideScenarioContextDocument, { scenarioId });
  return result.scenarios_by_pk;
}
async function getReturnRideContractRules(contractId) {
  const result = await resolveExecutor18().query(GetReturnRideContractRulesDocument, { contractId });
  return result.contracts_by_pk;
}

// src/features/ar-triggers/algorithms/returnRideScenarioV1/execute.ts
function partiesOf2(triggerContext) {
  return { customerId: triggerContext.customerId, orgId: triggerContext.orgId };
}
var returnRideScenarioV1Spec = {
  key: ALGORITHM_RETURN_RIDE_SCENARIO_V1,
  checkReadiness: async () => null,
  loadContext: async ({ scenarioId, shell }) => {
    const { triggerContext, metadataLogger } = shell;
    if (!triggerContext.contractId) {
      metadataLogger.warning("system", "No contractId on trigger for return_ride_scenario_v1");
      return algorithmSkip("No contractId on trigger", { metadata: metadataLogger.toMetadata() });
    }
    const scenario = await getReturnRideScenarioContext(scenarioId);
    if (!scenario) {
      metadataLogger.error("system", `Scenario ${scenarioId} not found`);
      return algorithmSkip(`Scenario ${scenarioId} not found`, { metadata: metadataLogger.toMetadata() });
    }
    const moves = (scenario.moves ?? []).map((link) => link.move).filter((m) => m != null);
    const product = classifyRidehailProduct({
      moveId: moves[0]?.id ?? null,
      scenarioProductKey: scenario.product_key ?? null,
      liteFlags: moves.map((m) => m.lite)
    });
    if (product !== RIDEHAIL_PRODUCT.RETURN_RIDES) {
      metadataLogger.warning("input", "Scenario is not Valet Lite; its rides are not return rides", {
        scenarioId,
        productKey: scenario.product_key ?? null
      });
      return algorithmSkip("Scenario is not Valet Lite", {
        metadata: metadataLogger.toMetadata(),
        ...partiesOf2(triggerContext)
      });
    }
    const rides = [];
    for (const move of moves) {
      if (move.move_type !== "ride" || move.active === 0) continue;
      for (const ridehail of move.ridehails ?? []) {
        rides.push({
          rideMoveId: move.id,
          ridehailId: ridehail.id,
          provider: ridehail.provider ?? null,
          status: ridehail.status ?? null,
          actualPrice: ridehail.actual_price ?? null,
          estimatedPrice: ridehail.estimated_price ?? null
        });
      }
    }
    if (rides.length === 0) {
      metadataLogger.warning("input", "Lite scenario has no ridehails on an active ride move", { scenarioId });
      return algorithmSkip("Lite scenario has no ridehails on an active ride move", {
        metadata: metadataLogger.toMetadata(),
        ...partiesOf2(triggerContext)
      });
    }
    return { ...partiesOf2(triggerContext), rides };
  },
  loadContract: async ({ shell }) => {
    const { triggerContext, metadataLogger } = shell;
    const contract = await getReturnRideContractRules(triggerContext.contractId);
    if (!contract) {
      metadataLogger.error("contract", `Contract ${triggerContext.contractId} not found for return_ride_scenario_v1`);
      return algorithmSkip(`Contract ${triggerContext.contractId} not found`, {
        metadata: metadataLogger.toMetadata(),
        ...partiesOf2(triggerContext)
      });
    }
    metadataLogger.logContractLoaded(contract.id, triggerContext.customerId);
    return { id: contract.id, rules: contract.contract_rules ?? [] };
  },
  price: async ({ scenarioId, context, contract, shell }) => {
    const { metadataLogger } = shell;
    const fee = readReturnRidePlatformFee(
      contract.rules,
      ruleContextFrom(shell, contract.id, "return ride platform fee")
    );
    if (fee.missingReason) {
      metadataLogger.warning("contract", "No readable return-rides per-use-fee rule; billing rides with no platform fee", {
        contractId: contract.id,
        reason: fee.missingReason
      });
    } else {
      metadataLogger.info("contract", "Loaded return-rides platform fee from contract rule", {
        contractId: contract.id,
        contractRuleId: fee.ruleId,
        platformChargeAmount: fee.amount,
        waived: fee.waived ?? false
      });
    }
    const result = await returnRideScenarioV1(
      {
        scenarioId,
        customerId: context.customerId,
        orgId: context.orgId,
        contractId: contract.id,
        rides: context.rides
      },
      fee.amount,
      metadataLogger
    );
    metadataLogger.setSummary({
      chargesCreated: result.charges.length,
      totalAmount: result.charges.reduce((sum2, c) => sum2 + c.amount, 0)
    });
    return { charges: result.charges, metadata: metadataLogger.toMetadata() };
  }
};
var execute6 = runScenarioAlgorithm(returnRideScenarioV1Spec);

// src/features/ar-triggers/algorithms/programMoveScenarioV1/decide.ts
var CONSUMER_TYPE_CUSTOMER2 = "customer";
var CONSUMER_TYPE_LOANER2 = "loaner";
function standardQualifies(m) {
  return m.active && !m.canceled && m.chargeable;
}
function earnsLoanerPerUseFee(m, tripHasQualifyingCustomerMove) {
  return m.consumerType === CONSUMER_TYPE_LOANER2 && m.active && !m.canceled && tripHasQualifyingCustomerMove;
}
function decideProgramScenarioCharge(state, config) {
  const amount = typeof config.amount === "number" ? config.amount : NaN;
  if (!Number.isFinite(amount) || amount <= 0) {
    return { skip: true, reason: `Program fee amount missing or \u2264 0 for scenario ${state.scenarioId}` };
  }
  const tripHasQualifyingCustomerMove = state.moves.some(
    (m) => m.consumerType === CONSUMER_TYPE_CUSTOMER2 && standardQualifies(m)
  );
  const moveQualifies = (m) => standardQualifies(m) || earnsLoanerPerUseFee(m, tripHasQualifyingCustomerMove);
  const qualifying = state.moves.filter(moveQualifies);
  if (qualifying.length === 0) {
    return {
      skip: true,
      reason: `Scenario ${state.scenarioId} has no chargeable drive move \u2014 no program fee`
    };
  }
  return qualifying.map((m) => ({
    type: "per_use",
    name: `Program per-use fee \u2014 move ${m.moveId}`,
    amount,
    sourceType: "move",
    sourceId: String(m.moveId),
    notes: `Flat program per-use fee for move ${m.moveId}`
  }));
}
function isProgramScenarioSkip(result) {
  return result.skip === true;
}

// src/features/ar-triggers/algorithms/programMoveScenarioV1/execute.ts
init_accountingProductKeys();
var programMoveScenarioV1Spec = {
  key: ALGORITHM_PROGRAM_MOVE_SCENARIO_V1,
  accountingProductKey: ACCOUNTING_KEY_MOVE_VALIDATION_FEE,
  checkReadiness: driveMoveReadiness,
  loadContext: driveMoveContext,
  loadContract: async ({ context, shell }) => {
    const requireAnyProductKeys = readRequireAnyProductKeys(shell.triggerContext.config);
    if (requireAnyProductKeys.length === 0) {
      logMissingProductGate(shell.logger, {
        triggerId: shell.triggerContext.id,
        contractId: shell.triggerContext.contractId,
        programId: shell.triggerContext.programId,
        algorithmKey: ALGORITHM_PROGRAM_MOVE_SCENARIO_V1
      });
      return algorithmSkip(
        `Program trigger ${shell.triggerContext.id} has no usable config.${REQUIRE_ANY_PRODUCT_KEYS_FIELD} \u2014 no program per-use fee`,
        {
          customerId: context.customerId,
          orgId: context.orgId,
          metadata: { noCharge: true, missingField: REQUIRE_ANY_PRODUCT_KEYS_FIELD }
        }
      );
    }
    const today = shell.triggerContext.billableDate ?? (/* @__PURE__ */ new Date()).toISOString();
    const byCustomer = await getActiveContractProductKeys([context.customerId], today);
    const productKeys = byCustomer.get(context.customerId) ?? [];
    return {
      hasProduct: qualifiesForProductGate(productKeys, requireAnyProductKeys),
      requireAnyProductKeys
    };
  },
  price: async ({ scenarioId, context, contract, shell }) => {
    const decision = contract.hasProduct ? decideProgramScenarioCharge(
      {
        scenarioId,
        moves: context.moves.map((m) => ({
          moveId: m.moveId,
          chargeable: m.chargeable,
          canceled: m.cancelStatus === "canceled",
          active: m.active,
          consumerType: m.consumerType
        }))
      },
      shell.triggerContext.config
    ) : {
      skip: true,
      reason: `Customer ${context.customerId} carries none of [${contract.requireAnyProductKeys.join(", ")}] on an active contract \u2014 no program per-use fee`
    };
    const charges = isProgramScenarioSkip(decision) ? [] : decision;
    return {
      charges,
      metadata: {
        programId: shell.triggerContext.programId,
        scenarioId,
        chargesCreated: charges.length,
        totalAmount: charges.reduce((sum2, charge) => sum2 + charge.amount, 0),
        ...isProgramScenarioSkip(decision) && { noCharge: true, reason: decision.reason }
      }
    };
  }
};
var execute7 = runScenarioAlgorithm(programMoveScenarioV1Spec);

// src/features/ar-triggers/algorithms/programMoveCoverageV1/execute.ts
init_operations();

// src/features/ar-triggers/algorithms/programMoveCoverageV1/decide.ts
var PROGRAM_SKIP_REASON = {
  [MOVE_COST_SKIP.NOT_BILLABLE]: "not_chargeable",
  [MOVE_COST_SKIP.NO_DISTANCE]: "no_distance",
  [MOVE_COST_SKIP.NO_BANDS]: "no_band",
  [MOVE_COST_SKIP.NO_BAND_MATCH]: "no_band",
  [MOVE_COST_SKIP.UNKNOWN_RATE_TYPE]: "unknown_rate_type"
};
var CHARGE_SOURCE = { MOVE: "move", ACCESSORIAL: "accessorial" };
async function decideProgramMoveCoverage(moves, contract, settlement, strategy, eligible = true, policy, laneModifierByMoveId = /* @__PURE__ */ new Map(), ruleContext, accessorialOptions = {}, productKey = null) {
  const charges = [];
  const customerCharges = [];
  const settlements = [];
  const accessorialSettlements = [];
  const skipped3 = [];
  const isReimbursement = settlement === SETTLEMENT_MODE.REIMBURSEMENT;
  for (const move of moves) {
    let refusal = null;
    const priced = await priceMoveCost({
      move,
      bands: () => {
        const selected = resolveEffectiveRaterules(contract, { moveId: move.moveId }, ruleContext);
        if (isAlgorithmSkip(selected)) {
          refusal = selected;
          return [];
        }
        return selected.bands;
      },
      strategy,
      laneModifier: laneModifierByMoveId.get(move.moveId) ?? null,
      overrideBands: OVERRIDE_BANDS.RESOLVE,
      productKey
    });
    const spannedBands = priced.contributions.map((c) => `${c.band.distance_start}-${c.band.distance_end ?? "\u221E"}`).join(" + ");
    const chargeNote = (payer, amount, total) => [
      `Class ${priced.weightClass}`,
      spannedBands ? `${spannedBands} mile band${priced.contributions.length > 1 ? "s" : ""}` : "no band",
      `${payer} $${amount.toFixed(2)} of $${total.toFixed(2)} (${settlement}${eligible ? "" : ", ineligible"})`
    ].join(", ");
    if (priced.skipCode === MOVE_COST_SKIP.NOT_BILLABLE) {
      skipped3.push({ moveId: move.moveId, reason: "not_chargeable" });
      continue;
    }
    if (refusal) {
      skipped3.push({ moveId: move.moveId, reason: refusal.reason });
    } else if (priced.outcome === MOVE_COST_OUTCOME.SKIPPED) {
      skipped3.push({ moveId: move.moveId, reason: PROGRAM_SKIP_REASON[priced.skipCode] ?? "skipped" });
    } else if (priced.outcome === MOVE_COST_OUTCOME.NO_TRANSPORT) {
      skipped3.push({ moveId: move.moveId, reason: "cancel_started" });
    } else {
      const banded = coverageSplitFromContributions(priced.contributions, eligible);
      const overrideGovernsPrice = priced.outcome === MOVE_COST_OUTCOME.PRICE_OVERRIDE && !isReimbursement;
      const split = overrideGovernsPrice ? scaleSplitToTotal(banded, priced.total) : banded;
      const finalSplit = isReimbursement ? reimbursementSplit(split, eligible) : split;
      const result = applySettlement(move.moveId, finalSplit, settlement);
      settlements.push(result);
      if (result.programCharge > 0) {
        charges.push({
          type: "move",
          name: `Program coverage \u2014 move ${move.moveId}`,
          amount: result.programCharge,
          sourceType: CHARGE_SOURCE.MOVE,
          sourceId: String(move.moveId),
          notes: chargeNote("program coverage", result.programCharge, result.totalCost)
        });
      }
      if (result.customerCharge > 0) {
        customerCharges.push({
          type: "move",
          name: `Customer share \u2014 move ${move.moveId}`,
          amount: result.customerCharge,
          sourceType: CHARGE_SOURCE.MOVE,
          sourceId: String(move.moveId),
          notes: chargeNote("customer share", result.customerCharge, result.totalCost)
        });
      }
      if (priced.laneTolls > 0) {
        const tolls = settleLaneTolls(move.moveId, priced.tolls, policy, settlement, eligible);
        accessorialSettlements.push(tolls.settlement);
        charges.push(...tolls.charges);
        customerCharges.push(...tolls.customerCharges);
      }
    }
    const accSettlement = accessorialSettlementFor(settlement);
    for (const acc of selectBillableAccessorials(move, accessorialOptions)) {
      const payer = resolveAccessorialPayerFor(policy, acc.code);
      const settled = settleAccessorial(acc.arAmount, payer, accSettlement, eligible);
      accessorialSettlements.push({ accessorialId: acc.accessorialId, code: acc.code, payer, settlement: accSettlement, ...settled });
      const type = acc.code.toLowerCase();
      const name = acc.code;
      const sourceId = String(acc.accessorialId);
      const documentReferenceId = acc.documentReferenceId ?? null;
      const notes = `Program accessorial (${payer}/${accSettlement}${eligible ? "" : ", ineligible"}): $${settled.totalCost.toFixed(2)}`;
      if (settled.programCharge > 0) {
        charges.push({ type, name, amount: settled.programCharge, sourceType: CHARGE_SOURCE.ACCESSORIAL, sourceId, notes, documentReferenceId });
      }
      if (settled.customerCharge > 0) {
        customerCharges.push({ type, name, amount: settled.customerCharge, sourceType: CHARGE_SOURCE.ACCESSORIAL, sourceId, notes, documentReferenceId });
      }
    }
  }
  return { charges, customerCharges, settlements, accessorialSettlements, skipped: skipped3 };
}
function reimbursementSplit(split, eligible) {
  const owed = (cost) => eligible ? cost : 0;
  return {
    ...split,
    programAmount: owed(split.totalCost),
    customerAmount: eligible ? 0 : split.totalCost,
    contributions: split.contributions.map((c) => ({
      ...c,
      programCoveragePct: eligible ? FULL_COVERAGE_PCT : 0,
      programAmount: owed(c.cost),
      customerAmount: eligible ? 0 : c.cost
    }))
  };
}
var FULL_COVERAGE_PCT = 100;
function settleLaneTolls(moveId, tolls, policy, settlement, eligible) {
  const payer = resolveAccessorialPayerFor(policy, TOLL_ACCESSORIAL_CODE);
  const tollSettlement = accessorialSettlementFor(settlement);
  const settled = settleAccessorial(tolls, payer, tollSettlement, eligible);
  const notes = `Program lane tolls (${payer}/${tollSettlement}${eligible ? "" : ", ineligible"}): $${tolls.toFixed(2)}`;
  const charge = (amount) => ({
    type: LANE_TOLL_CHARGE_TYPE,
    name: LANE_TOLL_CHARGE_NAME,
    amount,
    sourceType: CHARGE_SOURCE.MOVE,
    sourceId: String(moveId),
    notes
  });
  return {
    settlement: { accessorialId: LANE_TOLL_ACCESSORIAL_ID, code: TOLL_ACCESSORIAL_CODE, payer, settlement: tollSettlement, ...settled },
    charges: settled.programCharge > 0 ? [charge(settled.programCharge)] : [],
    customerCharges: settled.customerCharge > 0 ? [charge(settled.customerCharge)] : []
  };
}

// src/features/ar-triggers/algorithms/programMoveCoverageV1/resolveEligibility.ts
init_operations();
var INELIGIBLE = "ineligible";
async function resolveProgramEligibility(scenarioId, contractId) {
  const claim = (await getProgramClaim({ scenarioId, contractId }))[0];
  if (!claim) return false;
  return claim.eligibility_status !== INELIGIBLE;
}

// src/features/ar-triggers/algorithms/programMoveCoverageV1/execute.ts
init_productMapping();
init_accountingProductKeys();
async function coverageGate(shell, context) {
  const { triggerContext, logger } = shell;
  const productKey = triggerContext.product_key ?? null;
  const contractLine = coverageServiceLineForProduct(productKey);
  if (contractLine == null) {
    logger.error(
      `program_move_coverage_v1: coverage trigger ${triggerContext.id} is owned by no Valet product (${JSON.stringify(productKey)}); it cannot say which service line it prices`,
      {
        triggerId: triggerContext.id,
        contractId: triggerContext.contractId,
        programId: triggerContext.programId,
        algorithmKey: ALGORITHM_PROGRAM_MOVE_COVERAGE_V1,
        productKey
      }
    );
    return algorithmSkip(
      `coverage trigger ${triggerContext.id} is owned by no Valet product (${JSON.stringify(productKey)}); the contract cannot say which service line it prices`,
      { customerId: context.customerId, orgId: context.orgId, metadata: { noCharge: true, productKey } }
    );
  }
  const gate = coverageGateFor(contractLine);
  const asOf = triggerContext.billableDate ?? (/* @__PURE__ */ new Date()).toISOString();
  const productKeys = (await getActiveContractProductKeys([context.customerId], asOf)).get(context.customerId) ?? [];
  if (!qualifiesForProductGate(productKeys, gate)) {
    return algorithmSkip(
      `customer ${context.customerId} carries none of [${gate.join(", ")}] on an active contract; this ${contractLine} coverage contract does not price scenario ${context.scenarioId}`,
      { customerId: context.customerId, orgId: context.orgId, metadata: { noCharge: true } }
    );
  }
  const scenario = resolveScenarioServiceLine({ productKey: context.productKey, moves: context.moves });
  if (isUnrecognizedScenarioProduct(scenario)) {
    logger.error(
      `program_move_coverage_v1: scenario ${context.scenarioId} carries product "${scenario.unrecognizedProductKey}", which no Valet coverage contract sells; refusing to price it as ${contractLine}`,
      {
        triggerId: triggerContext.id,
        contractId: triggerContext.contractId,
        programId: triggerContext.programId,
        scenarioId: context.scenarioId,
        customerId: context.customerId,
        productKey: scenario.unrecognizedProductKey,
        algorithmKey: ALGORITHM_PROGRAM_MOVE_COVERAGE_V1
      }
    );
    return algorithmSkip(
      `scenario ${context.scenarioId} carries product "${scenario.unrecognizedProductKey}", which names no Valet service line; this coverage contract cannot price it`,
      {
        customerId: context.customerId,
        orgId: context.orgId,
        metadata: { noCharge: true, unrecognizedProductKey: scenario.unrecognizedProductKey }
      }
    );
  }
  if (scenario.serviceLine !== contractLine) {
    const via = scenario.source === SCENARIO_LINE_SOURCE.PRODUCT_KEY ? `product ${context.productKey}` : "legacy moves.lite";
    return algorithmSkip(
      `scenario ${context.scenarioId} is ${scenario.serviceLine} (${via}); this ${contractLine} coverage contract does not price it`
    );
  }
  return scenario.serviceLine;
}
var programMoveCoverageV1Spec = {
  key: ALGORITHM_PROGRAM_MOVE_COVERAGE_V1,
  // No spec-wide `accountingProductKey`, because move legs and accessorial legs
  // book to different products. The price hook resolves each charge's key.
  checkReadiness: driveMoveReadiness,
  loadContext: async (args) => {
    const context = await driveMoveContext(args);
    if (isAlgorithmSkip(context)) return context;
    const gated = await coverageGate(args.shell, context);
    if (isAlgorithmSkip(gated)) return gated;
    return { ...context, serviceLine: gated };
  },
  loadContract: async ({ scenarioId, context, shell }) => {
    const { triggerContext, logger } = shell;
    const [groups, eligible] = await Promise.all([
      getProgramContract({ contractId: triggerContext.contractId }),
      resolveProgramEligibility(scenarioId, triggerContext.contractId)
    ]);
    const group = groups[0];
    const contractRules = (group?.contract_rules ?? []).map((rule) => ({
      ...rule,
      raterules: toCoverageBands(rule.raterules)
    }));
    const ruleContext = ruleContextFrom(shell, triggerContext.contractId, "program coverage bands");
    const coverageRule = requireProgramCoverageRule({
      rules: contractRules,
      serviceLine: context.serviceLine,
      context: ruleContext
    });
    if (isAlgorithmSkip(coverageRule)) return coverageRule;
    const selectedRules = [coverageRule];
    const contractRuleId = coverageRule.id;
    const contractRuleSelection = CONTRACT_RULE_SELECTION.MATCHED_SCOPE;
    if (coverageRule.raterules.length === 0) {
      logger.warn(
        `program_move_coverage_v1: the ${context.serviceLine} coverage rule ${coverageRule.id} on contract ${triggerContext.contractId} (scenario ${scenarioId}) carries no bands \u2014 every move cost will skip; check the rule's rate rules`,
        {
          triggerId: triggerContext.id,
          contractId: triggerContext.contractId,
          scenarioId,
          programId: triggerContext.programId,
          serviceLine: context.serviceLine,
          contractRuleId: coverageRule.id
        }
      );
    }
    const policy = resolveProgramSettlementPolicy({
      rules: contractRules,
      serviceLine: context.serviceLine,
      context: ruleContextFrom(shell, triggerContext.contractId, "program settlement policy")
    });
    if (isAlgorithmSkip(policy)) return policy;
    return {
      contractRules,
      selectedRules,
      contractRuleId,
      contractRuleSelection,
      settlement: policy.settlement,
      strategy: policy.bandStrategy,
      eligible,
      policy
    };
  },
  price: async ({ scenarioId, context, contract, shell }) => {
    const billableDate = shell.triggerContext.billableDate;
    const laneModifierByMoveId = /* @__PURE__ */ new Map();
    if (billableDate) {
      for (const m of context.moves) {
        laneModifierByMoveId.set(
          m.moveId,
          await getApplicableArLaneModifier(
            {
              workflowsetId: m.workflowsetId,
              workflowsetType: m.workflowsetType,
              customerId: context.customerId,
              organizationId: context.orgId
            },
            billableDate
          )
        );
      }
    }
    const { charges, customerCharges, settlements, accessorialSettlements, skipped: skipped3 } = await decideProgramMoveCoverage(
      context.moves,
      // Only the rule the cascade selected reaches the pricer, so the per-move
      // band read inside `decide` resolves it as the single candidate.
      { id: shell.triggerContext.contractId, contract_rules: contract.selectedRules },
      contract.settlement,
      contract.strategy,
      contract.eligible,
      contract.policy,
      laneModifierByMoveId,
      ruleContextFrom(shell, shell.triggerContext.contractId, "program coverage bands"),
      { rideChargesOwnedByReturnRides: returnRidesOwnRideCharges(context) },
      context.productKey ?? null
    );
    const allCharges = [...charges, ...customerCharges];
    const moveProduct = ACCOUNTING_KEY_MOVE;
    const productFor = (charge) => {
      if (charge.sourceType === CHARGE_SOURCE.ACCESSORIAL) return charge.type;
      if (charge.type === LANE_TOLL_CHARGE_TYPE) return ACCOUNTING_KEY_TOLL;
      return moveProduct;
    };
    const products = [...new Set(allCharges.map(productFor))];
    const keysByProduct = new Map(
      await Promise.all(products.map(async (product) => [product, await resolveAccountingKey(product)]))
    );
    for (const charge of allCharges) charge.accountingKey = keysByProduct.get(productFor(charge));
    return {
      charges,
      customerCharges,
      metadata: {
        programId: shell.triggerContext.programId,
        scenarioId,
        // Persisted on `argroups.run_metadata` so the contract that priced a
        // move is readable from the row, not only from logs.
        contractId: shell.triggerContext.contractId,
        // `single-candidate` is the value to search for once program contracts
        // carry several banded rules.
        contractRuleId: contract.contractRuleId,
        contractRuleSelection: contract.contractRuleSelection,
        eventKey: shell.triggerContext.eventKey,
        moveProduct,
        settlement: contract.settlement,
        eligible: contract.eligible,
        chargesCreated: charges.length,
        customerChargesCreated: customerCharges.length,
        totalProgramAmount: charges.reduce((sum2, charge) => sum2 + charge.amount, 0),
        totalCustomerAmount: customerCharges.reduce((sum2, charge) => sum2 + charge.amount, 0),
        // For the program_ledger writer. The recoup under program_fronts is
        // informational. Under split it is the customer remainder.
        ledger: settlements.map((s) => ({
          moveId: s.moveId,
          totalCost: s.totalCost,
          programPayment: s.programCharge,
          customerCharge: s.customerCharge,
          recoup: s.recoup,
          reimbursement: s.reimbursement,
          // `bandId` is the `raterules.id`, so pricing traces to exact rows
          // without re-deriving it from the amount.
          bands: s.split.contributions
        })),
        // Ledger rows with source_type='accessorial', source_id=accessorial_id.
        accessorialLedger: accessorialSettlements.map((s) => ({
          accessorialId: s.accessorialId,
          code: s.code,
          payer: s.payer,
          totalCost: s.totalCost,
          programPayment: s.programCharge,
          customerCharge: s.customerCharge,
          recoup: s.recoup,
          reimbursement: s.reimbursement
        })),
        // The line's own rule, not the contract: another line's bands price nothing here.
        noBands: contract.selectedRules.every((rule) => rule.raterules.length === 0),
        skipped: skipped3
      }
    };
  }
};
var execute8 = runScenarioAlgorithm(programMoveCoverageV1Spec);

// src/features/ar-triggers/algorithms/index.ts
var EXECUTE_REGISTRY = {
  [ALGORITHM_MOVE_SCENARIO_V1]: execute,
  [ALGORITHM_STATIC_PRODUCT_CHARGE_V1]: execute2,
  [ALGORITHM_PREPAID_PRODUCT_V1]: execute3,
  // Program-level AR (additive — see docs/program-ar-design.md).
  [ALGORITHM_PROGRAM_MOVE_SCENARIO_V1]: execute7,
  [ALGORITHM_PROGRAM_MOVE_COVERAGE_V1]: execute8,
  [ALGORITHM_GUESTRIDE_SCENARIO_V1]: execute4,
  [ALGORITHM_RETURN_RIDE_SCENARIO_V1]: execute6,
  // Placeholder — see header comment.
  [ALGORITHM_MOBILE_SERVICE_V1]: execute5
};
function resolveAlgorithmExecute(name) {
  const fn = EXECUTE_REGISTRY[name];
  if (!fn) {
    throw new Error(
      `Algorithm "${name}" not found in registry. Available algorithms: ${Object.keys(EXECUTE_REGISTRY).join(", ")}`
    );
  }
  return fn;
}

// src/features/ar-invoices/index.ts
init_invoiceManager();

// src/features/ar-invoices/invoice-management/closeInvoice.ts
init_schema();
import { resolveExecutor as resolveExecutor22, getLogger as getLogger18 } from "@hopdrive/sdk-core";

// src/features/ar-invoices/invoice-management/postInvoicePayments.ts
init_schema();
init_reconcileProcessingFee();
import { resolveExecutor as resolveExecutor21, getLogger as getLogger17 } from "@hopdrive/sdk-core";

// src/features/ar-invoices/index.ts
init_programInvoiceManager();
init_rollupByRooftop();
init_invoiceLines();
init_invoicePdfRows();

// src/features/ar-invoices/invoice-lines/singleMoveStatement.ts
init_currency();
init_paymentStatus();
init_invoiceAmountDue();
init_invoicePdfRows();
init_invoiceLines();
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
var toNumber3 = (value) => Number(value ?? 0) || 0;
var noLessThanZero = (amount) => amount > 0 ? amount : 0;
function findMoveChargesRow(argroups, moveId) {
  const id = String(moveId);
  return groupChargesByMove(argroups).find(
    (row) => row.sourceKind === "move" && row.moves.some((move) => move != null && String(move.id) === id)
  ) ?? null;
}
function chargesSingleMoveStatement(row, netDue) {
  const charges = row.charges;
  const credits = row.credits;
  const subtotal = roundCurrency(charges.reduce((sum2, charge) => sum2 + toNumber3(charge.amount), 0));
  const credited = roundCurrency(credits.reduce((sum2, credit) => sum2 + toNumber3(credit.amount), 0));
  const paid = roundCurrency(settledAllocationTotal(charges.flatMap((charge) => charge.arpaymentdetails ?? [])));
  const total = noLessThanZero(subtotal - credited);
  const due = noLessThanZero(netDue);
  return {
    subtotal,
    discounted: credited,
    credits: credited,
    disputed: 0,
    paid,
    paymentAmount: paid,
    total,
    moveDueTotal: total,
    dueSans: due,
    processingFee: 0,
    due
  };
}
var sameId = (a, b) => a != null && b != null && String(a) === String(b);
function scopeMoveToInvoice(move, invoiceId) {
  if (!move?.accessorials) return move;
  const onInvoice = (row) => row.argroup?.arinvoice_id == null || sameId(row.argroup.arinvoice_id, invoiceId);
  return {
    ...move,
    accessorials: move.accessorials.map((accessorial) => ({
      ...accessorial,
      archarges: accessorial.archarges?.filter(onInvoice),
      arcredits: accessorial.arcredits?.filter(onInvoice)
    }))
  };
}
async function buildSingleMoveChargesInvoice(argroups, move) {
  const invoice = (argroups ?? []).find((group) => group.arinvoice)?.arinvoice;
  if (!invoice) return null;
  const onInvoice = (argroups ?? []).filter((group) => sameId(group.arinvoice?.id ?? group.arinvoice_id, invoice.id)).map((group) => ({
    ...group,
    archarges: group.archarges?.map(
      (charge) => charge?.move ? { ...charge, move: charge.move.map((chargeMove) => scopeMoveToInvoice(chargeMove, invoice.id)) } : charge
    )
  }));
  const row = findMoveChargesRow(onInvoice, move.id);
  if (!row) return null;
  const netDue = await getChargesAmountDue(row.charges);
  const line = movePdfRow(invoice, row);
  const consumer = move.consumer_name ? `_${move.consumer_name.replace(/ /g, "_")}` : "";
  const billed = dayjs.utc(line.billable_datetime).format("MM-DD-YYYY");
  return {
    invoice: { ...invoice, armoves: [line] },
    amount: chargesSingleMoveStatement(row, netDue),
    fileName: `${move.id}${consumer}_${billed}_invoice.pdf`
  };
}

// src/features/ar-invoices/invoice-lines/perMoveLines.ts
init_allocateSourceCredits();
init_rollupByRooftop();
init_invoiceLines();
var PER_MOVE_BUCKETS = ["transport", "fuel", "surge", "partial", "waived", "tow", "delay", "ride"];
var HISTORICAL_ARGROUP_STATUS2 = "historical";
var PROCESSING_FEE_CHARGE_TYPE2 = "processing_fee";
var ACCESSORIAL_BUCKETS = /* @__PURE__ */ new Set(["fuel", "surge", "partial", "waived", "tow", "delay", "ride"]);
var RIDE_CHARGE_TYPES = /* @__PURE__ */ new Set(["ride", "ridehail"]);
var toNumber4 = (value) => Number(value ?? 0) || 0;
var cents = (value) => Math.round(value * 100) / 100;
var emptyBuckets = () => Object.fromEntries(PER_MOVE_BUCKETS.map((bucket) => [bucket, { total: 0, count: 0 }]));
var emptyTotals = () => ({
  buckets: emptyBuckets(),
  charged: 0,
  credited: 0,
  net: 0,
  billableDatetime: null,
  chargeIds: [],
  creditIds: []
});
function bucketFor(charge, byTypeAlone = false) {
  const type = (charge.type ?? "").toLowerCase();
  if (type === "move") return "transport";
  if (RIDE_CHARGE_TYPES.has(type)) return "ride";
  if ((byTypeAlone || charge.source_type === "accessorial") && ACCESSORIAL_BUCKETS.has(type)) return type;
  return null;
}
var otherSourceKey = (source) => source.source_type && source.source_id != null ? `${source.source_type}:${String(source.source_id)}` : null;
function sourceMoveId(source) {
  switch (source.source_type) {
    case "move":
      return source.source_id ?? null;
    case "accessorial":
      return source.accessorial?.[0]?.move_id ?? null;
    case "ridehail": {
      const ride = source.ridehail?.[0]?.move;
      return ride?.parent_move_id ?? ride?.id ?? null;
    }
    default:
      return null;
  }
}
function addCharge(line, charge, byTypeAlone = false) {
  const amount = toNumber4(charge.amount);
  line.charged += amount;
  line.chargeIds.push(charge.id);
  const bucket = bucketFor(charge, byTypeAlone);
  if (bucket) {
    line.buckets[bucket].total += amount;
    line.buckets[bucket].count += 1;
  }
  const stamp = charge.billable_datetime;
  if (stamp && (!line.billableDatetime || new Date(stamp) < new Date(line.billableDatetime))) line.billableDatetime = stamp;
}
function addCredit(line, credit) {
  line.credited += toNumber4(credit.amount);
  line.creditIds.push(credit.id);
}
function finish(line) {
  for (const bucket of PER_MOVE_BUCKETS) line.buckets[bucket].total = cents(line.buckets[bucket].total);
  line.charged = cents(line.charged);
  line.credited = cents(line.credited);
  line.net = Math.max(cents(line.charged - line.credited), 0);
  return line;
}
var isLive = (source) => source.argroup?.status !== HISTORICAL_ARGROUP_STATUS2;
var toUnitId = (id) => id == null ? null : Number(id);
var productCreditKey = (source) => creditBucketKey(
  { programId: toUnitId(source.argroup?.program_id), customerId: toUnitId(source.argroup?.customer_id) },
  "product",
  String(source.source_id)
);
function creditProducts(products, productCharges, credits) {
  const keys = productCharges.map(productCreditKey);
  const pooled = new Set(keys);
  const unplaced = [];
  const creditByKey = /* @__PURE__ */ new Map();
  const creditsByKey = /* @__PURE__ */ new Map();
  for (const credit of credits) {
    const key = productCreditKey(credit);
    if (!pooled.has(key)) {
      unplaced.push(credit);
      continue;
    }
    creditByKey.set(key, (creditByKey.get(key) ?? 0) + toNumber4(credit.amount));
    creditsByKey.set(key, [...creditsByKey.get(key) ?? [], credit]);
  }
  if (creditByKey.size === 0) return unplaced;
  const applied = allocateSourceCredits(
    productCharges.map((charge, i) => ({ key: keys[i], amount: toNumber4(charge.amount), paid: 0 })),
    creditByKey
  );
  const reached = /* @__PURE__ */ new Set();
  products.forEach((line, i) => {
    if (applied[i] <= 0) return;
    line.credited += applied[i];
    line.creditIds.push(...(creditsByKey.get(keys[i]) ?? []).map((credit) => credit.id));
    reached.add(keys[i]);
  });
  for (const [key, keyed] of creditsByKey) {
    if (reached.has(key)) continue;
    products[keys.indexOf(key)].creditIds.push(...keyed.map((credit) => credit.id));
  }
  return unplaced;
}
function buildPerMoveLines({ charges, credits, moves = [] }) {
  const moveLines = /* @__PURE__ */ new Map();
  const guestrides = /* @__PURE__ */ new Map();
  const products = [];
  const productCharges = [];
  const perUse = [];
  const unattributed = {
    ...emptyTotals(),
    kind: "unattributed",
    sourceId: null,
    name: null,
    notes: null,
    count: 0
  };
  const otherLines = [];
  const otherLineBySource = /* @__PURE__ */ new Map();
  const toScenario = [];
  const creditsToScenario = [];
  const moveLine = (moveId, scenarioId) => {
    const key = String(moveId);
    let line = moveLines.get(key);
    if (!line) {
      line = { ...emptyTotals(), moveId, scenarioId };
      moveLines.set(key, line);
    } else if (line.scenarioId == null && scenarioId != null) {
      line.scenarioId = scenarioId;
    }
    return line;
  };
  const otherLine = (map, kind, sourceId, name) => {
    const key = String(sourceId);
    let line = map.get(key);
    if (!line) {
      line = { ...emptyTotals(), kind, sourceId, name, notes: null, count: 0 };
      map.set(key, line);
    }
    return line;
  };
  for (const charge of charges) {
    if (!isLive(charge) || charge.type === PROCESSING_FEE_CHARGE_TYPE2) continue;
    if (charge.type === PER_USE_CHARGE_TYPE) {
      perUse.push(charge);
      continue;
    }
    const scenarioId = charge.argroup?.scenario_id ?? null;
    if (charge.source_type === "product") {
      const line = { ...emptyTotals(), kind: "product", sourceId: charge.source_id ?? null, name: charge.name ?? null, notes: charge.notes ?? null, count: 1 };
      addCharge(line, charge);
      products.push(line);
      productCharges.push(charge);
      continue;
    }
    if (charge.source_type === "guestride" && charge.source_id != null) {
      const line = otherLine(guestrides, "guestride", charge.source_id, null);
      line.count += 1;
      addCharge(line, charge);
      continue;
    }
    if (charge.source_type === "scenario" && scenarioId != null) {
      toScenario.push(charge);
      continue;
    }
    const moveId = sourceMoveId(charge);
    if (moveId == null) {
      const line = { ...emptyTotals(), kind: "other", sourceId: charge.source_id ?? null, name: charge.name ?? null, notes: charge.notes ?? null, count: 1 };
      addCharge(line, charge, true);
      otherLines.push(line);
      const sourceKey = otherSourceKey(charge);
      if (sourceKey && !otherLineBySource.has(sourceKey)) otherLineBySource.set(sourceKey, line);
      continue;
    }
    addCharge(moveLine(moveId, scenarioId), charge);
  }
  const liveCredits = credits.filter(isLive);
  const unplacedProductCredits = creditProducts(
    products,
    productCharges,
    liveCredits.filter((credit) => credit.source_type === "product" && credit.source_id != null)
  );
  for (const credit of liveCredits) {
    const scenarioId = credit.argroup?.scenario_id ?? null;
    if (credit.source_type === "product" && credit.source_id != null && !unplacedProductCredits.includes(credit)) continue;
    if (credit.source_type === "guestride" && credit.source_id != null) {
      addCredit(otherLine(guestrides, "guestride", credit.source_id, null), credit);
      continue;
    }
    if (credit.source_type === "scenario" && scenarioId != null) {
      creditsToScenario.push(credit);
      continue;
    }
    const moveId = sourceMoveId(credit);
    if (moveId != null) {
      addCredit(moveLine(moveId, scenarioId), credit);
      continue;
    }
    const sourceKey = otherSourceKey(credit);
    addCredit(sourceKey && otherLineBySource.get(sourceKey) || unattributed, credit);
  }
  if (toScenario.length || creditsToScenario.length) {
    const movesById = new Map(moves.map((move) => [String(move.id), move]));
    const anchors = /* @__PURE__ */ new Map();
    for (const line of moveLines.values()) {
      if (line.scenarioId == null) continue;
      const key = String(line.scenarioId);
      const score = (candidate) => scenarioLegScore(movesById.get(String(candidate.moveId)), candidate.buckets.transport.count > 0);
      const best = anchors.get(key);
      if (!best || score(line) > score(best)) anchors.set(key, line);
    }
    for (const charge of toScenario) {
      const anchor = anchors.get(String(charge.argroup?.scenario_id));
      if (anchor) addCharge(anchor, charge);
      else {
        unattributed.count += 1;
        addCharge(unattributed, charge);
      }
    }
    for (const credit of creditsToScenario) {
      addCredit(anchors.get(String(credit.argroup?.scenario_id)) ?? unattributed, credit);
    }
  }
  const others = [...guestrides.values(), ...products, ...otherLines];
  const condensed = condenseIntoOneLine(
    perUse.map((charge) => ({ type: PER_USE_CHARGE_TYPE, name: charge.name ?? null, amount: charge.amount ?? null }))
  );
  if (condensed) {
    const line = { ...emptyTotals(), kind: "perUse", sourceId: null, name: condensed.label, notes: null, count: condensed.count };
    for (const charge of perUse) addCharge(line, charge);
    others.push(line);
  }
  if (unattributed.chargeIds.length || unattributed.creditIds.length) others.push(unattributed);
  const ordered = [...moveLines.values()].sort((a, b) => {
    const at = a.billableDatetime ? new Date(a.billableDatetime).getTime() : Infinity;
    const bt = b.billableDatetime ? new Date(b.billableDatetime).getTime() : Infinity;
    if (at !== bt) return at - bt;
    return Number(a.moveId) - Number(b.moveId);
  });
  return { moves: ordered.map(finish), others: others.map(finish) };
}

// src/features/ar-invoices/index.ts
init_invoiceAmountDue();

// src/features/ar-triggers/orchestrators/processEvent.ts
init_invoiceFrequency();
async function processEvent(input) {
  logDispatchStart(input);
  const triggerData = buildTriggerData(input);
  const outcome = await executeAlgorithm(input, triggerData);
  if (outcome.status === ALGORITHM_STATUS_ERROR) return buildErrorResult(input, outcome.error);
  if (outcome.status === ALGORITHM_STATUS_SKIPPED) return buildSkippedResult(input, outcome);
  try {
    const argroupId = await commitArRun(input, outcome);
    return buildCompletedResult(input, outcome, argroupId);
  } catch (error) {
    if (!(error instanceof LockedLegacyInvoiceError)) throw error;
    return buildSkippedResult(input, {
      status: ALGORITHM_STATUS_SKIPPED,
      skipReason: error.message
    });
  }
}
function logDispatchStart(input) {
  const { contextObject, eventKey, algorithm, trigger } = input;
  getLogger19().info(
    `AR dispatch start for customer ${contextObject.customerId} contract ${contextObject.contractId} scenario ${contextObject.scenarioId} \u2014 ${eventKey} \u2192 ${algorithm} trigger ${trigger.id}`,
    {
      scenarioId: contextObject.scenarioId,
      contractId: contextObject.contractId,
      customerId: contextObject.customerId,
      eventKey,
      algorithm,
      triggerId: trigger.id
    }
  );
}
function buildTriggerData(input) {
  const { contextObject, eventKey, trigger } = input;
  return {
    id: trigger.id,
    contractId: contextObject.contractId,
    customerId: contextObject.customerId,
    orgId: contextObject.orgId,
    // Additive: present only on program runs; program algorithms read these.
    programId: contextObject.programId,
    moveId: contextObject.moveId,
    algorithmKey: trigger.algorithm_key,
    config: trigger.config ?? {},
    // The trigger's OWNING product, carried through for identity and
    // diagnostics. Deliberately not an accounting input: each event algorithm
    // resolves its own accounting product(s) while pricing.
    product_key: trigger.product_key ?? void 0,
    scenarioId: contextObject.scenarioId,
    eventKey,
    billableDate: contextObject.billableDate
    // No `scenarioData` — algorithms fetch their own product-specific
    // content. Keeps the dispatcher entity-agnostic.
  };
}
async function executeAlgorithm(input, triggerData) {
  const algorithmExecute = resolveAlgorithmExecute(input.algorithm);
  try {
    return await algorithmExecute(triggerData);
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    getLogger19().warn(`AR ${input.algorithm} failed on trigger ${input.trigger.id}: ${errorMessage}`, {
      scenarioId: input.contextObject.scenarioId,
      contractId: input.contextObject.contractId,
      eventKey: input.eventKey,
      triggerId: input.trigger.id,
      algorithm: input.algorithm,
      error: errorMessage
    });
    return { status: ALGORITHM_STATUS_ERROR, error };
  }
}
async function commitArRun(input, result) {
  if (input.contextObject.programId != null) {
    return commitProgramArRun(input, result);
  }
  const { contextObject, trigger, createdBy = "system" } = input;
  const billingFrequency = resolveInvoiceFrequency(trigger.config, input.billingFrequency);
  const customerTier = input.customerTier ?? null;
  const { invoiceId, invoiceMetadata } = await assignInvoice(input, billingFrequency, customerTier);
  const argroupId = await commitRun(
    {
      scenarioId: contextObject.scenarioId,
      triggerId: trigger.id,
      customerId: result.customerId ?? contextObject.customerId,
      orgId: result.orgId ?? contextObject.orgId,
      algorithmKey: trigger.algorithm_key,
      runMetadata: {
        ...result.metadata,
        algorithmKey: trigger.algorithm_key,
        triggerId: trigger.id,
        invoice: invoiceMetadata
      },
      createdBy,
      arinvoiceId: invoiceId
    },
    {
      charges: result.charges ?? [],
      metadata: result.metadata ?? {}
    },
    contextObject.billableDate
  );
  const chargeCount = result.charges?.length ?? 0;
  getLogger19().info(
    `AR run committed: argroup ${argroupId} for scenario ${contextObject.scenarioId} trigger ${trigger.id} (${input.algorithm}) \u2014 ${chargeCount} charge${chargeCount === 1 ? "" : "s"}`,
    {
      scenarioId: contextObject.scenarioId,
      contractId: contextObject.contractId,
      eventKey: input.eventKey,
      triggerId: trigger.id,
      algorithm: input.algorithm,
      argroupId,
      chargeCount
    }
  );
  return argroupId;
}
async function commitProgramArRun(input, result) {
  const { contextObject, trigger, createdBy = "system" } = input;
  const programId = contextObject.programId;
  const charges = result.charges ?? [];
  const willCharge = charges.length > 0;
  let invoiceId;
  let invoiceMetadata = {};
  if (willCharge) {
    try {
      const invoiceResult = await getOrCreateProgramInvoice(
        programId,
        contextObject.billableDate
      );
      invoiceId = invoiceResult.invoiceId;
      invoiceMetadata = {
        invoiceId: invoiceResult.invoiceId,
        invoiceDateRange: invoiceResult.dateRange,
        invoiceType: invoiceResult.invoiceType,
        billingFrequency: invoiceResult.billingFrequency
      };
    } catch (error) {
      invoiceMetadata = {
        invoiceError: error instanceof Error ? error.message : String(error),
        invoiceAttemptFailed: true
      };
      getLogger19().warn(
        `AR program invoice assignment failed for program ${programId} on ${contextObject.billableDate} \u2014 continuing without invoice link`,
        { programId, ...invoiceMetadata }
      );
    }
  }
  const commit = await commitProgramScenarioRun(
    {
      scenarioId: contextObject.scenarioId,
      triggerId: trigger.id,
      programId,
      customerId: contextObject.customerId,
      algorithmKey: trigger.algorithm_key,
      runMetadata: {
        ...result.metadata,
        algorithmKey: trigger.algorithm_key,
        triggerId: trigger.id,
        programId,
        invoice: invoiceMetadata
      },
      createdBy,
      arinvoiceId: invoiceId
    },
    { charges, metadata: result.metadata ?? {} },
    contextObject.billableDate
  );
  getLogger19().info(
    `AR program scenario ${contextObject.scenarioId} ${commit.action} for program ${programId} (trigger ${trigger.id}, ${input.algorithm}) \u2014 argroup ${commit.argroupId}${commit.deactivatedArgroupIds.length ? ` (superseded ${commit.deactivatedArgroupIds.join(",")})` : ""}`,
    {
      programId,
      scenarioId: contextObject.scenarioId,
      contractId: contextObject.contractId,
      eventKey: input.eventKey,
      triggerId: trigger.id,
      algorithm: input.algorithm,
      action: commit.action,
      argroupId: commit.argroupId,
      deactivatedArgroupIds: commit.deactivatedArgroupIds,
      chargeCount: charges.length
    }
  );
  if (result.customerCharges) {
    await commitProgramCustomerLeg(input, result);
  }
  return commit.argroupId ?? 0;
}
async function commitProgramCustomerLeg(input, result) {
  const { contextObject, trigger, createdBy = "system" } = input;
  const customerCharges = result.customerCharges ?? [];
  let invoiceId;
  let invoiceMetadata = {};
  if (customerCharges.length > 0) {
    try {
      const invoiceResult = await getOrCreateInvoice(
        contextObject.customerId,
        contextObject.billableDate,
        input.billingFrequency ?? "monthly",
        input.customerTier ?? null
      );
      invoiceId = invoiceResult.invoiceId;
      invoiceMetadata = {
        invoiceId: invoiceResult.invoiceId,
        invoiceDateRange: invoiceResult.dateRange,
        invoiceType: invoiceResult.invoiceType,
        billingFrequency: invoiceResult.billingFrequency,
        customerId: invoiceResult.customerId
      };
    } catch (error) {
      if (error instanceof LockedLegacyInvoiceError) {
        getLogger19().info(
          `AR program customer leg skipped for scenario ${contextObject.scenarioId}: ${error.message}`,
          { customerId: contextObject.customerId, scenarioId: contextObject.scenarioId, periodStart: error.periodStart }
        );
        return 0;
      }
      invoiceMetadata = {
        invoiceError: error instanceof Error ? error.message : String(error),
        invoiceAttemptFailed: true
      };
      getLogger19().warn(
        `AR customer-leg invoice assignment failed for customer ${contextObject.customerId} on ${contextObject.billableDate} \u2014 continuing without invoice link`,
        { customerId: contextObject.customerId, scenarioId: contextObject.scenarioId, ...invoiceMetadata }
      );
    }
  }
  const argroupId = await commitRun(
    {
      scenarioId: contextObject.scenarioId,
      triggerId: trigger.id,
      customerId: result.customerId ?? contextObject.customerId,
      orgId: result.orgId ?? contextObject.orgId,
      algorithmKey: trigger.algorithm_key,
      runMetadata: {
        ...result.metadata,
        algorithmKey: trigger.algorithm_key,
        triggerId: trigger.id,
        programId: contextObject.programId,
        customerLeg: true,
        invoice: invoiceMetadata
      },
      createdBy,
      arinvoiceId: invoiceId
    },
    {
      charges: customerCharges,
      metadata: result.metadata ?? {}
    },
    contextObject.billableDate
  );
  getLogger19().info(
    `AR program customer leg committed: argroup ${argroupId} for scenario ${contextObject.scenarioId} (program ${contextObject.programId}, ${input.algorithm}) \u2014 ${customerCharges.length === 0 ? "empty $0" : `${customerCharges.length} charge${customerCharges.length === 1 ? "" : "s"}`}`,
    {
      programId: contextObject.programId,
      scenarioId: contextObject.scenarioId,
      contractId: contextObject.contractId,
      customerId: contextObject.customerId,
      triggerId: trigger.id,
      algorithm: input.algorithm,
      argroupId,
      chargeCount: customerCharges.length
    }
  );
  return argroupId;
}
async function assignInvoice(input, billingFrequency, customerTier) {
  const { contextObject } = input;
  try {
    const invoiceResult = await getOrCreateInvoice(
      contextObject.customerId,
      contextObject.billableDate,
      billingFrequency,
      customerTier
    );
    const invoiceMetadata = {
      invoiceId: invoiceResult.invoiceId,
      invoiceDateRange: invoiceResult.dateRange,
      invoiceType: invoiceResult.invoiceType,
      billingFrequency: invoiceResult.billingFrequency,
      customerId: invoiceResult.customerId
    };
    getLogger19().info(
      `AR invoice ${invoiceResult.invoiceId} assigned for customer ${contextObject.customerId} (${invoiceResult.invoiceType}, ${invoiceResult.billingFrequency})`,
      invoiceMetadata
    );
    return { invoiceId: invoiceResult.invoiceId, invoiceMetadata };
  } catch (error) {
    if (error instanceof LockedLegacyInvoiceError) throw error;
    const invoiceMetadata = {
      invoiceError: error instanceof Error ? error.message : String(error),
      invoiceAttemptFailed: true,
      attemptedWith: {
        customerId: contextObject.customerId,
        billableDate: contextObject.billableDate,
        billingFrequency,
        customerTier
      }
    };
    getLogger19().warn(
      `AR invoice assignment failed for customer ${contextObject.customerId} on ${contextObject.billableDate}: ${invoiceMetadata.invoiceError} \u2014 continuing without invoice link`,
      { ...invoiceMetadata }
    );
    return { invoiceId: void 0, invoiceMetadata };
  }
}
function buildCompletedResult(input, result, argroupId) {
  return {
    scenarioId: input.contextObject.scenarioId,
    eventKey: input.eventKey,
    contractId: input.contextObject.contractId,
    algorithm: input.algorithm,
    triggerId: input.trigger.id,
    status: ALGORITHM_STATUS_COMPLETED,
    argroupId,
    chargeCount: result.charges?.length ?? 0
  };
}
function buildSkippedResult(input, result) {
  getLogger19().info(
    `AR ${input.algorithm} skipped trigger ${input.trigger.id}: ${result.skipReason ?? "(no reason given)"}`,
    {
      scenarioId: input.contextObject.scenarioId,
      contractId: input.contextObject.contractId,
      eventKey: input.eventKey,
      triggerId: input.trigger.id,
      algorithm: input.algorithm,
      skipReason: result.skipReason
    }
  );
  return {
    scenarioId: input.contextObject.scenarioId,
    eventKey: input.eventKey,
    contractId: input.contextObject.contractId,
    algorithm: input.algorithm,
    triggerId: input.trigger.id,
    status: ALGORITHM_STATUS_SKIPPED,
    skipReason: result.skipReason
  };
}
function buildErrorResult(input, error) {
  return {
    scenarioId: input.contextObject.scenarioId,
    eventKey: input.eventKey,
    contractId: input.contextObject.contractId,
    algorithm: input.algorithm,
    triggerId: input.trigger.id,
    status: ALGORITHM_STATUS_ERROR,
    error
  };
}

// src/features/ar-triggers/orchestrators/time-triggers/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor24, getLogger as getLogger20 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/orchestrators/time-triggers/contractActivity.ts
function isContractActiveOnBillingDate(contract, date) {
  const billingDate = new Date(date);
  billingDate.setUTCHours(0, 0, 0, 0);
  return isContractLive(contract, billingDate);
}

// src/features/ar-triggers/orchestrators/time-triggers/queries.ts
function isProgramTimeTrigger(trigger) {
  const c = trigger.contract;
  return !!c && c.program_id != null && c.customer_id == null;
}
async function getTimeTriggersDueToday(date = /* @__PURE__ */ new Date()) {
  const executor = resolveExecutor24();
  const logger = getLogger20();
  const utcDate = new Date(date);
  utcDate.setUTCHours(0, 0, 0, 0);
  const dailyBounds = currentPeriodBounds("daily", utcDate);
  const weeklyBounds = currentPeriodBounds("weekly", utcDate);
  const monthlyBounds = currentPeriodBounds("monthly", utcDate);
  const oneTimeBounds = { start: /* @__PURE__ */ new Date("2000-01-01T00:00:00Z"), end: utcDate };
  const dayOfWeek = utcDate.getUTCDay();
  const dailyConfigFilter = { frequency: "daily" };
  const weeklyConfigFilter = { frequency: "weekly", day_of_week: dayOfWeek };
  const monthlyConfigFilter = { frequency: "monthly" };
  const onceConfigFilter = { frequency: "once" };
  logger.debug("Building query variables for time triggers", {
    date: utcDate.toISOString(),
    dayOfWeek,
    dailyConfigFilter,
    weeklyConfigFilter,
    monthlyConfigFilter,
    onceConfigFilter
  });
  const variables = {
    // Daily
    dailyConfigFilter,
    dailyStart: dailyBounds.start.toISOString(),
    dailyEnd: dailyBounds.end.toISOString(),
    // Weekly
    weeklyConfigFilter,
    weeklyStart: weeklyBounds.start.toISOString(),
    weeklyEnd: weeklyBounds.end.toISOString(),
    // Monthly
    monthlyConfigFilter,
    monthlyStart: monthlyBounds.start.toISOString(),
    monthlyEnd: monthlyBounds.end.toISOString(),
    // Once
    oneTimeConfigFilter: onceConfigFilter,
    oneTimeStart: oneTimeBounds.start.toISOString()
  };
  const result = await executor.query(
    GetDueTimeTriggersDocument,
    variables
  );
  logger.debug("Query returned time triggers", {
    count: result.artriggers.length,
    date: utcDate.toISOString(),
    triggers: result.artriggers.map((t) => ({
      id: t.id,
      config: t.config
    }))
  });
  const filteredTriggers = result.artriggers.filter((trigger) => {
    if (isProgramTimeTrigger(trigger)) {
      logger.debug("Excluding program time trigger from customer sync path", {
        triggerId: trigger.id
      });
      return false;
    }
    if (!isContractActiveOnBillingDate(trigger.contract, utcDate)) {
      logger.info("Time trigger skipped because its contract is inactive", {
        triggerId: trigger.id,
        contractId: trigger.contract_id,
        executionDate: utcDate.toISOString(),
        reason: "contract-inactive"
      });
      return false;
    }
    const config = trigger.config;
    const shouldFire = shouldTriggerFire(config, utcDate);
    logger.debug("Checking if trigger should fire", {
      triggerId: trigger.id,
      frequency: config.frequency,
      config,
      utcDate: utcDate.toISOString(),
      shouldFire
    });
    return shouldFire;
  });
  logger.debug("Completed trigger filtering", {
    beforeCount: result.artriggers.length,
    afterCount: filteredTriggers.length
  });
  return filteredTriggers;
}

// src/features/ar-triggers/orchestrators/time-triggers/mutations.ts
init_schema();
import { resolveExecutor as resolveExecutor25 } from "@hopdrive/sdk-core";
async function insertStubArgroup(triggerId, customerId, orgId, algorithmKey, arinvoiceId) {
  const executor = resolveExecutor25();
  const variables = {
    triggerId,
    customerId,
    orgId,
    algorithmKey,
    arinvoiceId
  };
  const result = await executor.query(
    ClaimPeriodDocument,
    variables
  );
  if (!result.insert_argroups_one) {
    throw new Error("Failed to insert stub argroup: mutation returned null");
  }
  return result.insert_argroups_one.id;
}
async function findActiveProgramCustomerArgroupId(input) {
  const executor = resolveExecutor25();
  const result = await executor.query(FindActiveProgramCustomerArgroupDocument, {
    programId: input.programId,
    customerId: input.customerId,
    triggerId: input.triggerId,
    algorithmKey: input.algorithmKey,
    periodStart: input.periodStart,
    periodEnd: input.periodEnd
  });
  return result.argroups[0]?.id ?? null;
}
async function markProcessing(argroupId) {
  const executor = resolveExecutor25();
  const variables = {
    id: argroupId
  };
  await executor.query(
    SetProcessingDocument,
    variables
  );
}
async function finalizeArgroup(argroupId, metadata, algorithmKey) {
  const executor = resolveExecutor25();
  const variables = {
    id: argroupId,
    metadata,
    algorithmKey
  };
  await executor.query(
    FinalizeArgroupDocument,
    variables
  );
}

// src/features/ar-triggers/orchestrators/time-triggers/processTimeTriggers.ts
import { getLogger as getLogger21, resolveExecutor as resolveExecutor26 } from "@hopdrive/sdk-core";
init_schema();
function buildTriggerDataFor(trigger, date) {
  return {
    id: trigger.id,
    contractId: trigger.contract_id,
    customerId: trigger.contract.customer_id,
    // Conflation fix: do NOT map program_id into orgId. Program triggers are
    // excluded from this customer path (see getTimeTriggersDueToday) and run
    // via the program fan-out, so this builder only sees customer triggers
    // (program_id null) — orgId is always undefined here; behavior unchanged.
    orgId: void 0,
    algorithmKey: trigger.algorithm_key,
    config: trigger.config ?? {},
    executionDate: date,
    product_key: trigger.product_key ?? void 0,
    productByKey: trigger.product_by_key ?? void 0
  };
}
function mapCharges(result, trigger, argroupId, date, createdBy) {
  if (!result.charges || result.charges.length === 0) {
    return [];
  }
  return result.charges.map((charge) => ({
    argroup_id: argroupId,
    name: charge.name,
    amount: charge.amount,
    type: charge.type,
    accounting_key: charge.accountingKey ?? null,
    notes: charge.notes ?? null,
    // `archarges.source_id` is a bigint, so a product-sourced charge still
    // points at `products.id`, resolved from the row the KEY join returned,
    // never from an id column on the trigger, because `id` is an internal
    // surrogate and `key` is identity.
    source_type: charge.sourceType ?? (trigger.product_by_key ? "product" : "manual"),
    source_id: charge.sourceId ?? (trigger.product_by_key?.id ?? null),
    billable_datetime: date.toISOString(),
    createdby: createdBy
  }));
}
async function finalizeRun(argroupId, status, trigger, result, period, date, invoiceMetadata) {
  const metadata = {
    ...result.metadata,
    algorithmKey: trigger.algorithm_key,
    triggerId: trigger.id,
    period,
    executionDate: date.toISOString(),
    invoice: invoiceMetadata,
    // Store invoice metadata in argroup
    ...status === ALGORITHM_STATUS_SKIPPED && { status: ALGORITHM_STATUS_SKIPPED, skipReason: result.skipReason }
  };
  await finalizeArgroup(argroupId, metadata, trigger.algorithm_key);
}
async function executeTrigger(trigger, date, createdBy = "system") {
  const logger = getLogger21();
  if (!isContractActiveOnBillingDate(trigger.contract, date)) {
    logger.info("Time trigger skipped because its contract is inactive", {
      triggerId: trigger.id,
      contractId: trigger.contract_id,
      executionDate: date.toISOString(),
      reason: "contract-inactive"
    });
    return {
      triggerId: trigger.id,
      contractId: trigger.contract_id,
      algorithmKey: trigger.algorithm_key,
      status: ALGORITHM_STATUS_SKIPPED,
      skipReason: "contract-inactive"
    };
  }
  const config = trigger.config;
  const period = derivePeriodKey(config.frequency, date, config);
  try {
    logger.info("Executing time-based trigger with early-insert pattern", {
      triggerId: trigger.id,
      contractId: trigger.contract_id,
      algorithmKey: trigger.algorithm_key,
      period,
      date: date.toISOString()
    });
    const billingFrequency = trigger.contract.customer.billing_frequency ?? "monthly";
    const customerTier = trigger.contract.customer.tier ?? null;
    const billableDate = date.toISOString().split("T")[0] + "T00:00:00.000Z";
    let invoiceId;
    let invoiceMetadata = {};
    try {
      const invoiceResult = await getOrCreateInvoice(
        trigger.contract.customer_id,
        billableDate,
        billingFrequency,
        customerTier
      );
      invoiceMetadata = {
        invoiceId: invoiceResult.invoiceId,
        invoiceDateRange: invoiceResult.dateRange,
        invoiceType: invoiceResult.invoiceType,
        billingFrequency: invoiceResult.billingFrequency,
        customerId: invoiceResult.customerId
      };
      invoiceId = invoiceResult.invoiceId;
      logger.info("Invoice assigned", invoiceMetadata);
    } catch (error) {
      if (error instanceof LockedLegacyInvoiceError) {
        logger.info("Time trigger skipped because its period bills into a closed legacy invoice", {
          triggerId: trigger.id,
          contractId: trigger.contract_id,
          customerId: error.customerId,
          periodStart: error.periodStart,
          reason: "legacy-invoice-locked"
        });
        return {
          triggerId: trigger.id,
          contractId: trigger.contract_id,
          algorithmKey: trigger.algorithm_key,
          status: ALGORITHM_STATUS_SKIPPED,
          skipReason: "legacy-invoice-locked"
        };
      }
      invoiceMetadata = {
        invoiceError: error instanceof Error ? error.message : String(error),
        invoiceAttemptFailed: true,
        attemptedWith: {
          customerId: trigger.contract.customer_id,
          billableDate,
          billingFrequency,
          customerTier
        }
      };
      logger.warn("Failed to create invoice, continuing without invoice link", {
        ...invoiceMetadata
      });
    }
    const argroupId = await insertStubArgroup(
      trigger.id,
      trigger.contract.customer_id,
      trigger.contract.program_id ?? null,
      trigger.algorithm_key,
      invoiceId
    );
    logger.info("Period claimed with stub argroup", {
      triggerId: trigger.id,
      argroupId,
      period,
      invoiceId
    });
    try {
      await markProcessing(argroupId);
      const triggerData = buildTriggerDataFor(trigger, date);
      const algorithmExecute = resolveAlgorithmExecute(trigger.algorithm_key);
      const result = await algorithmExecute(triggerData);
      if (result.status === ALGORITHM_STATUS_SKIPPED) {
        logger.info("Time-based trigger skipped by algorithm", {
          triggerId: trigger.id,
          argroupId,
          skipReason: result.skipReason
        });
        await finalizeRun(argroupId, ALGORITHM_STATUS_SKIPPED, trigger, result, period, date, invoiceMetadata);
        return {
          triggerId: trigger.id,
          contractId: trigger.contract_id,
          algorithmKey: trigger.algorithm_key,
          status: ALGORITHM_STATUS_SKIPPED,
          skipReason: result.skipReason,
          argroupId
        };
      }
      const chargeRows = mapCharges(result, trigger, argroupId, date, createdBy);
      if (chargeRows.length > 0) {
        const executor = resolveExecutor26();
        await executor.query(
          InsertArchargesDocument,
          { charges: chargeRows }
        );
        logger.info("Charges inserted", {
          triggerId: trigger.id,
          argroupId,
          chargeCount: chargeRows.length
        });
      }
      await finalizeRun(argroupId, ALGORITHM_STATUS_COMPLETED, trigger, result, period, date, invoiceMetadata);
      logger.info("Time-based trigger execution completed", {
        triggerId: trigger.id,
        argroupId,
        period,
        chargeCount: result.charges?.length ?? 0
      });
      return {
        triggerId: trigger.id,
        contractId: trigger.contract_id,
        algorithmKey: trigger.algorithm_key,
        status: ALGORITHM_STATUS_COMPLETED,
        argroupId,
        chargeCount: result.charges?.length ?? 0
      };
    } catch (algorithmError) {
      logger.error("Time-based trigger processing failed, stub argroup left for triage", {
        error: algorithmError,
        triggerId: trigger.id,
        argroupId,
        period
      });
      throw algorithmError;
    }
  } catch (error) {
    logger.error("Time-based trigger execution failed", {
      error,
      triggerId: trigger.id,
      contractId: trigger.contract_id,
      period
    });
    return {
      triggerId: trigger.id,
      contractId: trigger.contract_id,
      algorithmKey: trigger.algorithm_key,
      status: ALGORITHM_STATUS_ERROR,
      error
    };
  }
}
async function processTimeTriggers(date = /* @__PURE__ */ new Date(), createdBy = "system") {
  const logger = getLogger21();
  const executionDate = new Date(date);
  executionDate.setUTCHours(0, 0, 0, 0);
  logger.info("Processing time-based triggers with date-range deduplication", {
    date: executionDate.toISOString()
  });
  const triggers = await getTimeTriggersDueToday(executionDate);
  logger.info("Found due time-based triggers (after deduplication)", { count: triggers.length });
  const results = [];
  let executed = 0;
  let skipped3 = 0;
  let errors = 0;
  for (const trigger of triggers) {
    const result = await executeTrigger(trigger, executionDate, createdBy);
    results.push(result);
    if (result.status === ALGORITHM_STATUS_COMPLETED) {
      executed++;
    } else if (result.status === ALGORITHM_STATUS_SKIPPED) {
      skipped3++;
    } else if (result.status === ALGORITHM_STATUS_ERROR) {
      errors++;
    }
  }
  logger.info("Time-based trigger processing completed", {
    date: executionDate.toISOString(),
    totalTriggers: triggers.length,
    executed,
    skipped: skipped3,
    errors
  });
  return {
    date: executionDate.toISOString(),
    totalTriggers: triggers.length,
    executed,
    skipped: skipped3,
    errors,
    results
  };
}

// src/features/ar-triggers/orchestrators/time-triggers/programFanout.ts
init_schema();
import { resolveExecutor as resolveExecutor28, getLogger as getLogger23 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/orchestrators/time-triggers/processProgramCustomerTimeTrigger.ts
import { getLogger as getLogger22, resolveExecutor as resolveExecutor27 } from "@hopdrive/sdk-core";
init_schema();
function hasPositiveAmount(t) {
  const amount = Number(t.config.amount);
  return Number.isFinite(amount) && amount > 0;
}
async function chargesForTrigger(t, input) {
  const triggerData = {
    id: t.id,
    contractId: input.contractId,
    customerId: input.customerId,
    programId: input.programId,
    algorithmKey: t.algorithmKey,
    config: t.config,
    // static_product_charge_v1 resolves its accounting product from
    // product_key (or config.accounting_product_key); productByKey supplies the
    // owning product's description fallback.
    product_key: t.productKey,
    productByKey: t.productByKey,
    executionDate: input.date,
    customerName: input.customerName
  };
  const result = await resolveAlgorithmExecute(t.algorithmKey)(triggerData);
  return result.status === ALGORITHM_STATUS_COMPLETED ? result.charges ?? [] : [];
}
async function processProgramCustomerTimeTrigger(input) {
  const logger = getLogger22();
  const { programId, customerId, triggerId, contractId = 0, billableDate, period, createdBy = "system" } = input;
  const date = new Date(billableDate);
  try {
    const dueTriggers = await getDueProgramBillingTriggers(programId, date);
    const trigger = dueTriggers.find((t) => t.id === triggerId);
    if (!trigger) {
      return {
        programId,
        customerId,
        status: ALGORITHM_STATUS_SKIPPED,
        skipReason: "Trigger not found or not due this period"
      };
    }
    const [billableCustomerId, enrollees] = await Promise.all([
      getProgramBillableCustomerId(programId),
      getProgramActiveEnrollees(programId, billableDate)
    ]);
    const record = enrollees.find((e) => e.customerId === customerId);
    const isBillable = billableCustomerId != null && billableCustomerId === customerId;
    const isEnrollee = record != null;
    const productKeys = record?.productKeys ?? [];
    if (!hasPositiveAmount(trigger)) {
      return {
        programId,
        customerId,
        status: ALGORITHM_STATUS_SKIPPED,
        skipReason: "Trigger has zero or invalid amount"
      };
    }
    if (trigger.mode === PROGRAM_TRIGGER_MODE_PER_SERVICE) {
      const requireAnyProductKeys = readRequireAnyProductKeys(trigger.config);
      if (requireAnyProductKeys.length === 0) {
        logMissingProductGate(logger, {
          triggerId: trigger.id,
          contractId,
          programId,
          algorithmKey: trigger.algorithmKey
        });
        return {
          programId,
          customerId,
          status: ALGORITHM_STATUS_SKIPPED,
          skipReason: `Program trigger has no usable config.${REQUIRE_ANY_PRODUCT_KEYS_FIELD} \u2014 skipped rather than billed`
        };
      }
    }
    const qualifies = (() => {
      if (trigger.mode === PROGRAM_TRIGGER_MODE_PROGRAM) return isBillable;
      if (trigger.mode === PROGRAM_TRIGGER_MODE_PER_CUSTOMER) return isEnrollee;
      if (trigger.mode === PROGRAM_TRIGGER_MODE_PER_SERVICE) {
        return isEnrollee && qualifiesForProductGate(productKeys, readRequireAnyProductKeys(trigger.config));
      }
      return false;
    })();
    if (!qualifies) {
      return {
        programId,
        customerId,
        status: ALGORITHM_STATUS_SKIPPED,
        skipReason: "Customer no longer qualifies for this trigger"
      };
    }
    let customerName;
    if (record) {
      customerName = record.customerName;
    } else if (isBillable) {
      try {
        const executor = resolveExecutor27();
        const customerResult = await executor.query(
          GetCustomerNameDocument,
          { customerId }
        );
        customerName = customerResult.customers_by_pk?.name ?? void 0;
      } catch (error) {
        logger.warn("Failed to fetch billable customer name; charge will not include customer name", {
          customerId,
          error: error instanceof Error ? error.message : String(error)
        });
      }
    }
    const charges = await chargesForTrigger(trigger, { programId, customerId, contractId, date, customerName });
    if (charges.length === 0) {
      return {
        programId,
        customerId,
        status: ALGORITHM_STATUS_SKIPPED,
        skipReason: "Trigger produced no charges"
      };
    }
    const freq = trigger.config.frequency ?? "monthly";
    const bounds = currentPeriodBounds(freq, date);
    const existing = await findActiveProgramCustomerArgroupId({
      programId,
      customerId,
      triggerId,
      algorithmKey: ALGORITHM_PROGRAM_TIME_CHARGE,
      periodStart: bounds.start.toISOString(),
      periodEnd: bounds.end.toISOString()
    });
    if (existing != null) {
      logger.info("Program billing already present for this unit/period \u2014 skipping", {
        programId,
        customerId,
        triggerId,
        period,
        existingArgroupId: existing
      });
      return { programId, customerId, status: ALGORITHM_STATUS_SKIPPED, skipReason: "already-billed-this-period" };
    }
    let invoiceId;
    try {
      invoiceId = (await getOrCreateProgramInvoice(programId, billableDate)).invoiceId;
    } catch (error) {
      logger.warn("Program invoice resolve failed; committing without invoice link", {
        programId,
        customerId,
        triggerId,
        error: error instanceof Error ? error.message : String(error)
      });
    }
    const argroupId = await commitProgramRun(
      {
        programId,
        customerId,
        triggerId,
        algorithmKey: ALGORITHM_PROGRAM_TIME_CHARGE,
        runMetadata: {
          algorithmKey: ALGORITHM_PROGRAM_TIME_CHARGE,
          programId,
          customerId,
          triggerId,
          billedAsBillableCustomer: isBillable,
          period,
          chargesCreated: charges.length,
          totalAmount: charges.reduce((s, c) => s + c.amount, 0),
          invoice: invoiceId ? { invoiceId } : { invoiceAttemptFailed: true }
        },
        createdBy,
        arinvoiceId: invoiceId
      },
      { charges, metadata: {} },
      billableDate
    );
    logger.info("Program billing committed", {
      programId,
      customerId,
      triggerId,
      billedAsBillableCustomer: isBillable,
      argroupId,
      period,
      chargeCount: charges.length
    });
    return { programId, customerId, status: ALGORITHM_STATUS_COMPLETED, argroupId, chargeCount: charges.length };
  } catch (error) {
    logger.error("Program billing failed", { programId, customerId, period, error });
    return { programId, customerId, status: ALGORITHM_STATUS_ERROR, error };
  }
}

// src/features/ar-triggers/orchestrators/runArWorkUnit.ts
var ALGORITHM_COMMIT_STRATEGY = {
  [ALGORITHM_PROGRAM_MOVE_SCENARIO_V1]: "program_scenario",
  [ALGORITHM_PROGRAM_MOVE_COVERAGE_V1]: "program_scenario",
  [ALGORITHM_PROGRAM_TIME_CHARGE]: "program_time"
};
function commitStrategyFor(algorithm) {
  return ALGORITHM_COMMIT_STRATEGY[algorithm] ?? "customer_scenario";
}
function arDedupeKey({ algorithm, context }) {
  switch (commitStrategyFor(algorithm)) {
    case "program_scenario":
      return `ar:${algorithm}:program:${context.programId}:contract:${context.contractId}:trigger:${context.trigger?.id ?? context.triggerId ?? ""}:scenario:${context.scenarioId}`;
    case "program_time":
      return `ar:${algorithm}:program:${context.programId}:customer:${context.customerId}:trigger:${context.triggerId}:period:${context.period}`;
    default:
      return `ar:${algorithm}:contract:${context.contractId}:scenario:${context.scenarioId}`;
  }
}
async function runArWorkUnit(input) {
  const { algorithm, context, createdBy = "system" } = input;
  const strategy = commitStrategyFor(algorithm);
  if (strategy === "program_time") {
    const r2 = await processProgramCustomerTimeTrigger({
      programId: context.programId,
      customerId: context.customerId,
      triggerId: context.triggerId,
      contractId: context.contractId,
      billableDate: context.billableDate,
      period: context.period,
      createdBy
    });
    return {
      status: r2.status,
      argroupId: r2.argroupId,
      chargeCount: r2.chargeCount,
      skipReason: r2.skipReason,
      error: r2.error
    };
  }
  const eventInput = {
    contextObject: {
      scenarioId: context.scenarioId ?? 0,
      contractId: context.contractId,
      customerId: context.customerId ?? 0,
      workflowsetId: 0,
      // not read by the commit path; present for type-shape only
      orgId: context.orgId,
      billableDate: context.billableDate,
      programId: context.programId,
      moveId: context.moveId
    },
    eventKey: context.eventKey ?? "",
    algorithm,
    trigger: context.trigger,
    billingFrequency: context.billingFrequency,
    customerTier: context.customerTier,
    createdBy
  };
  const r = await processEvent(eventInput);
  return {
    status: r.status,
    argroupId: r.argroupId,
    chargeCount: r.chargeCount,
    skipReason: r.skipReason,
    error: r.error
  };
}

// src/features/ar-triggers/orchestrators/time-triggers/programFanout.ts
function hasPositiveAmount2(t) {
  const amount = Number(t.config.amount);
  return Number.isFinite(amount) && amount > 0;
}
function enrolleeHasDueProgramCharge(productKeys, dueTriggers) {
  return dueTriggers.some((t) => {
    if (!hasPositiveAmount2(t)) return false;
    if (t.mode === PROGRAM_TRIGGER_MODE_PER_CUSTOMER) return true;
    if (t.mode === PROGRAM_TRIGGER_MODE_PER_SERVICE) {
      return qualifiesForProductGate(productKeys, readRequireAnyProductKeys(t.config));
    }
    return false;
  });
}
async function getDueProgramTimeTriggers(date = /* @__PURE__ */ new Date()) {
  const executor = resolveExecutor28();
  const logger = getLogger23();
  const utcDate = new Date(date);
  utcDate.setUTCHours(0, 0, 0, 0);
  const billableDate = utcDate.toISOString().split("T")[0] + "T00:00:00.000Z";
  const result = await executor.query(GetAllProgramBillingTriggersDocument, { billableDate });
  const byKey = /* @__PURE__ */ new Map();
  for (const t of result.artriggers) {
    const programId = t.contract?.program_id;
    const contractId = t.contract?.id;
    if (typeof programId !== "number" || typeof contractId !== "number") continue;
    const config = t.config ?? {};
    if (!shouldTriggerFire(config, utcDate)) continue;
    const period = derivePeriodKey(config.frequency ?? "monthly", utcDate, config);
    const key = `${programId}:${period}`;
    if (!byKey.has(key)) byKey.set(key, { programId, contractId, billableDate, period });
  }
  const obligations = Array.from(byKey.values());
  logger.info(`getDueProgramTimeTriggers: ${obligations.length} program obligation(s) due`, {
    date: billableDate,
    count: obligations.length
  });
  return obligations;
}
async function getProgramBillableCustomers(programId, billableDate) {
  const date = new Date(billableDate);
  const [enrollees, dueTriggers] = await Promise.all([
    getProgramActiveEnrollees(programId, billableDate),
    getDueProgramBillingTriggers(programId, date)
  ]);
  if (dueTriggers.length === 0) return [];
  return enrollees.filter((e) => enrolleeHasDueProgramCharge(e.productKeys, dueTriggers)).map((e) => ({ customerId: e.customerId }));
}
async function getDueProgramArWorkUnits(date = /* @__PURE__ */ new Date()) {
  const logger = getLogger23();
  const obligations = await getDueProgramTimeTriggers(date);
  const units = [];
  const makeUnit = (o, customerId, triggerId) => {
    const unit = {
      // Program-time ROUTING token (not the trigger algorithm_key).
      algorithm: ALGORITHM_PROGRAM_TIME_CHARGE,
      context: {
        contractId: o.contractId,
        programId: o.programId,
        customerId,
        triggerId,
        billableDate: o.billableDate,
        period: o.period
      }
    };
    return { ...unit, dedupeKey: arDedupeKey(unit) };
  };
  for (const o of obligations) {
    const dueTriggers = await getDueProgramBillingTriggers(o.programId, new Date(o.billableDate));
    const enrollees = await getProgramActiveEnrollees(o.programId, o.billableDate);
    for (const trigger of dueTriggers) {
      if (!hasPositiveAmount2(trigger)) continue;
      if (trigger.mode === PROGRAM_TRIGGER_MODE_PROGRAM) {
        const billableCustomerId = await getProgramBillableCustomerId(o.programId);
        if (billableCustomerId != null) {
          units.push(makeUnit(o, billableCustomerId, trigger.id));
        } else {
          logger.warn(
            `Program ${o.programId} has a due program-wide fee (trigger ${trigger.id}) but no billable customer \u2014 skipping`,
            { programId: o.programId, triggerId: trigger.id, period: o.period }
          );
        }
      } else if (trigger.mode === PROGRAM_TRIGGER_MODE_PER_CUSTOMER) {
        for (const enrollee of enrollees) {
          units.push(makeUnit(o, enrollee.customerId, trigger.id));
        }
      } else if (trigger.mode === PROGRAM_TRIGGER_MODE_PER_SERVICE) {
        const requireAnyProductKeys = readRequireAnyProductKeys(trigger.config);
        if (requireAnyProductKeys.length === 0) {
          logMissingProductGate(logger, {
            triggerId: trigger.id,
            contractId: o.contractId,
            programId: o.programId,
            algorithmKey: trigger.algorithmKey
          });
          continue;
        }
        for (const enrollee of enrollees) {
          if (qualifiesForProductGate(enrollee.productKeys, requireAnyProductKeys)) {
            units.push(makeUnit(o, enrollee.customerId, trigger.id));
          }
        }
      }
    }
  }
  return units;
}

// src/features/ar-triggers/orchestrators/customerArWorkUnit.ts
function customerArWorkUnit(input) {
  const { contextObject, eventKey, trigger, createdBy } = input;
  return {
    algorithm: trigger.algorithm_key,
    context: {
      scenarioId: contextObject.scenarioId,
      contractId: contextObject.contractId,
      customerId: contextObject.customerId,
      orgId: contextObject.orgId,
      billableDate: contextObject.billableDate,
      billingFrequency: contextObject.billingFrequency,
      customerTier: contextObject.customerTier,
      eventKey,
      trigger
    },
    createdBy
  };
}

// src/features/ar-triggers/orchestrators/runArUnitForScenario.ts
import { getLogger as getLogger30 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/context/shared/getContract.ts
init_schema();
import { resolveExecutor as resolveExecutor29, getLogger as getLogger24 } from "@hopdrive/sdk-core";
async function getContract2(customerId, workflowsetId, billableDate) {
  const executor = resolveExecutor29();
  const result = await executor.query(
    GetContractDocument,
    {
      customerId,
      workflowsetId,
      billableDate
    }
  );
  const contracts = result.contracts ?? [];
  if (contracts.length === 0) {
    return null;
  }
  if (contracts.length > 1) {
    getLogger24().warn(
      `getContract: data-integrity issue \u2014 found ${contracts.length} overlapping contracts for customer ${customerId}, workflowset ${workflowsetId}, billableDate ${billableDate}. Using most-recently-created (#${contracts[0].id}); contracts must not overlap \u2014 investigate.`,
      {
        customerId,
        workflowsetId,
        billableDate,
        contractIds: contracts.map((c) => c.id),
        chosenContractId: contracts[0].id
      }
    );
  }
  return contracts[0];
}

// src/features/ar-triggers/context/move/getMoveContext.ts
import { getLogger as getLogger25 } from "@hopdrive/sdk-core";
var CONSUMER_TYPE_CUSTOMER3 = "customer";
var CONSUMER_TYPE_LOANER3 = "loaner";
var CANCEL_STATUS_CANCELED = "canceled";
async function getMoveContext(moveId) {
  const logger = getLogger25();
  const scenarioId = await getScenarioIdFromMove(moveId);
  if (!scenarioId) {
    logger.info(`getMoveContext: move ${moveId} has no scenario, skipping`, { moveId });
    return null;
  }
  return getScenarioARContext(scenarioId, { moveId });
}
async function resolveScenarioCustomerContext(scenarioId, opts = {}) {
  const logger = getLogger25();
  const { moveId } = opts;
  const scenarioData = await getScenarioContext(scenarioId);
  if (!scenarioData) {
    logger.info(`getScenarioARContext: scenario ${scenarioId} not found, skipping`, {
      scenarioId,
      moveId
    });
    return { context: null, hasDriveMoves: false, productKey: null };
  }
  const productKey = scenarioData.product_key ?? null;
  const driveMoves = scenarioData.moves.filter((stm) => stm.move.move_type === "drive");
  if (driveMoves.length === 0) {
    logger.info(
      `getScenarioARContext: scenario ${scenarioId} has no drive moves (${scenarioData.moves.length} ride moves only), skipping`,
      { scenarioId, moveId, totalMoves: scenarioData.moves.length }
    );
    return { context: null, hasDriveMoves: false, productKey };
  }
  const hasLoanerLeg = driveMoves.some((stm) => stm.move.consumer_type === CONSUMER_TYPE_LOANER3);
  const rank = (stm) => {
    const m = stm.move;
    let r = 0;
    if (hasLoanerLeg && m.consumer_type !== CONSUMER_TYPE_CUSTOMER3) r += 2;
    if (m.active !== 1 || m.cancel_status === CANCEL_STATUS_CANCELED) r += 1;
    return r;
  };
  const ordered = [...driveMoves].sort((a, b) => rank(a) - rank(b));
  const anchorMove = ordered[0].move;
  const seen = /* @__PURE__ */ new Set();
  const candidates = ordered.filter((stm) => {
    const m = stm.move;
    const key = `${m.customer?.id ?? "\u2205"}:${m.workflowset_id ?? "\u2205"}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  for (const { move } of candidates) {
    if (!move.customer) continue;
    const workflowsetId = move.workflowset_id ?? void 0;
    if (!workflowsetId) continue;
    let billableDate;
    try {
      billableDate = calculateBillableDateFromMove({
        delivery_successful: move.delivery_successful ?? void 0,
        delivery_arrived: move.delivery_arrived ?? void 0,
        delivery_started: move.delivery_started ?? void 0,
        pickup_successful: move.pickup_successful ?? void 0,
        pickup_arrived: move.pickup_arrived ?? void 0,
        pickup_started: move.pickup_started ?? void 0,
        pickup_time: move.pickup_time ?? void 0
      });
    } catch {
      billableDate = defaultBillableDate();
    }
    const contract = await getContract2(move.customer.id, workflowsetId, billableDate);
    if (!contract) continue;
    if (move.id !== anchorMove.id) {
      logger.warn(
        `getScenarioARContext: scenario ${scenarioId} anchor move ${anchorMove.id} resolved no contract; billing on move ${move.id} instead (billableDate ${billableDate})`,
        { scenarioId, moveId, anchorMoveId: anchorMove.id, resolvedMoveId: move.id, billableDate }
      );
    }
    return {
      context: {
        scenarioId,
        contractId: contract.id,
        customerId: move.customer.id,
        workflowsetId,
        orgId: move.customer.organization_id ?? void 0,
        billableDate,
        billingFrequency: move.customer.billing_frequency ?? void 0,
        customerTier: move.customer.tier ?? void 0
      },
      hasDriveMoves: true,
      productKey
    };
  }
  logger.info(
    `getScenarioARContext: no active contract on any of the ${driveMoves.length} drive move(s) of scenario ${scenarioId}, skipping`,
    { scenarioId, moveId, driveMoveCount: driveMoves.length }
  );
  return { context: null, hasDriveMoves: true, productKey };
}
async function getScenarioARContext(scenarioId, opts = {}) {
  return (await resolveScenarioCustomerContext(scenarioId, opts)).context;
}

// src/features/ar-triggers/context/move/getAccessorialContext.ts
import { getLogger as getLogger26 } from "@hopdrive/sdk-core";
async function getAccessorialContext(accessorialId) {
  const logger = getLogger26();
  const moveId = await getAccessorialMoveId(accessorialId);
  if (!moveId) {
    logger.info(
      `getAccessorialContext: accessorial ${accessorialId} has no move_id, skipping`,
      { accessorialId }
    );
    return null;
  }
  return getMoveContext(moveId);
}

// src/features/ar-triggers/context/move/getPriceOverrideContext.ts
import { getLogger as getLogger27 } from "@hopdrive/sdk-core";
async function getPriceOverrideContext(priceOverrideId) {
  const logger = getLogger27();
  const moveId = await getPriceOverrideMoveId(priceOverrideId);
  if (!moveId) {
    logger.info(
      `getPriceOverrideContext: priceOverride ${priceOverrideId} has no move_id, skipping`,
      { priceOverrideId }
    );
    return null;
  }
  return getMoveContext(moveId);
}

// src/features/ar-triggers/context/move/getMoveBillingContext.ts
import { getLogger as getLogger28 } from "@hopdrive/sdk-core";
async function getMoveBillingContext(moveId) {
  const logger = getLogger28();
  const scenarioId = await getScenarioIdFromMove(moveId);
  if (!scenarioId) {
    logger.info(`getMoveBillingContext: move ${moveId} has no scenario, skipping`, { moveId });
    return null;
  }
  const billing = await getScenarioBillingContext(scenarioId, { moveId });
  if (!billing) return null;
  return { ...billing, moveId };
}
async function getScenarioBillingContext(scenarioId, opts = {}) {
  const logger = getLogger28();
  const { moveId } = opts;
  const scenarioData = await getScenarioContext(scenarioId);
  if (!scenarioData) {
    logger.info(`getScenarioBillingContext: scenario ${scenarioId} not found`, {
      scenarioId,
      moveId
    });
    return null;
  }
  const driveMoves = scenarioData.moves.filter((stm) => stm.move.move_type === "drive");
  if (driveMoves.length === 0) {
    logger.info(`getScenarioBillingContext: scenario ${scenarioId} has no drive moves`, {
      scenarioId,
      moveId
    });
    return null;
  }
  const firstMove = driveMoves[0].move;
  if (!firstMove.customer) {
    logger.info(
      `getScenarioBillingContext: first drive move ${firstMove.id} in scenario ${scenarioId} has no customer`,
      { scenarioId, moveId }
    );
    return null;
  }
  const customerId = firstMove.customer.id;
  const orgId = firstMove.customer.organization_id ?? void 0;
  let billableDate;
  try {
    billableDate = calculateBillableDateFromMove({
      delivery_successful: firstMove.delivery_successful ?? void 0,
      delivery_arrived: firstMove.delivery_arrived ?? void 0,
      delivery_started: firstMove.delivery_started ?? void 0,
      pickup_successful: firstMove.pickup_successful ?? void 0,
      pickup_arrived: firstMove.pickup_arrived ?? void 0,
      pickup_started: firstMove.pickup_started ?? void 0,
      pickup_time: firstMove.pickup_time ?? void 0
    });
  } catch {
    billableDate = defaultBillableDate();
  }
  return {
    moveId: firstMove.id,
    scenarioId,
    customerId,
    orgId,
    billableDate,
    billingFrequency: firstMove.customer.billing_frequency ?? void 0,
    customerTier: firstMove.customer.tier ?? void 0,
    productKey: scenarioData.product_key ?? null,
    serviceLine: resolveScenarioServiceLine({
      productKey: scenarioData.product_key,
      moves: driveMoves.map((stm) => stm.move)
    }).serviceLine
  };
}

// src/features/ar-triggers/context/guestRide/getGuestRideContext.ts
import { getLogger as getLogger29 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/context/guestRide/queries.ts
init_schema();
import { resolveExecutor as resolveExecutor30 } from "@hopdrive/sdk-core";
async function getGuestRideById(guestRideId) {
  const executor = resolveExecutor30();
  const result = await executor.query(GetGuestRideByIdDocument, { guestRideId });
  return result ?? null;
}
async function getScenarioGuestRideIds(scenarioId) {
  const executor = resolveExecutor30();
  const result = await executor.query(GetScenarioGuestRideIdDocument, { scenarioId });
  return (result?.scenarios_by_pk?.guestride_links ?? []).map((l) => l.guestride_id);
}

// src/features/ar-triggers/context/guestRide/getGuestRideContext.ts
async function getGuestRideContext(guestRideId) {
  const logger = getLogger29();
  const result = await getGuestRideById(guestRideId);
  const guestride = result?.guestrides_by_pk;
  if (!guestride) {
    logger.info(`getGuestRideContext: guestride ${guestRideId} not found, skipping`, {
      guestRideId
    });
    return null;
  }
  const scenario = result?.scenarios?.[0];
  if (!scenario) {
    logger.info(
      `getGuestRideContext: guestride ${guestRideId} has no linked scenario, skipping`,
      { guestRideId }
    );
    return null;
  }
  const scenarioId = scenario.id;
  if (!guestride.customer) {
    logger.info(
      `getGuestRideContext: guestride ${guestRideId} has no customer, skipping`,
      { guestRideId, scenarioId }
    );
    return null;
  }
  const customerId = guestride.customer.id;
  const orgId = guestride.customer.organization_id ?? void 0;
  const workflowsetId = guestride.workflowset_id ?? void 0;
  if (!workflowsetId) {
    logger.info(
      `getGuestRideContext: guestride ${guestRideId} has no workflowset_id, skipping (scenario ${scenarioId})`,
      { guestRideId, scenarioId, customerId }
    );
    return null;
  }
  const billableDate = guestride.created_at ? new Date(guestride.created_at).toISOString().split("T")[0] + "T00:00:00.000Z" : (/* @__PURE__ */ new Date()).toISOString().split("T")[0] + "T00:00:00.000Z";
  const contract = await getContract2(customerId, workflowsetId, billableDate);
  if (!contract) {
    logger.info(
      `getGuestRideContext: no active contract for customer ${customerId} / workflowset ${workflowsetId} on ${billableDate}, skipping guestride ${guestRideId} (scenario ${scenarioId})`,
      { guestRideId, scenarioId, customerId, workflowsetId, billableDate }
    );
    return null;
  }
  return {
    scenarioId,
    contractId: contract.id,
    customerId,
    workflowsetId,
    orgId,
    billableDate,
    billingFrequency: guestride.customer.billing_frequency ?? void 0,
    customerTier: guestride.customer.tier ?? void 0
  };
}
async function getScenarioGuestRideContext(scenarioId) {
  const logger = getLogger29();
  const guestRideIds = await getScenarioGuestRideIds(scenarioId);
  if (guestRideIds.length === 0) {
    logger.info(
      `getScenarioGuestRideContext: scenario ${scenarioId} links no guestride, skipping`,
      { scenarioId }
    );
    return null;
  }
  if (guestRideIds.length > 1) {
    logger.info(
      `getScenarioGuestRideContext: scenario ${scenarioId} links ${guestRideIds.length} guestrides; resolving context from guestride ${guestRideIds[0]} (algorithm bills all ridehails)`,
      { scenarioId, guestRideIds }
    );
  }
  return getGuestRideContext(guestRideIds[0]);
}

// src/features/ar-triggers/context/returnRide/getRideMoveProductFacts.ts
init_schema();
import { resolveExecutor as resolveExecutor31 } from "@hopdrive/sdk-core";
async function getRideMoveProductFacts(moveId) {
  const result = await resolveExecutor31().query(GetRideMoveProductFactsDocument, { moveId });
  const move = result.moves_by_pk;
  if (!move) return null;
  const scenario = result.scenariotomoves?.[0]?.scenario ?? null;
  const scenarioLite = (scenario?.moves ?? []).map((link) => link.move?.lite ?? null);
  return {
    guestrideId: null,
    moveId: move.id,
    scenarioId: scenario?.id ?? null,
    scenarioProductKey: scenario?.product_key ?? null,
    liteFlags: [move.lite ?? null, ...scenarioLite]
  };
}

// src/features/ar-triggers/context/mobileService/getMobileServiceContext.ts
async function getMobileServiceContext(_serviceAppointmentId) {
  throw new Error(
    "NotImplementedError: getMobileServiceContext is a placeholder. See packages/ar/src/context/getMoveContext.ts as the implementation template and packages/ar/docs/INTEGRATING_NEW_PRODUCT.md for the 5-step integration guide."
  );
}

// src/features/ar-triggers/dispatch/selectTrigger.ts
var MANUAL_RECALC_EVENT_KEY = "move.manual";
function filterTriggersByEvent(triggers, eventKey) {
  return (triggers ?? []).filter((trigger) => trigger?.event_key === eventKey);
}
function selectTrigger(triggers, opts = {}) {
  const candidates = triggers ?? [];
  if (candidates.length === 0) {
    return { skipReason: "contract has no event triggers" };
  }
  const ofProduct = opts.productKey ? candidates.filter((t) => t.product_key === opts.productKey) : [];
  const all = ofProduct.length > 0 ? ofProduct : candidates;
  const pool = opts.algorithm ? all.filter((t) => t.algorithm_key === opts.algorithm) : all;
  if (pool.length === 0) {
    return { skipReason: `no trigger for algorithm '${opts.algorithm}' on this contract` };
  }
  const chosen = (opts.eventKey ? pool.find((t) => t.event_key === opts.eventKey) : void 0) ?? pool.find((t) => t.event_key === MANUAL_RECALC_EVENT_KEY) ?? pool[0];
  if (!opts.algorithm) {
    const choseByPreference = opts.eventKey != null && chosen.event_key === opts.eventKey || chosen.event_key === MANUAL_RECALC_EVENT_KEY;
    if (!choseByPreference) {
      const distinct = Array.from(new Set(pool.map((t) => t.algorithm_key)));
      if (distinct.length > 1) {
        return {
          skipReason: `ambiguous algorithm \u2014 contract triggers expose ${distinct.length} algorithm keys (${distinct.join(", ")}) with no ${MANUAL_RECALC_EVENT_KEY} or eventKey to disambiguate; pass an explicit algorithm`
        };
      }
    }
  }
  return { trigger: chosen, algorithm: chosen.algorithm_key };
}

// src/features/ar-triggers/dispatch/recordArDispatchSkip.ts
init_schema();
import { resolveExecutor as resolveExecutor32 } from "@hopdrive/sdk-core";
var AR_DISPATCH_SKIP_REASON = {
  NO_CONTRACT: "no_contract",
  NO_MATCHING_TRIGGER: "no_matching_trigger"
};
var AR_DISPATCH_SKIP_LEVEL = 300;
function reasonText(skip) {
  if (skip.reason === AR_DISPATCH_SKIP_REASON.NO_MATCHING_TRIGGER) {
    return `contract ${skip.contractId ?? "none"} has no trigger for this event`;
  }
  return "no customer contract covers it";
}
function arDispatchSkipRow(skip) {
  const ids = `scenario ${skip.scenarioId ?? "none"}, contract ${skip.contractId ?? "none"}`;
  const message = `AR v2 did not run for ${skip.source} on event ${skip.eventKey}: ${reasonText(skip)} (${ids}).` + (skip.detail ? ` ${skip.detail}` : "");
  return {
    arevent_id: `ar_v2.skip.${skip.reason}`,
    level: AR_DISPATCH_SKIP_LEVEL,
    move_id: skip.moveId ?? null,
    message
  };
}
async function recordArDispatchSkip(skip) {
  const executor = resolveExecutor32();
  const result = await executor.mutate(
    InsertArDispatchSkipDocument,
    { object: arDispatchSkipRow(skip) }
  );
  const id = result?.insert_arevents_one?.id;
  if (id == null) {
    throw new Error(`AR dispatch skip record was not written for ${skip.source} on event ${skip.eventKey}`);
  }
  return id;
}

// src/features/ar-triggers/orchestrators/runArUnitForScenario.ts
function skipped2(skipReason, algorithm) {
  return { status: ALGORITHM_STATUS_SKIPPED, skipReason, algorithm };
}
async function resolveArUnitForScenario(input) {
  const { scenarioId, programId, algorithm, eventKey } = input;
  return programId != null ? resolveProgramUnit(scenarioId, programId, { algorithm, eventKey }) : resolveCustomerUnit(scenarioId, { algorithm, eventKey });
}
async function runArUnitForScenario(input) {
  const logger = getLogger30();
  const resolved = await resolveArUnitForScenario(input);
  if (resolved.skipReason) return skipped2(resolved.skipReason);
  const { algorithm, context } = resolved.unit;
  logger.info(
    `runArUnitForScenario: running ${context.programId != null ? "program" : "customer"} AR \u2014 scenario ${input.scenarioId}${context.programId != null ? `, program ${context.programId}` : ""}, contract ${context.contractId}, algorithm ${algorithm} (trigger ${context.trigger?.id})`,
    {
      scenarioId: input.scenarioId,
      programId: context.programId,
      contractId: context.contractId,
      algorithm,
      triggerId: context.trigger?.id
    }
  );
  const result = await runArWorkUnit({ algorithm, context, createdBy: input.createdBy ?? "system" });
  return { ...result, algorithm };
}
async function resolveCustomerUnit(scenarioId, opts) {
  const logger = getLogger30();
  const { context: driveCtx, hasDriveMoves, productKey } = await resolveScenarioCustomerContext(scenarioId);
  const ctx = driveCtx ?? (hasDriveMoves ? null : await getScenarioGuestRideContext(scenarioId));
  if (!ctx) {
    logger.info(
      `runArUnitForScenario: scenario ${scenarioId} has no customer AR context \u2014 skipping customer rerun`,
      { scenarioId }
    );
    return { skipReason: `no customer AR context for scenario ${scenarioId}` };
  }
  const { triggers } = await getContractEventTriggers(ctx.contractId);
  const sel = selectTrigger(triggers, {
    algorithm: opts.algorithm,
    eventKey: opts.eventKey,
    productKey
  });
  if (sel.skipReason) {
    logger.warn(
      `runArUnitForScenario: scenario ${scenarioId} customer contract ${ctx.contractId} \u2014 ${sel.skipReason}`,
      { scenarioId, contractId: ctx.contractId, algorithm: opts.algorithm, eventKey: opts.eventKey, productKey }
    );
    return { skipReason: sel.skipReason };
  }
  const context = {
    contractId: ctx.contractId,
    customerId: ctx.customerId,
    orgId: ctx.orgId,
    billableDate: ctx.billableDate,
    scenarioId: ctx.scenarioId,
    eventKey: sel.trigger.event_key,
    trigger: sel.trigger,
    billingFrequency: ctx.billingFrequency,
    customerTier: ctx.customerTier
  };
  return { unit: { algorithm: sel.algorithm, context } };
}
async function resolveProgramUnit(scenarioId, programId, opts) {
  const logger = getLogger30();
  const billing = await getScenarioBillingContext(scenarioId);
  if (!billing) {
    logger.info(
      `runArUnitForScenario: scenario ${scenarioId} has no billing context \u2014 skipping program ${programId} rerun`,
      { scenarioId, programId }
    );
    return { skipReason: `no billing context for scenario ${scenarioId}` };
  }
  const programContracts = await getProgramContractsForMove(billing.customerId, billing.billableDate);
  const candidates = programContracts.filter((c) => c.programId === programId);
  const pc = candidates.length > 1 ? await selectProgramContract(billing, candidates, opts.algorithm) : candidates[0];
  if (!pc) {
    logger.warn(
      `runArUnitForScenario: no active contract for program ${programId} on customer ${billing.customerId} at ${billing.billableDate} (scenario ${scenarioId}) \u2014 skipping`,
      { scenarioId, programId, customerId: billing.customerId, billableDate: billing.billableDate }
    );
    return { skipReason: `no active program contract for program ${programId} on scenario ${scenarioId}` };
  }
  const { triggers: contractTriggers } = await getContractEventTriggers(pc.contractId);
  const programTriggers = opts.algorithm ? contractTriggers.filter((trigger) => trigger.algorithm_key === opts.algorithm) : contractTriggers;
  const sel = selectTrigger(programTriggers, {
    algorithm: opts.algorithm,
    eventKey: opts.eventKey,
    // A scenario from before product identity has no product key; its line
    // still names the Valet product a coverage trigger is gated to.
    productKey: billing.productKey ?? (billing.serviceLine ? COVERAGE_PRODUCT_KEY[billing.serviceLine] : null)
  });
  if (sel.skipReason) {
    logger.warn(
      `runArUnitForScenario: scenario ${scenarioId} program contract ${pc.contractId} \u2014 ${sel.skipReason}`,
      { scenarioId, programId, contractId: pc.contractId, algorithm: opts.algorithm, eventKey: opts.eventKey }
    );
    return { skipReason: sel.skipReason };
  }
  const context = {
    contractId: pc.contractId,
    customerId: billing.customerId,
    orgId: billing.orgId,
    billableDate: billing.billableDate,
    scenarioId: billing.scenarioId,
    eventKey: sel.trigger.event_key,
    trigger: sel.trigger,
    programId: pc.programId,
    // Non-load-bearing: the program algorithm prices the whole scenario. Set to
    // the scenario's first drive move for deterministic metadata.
    moveId: billing.moveId,
    // Invoice PERIOD for the customer leg (getInvoiceDateRange) — a top-level
    // customer field, absent from effective_config, so it must be threaded (#3).
    billingFrequency: billing.billingFrequency,
    customerTier: billing.customerTier
  };
  return { unit: { algorithm: sel.algorithm, context } };
}
async function selectProgramContract(billing, candidates, algorithm) {
  const coverage = await getProgramCoverageContracts(billing.customerId, billing.billableDate);
  const onThisLine = new Set(
    coverage.filter((c) => c.serviceLine === billing.serviceLine).map((c) => c.contract.contractId)
  );
  const otherLine = new Set(
    coverage.filter((c) => !onThisLine.has(c.contract.contractId)).map((c) => c.contract.contractId)
  );
  const triggersByContract = /* @__PURE__ */ new Map();
  for (const candidate of candidates) {
    const { triggers } = await getContractEventTriggers(candidate.contractId);
    triggersByContract.set(candidate.contractId, triggers);
  }
  const onLine = candidates.filter((candidate) => {
    if (otherLine.has(candidate.contractId)) return false;
    return (triggersByContract.get(candidate.contractId) ?? []).length > 0;
  });
  if (!algorithm) return onLine[0];
  for (const candidate of onLine) {
    const triggers = triggersByContract.get(candidate.contractId) ?? [];
    if (triggers.some((trigger) => trigger.algorithm_key === algorithm)) return candidate;
  }
  return onLine[0];
}

// src/features/ar-triggers/templates/loadTemplates.ts
init_schema();
import { resolveExecutor as resolveExecutor33 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/templates/dbTypes.ts
var TEMPLATE_SCOPES = ["customer", "program"];
var TEMPLATE_KEY_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var SCHEMA_KEY_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var TRIGGER_TYPE_TIME = "time";
var TRIGGER_TYPE_EVENT = "event";
var TemplateDefinitionError = class extends Error {
  constructor(templateKey, detail) {
    super(`Template "${templateKey}" is not readable: ${detail}`);
    this.name = "TemplateDefinitionError";
    this.templateKey = templateKey;
  }
};

// src/features/ar-triggers/templates/loadTemplates.ts
async function listTemplates(opts) {
  const all = await loadAllTemplates();
  return all.filter(
    (t) => (opts?.includeInactive === true || t.active) && (opts?.scope === void 0 || t.scope === opts.scope)
  );
}
async function getTemplate(key) {
  const all = await loadAllTemplates();
  return all.find((t) => t.key === key) ?? null;
}
async function loadAllTemplates() {
  const executor = resolveExecutor33();
  const result = await executor.query(
    ListArTemplatesDocument,
    {}
  );
  return (result.artemplates ?? []).map(readTemplate);
}
function readTemplate(row) {
  const ruleIds = new Set(row.artemplate_rules.map((rule) => rule.id));
  const bandsByRule = /* @__PURE__ */ new Map();
  const looseBands = [];
  for (const raw of row.artemplate_raterules) {
    const ruleId = raw.artemplate_rule_id ?? null;
    if (ruleId === null) {
      looseBands.push(readRateRule(raw));
      continue;
    }
    if (!ruleIds.has(ruleId)) {
      throw new TemplateDefinitionError(
        row.key,
        `band row ${raw.id} names artemplate_rule_id ${ruleId}, which is not one of this template's rules`
      );
    }
    const under = bandsByRule.get(ruleId);
    if (under === void 0) bandsByRule.set(ruleId, [readRateRule(raw)]);
    else under.push(readRateRule(raw));
  }
  return {
    id: row.id,
    updatedAt: row.updatedat,
    key: row.key,
    name: row.name,
    description: row.description ?? null,
    scope: readScope(row.key, row.scope),
    active: row.active,
    // The persist branches on `engine === null`, so an `undefined` from a row
    // that did not select the column would write `engine: undefined`.
    requiredEngine: row.required_engine ?? null,
    parameters: readParameters(row.key, row.parameters),
    triggers: row.artemplate_triggers.map((t) => readTrigger(row.key, t)),
    rules: row.artemplate_rules.map((rule) => readRule(row.key, rule, bandsByRule.get(rule.id) ?? [])),
    rateRules: looseBands,
    products: row.artemplate_products.map(readProductSettings)
  };
}
function readRule(templateKey, row, rateRules) {
  if (typeof row.schema_key !== "string" || row.schema_key.length === 0) {
    throw new TemplateDefinitionError(templateKey, `rule row ${row.id} has no schema_key`);
  }
  return {
    id: row.id,
    name: row.name,
    description: row.description ?? null,
    product_key: row.product_key ?? null,
    schema_key: row.schema_key,
    config: asObject(row.config),
    sort_order: row.sort_order,
    rateRules
  };
}
function readScope(templateKey, scope) {
  if (scope === "customer" || scope === "program") return scope;
  throw new TemplateDefinitionError(
    templateKey,
    `scope ${JSON.stringify(scope)} is neither 'customer' nor 'program'`
  );
}
function readTrigger(templateKey, row) {
  return {
    id: row.id,
    trigger_type: readTriggerType(templateKey, row.id, row.trigger_type),
    algorithm_key: row.algorithm_key,
    product_key: row.product_key,
    event_key: row.event_key ?? null,
    config: asObject(row.config),
    sort_order: row.sort_order,
    productSalable: row.product ? row.product.salable : null
  };
}
function readTriggerType(templateKey, rowId, type) {
  if (type === TRIGGER_TYPE_TIME || type === TRIGGER_TYPE_EVENT) return type;
  throw new TemplateDefinitionError(
    templateKey,
    `trigger row ${rowId} has trigger_type ${JSON.stringify(type)}, expected 'time' or 'event'`
  );
}
function readRateRule(row) {
  return {
    id: row.id,
    distance_start: numOrNull(row.distance_start),
    distance_end: numOrNull(row.distance_end),
    type: row.type ?? null,
    class: row.class ?? null,
    rate: numOrNull(row.rate),
    flat_rate: numOrNull(row.flat_rate),
    class_3_rate: numOrNull(row.class_3_rate),
    class_3_flat_rate: numOrNull(row.class_3_flat_rate),
    class_4_rate: numOrNull(row.class_4_rate),
    class_4_flat_rate: numOrNull(row.class_4_flat_rate),
    class_5_rate: numOrNull(row.class_5_rate),
    class_5_flat_rate: numOrNull(row.class_5_flat_rate),
    class_6_rate: numOrNull(row.class_6_rate),
    class_6_flat_rate: numOrNull(row.class_6_flat_rate),
    program_coverage_pct: numOrNull(row.program_coverage_pct),
    sort_order: row.sort_order
  };
}
function readProductSettings(row) {
  return { id: row.id, product_key: row.product_key, settings: asObject(row.settings) };
}
var PARAMETER_TYPES = [
  "currency",
  "percentage",
  "integer",
  "number",
  "text",
  "boolean",
  "frequency",
  "day_of_month",
  "day_of_week",
  "enum"
];
function readParameters(templateKey, raw) {
  if (raw === null || raw === void 0) return [];
  if (!Array.isArray(raw)) {
    throw new TemplateDefinitionError(
      templateKey,
      "parameters must be a JSON array of parameter objects"
    );
  }
  const seen = /* @__PURE__ */ new Set();
  return raw.map((entry, i) => {
    if (typeof entry !== "object" || entry === null || Array.isArray(entry)) {
      throw new TemplateDefinitionError(templateKey, `parameters[${i}] is not an object`);
    }
    const p = entry;
    if (typeof p.name !== "string" || p.name.length === 0) {
      throw new TemplateDefinitionError(templateKey, `parameters[${i}] has no name`);
    }
    if (seen.has(p.name)) {
      throw new TemplateDefinitionError(
        templateKey,
        `parameters declares ${JSON.stringify(p.name)} twice`
      );
    }
    seen.add(p.name);
    if (!PARAMETER_TYPES.includes(p.type)) {
      throw new TemplateDefinitionError(
        templateKey,
        `parameter ${JSON.stringify(p.name)} has type ${JSON.stringify(p.type)}, expected one of: ${PARAMETER_TYPES.join(", ")}`
      );
    }
    if (typeof p.label !== "string" || p.label.length === 0) {
      throw new TemplateDefinitionError(
        templateKey,
        `parameter ${JSON.stringify(p.name)} has no label`
      );
    }
    if (p.type === "enum" && (!Array.isArray(p.options) || p.options.length === 0)) {
      throw new TemplateDefinitionError(
        templateKey,
        `parameter ${JSON.stringify(p.name)} is an enum with no options`
      );
    }
    const parameter = {
      name: p.name,
      type: p.type,
      label: p.label
    };
    if (p.required === true) parameter.required = true;
    if (typeof p.helpText === "string") parameter.helpText = p.helpText;
    if (typeof p.min === "number") parameter.min = p.min;
    if (typeof p.max === "number") parameter.max = p.max;
    if (Array.isArray(p.options)) parameter.options = p.options.map(String);
    if ("default" in p) parameter.default = p.default;
    return parameter;
  });
}
function asObject(raw) {
  if (typeof raw === "object" && raw !== null && !Array.isArray(raw)) {
    return raw;
  }
  return {};
}
function numOrNull(raw) {
  if (raw === null || raw === void 0) return null;
  if (typeof raw === "number") return Number.isNaN(raw) ? null : raw;
  const parsed = Number(raw);
  return Number.isNaN(parsed) ? null : parsed;
}

// src/features/ar-triggers/templates/saveTemplate.ts
init_schema();
import { getLogger as getLogger31, resolveExecutor as resolveExecutor34 } from "@hopdrive/sdk-core";
var REQUIRED_ENGINES = ["archarges", "armoves"];
var TRIGGER_TYPES = [TRIGGER_TYPE_TIME, TRIGGER_TYPE_EVENT];
var ARTEMPLATE_RULES_NAME_CONSTRAINT = "artemplate_rules_artemplate_id_name_key";
function assertSaveable(template) {
  const refuse = (detail) => {
    throw new TemplateDefinitionError(template.key || "(no key)", detail);
  };
  if (!TEMPLATE_KEY_PATTERN.test(template.key)) {
    refuse("a key must be lower-case words joined by single hyphens");
  }
  if (template.name.trim() === "") refuse("a template needs a name");
  if (!TEMPLATE_SCOPES.includes(template.scope)) {
    refuse(`scope must be one of ${TEMPLATE_SCOPES.join(", ")}`);
  }
  if (template.requiredEngine !== null && !REQUIRED_ENGINES.includes(template.requiredEngine)) {
    refuse(`required engine must be one of ${REQUIRED_ENGINES.join(", ")}, or none`);
  }
  for (const [index, trigger] of template.triggers.entries()) {
    const at = `trigger ${index + 1}`;
    if (!TRIGGER_TYPES.includes(trigger.trigger_type)) refuse(`${at} must be a time or event trigger`);
    if (!trigger.algorithm_key) refuse(`${at} has no algorithm`);
    if (!trigger.product_key) refuse(`${at} has no owning product`);
  }
  const named = /* @__PURE__ */ new Set();
  for (const [index, rule] of template.rules.entries()) {
    const at = rule.name.trim() === "" ? `rule ${index + 1}` : `rule "${rule.name}"`;
    if (rule.name.trim() === "") refuse(`${at} needs a name`);
    if (named.has(rule.name)) refuse(`two rules are both named "${rule.name}", so the template cannot tell them apart`);
    named.add(rule.name);
    if (!SCHEMA_KEY_PATTERN.test(rule.schema_key)) refuse(`${at} needs a schema`);
  }
}
function bandColumns(band, sortOrder, updatedBy) {
  return {
    distance_start: band.distance_start,
    distance_end: band.distance_end,
    type: band.type,
    class: band.class,
    rate: band.rate,
    flat_rate: band.flat_rate,
    class_3_rate: band.class_3_rate,
    class_3_flat_rate: band.class_3_flat_rate,
    class_4_rate: band.class_4_rate,
    class_4_flat_rate: band.class_4_flat_rate,
    class_5_rate: band.class_5_rate,
    class_5_flat_rate: band.class_5_flat_rate,
    class_6_rate: band.class_6_rate,
    class_6_flat_rate: band.class_6_flat_rate,
    program_coverage_pct: band.program_coverage_pct,
    sort_order: sortOrder,
    createdby: updatedBy,
    updatedby: updatedBy
  };
}
async function createTemplateRow(executor, template, updatedBy) {
  const created = await executor.mutate(
    EnsureArTemplateRowDocument,
    {
      object: {
        key: template.key,
        name: template.name,
        scope: template.scope,
        parameters: [],
        createdby: updatedBy,
        updatedby: updatedBy
      }
    }
  );
  const id = created.insert_artemplates_one?.id;
  if (!id) throw new TemplateDefinitionError(template.key, "the database accepted no row for this template");
  return id;
}
async function saveTemplate({ template, updatedBy }) {
  assertSaveable(template);
  const executor = resolveExecutor34();
  const logger = getLogger31();
  const artemplateId = template.id || await createTemplateRow(executor, template, updatedBy);
  const saved = await executor.mutate(
    SaveArTemplateDocument,
    {
      key: template.key,
      object: {
        key: template.key,
        name: template.name,
        description: template.description,
        scope: template.scope,
        active: template.active,
        required_engine: template.requiredEngine,
        parameters: template.parameters,
        createdby: updatedBy,
        updatedby: updatedBy,
        artemplate_triggers: {
          data: template.triggers.map((trigger, index) => ({
            trigger_type: trigger.trigger_type,
            algorithm_key: trigger.algorithm_key,
            product_key: trigger.product_key,
            event_key: trigger.event_key,
            config: trigger.config,
            // Editor position is the order, so reordering rows needs no sort column.
            sort_order: index,
            createdby: updatedBy,
            updatedby: updatedBy
          }))
        },
        // Bands with no rule of their own. Nothing authors these, but the delete
        // above removes every band on the template, so a save that did not put
        // them back would erase rows the editor promises to preserve.
        artemplate_raterules: {
          data: template.rateRules.map((band, order) => bandColumns(band, order, updatedBy))
        },
        artemplate_rules: {
          data: template.rules.map((rule, index) => ({
            name: rule.name,
            description: rule.description,
            product_key: rule.product_key,
            schema_key: rule.schema_key,
            config: rule.config,
            sort_order: index,
            createdby: updatedBy,
            updatedby: updatedBy,
            // Hasura fills `artemplate_rule_id` from the rule but not
            // `artemplate_id` (see `bandColumns`).
            artemplate_raterules: {
              data: rule.rateRules.map((band, order) => ({
                ...bandColumns(band, order, updatedBy),
                artemplate_id: artemplateId
              }))
            }
          })),
          on_conflict: {
            constraint: ARTEMPLATE_RULES_NAME_CONSTRAINT,
            update_columns: ["description", "product_key", "schema_key", "config", "sort_order", "updatedby"]
          }
        }
      }
    }
  );
  const row = saved.insert_artemplates_one;
  if (!row) throw new TemplateDefinitionError(template.key, "the database accepted no row for this template");
  const triggerCount = row.artemplate_triggers.length;
  const ruleCount = row.artemplate_rules.length;
  const bandCount = row.artemplate_raterules.length + row.artemplate_rules.reduce((total, rule) => total + rule.artemplate_raterules.length, 0);
  logger.info(
    `[saveTemplate] saved template ${row.key}: ${triggerCount} trigger(s), ${ruleCount} rule(s), ${bandCount} band(s)`,
    {
      templateId: row.id,
      templateKey: row.key,
      triggerCount,
      ruleCount,
      bandCount,
      removedTriggerCount: saved.delete_artemplate_triggers?.affected_rows ?? 0,
      removedBandCount: saved.delete_artemplate_raterules?.affected_rows ?? 0,
      updatedBy
    }
  );
  return { id: row.id, key: row.key, triggerCount, ruleCount, bandCount };
}

// src/features/ar-triggers/templates/validateParameters.ts
function validateTemplateParameters(template, values) {
  const errors = [];
  for (const parameter of template.parameters) {
    const value = values[parameter.name];
    const supplied = Object.prototype.hasOwnProperty.call(values, parameter.name) && value !== void 0 && value !== null && value !== "";
    if (!supplied) {
      if (parameter.required === true && parameter.default === void 0) {
        errors.push({ field: parameter.name, message: `${parameter.label} is required` });
      }
      continue;
    }
    const typeError = checkType(parameter, value);
    if (typeError) {
      errors.push({ field: parameter.name, message: typeError });
      continue;
    }
    const rangeError = checkRange(parameter, value);
    if (rangeError) errors.push({ field: parameter.name, message: rangeError });
  }
  return errors;
}
function checkType(parameter, value) {
  const { type, label } = parameter;
  switch (type) {
    case "currency":
    case "percentage":
    case "number":
      return isFiniteNumber(value) ? null : `${label} must be a number`;
    case "integer":
    case "day_of_month":
    case "day_of_week":
      if (!isFiniteNumber(value)) return `${label} must be a number`;
      return Number.isInteger(value) ? null : `${label} must be a whole number`;
    case "text":
      return typeof value === "string" ? null : `${label} must be a string`;
    case "boolean":
      return typeof value === "boolean" ? null : `${label} must be true or false`;
    case "frequency":
      return value === "daily" || value === "weekly" || value === "monthly" ? null : `${label} must be 'daily', 'weekly', or 'monthly'`;
    case "enum": {
      if (typeof value !== "string") return `${label} must be a string`;
      const options = parameter.options ?? [];
      return options.includes(value) ? null : `${label} must be one of: ${options.join(", ")}`;
    }
  }
}
function checkRange(parameter, value) {
  if (typeof value !== "number") return null;
  if (typeof parameter.min === "number" && value < parameter.min) {
    return `${parameter.label} must be at least ${parameter.min}`;
  }
  if (typeof parameter.max === "number" && value > parameter.max) {
    return `${parameter.label} must be at most ${parameter.max}`;
  }
  return null;
}
function isFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value);
}
var TemplateNotMaterializableError = class extends Error {
  constructor(templateKey, reasons) {
    super(
      `Template "${templateKey}" cannot be applied: ${reasons.join("; ")}. Fix the artemplate_triggers rows.`
    );
    this.name = "TemplateNotMaterializableError";
    this.templateKey = templateKey;
  }
};
function assertTemplateMaterializable(template) {
  const reasons = [];
  for (const trigger of template.triggers) {
    if (trigger.productSalable === null) {
      reasons.push(
        `trigger row ${trigger.id} is owned by product_key ${JSON.stringify(trigger.product_key)}, which resolves to no product row`
      );
    } else if (trigger.productSalable === false) {
      reasons.push(
        `trigger row ${trigger.id} is owned by product_key ${JSON.stringify(trigger.product_key)}, which is not salable \u2014 only salable products may own a trigger, and an accounting product belongs in config.accounting_product_key`
      );
    }
    if (!AR_ALGORITHM_KEYS.includes(trigger.algorithm_key)) {
      reasons.push(
        `trigger row ${trigger.id} names algorithm_key ${JSON.stringify(trigger.algorithm_key)}, which sdk-ar cannot execute. Known: ${AR_ALGORITHM_KEYS.join(", ")}`
      );
    }
  }
  const bandGroups = [
    ...template.rules.filter((rule) => rule.rateRules.length > 0).map((rule) => ({ label: `rule row ${rule.id} ("${rule.name}")`, schema_key: rule.schema_key, config: rule.config, product_key: rule.product_key })),
    ...template.rateRules.length > 0 ? [{ label: "the bands authored with no rule", schema_key: null, config: {} }] : []
  ];
  for (let i = 0; i < bandGroups.length; i++) {
    for (let j = i + 1; j < bandGroups.length; j++) {
      if (!contractRuleBandsCoexist(bandGroups[i], bandGroups[j])) {
        reasons.push(
          `${bandGroups[i].label} and ${bandGroups[j].label} both carry bands that nothing could tell apart, so applying this recipe would leave the contract unable to price`
        );
      }
    }
  }
  const ruleIdentities = /* @__PURE__ */ new Map();
  for (const rule of template.rules) {
    const identity = `${rule.schema_key}:${contractRuleIdentity(rule.schema_key, rule.config, rule.product_key) ?? ""}`;
    const first = ruleIdentities.get(identity);
    if (first === void 0) {
      ruleIdentities.set(identity, rule.id);
    } else {
      reasons.push(
        `rule rows ${first} and ${rule.id} are the same rule to the apply (schema_key ${JSON.stringify(rule.schema_key)}), so the second would never be written`
      );
    }
    const schema = getContractRuleSchema(rule.schema_key);
    if (schema === void 0) {
      reasons.push(
        `rule row ${rule.id} ("${rule.name}") names schema_key ${JSON.stringify(rule.schema_key)}, which is not a registered contract rule schema`
      );
    } else if (schema.status !== "active") {
      reasons.push(
        `rule row ${rule.id} ("${rule.name}") names schema_key ${JSON.stringify(rule.schema_key)}, which is ${schema.status} and may not be written to new rules`
      );
    }
  }
  if (reasons.length > 0) throw new TemplateNotMaterializableError(template.key, reasons);
}

// src/features/ar-triggers/templates/bindParameters.ts
var PARAM_BINDING_KEY = "$param";
var UNRESOLVED = /* @__PURE__ */ Symbol("unresolved-parameter");
function resolveParameterValues(template, supplied) {
  const resolved = {};
  for (const parameter of template.parameters) {
    const value = supplied[parameter.name];
    if (value !== void 0 && value !== null && value !== "") {
      resolved[parameter.name] = value;
    } else if (parameter.default !== void 0) {
      resolved[parameter.name] = parameter.default;
    }
  }
  return resolved;
}
function bindParameters(value, resolved) {
  const bound = bind(value, resolved);
  return bound === UNRESOLVED ? void 0 : bound;
}
function bind(value, resolved) {
  const name = bindingName(value);
  if (name !== null) {
    return Object.prototype.hasOwnProperty.call(resolved, name) ? resolved[name] : UNRESOLVED;
  }
  if (Array.isArray(value)) {
    const out = [];
    for (const entry of value) {
      const bound = bind(entry, resolved);
      if (bound !== UNRESOLVED) out.push(bound);
    }
    return out;
  }
  if (isPlainObject2(value)) {
    const out = {};
    for (const [key, entry] of Object.entries(value)) {
      const bound = bind(entry, resolved);
      if (bound !== UNRESOLVED) out[key] = bound;
    }
    return out;
  }
  return value;
}
function bindingName(value) {
  if (!isPlainObject2(value)) return null;
  const keys = Object.keys(value);
  if (keys.length !== 1 || keys[0] !== PARAM_BINDING_KEY) return null;
  const name = value[PARAM_BINDING_KEY];
  return typeof name === "string" && name.length > 0 ? name : null;
}
function isPlainObject2(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

// src/features/ar-triggers/templates/applyTemplate.ts
import { getLogger as getLogger33 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/templates/persistApplyTemplate.ts
init_schema();
import { resolveExecutor as resolveExecutor35, getLogger as getLogger32 } from "@hopdrive/sdk-core";

// src/features/ar-triggers/templates/materialize.ts
var RULE_SKIP_REASON = {
  /** The contract already carries an active rule of this schema with the same identity. */
  SAME_RULE_EXISTS: "same-rule-exists",
  /** The contract already prices from active bands that would change meaning beside this rule's. */
  BANDS_WOULD_COLLIDE: "bands-would-collide"
};
function toExistingContractRule(row, activeBandCount) {
  return { id: row.id, product_key: row.product_key ?? null, schema_key: row.schema_key ?? null, config: row.config, activeBandCount };
}
var TemplateMaterializationError = class extends Error {
  constructor(templateKey, detail) {
    super(`Template "${templateKey}" cannot be materialized: ${detail}`);
    this.name = "TemplateMaterializationError";
  }
};
function materializeTemplate(input) {
  const { template, contractId, customerId, parameters, appliedAt, existingRules, ruleOverrides } = input;
  const resolved = resolveParameterValues(template, parameters);
  const provenance = { template_key: template.key, applied_at: appliedAt };
  const triggers = template.triggers.map((row) => {
    const config = bindParameters(row.config, resolved) ?? {};
    if (row.trigger_type === TRIGGER_TYPE_EVENT) {
      const eventKey = row.event_key ?? config.event_key;
      if (typeof eventKey !== "string" || eventKey.length === 0) {
        throw new TemplateMaterializationError(
          template.key,
          `trigger row ${row.id} is event-type with no event_key, on the column or in config`
        );
      }
      if (!EVENT_KEY_SHAPE.test(eventKey)) {
        throw new TemplateMaterializationError(
          template.key,
          `trigger row ${row.id} has event_key ${JSON.stringify(eventKey)}, which is not <root>.<predicate>`
        );
      }
      config.event_key = eventKey;
    }
    return {
      contract_id: contractId,
      trigger_type: row.trigger_type,
      algorithm_key: row.algorithm_key,
      product_key: row.product_key,
      config: { ...config, provenance }
    };
  });
  const productSettings = {};
  for (const row of template.products) {
    productSettings[row.product_key] = bindParameters(row.settings, resolved) ?? {};
  }
  const productKeys = Array.from(
    /* @__PURE__ */ new Set([
      ...template.triggers.map((t) => t.product_key),
      ...template.products.map((p) => p.product_key)
    ])
  ).sort();
  const describe2 = (authored) => authored?.trim() || `Seeded from AR template ${template.key}.`;
  const overrides = ruleOverrides ?? {};
  for (const name of Object.keys(overrides)) {
    if (!template.rules.some((row) => row.name === name)) {
      throw new TemplateMaterializationError(
        template.key,
        `there is an edit for a rule named ${JSON.stringify(name)}, which this recipe does not seed. Its rules are: ${template.rules.map((row) => JSON.stringify(row.name)).join(", ") || "none"}`
      );
    }
  }
  const candidates = template.rules.map((row) => {
    const override = overrides[row.name] ?? {};
    const name = override.name === void 0 ? row.name : override.name;
    if (name.trim() === "") {
      throw new TemplateMaterializationError(
        template.key,
        `rule row ${row.id} ("${row.name}") was renamed to a blank name, which the contract_rules column refuses`
      );
    }
    const bands = override.bands ?? row.rateRules;
    for (const band of bands) assertBandPriceable(template.key, row.id, row.name, band);
    const config = bindParameters(override.config ?? row.config, resolved) ?? {};
    const validation = validateContractRuleConfig(row.schema_key, config);
    if (validation.ok === true) {
      return {
        contract_id: contractId,
        name,
        description: describe2(override.description === void 0 ? row.description : override.description),
        product_key: row.product_key,
        config,
        schema_key: row.schema_key,
        raterules: bands.map((band) => toRateRule(band, customerId))
      };
    }
    const edited = override.config === void 0 ? "has a config that does not validate" : "was edited to a config that does not validate";
    throw new TemplateMaterializationError(
      template.key,
      `rule row ${row.id} ("${row.name}") ${edited} as ${row.schema_key}: ${formatContractRuleConfigIssues(validation.issues)}`
    );
  });
  if (template.rateRules.length > 0) {
    candidates.push({
      contract_id: contractId,
      name: template.name,
      description: describe2(template.description),
      // One key means the rule is that product's; several means it is the
      // recipe's and belongs to no single product.
      product_key: productKeys.length === 1 ? productKeys[0] : null,
      config: {},
      schema_key: null,
      raterules: template.rateRules.map((band) => toRateRule(band, customerId))
    });
  }
  const contractRules = [];
  const skippedRules = [];
  for (const rule of candidates) {
    const heldBack = whyHeldBack(rule, existingRules);
    if (heldBack === null) {
      contractRules.push(rule);
    } else {
      skippedRules.push({
        name: rule.name,
        schema_key: rule.schema_key,
        reason: heldBack.reason,
        existingContractRuleIds: heldBack.existingContractRuleIds,
        rateRuleCount: rule.raterules.length
      });
    }
  }
  return {
    productKeys,
    triggers,
    contractRules,
    skippedRules,
    productSettings,
    engine: template.requiredEngine
  };
}
function whyHeldBack(rule, existing) {
  const identity = contractRuleIdentity(rule.schema_key, rule.config, rule.product_key);
  if (rule.schema_key !== null) {
    const same = existing.filter(
      (e) => e.schema_key === rule.schema_key && contractRuleIdentity(e.schema_key, e.config, e.product_key) === identity
    );
    if (same.length > 0) {
      return { reason: RULE_SKIP_REASON.SAME_RULE_EXISTS, existingContractRuleIds: same.map((e) => e.id) };
    }
  }
  if (rule.raterules.length > 0) {
    const colliding = existing.filter((e) => e.activeBandCount > 0 && !contractRuleBandsCoexist(rule, e));
    if (colliding.length > 0) {
      return { reason: RULE_SKIP_REASON.BANDS_WOULD_COLLIDE, existingContractRuleIds: colliding.map((e) => e.id) };
    }
  }
  return null;
}
var PROGRAM_COVERAGE_PCT_RANGE = { min: 0, max: 100 };
function assertBandPriceable(templateKey, ruleId, ruleName, band) {
  const where = `rule row ${ruleId} ("${ruleName}")`;
  const pct = band.program_coverage_pct;
  if (pct !== null && (pct < PROGRAM_COVERAGE_PCT_RANGE.min || pct > PROGRAM_COVERAGE_PCT_RANGE.max)) {
    throw new TemplateMaterializationError(
      templateKey,
      `${where} has a band covering ${pct}%, outside ${PROGRAM_COVERAGE_PCT_RANGE.min} to ${PROGRAM_COVERAGE_PCT_RANGE.max}`
    );
  }
  const { distance_start: start, distance_end: end } = band;
  if (start !== null && end !== null && start >= end) {
    throw new TemplateMaterializationError(
      templateKey,
      `${where} has a band from ${start} to ${end}, which covers no distance`
    );
  }
}
function toRateRule(band, customerId) {
  return {
    customer_id: customerId,
    // raterules.active is an integer flag, not a boolean.
    active: 1,
    distance_start: band.distance_start,
    distance_end: band.distance_end,
    type: band.type,
    class: band.class,
    rate: band.rate,
    flat_rate: band.flat_rate,
    class_3_rate: band.class_3_rate,
    class_3_flat_rate: band.class_3_flat_rate,
    class_4_rate: band.class_4_rate,
    class_4_flat_rate: band.class_4_flat_rate,
    class_5_rate: band.class_5_rate,
    class_5_flat_rate: band.class_5_flat_rate,
    class_6_rate: band.class_6_rate,
    class_6_flat_rate: band.class_6_flat_rate,
    program_coverage_pct: band.program_coverage_pct
  };
}

// src/features/ar-triggers/templates/contractStarted.ts
function utcDayOf(value) {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) {
    throw new Error(`utcDayOf: "${String(value)}" is not a date`);
  }
  return date.toISOString().slice(0, 10);
}
function contractHasStarted(beginDate, now = /* @__PURE__ */ new Date()) {
  const lastInstantOfYesterday = new Date(Date.parse(`${utcDayOf(now)}T00:00:00.000Z`) - 1);
  return contractBegunBy(beginDate, lastInstantOfYesterday);
}
function contractStartedRefusal(contractId, beginDate, now = /* @__PURE__ */ new Date()) {
  if (!beginDate || !contractHasStarted(beginDate, now)) return null;
  return { status: "contract_started", contractId, beginDay: utcDayOf(beginDate), today: utcDayOf(now) };
}

// src/features/ar-triggers/templates/persistApplyTemplate.ts
var ContractNotFoundError = class extends Error {
  constructor(contractId) {
    super(`Contract ${contractId} not found \u2014 nothing to apply a template to`);
    this.name = "ContractNotFoundError";
    this.contractId = contractId;
  }
};
async function persistApplyTemplate(input) {
  const { template, contractId, parameters, updatedBy, ruleOverrides } = input;
  const logger = getLogger32();
  const executor = resolveExecutor35();
  const now = "now";
  const read = await executor.query(
    GetContractConfigForApplyDocument,
    { contractId }
  );
  const contract = read.contracts_by_pk;
  if (!contract) throw new ContractNotFoundError(contractId);
  if (!input.allowStartedContract) {
    const refusal = contractStartedRefusal(contractId, contract.begin_date);
    if (refusal) {
      logger.info("[applyTemplate] refused, the contract has started", {
        contractId,
        templateKey: template.key,
        beginDay: refusal.beginDay,
        today: refusal.today
      });
      return refusal;
    }
  }
  const rawAr = readArBlock(contract.config);
  const existingProducts = readProductsBlock(rawAr);
  const existingRules = (contract.contract_rules ?? []).map(
    (rule) => toExistingContractRule(rule, rule.raterules_aggregate?.aggregate?.count ?? 0)
  );
  const materialized = materializeTemplate({
    template,
    contractId,
    customerId: contract.customer_id ?? null,
    parameters,
    appliedAt: template.updatedAt,
    existingRules,
    ruleOverrides
  });
  const mergedProducts = { ...existingProducts };
  for (const [key, settings] of Object.entries(materialized.productSettings)) {
    mergedProducts[key] = settings;
  }
  const newArValue = {
    ...rawAr,
    ...materialized.engine === null ? {} : { engine: materialized.engine },
    products: mergedProducts
  };
  const newTriggers = materialized.triggers.map((t) => ({
    contract_id: t.contract_id,
    trigger_type: t.trigger_type,
    algorithm_key: t.algorithm_key,
    product_key: t.product_key,
    config: t.config,
    createdat: now,
    createdby: updatedBy,
    updatedat: now,
    updatedby: updatedBy
  }));
  const newContractRules = materialized.contractRules.map(({ raterules, ...rule }) => ({
    ...rule,
    createdat: now,
    createdby: updatedBy,
    updatedat: now,
    updatedby: updatedBy,
    raterules: {
      // Bands get timestamps only. Who applied the template is recorded once,
      // on the rule.
      data: raterules.map((r) => ({
        ...r,
        createdat: now,
        updatedat: now
      }))
    }
  }));
  const write = await executor.mutate(ApplyTemplatePersistDocument, {
    templateId: template.id,
    templateKey: template.key,
    expectedUpdatedAt: template.updatedAt,
    contractId,
    configValue: { ar: newArValue },
    // Only triggers stamped with this recipe's template_key are deleted, so a
    // sibling recipe on the same product keeps its own. Built here rather than
    // inline in the document (see the .gql).
    provenanceMatch: { provenance: { template_key: template.key } },
    newTriggers,
    newContractRules,
    updatedBy,
    now
  });
  const deletedTriggerCount = write.delete_artriggers?.affected_rows ?? 0;
  const insertedTriggerIds = write.insert_artriggers?.returning?.map((r) => r.id) ?? [];
  const insertedRules = write.insert_contract_rules?.returning ?? [];
  const insertedContractRuleIds = insertedRules.map((r) => r.id);
  const insertedRateRuleCount = insertedRules.reduce((n, r) => n + (r.raterules?.length ?? 0), 0);
  logger.info("[applyTemplate] persisted", {
    contractId,
    templateKey: template.key,
    productKeys: materialized.productKeys,
    deletedTriggerCount,
    insertedTriggerCount: insertedTriggerIds.length,
    insertedContractRuleIds,
    insertedRateRuleCount,
    engine: materialized.engine,
    skippedRuleCount: materialized.skippedRules.length,
    siblingProductCount: Object.keys(existingProducts).filter(
      (k) => !materialized.productKeys.includes(k)
    ).length
  });
  for (const skipped3 of materialized.skippedRules) {
    logger.warn(
      `[applyTemplate] left contract ${contractId} rule "${skipped3.name}" untouched: ${skipped3.reason}`,
      { contractId, templateKey: template.key, ...skipped3 }
    );
  }
  const result = {
    ...materialized,
    triggers: (write.insert_artriggers?.returning ?? []).map((trigger) => ({
      contract_id: trigger.contract_id,
      trigger_type: trigger.trigger_type,
      algorithm_key: trigger.algorithm_key,
      product_key: trigger.product_key,
      config: trigger.config
    })),
    deletedTriggerCount,
    insertedTriggerIds,
    insertedRateRuleCount,
    insertedContractRuleIds,
    writtenArValue: newArValue
  };
  return { status: "persisted", result };
}
function readArBlock(config) {
  if (typeof config !== "object" || config === null) return {};
  const ar = config.ar;
  return typeof ar === "object" && ar !== null && !Array.isArray(ar) ? ar : {};
}
function readProductsBlock(ar) {
  const products = ar.products;
  return typeof products === "object" && products !== null && !Array.isArray(products) ? products : {};
}

// src/features/ar-triggers/templates/applyTemplate.ts
var DEFAULT_UPDATED_BY2 = "sdk-ar";
async function applyTemplate(contractId, templateKey, parameters = {}, options = {}) {
  return applyTemplateInternal(contractId, templateKey, parameters, options, { allowStartedContract: false });
}
async function applyTemplateInternal(contractId, templateKey, parameters, options, guard) {
  const logger = getLogger33();
  const template = await getTemplate(templateKey);
  if (!template) {
    const available = await listTemplates({ includeInactive: true });
    return {
      status: "unknown_template",
      templateKey,
      contractId,
      availableKeys: available.map((t) => t.key)
    };
  }
  if (options.reviewedUpdatedAt !== void 0 && options.reviewedUpdatedAt !== template.updatedAt) {
    return {
      status: "stale_template",
      templateKey,
      contractId,
      reviewedUpdatedAt: options.reviewedUpdatedAt,
      currentUpdatedAt: template.updatedAt
    };
  }
  const errors = validateTemplateParameters(template, parameters);
  if (errors.length > 0) {
    return { status: "invalid_parameters", templateKey, contractId, errors };
  }
  assertTemplateMaterializable(template);
  const outcome = await persistApplyTemplate({
    template,
    contractId,
    parameters,
    updatedBy: options.updatedBy ?? DEFAULT_UPDATED_BY2,
    ruleOverrides: options.ruleOverrides,
    allowStartedContract: guard.allowStartedContract
  });
  if (outcome.status === "contract_started") {
    return {
      status: "contract_started",
      templateKey,
      contractId,
      beginDay: outcome.beginDay,
      today: outcome.today
    };
  }
  const persisted = outcome.result;
  logger.info("[applyTemplate] applied", {
    contractId,
    templateKey,
    productKeys: persisted.productKeys,
    triggerCount: persisted.triggers.length,
    contractRuleCount: persisted.insertedContractRuleIds.length,
    rateRuleCount: persisted.insertedRateRuleCount
  });
  return {
    status: "applied",
    templateKey,
    contractId,
    productKeys: persisted.productKeys,
    triggers: persisted.triggers,
    contractRules: persisted.contractRules,
    skippedRules: persisted.skippedRules,
    productSettings: persisted.productSettings,
    deletedTriggerCount: persisted.deletedTriggerCount,
    insertedTriggerIds: persisted.insertedTriggerIds,
    insertedRateRuleCount: persisted.insertedRateRuleCount,
    insertedContractRuleIds: persisted.insertedContractRuleIds
  };
}

// src/features/ar-triggers/templates/removeProduct.ts
init_schema();
import { resolveExecutor as resolveExecutor36, getLogger as getLogger34 } from "@hopdrive/sdk-core";
var DEFAULT_UPDATED_BY3 = "sdk-ar";
async function getProductRemovability(contractId, productKey) {
  const executor = resolveExecutor36();
  const result = await executor.query(GetProductRemovabilityDocument, { contractId, productKey });
  const triggerCount = result.artriggers_aggregate?.aggregate?.count ?? 0;
  const argroupCount = result.argroups_aggregate?.aggregate?.count ?? 0;
  return { removable: argroupCount === 0, argroupCount, triggerCount };
}
async function removeProduct(contractId, productKey, updatedBy) {
  const logger = getLogger34();
  const executor = resolveExecutor36();
  const actor = updatedBy ?? DEFAULT_UPDATED_BY3;
  const [configRead, removability] = await Promise.all([
    executor.query(
      GetContractConfigForApplyDocument,
      { contractId }
    ),
    getProductRemovability(contractId, productKey)
  ]);
  const rawConfig = configRead.contracts_by_pk?.config;
  const rawAr = typeof rawConfig?.ar === "object" && rawConfig.ar !== null && !Array.isArray(rawConfig.ar) ? rawConfig.ar : {};
  const existingProducts = typeof rawAr.products === "object" && rawAr.products !== null && !Array.isArray(rawAr.products) ? rawAr.products : {};
  const hasSettingsBlock = Object.prototype.hasOwnProperty.call(existingProducts, productKey);
  if (!removability.removable) {
    logger.info("[removeProduct] refused \u2014 product has AR", {
      contractId,
      productKey,
      argroupCount: removability.argroupCount,
      triggerCount: removability.triggerCount
    });
    return { removed: false, reason: "has-ar" };
  }
  if (!hasSettingsBlock && removability.triggerCount === 0) {
    logger.info("[removeProduct] nothing to remove", { contractId, productKey });
    return { removed: false, reason: "not-found" };
  }
  const remainingProducts = { ...existingProducts };
  delete remainingProducts[productKey];
  const newArValue = { ...rawAr, products: remainingProducts };
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const write = await executor.mutate(RemoveProductPersistDocument, {
    contractId,
    configValue: { ar: newArValue },
    productKey,
    updatedBy: actor,
    now
  });
  const deletedTriggerCount = write.delete_artriggers?.affected_rows ?? 0;
  logger.info("[removeProduct] removed", {
    contractId,
    productKey,
    deletedTriggerCount,
    siblingProductCount: Object.keys(remainingProducts).length
  });
  return { removed: true, deletedTriggerCount };
}

// src/features/ar-triggers/templates/removeTrigger.ts
init_schema();
import { getLogger as getLogger35, resolveExecutor as resolveExecutor37 } from "@hopdrive/sdk-core";
async function getTriggerRemovability(contractId, triggerId) {
  const executor = resolveExecutor37();
  const result = await executor.query(
    GetTriggerRemovabilityDocument,
    { contractId, triggerId }
  );
  const target = result.artriggers[0];
  if (!target) return { found: false, removable: false, argroupCount: 0 };
  const argroupCount = target.argroups_aggregate.aggregate?.count ?? 0;
  return { found: true, removable: argroupCount === 0, argroupCount };
}
async function removeTrigger(contractId, triggerId) {
  const logger = getLogger35();
  const executor = resolveExecutor37();
  const removability = await getTriggerRemovability(contractId, triggerId);
  if (!removability.found) {
    logger.info("[removeTrigger] trigger not found", { contractId, triggerId });
    return { removed: false, reason: "not-found" };
  }
  if (!removability.removable) {
    logger.info("[removeTrigger] refused because trigger has AR", {
      contractId,
      triggerId,
      argroupCount: removability.argroupCount
    });
    return { removed: false, reason: "has-ar" };
  }
  const result = await executor.mutate(
    RemoveTriggerDocument,
    { contractId, triggerId }
  );
  const deleted = result.delete_artriggers?.returning ?? [];
  if (deleted.length === 0) {
    logger.info("[removeTrigger] trigger disappeared before deletion", { contractId, triggerId });
    return { removed: false, reason: "not-found" };
  }
  if (deleted.length !== 1 || deleted[0].id !== triggerId) {
    throw new Error(`RemoveTrigger returned an unexpected trigger for ${contractId}/${triggerId}`);
  }
  logger.info("[removeTrigger] removed", { contractId, triggerId });
  return { removed: true, deletedTriggerId: triggerId };
}

// src/features/ar-triggers/templates/convertLegacyContract.ts
init_schema();
import { resolveExecutor as resolveExecutor38, getLogger as getLogger36 } from "@hopdrive/sdk-core";
var LEGACY_CONVERSION_OWNING_PRODUCT_KEYS = [
  "valet-lite",
  "valet-full-service"
];
var LegacyContractNotFoundError = class extends Error {
  constructor(contractId) {
    super(
      `convertLegacyContract: contract ${contractId} not found. Verify the contract id and that the contract exists.`
    );
    this.name = "LegacyContractNotFoundError";
  }
};
async function convertLegacyContract(contractId, options = {}) {
  const logger = getLogger36();
  const executor = resolveExecutor38();
  const result = await executor.query(
    GetLegacyContractForConversionDocument,
    { contractId }
  );
  const found = result.contracts_by_pk;
  if (!found) throw new LegacyContractNotFoundError(contractId);
  const { contract_rules, ...rest } = found;
  const contract = {
    ...rest,
    rateruleCount: contract_rules.reduce((n, rule) => n + rule.raterules.length, 0),
    existingRules: contract_rules.map((rule) => toExistingContractRule(rule, rule.raterules.length))
  };
  const plan = planLegacyConversion(contract, options.owningProductKey);
  if (plan.status === "unresolved_ownership") {
    logger.info("[convertLegacyContract] ownership unresolved", {
      contractId,
      reason: plan.reason,
      requestedOwningProductKey: plan.requestedOwningProductKey,
      ...plan.observed
    });
    return { ...plan, contractId };
  }
  if (!options.templateKey) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "template_key_required",
      void 0,
      "Choose a customer template owned by the selected product before converting this contract."
    );
  }
  const template = await getTemplate(options.templateKey);
  const templateProblem = validateSelectedTemplate(
    contractId,
    contract,
    plan,
    options.templateKey,
    template
  );
  if (templateProblem) {
    logger.info("[convertLegacyContract] template unresolved", {
      contractId,
      reason: templateProblem.reason,
      owningProductKey: plan.owningProductKey,
      templateKey: options.templateKey
    });
    return templateProblem;
  }
  logger.info("[convertLegacyContract] validated", {
    contractId,
    templateKey: options.templateKey,
    owningProductKey: plan.owningProductKey,
    evidence: plan.evidence,
    ...plan.observed
  });
  return applyTemplateInternal(
    contractId,
    options.templateKey,
    plan.parameters,
    { updatedBy: options.updatedBy },
    { allowStartedContract: true }
  );
}
function planLegacyConversion(contract, owningProductKey) {
  const observed = {
    productfeeCount: contract.productfees.length,
    rateruleCount: contract.rateruleCount
  };
  if (owningProductKey === void 0) {
    return {
      status: "unresolved_ownership",
      reason: "owning_product_required",
      supportedOwningProductKeys: LEGACY_CONVERSION_OWNING_PRODUCT_KEYS,
      observed
    };
  }
  if (!isSupportedOwningProductKey(owningProductKey)) {
    return {
      status: "unresolved_ownership",
      reason: "unsupported_owning_product",
      supportedOwningProductKeys: LEGACY_CONVERSION_OWNING_PRODUCT_KEYS,
      requestedOwningProductKey: owningProductKey,
      observed
    };
  }
  const logger = getLogger36();
  const recurring = contract.productfees.filter(
    (pf) => pf.product?.term === "monthly" || pf.product?.term === "weekly"
  );
  if (recurring.length > 1) {
    logger.warn(
      "[convertLegacyContract] multiple recurring productfees; using the first. Review the converted contract.",
      {
        productfeeIds: recurring.map((pf) => pf.id),
        productNames: recurring.map((pf) => pf.product?.name)
      }
    );
  }
  const first = recurring[0];
  const charge = first?.charge;
  const priced = typeof charge === "number" && charge > 0;
  const parameters = {};
  if (priced) {
    parameters.monthlyFee = charge;
    parameters.frequency = first?.product?.term === "weekly" ? "weekly" : "monthly";
  }
  return {
    status: "ready",
    owningProductKey,
    parameters,
    evidence: priced ? `operator selected ${owningProductKey}; recurring productfee ${first?.id} charges ${charge} per ${first?.product?.term}` : `operator selected ${owningProductKey}; no recurring productfee has a positive charge`,
    observed
  };
}
function validateSelectedTemplate(contractId, contract, plan, selectedTemplateKey, template) {
  if (!template) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "unknown_template",
      selectedTemplateKey,
      `Template "${selectedTemplateKey}" does not exist. Choose an active customer template from the database.`
    );
  }
  const templateKey = template.key;
  if (!template.active) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "inactive_template",
      templateKey,
      `Template "${templateKey}" is inactive. Choose an active template.`
    );
  }
  if (template.scope !== "customer") {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "wrong_template_scope",
      templateKey,
      `Template "${templateKey}" has ${template.scope} scope. Legacy Valet conversion requires a customer template.`
    );
  }
  const owners = /* @__PURE__ */ new Set([
    ...template.triggers.map((trigger) => trigger.product_key),
    ...template.products.map((product) => product.product_key)
  ]);
  if (owners.size !== 1 || !owners.has(plan.owningProductKey)) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "wrong_template_owner",
      templateKey,
      `Template "${templateKey}" must be owned solely by ${plan.owningProductKey}.`
    );
  }
  if (template.triggers.length === 0 || template.triggers.some((trigger) => trigger.productSalable !== true)) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "non_salable_template_owner",
      templateKey,
      `Template "${templateKey}" must resolve every trigger owner to the selected salable product.`
    );
  }
  const materialized = materializeTemplate({
    template,
    contractId,
    customerId: contract.customer_id ?? null,
    parameters: plan.parameters,
    appliedAt: (/* @__PURE__ */ new Date()).toISOString(),
    existingRules: contract.existingRules
  });
  const timeCharges = materialized.triggers.filter(
    (trigger) => trigger.trigger_type === "time" && typeof trigger.config.amount === "number"
  );
  const expectedAmount = plan.parameters.monthlyFee;
  const expectedFrequency = plan.parameters.frequency;
  if (typeof expectedAmount === "number") {
    const preserved = timeCharges.length === 1 && timeCharges.some(
      (trigger) => trigger.config.amount === expectedAmount && trigger.config.frequency === expectedFrequency
    );
    if (!preserved) {
      return unresolvedTemplate(
        contractId,
        plan.owningProductKey,
        "recurring_fee_not_preserved",
        templateKey,
        `Template "${templateKey}" does not preserve the legacy recurring charge of ${expectedAmount} dollars per ${expectedFrequency}.`
      );
    }
  } else if (timeCharges.length > 0) {
    return unresolvedTemplate(
      contractId,
      plan.owningProductKey,
      "unexpected_recurring_fee",
      templateKey,
      `Template "${templateKey}" adds a recurring charge to a legacy contract with no positive recurring fee.`
    );
  }
  return null;
}
function unresolvedTemplate(contractId, owningProductKey, reason, templateKey, detail) {
  return {
    status: "unresolved_template",
    reason,
    contractId,
    owningProductKey,
    ...templateKey === void 0 ? {} : { templateKey },
    detail
  };
}
function isSupportedOwningProductKey(key) {
  return LEGACY_CONVERSION_OWNING_PRODUCT_KEYS.some((supported) => supported === key);
}

// src/features/ar-triggers/templates/contractTriggers.ts
init_schema();
import { resolveExecutor as resolveExecutor39, getLogger as getLogger37 } from "@hopdrive/sdk-core";
var DEFAULT_UPDATED_BY4 = "sdk-ar";
var TRIGGER_IDENTITY_CONFIG_KEYS = ["template_key", "service_key", "provenance"];
var IDENTITY_KEYS = TRIGGER_IDENTITY_CONFIG_KEYS;
function assertNoIdentity(config, path = "config") {
  for (const [key, value] of Object.entries(config)) {
    if (IDENTITY_KEYS.includes(key)) {
      throw new Error(
        `${path}.${key} is not writable here: triggers carry product_key and nothing that names a template or service`
      );
    }
    if (value && typeof value === "object" && !Array.isArray(value)) {
      assertNoIdentity(value, `${path}.${key}`);
    }
  }
}
function assertConfigShape(triggerType, config) {
  if (triggerType === "event" && typeof config.event_key !== "string") {
    throw new Error("an event trigger needs config.event_key");
  }
  if (triggerType === "time" && typeof config.frequency !== "string") {
    throw new Error("a time trigger needs config.frequency");
  }
}
function isOneTimeCharge(input) {
  return input.triggerType === "time" && input.config.frequency === "once";
}
async function createContractTrigger(contractId, input, options = {}) {
  assertNoIdentity(input.config);
  assertConfigShape(input.triggerType, input.config);
  const executor = resolveExecutor39();
  const logger = getLogger37();
  const actor = options.updatedBy ?? DEFAULT_UPDATED_BY4;
  const owner = await executor.query(
    GetProductForTriggerOwnerDocument,
    { productKey: input.productKey }
  );
  const row = owner.products[0];
  if (!row) {
    logger.info("[createContractTrigger] refused \u2014 no active product for key", {
      contractId,
      productKey: input.productKey
    });
    return { status: "unknown_product", productKey: input.productKey };
  }
  if (!row.salable) {
    logger.info("[createContractTrigger] refused \u2014 owner is not salable", {
      contractId,
      productKey: input.productKey
    });
    return { status: "not_salable", productKey: input.productKey };
  }
  const target = await executor.query(GetContractForTriggerWriteDocument, { contractId, productKey: input.productKey });
  const contract = target.contracts_by_pk;
  if (!contract) throw new ContractNotFoundError(contractId);
  const ownerOnContract = contract.artriggers.length > 0;
  if (!(isOneTimeCharge(input) && ownerOnContract)) {
    const refusal = contractStartedRefusal(contractId, contract.begin_date);
    if (refusal) {
      logger.info("[createContractTrigger] refused, the contract has started", {
        contractId,
        productKey: input.productKey,
        beginDay: refusal.beginDay,
        today: refusal.today
      });
      return { ...refusal, productKey: input.productKey };
    }
  }
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const result = await executor.mutate(
    InsertContractTriggerDocument,
    {
      object: {
        contract_id: contractId,
        trigger_type: input.triggerType,
        algorithm_key: input.algorithmKey,
        product_key: input.productKey,
        config: input.config,
        createdat: now,
        createdby: actor,
        updatedat: now,
        updatedby: actor
      }
    }
  );
  const inserted = result.insert_artriggers_one;
  if (!inserted) throw new Error("insert_artriggers_one returned no row");
  logger.info("[createContractTrigger] inserted", {
    contractId,
    triggerId: inserted.id,
    productKey: input.productKey,
    algorithmKey: input.algorithmKey
  });
  return {
    status: "inserted",
    triggerId: Number(inserted.id),
    trigger: {
      id: Number(inserted.id),
      contract_id: Number(inserted.contract_id),
      trigger_type: String(inserted.trigger_type),
      algorithm_key: String(inserted.algorithm_key),
      product_key: String(inserted.product_key),
      config: inserted.config ?? {}
    }
  };
}
async function updateTriggerConfig(triggerId, patch, options = {}) {
  assertNoIdentity(patch, "patch");
  const executor = resolveExecutor39();
  const result = await executor.mutate(UpdateTriggerConfigDocument, {
    id: triggerId,
    patch,
    updatedBy: options.updatedBy ?? DEFAULT_UPDATED_BY4,
    now: (/* @__PURE__ */ new Date()).toISOString()
  });
  const row = result.update_artriggers_by_pk;
  if (!row) throw new Error(`trigger ${triggerId} not found`);
  return { id: Number(row.id), config: row.config ?? {} };
}

// src/features/ar-triggers/algorithms/configSchemas.ts
var event = {
  type: "text",
  label: "Event",
  optional: false,
  control: "event",
  helpText: "The event dispatcher matches this event to this trigger."
};
var productGate = {
  type: "string_array",
  label: "Required products",
  optional: false,
  editable: false,
  helpText: "Product keys the enrolled customer must hold. Preserved without editing."
};
var definitions = {
  [ALGORITHM_STATIC_PRODUCT_CHARGE_V1]: {
    triggerType: "time",
    status: "available",
    pricingSource: {
      kind: "fixed_amount",
      summary: "Charges the fixed amount set on this trigger (the Amount field) every time it fires. No contract rule or mileage band is consulted."
    },
    schema: {
      amount: { type: "currency", label: "Amount", optional: false, min: 0 },
      frequency: {
        type: "enum",
        options: ["daily", "weekly", "monthly", "once"],
        label: "Frequency",
        optional: false,
        default: "monthly",
        helpText: "How often this trigger posts a charge."
      },
      day_of_month: {
        type: "day_of_month",
        label: "Day of month",
        optional: false,
        min: 1,
        max: 31,
        default: 1,
        when: { field: "frequency", equals: "monthly" },
        helpText: "Day of the month. Short months may not include days 29\u201331."
      },
      day_of_week: {
        type: "day_of_week",
        label: "Day of week",
        optional: false,
        min: 0,
        max: 6,
        default: 0,
        when: { field: "frequency", equals: "weekly" },
        helpText: "0 is Sunday; 6 is Saturday."
      },
      scheduled_date: {
        type: "text",
        label: "Scheduled date",
        optional: false,
        when: { field: "frequency", equals: "once" },
        helpText: "UTC date, YYYY-MM-DD."
      },
      description: {
        type: "text",
        label: "Description",
        optional: true,
        helpText: "Overrides the accounting product description on the charge."
      },
      accounting_product_key: { type: "text", label: "Accounting product", optional: true, control: "accounting" },
      mode: {
        type: "enum",
        label: "Program billing mode",
        optional: false,
        scope: "program",
        options: ["program", "perCustomer", "perService"]
      },
      requireAnyProductKeys: { ...productGate, scope: "program", when: { field: "mode", equals: "perService" } }
    }
  },
  [ALGORITHM_MOVE_SCENARIO_V1]: {
    triggerType: "event",
    status: "available",
    pricingSource: {
      kind: "contract_rule_bands_by_product_key",
      summary: "Prices each move from a mileage band on one of the contract's rules. The rule is the one whose product key matches the scenario's product; if only one rule on the contract carries bands, that rule is used. Nothing on this trigger sets the amount."
    },
    schema: { event_key: event },
    helpText: "Pricing comes from contract rules and their mileage bands."
  },
  [ALGORITHM_GUESTRIDE_SCENARIO_V1]: {
    triggerType: "event",
    status: "available",
    pricingSource: {
      kind: "external_price",
      summary: "Charges the ride's actual fare, or its estimate when no actual fare exists, plus the per-ride fee from the contract's Guest Rides product settings. No mileage band and no amount on this trigger."
    },
    schema: { event_key: event },
    helpText: "The ride cost comes from ride data. The per-ride fee remains in the contract\u2019s Guest Rides product settings; this trigger does not set it."
  },
  [ALGORITHM_RETURN_RIDE_SCENARIO_V1]: {
    triggerType: "event",
    status: "available",
    pricingSource: {
      kind: "external_price",
      summary: "Charges each Lite return ride's actual fare, or its estimate when no actual fare exists, plus the per-ride fee from the contract's Return Rides rule. No mileage band and no amount on this trigger."
    },
    schema: {
      event_key: event,
      invoice_frequency: {
        type: "enum",
        label: "Invoice cadence",
        optional: true,
        options: ["daily", "weekly", "monthly"],
        default: "weekly",
        helpText: "The invoice these ride charges land on. Leave unset to use the customer's billing frequency."
      }
    },
    helpText: "The ride cost comes from ride data. The per-ride fee is the contract's Return Rides rule."
  },
  [ALGORITHM_PROGRAM_MOVE_SCENARIO_V1]: {
    triggerType: "event",
    status: "available",
    pricingSource: {
      kind: "fixed_amount",
      summary: "Charges the fixed per-move fee set on this trigger once for every qualifying drive move in the scenario. No contract rule or mileage band is consulted."
    },
    schema: {
      event_key: event,
      amount: { type: "currency", label: "Per-move fee", optional: false, min: 0 },
      requireAnyProductKeys: productGate
    }
  },
  [ALGORITHM_PROGRAM_MOVE_COVERAGE_V1]: {
    triggerType: "event",
    status: "available",
    pricingSource: {
      kind: "contract_rule_bands_by_config_field",
      summary: "Prices each leg from a mileage band on one of the contract's rules, chosen by the service line named in the rule's own config (Full Service or Lite). A contract with no rule naming the line refuses the move rather than falling back to another rule. Settlement comes from a separate config-only rule. Nothing on this trigger sets the amount."
    },
    // The trigger's owning product (valet-lite or valet-full-service) names the
    // line it covers (#3136), so the config carries no product gate.
    schema: {
      event_key: event
    },
    helpText: "Pricing and settlement inputs come from contract rules."
  },
  [ALGORITHM_PREPAID_PRODUCT_V1]: {
    triggerType: "time",
    status: "placeholder",
    pricingSource: {
      kind: "fixed_amount",
      summary: "Not implemented yet. When it is, it will charge the fixed amount set on this trigger, with no contract rule lookup."
    },
    schema: {},
    helpText: "This algorithm is not implemented. No editable trigger inputs are available."
  },
  [ALGORITHM_MOBILE_SERVICE_V1]: {
    triggerType: "event",
    status: "placeholder",
    pricingSource: {
      kind: "none",
      summary: "Not implemented. This trigger produces no charge today."
    },
    schema: { event_key: event },
    helpText: "This algorithm is not implemented. Only event routing is defined."
  },
  [ALGORITHM_MOVE_FLAT_FEE_V1]: {
    triggerType: "event",
    status: "unavailable",
    pricingSource: {
      kind: "none",
      summary: "No execution function is registered. This trigger produces no charge."
    },
    schema: { event_key: event },
    helpText: "This algorithm has no registered execution function. No pricing inputs are available."
  },
  [ALGORITHM_APPLY_PERUNIT_PRICING]: {
    triggerType: "event",
    status: "unavailable",
    pricingSource: {
      kind: "none",
      summary: "No execution function is registered. This trigger produces no charge."
    },
    schema: { event_key: event },
    helpText: "This algorithm has no registered execution function. No pricing inputs are available."
  }
};
function getAlgorithmConfigDefinition(key) {
  return definitions[key];
}
function algorithmConsumesRateRules(key) {
  if (!Object.prototype.hasOwnProperty.call(definitions, key)) return false;
  const kind = definitions[key].pricingSource.kind;
  return kind === "contract_rule_bands_by_product_key" || kind === "contract_rule_bands_by_config_field";
}
function getAlgorithmConfigSchema(key) {
  return definitions[key]?.schema;
}
function listAlgorithmsWithSchemas() {
  return Object.keys(definitions);
}
function getApplicableAlgorithmConfigSchema(key, context) {
  const definition = definitions[key];
  if (!definition || definition.triggerType !== context.triggerType) return {};
  return Object.fromEntries(
    Object.entries(definition.schema).filter(
      ([, field]) => (!field.scope || field.scope === context.scope) && (!field.when || Object.is(
        context.values[field.when.field] ?? definition.schema[field.when.field]?.default,
        field.when.equals
      ))
    )
  );
}

// src/features/program-quote/quoteProgram.ts
import { getLogger as getLogger38 } from "@hopdrive/sdk-core";
init_operations();
var QUOTE_RATE_CLASS = "base";
var QUOTE_WEIGHT_CLASS = 1;
async function quoteProgram(input) {
  const logger = getLogger38();
  const asOf = input.asOf ?? (/* @__PURE__ */ new Date()).toISOString();
  const asOfDate = new Date(asOf);
  if (Number.isNaN(asOfDate.getTime())) {
    throw new Error(`quoteProgram: invalid asOf date '${asOf}'`);
  }
  const billing = await resolveBillingContract({
    customerId: input.customerId,
    asOf,
    productKey: input.productKey,
    lite: input.lite,
    programId: input.programId
  });
  if (billing.authority === BILLING_AUTHORITY.UNRESOLVED) {
    logger.info(
      `quoteProgram: no quote for customer ${input.customerId} \u2014 product identity unresolved between [${billing.candidateProductKeys.join(", ")}]`,
      { customerId: input.customerId, candidateProductKeys: billing.candidateProductKeys }
    );
    return null;
  }
  if (billing.authority !== BILLING_AUTHORITY.PROGRAM) return null;
  const { serviceLine, contractId, programId, config } = billing;
  const groups = await getProgramContract({ contractId });
  const group = groups[0];
  const contractRules = (group?.contract_rules ?? []).map((rule) => ({
    ...rule,
    raterules: toCoverageBands(rule.raterules)
  }));
  const context = {
    algorithmKey: ALGORITHM_PROGRAM_MOVE_COVERAGE_V1,
    contractId,
    purpose: "program coverage quote"
  };
  const coverageRule = requireProgramCoverageRule({ rules: contractRules, serviceLine, context });
  if (isAlgorithmSkip(coverageRule)) {
    logger.info(
      `quoteProgram: no quote for customer ${input.customerId} on the ${serviceLine} coverage contract ${contractId} (program ${programId}) \u2014 ${coverageRule.reason}`,
      { customerId: input.customerId, programId, contractId }
    );
    return null;
  }
  const bands = coverageRule.raterules;
  if (bands.length === 0) {
    logger.info(
      `quoteProgram: no quote for customer ${input.customerId} on the ${serviceLine} coverage contract ${contractId} (program ${programId}) \u2014 coverage rule ${coverageRule.id} carries no bands`,
      { customerId: input.customerId, programId, contractId, contractRuleId: coverageRule.id }
    );
    return null;
  }
  const policy = resolveProgramSettlementPolicy({
    rules: contractRules,
    serviceLine,
    context: {
      algorithmKey: ALGORITHM_PROGRAM_MOVE_COVERAGE_V1,
      contractId,
      purpose: "program settlement policy (quote)"
    }
  });
  if (isAlgorithmSkip(policy)) {
    logger.info(
      `quoteProgram: no quote for customer ${input.customerId} on the ${serviceLine} coverage contract ${contractId} (program ${programId}) \u2014 ${policy.reason}`,
      { customerId: input.customerId, programId, contractId }
    );
    return null;
  }
  const { settlement, bandStrategy: strategy } = policy;
  const facts = {
    vehicleMake: input.vehicle.make,
    vehicleYear: input.vehicle.year,
    vehicleFactSource: input.vehicle.factSource,
    vehicleOdometer: input.vehicle.odometer,
    vehicleVin: input.vehicle.vin,
    referenceNum: input.referenceNum,
    currentYear: asOfDate.getUTCFullYear()
  };
  const eligibilityConfig = resolveProgramEligibilityConfig({ rules: contractRules, contractConfig: config, serviceLine, context });
  if (isAlgorithmSkip(eligibilityConfig)) {
    logger.info(
      `quoteProgram: no quote for customer ${input.customerId} on the ${serviceLine} coverage contract ${contractId} (program ${programId}) \u2014 ${eligibilityConfig.reason}`,
      { customerId: input.customerId, programId, contractId }
    );
    return null;
  }
  const eligibilityRules = (eligibilityConfig.eligibility ?? void 0)?.rules ?? [];
  const eligibility = evaluateProgramMoveEligibility({ eligibility: { rules: eligibilityRules } }, facts);
  const eligible = input.assumeEligible ?? eligibility.eligibilityStatus !== ELIGIBILITY_STATUS.INELIGIBLE;
  const isReimbursement = settlement === SETTLEMENT_MODE.REIMBURSEMENT;
  const laneModifier = input.distanceMiles ? await getApplicableArLaneModifier({ ...input.laneModifierScope, customerId: input.customerId }, asOf) : null;
  const priced = priceBands({
    distance: modifiedDistanceMiles(input.distanceMiles ?? 0, laneModifier),
    rateClass: QUOTE_RATE_CLASS,
    weightClass: QUOTE_WEIGHT_CLASS,
    bands,
    strategy
  });
  const banded = coverageSplitFromContributions(priced?.contributions ?? [], eligible);
  const split = isReimbursement ? { ...banded, programAmount: eligible ? banded.totalCost : 0, customerAmount: eligible ? 0 : banded.totalCost } : banded;
  const settled = settleSplit(split, settlement);
  const accSettlement = accessorialSettlementFor(settlement);
  const laneToll = laneTollAccessorial(billableLaneTolls({
    laneTolls: resolveLaneTolls(input.laneTolls, input.customerConfig),
    productKey: input.productKey,
    lite: input.lite
  }).tolls);
  const quotedAccessorials = laneToll ? [...input.accessorials ?? [], laneToll] : input.accessorials ?? [];
  const accessorials = quotedAccessorials.map((acc) => {
    const payer = resolveAccessorialPayerFor(policy, acc.code);
    const accSplit = accessorialCoverageSplit(acc.amount, payer, eligible);
    const accSettled = settleSplit(accSplit, accSettlement);
    return {
      accessorialId: acc.accessorialId,
      code: acc.code,
      payer,
      settlement: accSettlement,
      totalCost: accSplit.totalCost,
      programAmount: accSplit.programAmount,
      customerAmount: accSplit.customerAmount,
      programCharge: accSettled.programCharge,
      customerCharge: accSettled.customerCharge,
      recoup: accSettled.recoup,
      reimbursement: accSettled.reimbursement
    };
  });
  const moveFigures = {
    totalCost: split.totalCost,
    programAmount: split.programAmount,
    customerAmount: split.customerAmount,
    programCharge: settled.programCharge,
    customerCharge: settled.customerCharge,
    recoup: settled.recoup,
    reimbursement: settled.reimbursement
  };
  const onCancel = cancelBilling(input.cancelStatus);
  return {
    programId,
    contractId,
    eligibility,
    eligibilityRules,
    projectedMoneyFlow: {
      settlement,
      ...onCancel === CANCEL_BILLING.FULL ? moveFigures : zeroedFigures(moveFigures),
      accessorials: onCancel === CANCEL_BILLING.NOTHING ? accessorials.map(zeroedFigures) : accessorials
    }
  };
}
function zeroedFigures(figures) {
  return { ...figures, ...Object.fromEntries(TOTALLED_FIELDS.map((field) => [field, 0])) };
}
var TOTALLED_FIELDS = [
  "totalCost",
  "programAmount",
  "customerAmount",
  "programCharge",
  "customerCharge",
  "recoup",
  "reimbursement"
];
function totalProjectedMoneyFlow(flow) {
  const totals = Object.fromEntries(TOTALLED_FIELDS.map((field) => [field, flow[field]]));
  for (const acc of flow.accessorials) {
    for (const field of TOTALLED_FIELDS) totals[field] += acc[field];
  }
  return totals;
}

// src/features/profit-and-loss/commission.ts
var COMMISSION_RATE = 0.021;

// src/features/profit-and-loss/technologyCost.ts
var TECHNOLOGY_COST_PER_SCENARIO = 0.5;

// src/features/profit-and-loss/chargeClassification.ts
var CHARGE_CLASSIFICATION_RULES = [
  {
    name: "move-charge-is-transport-revenue",
    classification: "transport",
    types: ["move"],
    label: "Transport",
    isRevenue: true,
    isPassThrough: false
  },
  {
    name: "ridehail-charge-is-ride-revenue",
    classification: "ride",
    types: ["ridehail"],
    label: "Rideshare leg",
    isRevenue: true,
    isPassThrough: false
  },
  {
    name: "accessorial-charge-is-accessorial-revenue",
    classification: "accessorial",
    types: ["accessorial"],
    label: "Accessorial",
    isRevenue: true,
    isPassThrough: false
  },
  {
    name: "program-fee-is-revenue",
    classification: "programFee",
    types: ["per_use", "platform"],
    label: "Program fee",
    isRevenue: true,
    isPassThrough: false
  },
  {
    name: "product-charge-is-revenue",
    classification: "product",
    types: ["product"],
    label: "Product",
    isRevenue: true,
    isPassThrough: false
  },
  {
    // The gateway's card fee. The business hands it straight on, so counting it
    // as revenue would inflate the margin by the processor's cut.
    name: "processing-fee-is-a-pass-through",
    classification: "processingFee",
    types: ["processing_fee"],
    label: "Processing fee",
    isRevenue: false,
    isPassThrough: true
  },
  {
    // AR v2 writes no tax charge. If one is ever written, this keeps it out of revenue.
    name: "tax-is-a-pass-through",
    classification: "tax",
    types: ["tax", "sales_tax"],
    label: "Tax",
    isRevenue: false,
    isPassThrough: true
  }
];
var OTHER_RULE = {
  name: "unknown-type-is-other-revenue",
  classification: "other",
  types: [],
  label: "Other charge",
  isRevenue: true,
  isPassThrough: false
};
var classifyCharge = (charge) => {
  const type = (charge.type ?? "").trim().toLowerCase();
  const rule = CHARGE_CLASSIFICATION_RULES.find((candidate) => candidate.types.includes(type)) ?? OTHER_RULE;
  const label = charge.name?.trim() || rule.label;
  return { ...rule, label };
};

// src/features/profit-and-loss/revenue.ts
init_currency();
var storedAmount = (value) => {
  if (value === null || value === void 0 || value === "") return null;
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
function summarizeRevenue(charges, credits) {
  const revenue = charges.filter((charge) => classifyCharge(charge).isRevenue);
  const chargeTotal = revenue.reduce((sum2, charge) => sum2 + (storedAmount(charge.amount) ?? 0), 0);
  const creditTotal = credits.reduce((sum2, credit) => sum2 + (storedAmount(credit.amount) ?? 0), 0);
  return { hasRevenueCharges: revenue.length > 0, chargeTotal, creditTotal, netRevenue: chargeTotal - creditTotal };
}
function isPassThroughCharge(rule, charge, accessorial) {
  if (rule.isPassThrough) return true;
  if (charge.source_type !== "accessorial") return false;
  const arAmount = storedAmount(accessorial?.ar_amount ?? null);
  const cost = storedAmount(accessorial?.cost ?? null);
  return arAmount !== null && cost !== null && roundCurrency(arAmount) === roundCurrency(cost);
}

// src/features/profit-and-loss/margin.ts
function commissionOn(revenue) {
  return revenue * COMMISSION_RATE;
}
function grossProfitOf(revenue, costs) {
  return revenue - costs.reduce((sum2, cost) => sum2 + (cost ?? 0), 0);
}
function grossMarginPercent(revenue, grossProfit) {
  if (revenue === null || revenue === 0 || grossProfit === null) return null;
  return grossProfit / revenue * 100;
}
function perMileRate(amount, miles) {
  return miles > 0 ? amount / miles : 0;
}

// src/features/ar-triggers/algorithms/shared/estimate.ts
function normalizeRule(rule) {
  return {
    id: rule.id ?? 0,
    distance_start: rule.distance_start ?? 0,
    distance_end: rule.distance_end ?? Number.POSITIVE_INFINITY,
    class: rule.class ?? "",
    type: rule.type ?? "",
    rate: rule.rate ?? null,
    flat_rate: rule.flat_rate ?? null,
    class_3_rate: rule.class_3_rate ?? null,
    class_4_rate: rule.class_4_rate ?? null,
    class_5_rate: rule.class_5_rate ?? null,
    class_6_rate: rule.class_6_rate ?? null,
    class_3_flat_rate: rule.class_3_flat_rate ?? null,
    class_4_flat_rate: rule.class_4_flat_rate ?? null,
    class_5_flat_rate: rule.class_5_flat_rate ?? null,
    class_6_flat_rate: rule.class_6_flat_rate ?? null
  };
}
function estimateLanePrice(params) {
  const { distance, rateClass, weightClass, discount = 0, distanceMilesModifier = 0 } = params;
  const lane = billableLaneTolls({ laneTolls: params.tolls, productKey: params.productKey, lite: params.lite });
  const tolls = lane.tolls;
  const effectiveDistance = Math.max(0, distance + distanceMilesModifier);
  const priced = priceBands({
    distance: effectiveDistance,
    rateClass,
    weightClass,
    bands: params.rateRules.map(normalizeRule),
    strategy: BAND_STRATEGY.MATCH_ONE,
    discount
  });
  if (!priced) return null;
  const band = priced.contributions[0].band;
  const rateType = band.type ?? "";
  const rates = priced.rates;
  return {
    band,
    rates,
    rateType,
    baseAmount: priced.bandTotal,
    tolls,
    tollsWaived: lane.waived,
    discount,
    // AR bills tolls as their own charge beside the move; the estimate quotes both.
    total: Math.round((priced.total + tolls) * 100) / 100,
    distanceMilesModifier,
    effectiveDistance
  };
}

// src/features/ar-payments/index.ts
init_applyPayment();

// src/features/ar-payments/orchestration/bankVerification.ts
init_schema();
import { resolveExecutor as resolveExecutor42 } from "@hopdrive/sdk-core";
async function listPendingBankMethods(customerId) {
  const executor = resolveExecutor42();
  const res = await executor.query(GetPendingBankMethodsDocument, {
    customerId
  });
  return res.arpaymentmethods.map((row) => ({
    id: Number(row.id),
    customerId: Number(row.customer_id),
    setupIntentId: row.pending_setup_intent_id,
    gatewayToken: row.gateway_token
  }));
}
async function settleVerifiedBankMethod(input) {
  const executor = resolveExecutor42();
  const found = await executor.query(
    GetPendingBankMethodBySetupIntentDocument,
    { setupIntentId: input.setupIntentId }
  );
  const row = found.arpaymentmethods[0];
  if (!row) return { outcome: "no_pending_row" };
  const paymentMethodRowId = Number(row.id);
  const customerId = Number(row.customer_id);
  if (!input.paymentMethodId || row.gateway_token !== input.paymentMethodId) {
    await executor.mutate(
      RetireUnverifiedBankMethodDocument,
      { id: paymentMethodRowId }
    );
    return { outcome: "method_mismatch", paymentMethodRowId, customerId, rowToken: row.gateway_token };
  }
  const primaries = await executor.query(
    GetUsableStripePrimaryDocument,
    { customerId }
  );
  const hasUsablePrimary = primaries.arpaymentmethods.length > 0;
  if (hasUsablePrimary) {
    await executor.mutate(MarkBankMethodVerifiedDocument, {
      id: paymentMethodRowId
    });
  } else {
    await executor.mutate(
      MarkBankMethodVerifiedAsPrimaryDocument,
      { id: paymentMethodRowId, customerId }
    );
  }
  return { outcome: "verified", paymentMethodRowId, customerId, primary: !hasUsablePrimary };
}
async function retireUnverifiedBankMethod(paymentMethodRowId) {
  const executor = resolveExecutor42();
  await executor.mutate(
    RetireUnverifiedBankMethodDocument,
    { id: paymentMethodRowId }
  );
}
async function retirePendingBankMethodForSetupIntent(setupIntentId) {
  const executor = resolveExecutor42();
  const found = await executor.query(
    GetPendingBankMethodBySetupIntentDocument,
    { setupIntentId }
  );
  const row = found.arpaymentmethods[0];
  if (!row) return null;
  const id = Number(row.id);
  await retireUnverifiedBankMethod(id);
  return id;
}

// src/features/ar-payments/index.ts
init_reconcileProcessingFee();
init_calculateNetDue();
init_amountDue();
init_getAmountDue();
init_loadAmountDueInputs();

// src/features/ar-payments/orchestration/refundPayment.ts
init_schema();
init_paymentStatus();
init_currency();
init_applyPayment();
import { resolveExecutor as resolveExecutor43, getLogger as getLogger41 } from "@hopdrive/sdk-core";
async function getSettledPaymentsByTransaction(gatewayTransactionId) {
  const executor = resolveExecutor43();
  const result = await executor.query(
    GetSettledPaymentsByTransactionDocument,
    { gatewayTransactionId, settledStatuses: [...SETTLED_PAYMENT_STATUSES] }
  );
  return (result.arpayments || []).map((p) => ({ id: Number(p.id), amount: Number(p.amount), status: p.status }));
}
async function refundPayment(input) {
  const logger = getLogger41();
  const executor = resolveExecutor43();
  const createdBy = input.createdBy || "system";
  const loaded = await executor.query(
    GetArpaymentForRefundDocument,
    { paymentId: input.arpaymentId }
  );
  const payment = loaded.arpayments_by_pk;
  if (!payment) {
    return { success: false, error: `Payment ${input.arpaymentId} not found` };
  }
  if (!isSettledPaymentStatus(payment.status)) {
    return { success: false, error: `Payment ${input.arpaymentId} is ${payment.status}, not settled; nothing to refund` };
  }
  const paid = Number(payment.amount);
  const refund = input.amount ?? paid;
  if (!(refund > 0)) {
    return { success: false, error: `Refund amount must be greater than zero, got ${refund}` };
  }
  if (refund - paid > CURRENCY_TOLERANCE) {
    return { success: false, error: `Refund $${refund.toFixed(2)} is more than payment ${payment.id}'s $${paid.toFixed(2)}` };
  }
  await executor.mutate(UpdateArpaymentDocument, {
    paymentId: input.arpaymentId,
    updates: { status: "refunded", updatedby: createdBy }
  });
  const remainder = roundCurrency(paid - refund);
  if (remainder <= CURRENCY_TOLERANCE) {
    logger.info("Payment refunded in full", { arpaymentId: input.arpaymentId, amount: paid });
    return { success: true, refundedPaymentId: input.arpaymentId, refundedAmount: paid };
  }
  const archargeIds = Array.from(new Set((payment.details || []).map((d) => Number(d.archarge_id))));
  const kept = await applyPayment({
    customerId: Number(payment.method?.customer_id),
    amount: remainder,
    archargeIds,
    paymentMethodId: Number(payment.paymentmethod_id),
    invoiceId: payment.invoice_id != null ? Number(payment.invoice_id) : null,
    skipGateway: true,
    gatewayTransactionId: payment.gateway_transaction_id ?? void 0,
    notes: `Remainder of payment ${input.arpaymentId} after a $${refund.toFixed(2)} refund`,
    createdBy
  });
  if (!kept.success) {
    return {
      success: false,
      refundedPaymentId: input.arpaymentId,
      error: `Payment ${input.arpaymentId} is refunded in full, but the $${remainder.toFixed(2)} the payer kept was not recorded: ${kept.error}`
    };
  }
  logger.info("Payment refunded in part", { arpaymentId: input.arpaymentId, refund, remainder, remainderPaymentId: kept.arpaymentId });
  return {
    success: true,
    refundedPaymentId: input.arpaymentId,
    refundedAmount: refund,
    remainderPaymentId: kept.arpaymentId
  };
}

// src/features/ar-payments/index.ts
init_legacyArmoveFigures();

// src/features/ar-payments/business-logic/deriveChargeStatus.ts
init_paymentStatus();
init_currency();
init_allocateSourceCredits();
function deriveChargeStatus(archarge, credits, paymentDetails) {
  const creditAmount = roundCurrency(
    credits.reduce((sum2, credit) => sum2 + credit.amount, 0)
  );
  const paidAmount = roundCurrency(
    paymentDetails.reduce((sum2, detail) => {
      if (isSettledPaymentStatus(detail.paymentStatus)) {
        return sum2 + detail.amount;
      }
      return sum2;
    }, 0)
  );
  const netDue = roundCurrency(Math.max(0, archarge.amount - creditAmount));
  let status;
  if (paidAmount === 0) {
    status = "unpaid";
  } else if (currencyEquals(paidAmount, netDue)) {
    status = "paid";
  } else if (currencyGreaterThan(paidAmount, netDue)) {
    status = "overpaid";
  } else {
    status = "partial";
  }
  return {
    archargeId: archarge.id,
    grossAmount: archarge.amount,
    creditAmount,
    netDue,
    paidAmount,
    status
  };
}
function deriveChargeStatusBatch(archarges, allCredits, allPaymentDetails) {
  const creditByKey = /* @__PURE__ */ new Map();
  const sampleCreditByKey = /* @__PURE__ */ new Map();
  allCredits.forEach((credit) => {
    const key = creditBucketKey(credit, credit.sourceType, credit.sourceId);
    creditByKey.set(key, roundCurrency((creditByKey.get(key) ?? 0) + credit.amount));
    if (!sampleCreditByKey.has(key)) sampleCreditByKey.set(key, credit);
  });
  const paymentsMap = /* @__PURE__ */ new Map();
  allPaymentDetails.forEach((detail) => {
    if (!paymentsMap.has(detail.archargeId)) {
      paymentsMap.set(detail.archargeId, []);
    }
    paymentsMap.get(detail.archargeId).push(detail);
  });
  const chargeKeys = archarges.map((a) => creditBucketKey(a, a.sourceType, a.sourceId));
  const applied = allocateSourceCredits(
    archarges.map((a, i) => ({ key: chargeKeys[i], amount: a.amount, paid: 0 })),
    creditByKey
  );
  const appliedByKey = /* @__PURE__ */ new Map();
  const largestIndexByKey = /* @__PURE__ */ new Map();
  archarges.forEach((archarge, i) => {
    const key = chargeKeys[i];
    appliedByKey.set(key, roundCurrency((appliedByKey.get(key) ?? 0) + applied[i]));
    const current = largestIndexByKey.get(key);
    if (current === void 0 || archarge.amount > archarges[current].amount) largestIndexByKey.set(key, i);
  });
  largestIndexByKey.forEach((i, key) => {
    const remainder = roundCurrency((creditByKey.get(key) ?? 0) - (appliedByKey.get(key) ?? 0));
    if (remainder > 0) applied[i] = roundCurrency(applied[i] + remainder);
  });
  return archarges.map((archarge, i) => {
    const sample = sampleCreditByKey.get(chargeKeys[i]);
    const credits = sample && applied[i] > 0 ? [{ ...sample, amount: applied[i] }] : [];
    const paymentDetails = paymentsMap.get(archarge.id) || [];
    return deriveChargeStatus(archarge, credits, paymentDetails);
  });
}

// src/features/ar-payments/index.ts
init_allocatePayment();

// src/features/charge-object/rollup.ts
var roundCents2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
function aggregateChargeStatus(paid, netDue) {
  if (paid <= 0) return "unpaid";
  if (Math.abs(paid - netDue) < 5e-3) return "paid";
  if (paid > netDue) return "overpaid";
  return "partial";
}
var toSdkArcharge = (a) => ({
  id: a.id,
  argroupId: a.argroup_id,
  amount: Number(a.amount) || 0,
  sourceType: a.source_type ?? "",
  sourceId: String(a.source_id ?? ""),
  active: a.active,
  type: a.type,
  name: a.name ?? "",
  notes: a.notes ?? null,
  accountingKey: a.accounting_key ?? null,
  createdAt: a.createdat
});
var toSdkArcredit = (c) => ({
  id: c.id,
  argroupId: c.argroup_id,
  amount: Number(c.amount) || 0,
  type: c.type,
  sourceType: c.source_type ?? "",
  sourceId: String(c.source_id ?? ""),
  active: c.active,
  createdAt: c.createdat
});
function toPaymentDetails(rawCharges) {
  const details = [];
  for (const a of rawCharges) {
    for (const pd of a.arpaymentdetails ?? []) {
      details.push({
        arpaymentId: pd.parent ? pd.parent.id : null,
        archargeId: a.id,
        amount: Number(pd.amount) || 0,
        paymentStatus: pd.parent ? pd.parent.status : null
      });
    }
  }
  return details;
}
function summarizeArchargeRows(rawCharges, rawCredits, bandByArchargeId) {
  const charges = rawCharges ?? [];
  const credits = rawCredits ?? [];
  const statusResults = deriveChargeStatusBatch(
    charges.map(toSdkArcharge),
    credits.map(toSdkArcredit),
    toPaymentDetails(charges)
  );
  let grossTotal = 0;
  let creditTotal = 0;
  let paidTotal = 0;
  for (const r of statusResults) {
    grossTotal += r.grossAmount;
    creditTotal += r.creditAmount;
    paidTotal += r.paidAmount;
  }
  grossTotal = roundCents2(grossTotal);
  creditTotal = roundCents2(creditTotal);
  paidTotal = roundCents2(paidTotal);
  const netDue = roundCents2(Math.max(0, grossTotal - creditTotal));
  const balanceRemaining = roundCents2(Math.max(0, netDue - paidTotal));
  const details = charges.filter((a) => Number(a.amount) > 0).map((a) => ({
    name: a.name ?? null,
    notes: a.notes ?? null,
    amount: roundCents2(Number(a.amount) || 0),
    mileage_band: bandByArchargeId ? bandByArchargeId.get(a.id) ?? null : null,
    documents: (a.documents ?? []).map(({ name, url, mime_type, created_at }) => ({
      name,
      url,
      mime_type,
      created_at
    }))
  }));
  const creditReason = credits.map((c) => c.reason).find((r) => r != null && r !== "") ?? null;
  return {
    details,
    grossTotal,
    creditTotal,
    paidTotal,
    netDue,
    balanceRemaining,
    status: aggregateChargeStatus(paidTotal, netDue),
    creditReason
  };
}
function buildChargeFields(summary, type) {
  return {
    type: type || "move",
    status: summary.status,
    disputed: false,
    dispute_reason: null,
    discount_amount: summary.creditTotal,
    discount_reason: summary.creditReason,
    due_amount: summary.grossTotal,
    paid_amount: summary.paidTotal,
    balance_remaining: summary.balanceRemaining,
    details: summary.details
  };
}

// src/features/ar-credits/orchestration/createArcredit.ts
init_schema();
import { resolveExecutor as resolveExecutor44, getLogger as getLogger42 } from "@hopdrive/sdk-core";

// src/features/ar-credits/types.ts
var ARCREDIT_TYPES = [
  "charge_off",
  "partial_credit",
  "credit_memo",
  "program_contribution"
];
var ARCREDIT_SOURCE_TYPES = [
  "move",
  "guestride",
  "accessorial",
  "ridehail",
  "product",
  "scenario"
];

// src/features/ar-credits/validation/validateArcreditInput.ts
function validateCreateArcreditInput(input) {
  const errors = [];
  if (!input.sourceType || typeof input.sourceType !== "string") {
    errors.push("sourceType is required");
  }
  if (!Number.isInteger(input.sourceId) || input.sourceId <= 0) {
    errors.push("sourceId must be a positive integer");
  }
  if (typeof input.amount !== "number" || !Number.isFinite(input.amount) || input.amount <= 0) {
    errors.push("amount must be a positive number");
  }
  if (!ARCREDIT_TYPES.includes(input.type)) {
    errors.push(`type must be one of: ${ARCREDIT_TYPES.join(", ")}`);
  }
  if (!input.reason || typeof input.reason !== "string" || input.reason.trim().length === 0) {
    errors.push("reason is required");
  }
  if (!input.createdBy || typeof input.createdBy !== "string" || input.createdBy.trim().length === 0) {
    errors.push("createdBy is required");
  }
  if (input.billableDatetime !== void 0 && Number.isNaN(Date.parse(input.billableDatetime))) {
    errors.push("billableDatetime must be a valid ISO timestamp");
  }
  if (input.programId !== void 0 && input.programId !== null && (!Number.isInteger(input.programId) || input.programId <= 0)) {
    errors.push("programId must be a positive integer when provided");
  }
  const targetsProgram = input.programId !== void 0 && input.programId !== null;
  const hasAlgorithmKey = typeof input.algorithmKey === "string" && input.algorithmKey.trim().length > 0;
  if (targetsProgram && !hasAlgorithmKey) {
    errors.push("algorithmKey is required when programId is provided (names which program charge the credit reduces)");
  }
  if (input.algorithmKey !== void 0 && input.algorithmKey !== null && !hasAlgorithmKey) {
    errors.push("algorithmKey must be a non-empty string when provided");
  }
  return { valid: errors.length === 0, errors };
}

// src/features/ar-credits/orchestration/createArcredit.ts
var MAX_REFILE_ATTEMPTS = 2;
function toRecord(row, argroupId) {
  return {
    id: row.id,
    argroupId,
    amount: Number(row.amount),
    type: row.type,
    reason: row.reason,
    sourceType: row.source_type ?? null,
    sourceId: row.source_id ?? null,
    active: row.active,
    billableDatetime: row.billable_datetime ?? null,
    createdBy: row.createdby,
    createdAt: row.createdat
  };
}
async function resolveArgroupForSource(sourceType, sourceId, programId, algorithmKey) {
  const executor = resolveExecutor44();
  const result = await executor.query(GetChargedArgroupsForSourceDocument, { sourceType, sourceId });
  const argroups = (result.archarges ?? []).map((charge) => charge.argroup);
  const wanted = programId ?? null;
  const matches = /* @__PURE__ */ new Set();
  for (const argroup of argroups) {
    if (!argroup || (argroup.program_id ?? null) !== wanted) continue;
    if (wanted !== null && argroup.algorithm_key !== algorithmKey) continue;
    matches.add(argroup.id);
  }
  if (matches.size === 1) return { argroupId: [...matches][0], ambiguous: false };
  return { argroupId: null, ambiguous: matches.size > 1 };
}
async function createArcredit(input) {
  const logger = getLogger42();
  const executor = resolveExecutor44();
  const validation = validateCreateArcreditInput(input);
  if (!validation.valid) {
    return {
      success: false,
      error: validation.errors.join("; "),
      message: "Arcredit input validation failed"
    };
  }
  try {
    const target = await resolveArgroupForSource(
      input.sourceType,
      input.sourceId,
      input.programId,
      input.algorithmKey
    );
    const unit = input.programId ? `program ${input.programId} / ${input.algorithmKey}` : "customer";
    if (target.argroupId == null) {
      if (target.ambiguous) {
        return {
          success: false,
          error: `More than one active 'done' argroup carries ${input.sourceType} ${input.sourceId} for the ${unit} unit`,
          message: "Credit target is ambiguous \u2014 the source is charged on several current argroups"
        };
      }
      return {
        success: false,
        error: `No active charge on a 'done' argroup found for ${input.sourceType} ${input.sourceId} (${unit} unit)`,
        message: "Credit target could not be resolved \u2014 the source has no current charge"
      };
    }
    const argroupId = target.argroupId;
    const inserted = await executor.query(
      InsertArcreditDocument,
      {
        object: {
          argroup_id: argroupId,
          amount: input.amount,
          type: input.type,
          reason: input.reason.trim(),
          source_type: input.sourceType,
          source_id: input.sourceId,
          // Bill on a UTC calendar day, same convention as archarges — see
          // normalizeToBillableDate. Defaults to today (UTC start-of-day) when
          // the caller does not pin a date.
          billable_datetime: input.billableDatetime ? normalizeToBillableDate(input.billableDatetime) : defaultBillableDate(),
          createdby: input.createdBy
        }
      }
    );
    const row = inserted.insert_arcredits_one;
    if (!row) {
      return { success: false, error: "Insert returned no row", message: "Failed to insert arcredit" };
    }
    logger.info("[ar-credits] credit created", {
      arcreditId: row.id,
      argroupId: row.argroup_id,
      sourceType: input.sourceType,
      sourceId: input.sourceId,
      amount: input.amount,
      type: input.type,
      createdBy: input.createdBy
    });
    let currentArgroupId = row.argroup_id;
    let parentStatus = row.argroup?.status;
    for (let attempt = 0; parentStatus !== "done" && attempt < MAX_REFILE_ATTEMPTS; attempt++) {
      logger.warn("[ar-credits] insert raced an AR rerun; re-filing credit", {
        arcreditId: row.id,
        supersededArgroupId: currentArgroupId,
        attempt: attempt + 1
      });
      const fresh = await resolveArgroupForSource(
        input.sourceType,
        input.sourceId,
        input.programId,
        input.algorithmKey
      );
      const freshArgroupId = fresh.argroupId;
      if (freshArgroupId == null || freshArgroupId === currentArgroupId) break;
      const moved = await executor.query(MoveArcreditToArgroupDocument, { id: row.id, argroupId: freshArgroupId });
      const movedRow = moved.update_arcredits?.returning?.[0];
      currentArgroupId = movedRow?.argroup_id ?? currentArgroupId;
      parentStatus = movedRow?.argroup?.status;
    }
    if (parentStatus !== "done") {
      const cleanup = await executor.query(VoidArcreditForCleanupDocument, { id: row.id });
      if (cleanup.update_arcredits?.affected_rows !== 1) {
        logger.error("[ar-credits] race cleanup did not void the orphaned credit", {
          arcreditId: row.id,
          affectedRows: cleanup.update_arcredits?.affected_rows ?? 0
        });
      }
      logger.error("[ar-credits] could not re-file credit after rerun race; voided", {
        arcreditId: row.id
      });
      return {
        success: false,
        error: "Credit lost a race with an AR rerun and could not be re-filed; it was voided",
        message: "Failed to create arcredit \u2014 retry the operation"
      };
    }
    return {
      success: true,
      arcredit: toRecord(row, currentArgroupId),
      argroupId: currentArgroupId,
      message: "Credit created"
    };
  } catch (error) {
    const messageText = error instanceof Error ? error.message : String(error);
    logger.error("[ar-credits] createArcredit failed", {
      sourceType: input.sourceType,
      sourceId: input.sourceId,
      error: messageText
    });
    return { success: false, error: messageText, message: "Failed to create arcredit" };
  }
}

// src/features/ar-credits/orchestration/voidArcredit.ts
init_schema();
import { resolveExecutor as resolveExecutor45, getLogger as getLogger43 } from "@hopdrive/sdk-core";
async function voidArcredit(input) {
  const logger = getLogger43();
  const executor = resolveExecutor45();
  if (!Number.isInteger(input.id) || input.id <= 0) {
    return { success: false, error: "id must be a positive integer", message: "Void input validation failed" };
  }
  if (!input.updatedBy || input.updatedBy.trim().length === 0) {
    return { success: false, error: "updatedBy is required", message: "Void input validation failed" };
  }
  try {
    const result = await executor.query(
      VoidArcreditDocument,
      { id: input.id }
    );
    const voided = result.update_arcredits?.returning?.[0];
    if (result.update_arcredits?.affected_rows === 1 && voided) {
      logger.info("[ar-credits] credit voided", {
        arcreditId: voided.id,
        argroupId: voided.argroup_id,
        amount: Number(voided.amount),
        reason: voided.reason,
        updatedBy: input.updatedBy
      });
      return {
        success: true,
        arcredit: {
          id: voided.id,
          argroupId: voided.argroup_id,
          amount: Number(voided.amount),
          type: voided.type,
          reason: voided.reason,
          sourceType: voided.source_type ?? null,
          sourceId: voided.source_id ?? null,
          active: voided.active,
          billableDatetime: voided.billable_datetime ?? null,
          createdBy: voided.createdby,
          createdAt: voided.createdat
        },
        message: "Credit voided"
      };
    }
    const lookup = await executor.query(
      GetArcreditByIdDocument,
      { id: input.id }
    );
    const row = lookup.arcredits_by_pk;
    let error;
    if (!row) {
      error = `Arcredit ${input.id} not found`;
    } else if (!row.active) {
      error = `Arcredit ${input.id} is already voided`;
    } else {
      error = `Arcredit ${input.id} is on a '${row.argroup?.status}' argroup \u2014 only credits on the current 'done' argroup can be voided`;
    }
    return { success: false, error, message: "Failed to void arcredit" };
  } catch (error) {
    const messageText = error instanceof Error ? error.message : String(error);
    logger.error("[ar-credits] voidArcredit failed", { arcreditId: input.id, error: messageText });
    return { success: false, error: messageText, message: "Failed to void arcredit" };
  }
}

// src/index.ts
init_paymentStatus();
init_allocateSourceCredits();

// src/features/ar-triggers/templates/updateProductPerUseFee.ts
init_schema();
import { resolveExecutor as resolveExecutor46 } from "@hopdrive/sdk-core";
var object = (value) => value && typeof value === "object" && !Array.isArray(value) ? value : {};
async function updateProductPerUseFee(contractId, productKey, amount, options = {}) {
  if (!Number.isFinite(amount) || amount < 0) throw new Error("The fee must be a finite nonnegative amount.");
  if (!Number.isInteger(contractId) || contractId <= 0 || !productKey.trim())
    throw new Error("A contract and product are required.");
  const executor = resolveExecutor46();
  const result = await executor.query(GetProductPricingConfigDocument, {
    id: contractId
  });
  const row = result.contracts_by_pk;
  if (!row) throw new Error("Contract not found.");
  const config = object(row.config), ar = object(config.ar), products = object(ar.products);
  const next = {
    ...config,
    ar: { ...ar, products: { ...products, [productKey]: { ...object(products[productKey]), perUseFee: amount } } }
  };
  const saved = await executor.mutate(
    UpdateProductPricingConfigDocument,
    {
      where: { id: { _eq: contractId }, config: row.config == null ? { _is_null: true } : { _eq: row.config } },
      config: next,
      updatedBy: options.updatedBy ?? "sdk-ar",
      now: (/* @__PURE__ */ new Date()).toISOString()
    }
  );
  if (saved.update_contracts?.affected_rows !== 1)
    throw new Error("Contract pricing changed while you were editing. Reload and try again.");
}
export {
  ACCESSORIAL_AR_ADDED_EVENT_KEY,
  ACCESSORIAL_AR_CHANGED_EVENT_KEY,
  ACCESSORIAL_AR_PREDICATES,
  ACCESSORIAL_AR_REMOVED_EVENT_KEY,
  ACCESSORIAL_PAYER,
  ACCESSORIAL_REMOVED_EVENT_KEY,
  ACCESSORIAL_STATUS_CHANGED_EVENT_KEY,
  ACCOUNTING_KEY_MOBILE_SERVICE_ROOFTOP_SOFTWARE_FEE,
  ACCOUNTING_KEY_PARTS_DELIVERY_ROOFTOP_SOFTWARE_FEE,
  ACCOUNTING_KEY_VALET_ROOFTOP_SOFTWARE_FEE,
  ALGORITHM_APPLY_PERUNIT_PRICING,
  ALGORITHM_GUESTRIDE_SCENARIO_V1,
  ALGORITHM_MOBILE_SERVICE_V1,
  ALGORITHM_MOVE_FLAT_FEE_V1,
  ALGORITHM_MOVE_SCENARIO_V1,
  ALGORITHM_PREPAID_PRODUCT_V1,
  ALGORITHM_PROGRAM_MOVE_COVERAGE_V1,
  ALGORITHM_PROGRAM_MOVE_SCENARIO_V1,
  ALGORITHM_STATIC_PRODUCT_CHARGE_V1,
  ALGORITHM_STATUS_COMPLETED,
  ALGORITHM_STATUS_ERROR,
  ALGORITHM_STATUS_SKIPPED,
  ALL_AR_PREDICATES,
  ARCREDIT_SOURCE_TYPES,
  ARCREDIT_TYPES,
  AR_ACCOUNTING_PRODUCT_KEYS,
  AR_ALGORITHM_KEYS,
  AR_DISPATCH_SKIP_LEVEL,
  AR_DISPATCH_SKIP_REASON,
  BILLING_AUTHORITY,
  CANCEL_BILLING,
  CANCEL_STATUS,
  CHARGE_CLASSIFICATION_RULES,
  COMMISSION_RATE,
  CONTRACT_RULE_AMBIGUOUS,
  CONTRACT_RULE_CONFIG_FAILURE,
  CONTRACT_RULE_NOT_FOUND,
  CONTRACT_RULE_NO_BANDS,
  CONTRACT_RULE_SCHEMAS,
  CONTRACT_RULE_SCHEMA_KEYS,
  CONTRACT_RULE_SELECTION,
  CONTRACT_RULE_SKIP_SCHEMA_KEY_MISMATCH,
  COVERAGE_BAND_STRATEGY,
  CUSTOMER_BILLING_REASON,
  ContractNotFoundError,
  ContractRuleConfigError,
  ContractRuleWriteError,
  CreditReadError,
  ELIGIBILITY_RULE_TYPES,
  ELIGIBILITY_SOURCE,
  ELIGIBILITY_STATUS,
  EVENT_KEY_SHAPE,
  HELD_PRODUCTS_AMBIGUOUS,
  LANE_TOLL_ACCESSORIAL_ID,
  LANE_TOLL_CHARGE_NAME,
  LANE_TOLL_CHARGE_TYPE,
  LEGACY_CONVERSION_OWNING_PRODUCT_KEYS,
  LegacyContractNotFoundError,
  MANUAL_RECALC_EVENT_KEY,
  MOVE_ACTIVE_CHANGED_EVENT_KEY,
  MOVE_AR_PREDICATES,
  MOVE_CANCEL_FAILED_EVENT_KEY,
  MOVE_CANCEL_PARTIAL_EVENT_KEY,
  MOVE_CANCEL_SUCCEEDED_EVENT_KEY,
  MOVE_CHARGEABLE_CHANGED_EVENT_KEY,
  MOVE_CLASS_CHANGED_EVENT_KEY,
  MOVE_DELIVERY_SUCCESSFUL_EVENT_KEY,
  MOVE_DISPUTED_CHANGED_EVENT_KEY,
  MOVE_MANUAL_EVENT_KEY,
  MOVE_PICKUP_STARTED_EVENT_KEY,
  MOVE_RESCHEDULED_EVENT_KEY,
  MOVE_UNDISPATCHED_EVENT_KEY,
  MOVE_UNPLANNED_EVENT_KEY,
  MOVE_WEIGHT_CHANGED_EVENT_KEY,
  NOT_EVALUATED_SOURCE,
  ODOMETER_SOURCE,
  PARAM_BINDING_KEY,
  PER_MOVE_BUCKETS,
  PICKUP_VIN_SOURCE,
  POLICY_SOURCE,
  PRICEOVERRIDE_ADDED_EVENT_KEY,
  PRICEOVERRIDE_AR_PREDICATES,
  PRICEOVERRIDE_CHANGED_EVENT_KEY,
  PROCESSING_FEE_OUTCOME,
  PROGRAM_COVERAGE_EVENT_KEYS,
  PROGRAM_COVERAGE_PRICING_EVENT_KEYS,
  PROGRAM_COVERAGE_SCHEMA_KEY,
  PROGRAM_INVOICE_TYPE,
  PROGRAM_MOVE_LIFECYCLE_EVENT_KEYS,
  PROGRAM_SETTLEMENT_SCHEMA_KEY,
  RATE_TYPES,
  RIDEHAIL_ACTUAL_PRICE_UPDATED_EVENT_KEY,
  RIDEHAIL_AR_PREDICATES,
  RIDEHAIL_ESTIMATED_PRICE_UPDATED_EVENT_KEY,
  RIDEHAIL_PRODUCT,
  ROLLUP_LINE_LABELS,
  RULE_OUTCOMES,
  RULE_POLICY,
  RULE_SKIP_REASON,
  RULE_TIMING,
  SCENARIO_LINE_SOURCE,
  SERVICE_LINE,
  SERVICE_LINES,
  SETTLED_PAYMENT_STATUSES,
  SETTLEMENT_MODE,
  TECHNOLOGY_COST_PER_SCENARIO,
  TEMPLATE_KEY_PATTERN,
  TEMPLATE_SCOPES,
  TOLL_ACCESSORIAL_CODE,
  TRIGGER_IDENTITY_CONFIG_KEYS,
  TRIGGER_TYPE_EVENT,
  TRIGGER_TYPE_TIME,
  TemplateDefinitionError,
  TemplateMaterializationError,
  TemplateNotMaterializableError,
  UNATTRIBUTED_ROOFTOP_NAME,
  VALET_COVERAGE_PRODUCT_KEYS,
  VEHICLE_FACT_SOURCE,
  VIN_DECODED_SOURCE,
  aggregateChargeStatus,
  algorithmConsumesRateRules,
  allocatePayment,
  allocateSourceCredits,
  amountDueChargeIds,
  applyPayment,
  applyTemplate,
  arDedupeKey,
  arDispatchSkipRow,
  assertContractRuleConfig,
  assertTemplateMaterializable,
  bindParameters,
  buildChargeFields,
  buildInvoicePdfRows,
  buildPerMoveLines,
  buildSingleMoveChargesInvoice,
  calculateAmountDue,
  calculateBillableDateFromMove,
  calculateChargeBillableDate,
  calculateNetDueBatch,
  calculatePrice,
  cancelBilling,
  cardProcessingFee,
  chargesSingleMoveStatement,
  classifyCharge,
  classifyRidehailProduct,
  commissionOn,
  commitStrategyFor,
  condensePerUseCharges,
  configFieldScope,
  contractBegunBy,
  contractHasStarted,
  contractLiveState,
  contractLiveWhere,
  contractLiveWhereGql,
  convertLegacyContract,
  coverageGateFor,
  coverageServiceLineForProduct,
  createArcredit,
  createContractRule,
  createContractTrigger,
  customerArWorkUnit,
  decideProgramScenarioCharge,
  defaultBandStrategyFor,
  defaultSettlementFor,
  deleteContractRule,
  deriveChargeStatus,
  deriveChargeStatusBatch,
  describePerUseLine,
  describeRollupLine,
  estimateLanePrice,
  evaluateProgramMoveEligibility,
  executeTrigger,
  filterTriggersByEvent,
  findMoveChargesRow,
  formatAddressShort,
  gatewayChargeTotal,
  getAccessorialContext,
  getActiveCustomerContracts,
  getActiveServices,
  getAlgorithmConfigDefinition,
  getAlgorithmConfigSchema,
  getAmountDue,
  getApplicableAlgorithmConfigSchema,
  getApplicableArLaneModifier,
  getChargeGroupsAmountDue,
  getChargesAmountDue,
  getContract2 as getContract,
  getContractEventTriggers,
  getContractForService,
  getContractRuleSchema,
  getCurrentArgroups,
  getDueProgramArWorkUnits,
  getDueProgramTimeTriggers,
  getGuestRideContext,
  getInvoiceAmountDue,
  getInvoiceDateRange,
  getMileageBand,
  getMobileServiceContext,
  getMoveBillingContext,
  getMoveContext,
  getNetDueForEach,
  getNetDueForEachBatched,
  getNextFireDate,
  getOrCreateInvoice,
  getOrCreateProgramInvoice,
  getOtherCharges,
  getPriceOverrideContext,
  getProductCharges,
  getProductRemovability,
  getProgramActiveEnrollees,
  getProgramBillableCustomers,
  getProgramContractsForMove,
  getProgramCoverageContract,
  getProgramCoverageContracts,
  getRatesForWeightClass,
  getRideMoveProductFacts,
  getScenarioARContext,
  getScenarioBillingContext,
  getScenarioGuestRideContext,
  getScenarioIdFromMove,
  getService,
  getSettledPaymentsByTransaction,
  getTemplate,
  getTriggerRemovability,
  getVehicleClassFromWeight,
  grossMarginPercent,
  grossProfitOf,
  groupChargesByMove,
  init,
  invoiceAmountDueChargeIds,
  invoiceVehicleMoves,
  isAlgorithmSkip,
  isContractLive,
  isContractRuleSchemaKey,
  isKnownPredicate,
  isPassThroughCharge,
  isProgramScenarioSkip,
  isProgramTimeTrigger,
  isServiceEnabled,
  isSettledPaymentStatus,
  isTriggerScheduleMisconfigured,
  isUnrecognizedScenarioProduct,
  isValidBillableDate,
  laneModifierDistanceMiles,
  laneTollAccessorial,
  legacyArmoveLine,
  legacySingleMoveStatement,
  listAlgorithmsWithSchemas,
  listContractRuleSchemas,
  listPendingBankMethods,
  listTemplates,
  listedInvoiceAmountDue,
  loadContractRules,
  materializeTemplate,
  movePdfRow,
  perMileRate,
  planLegacyConversion,
  prepareContractRuleConfigUpdate,
  prepareContractRuleInsert,
  prepareContractRuleMetadataUpdate,
  processEvent,
  processTimeTriggers,
  productKeyScope,
  programCoverageRuleCriteria,
  quoteProgram,
  readContractRuleConfig,
  readGuestRidesPerUseFee,
  readProgramCoverageFragment,
  reconcileProcessingFee,
  recordArDispatchSkip,
  refundPayment,
  removeProduct,
  removeTrigger,
  requireContractRuleConfig,
  requireOneContractRule,
  resolveAccessorialPayer,
  resolveAccessorialPayerFor,
  resolveArUnitForScenario,
  resolveBandStrategy,
  resolveBillingContract,
  resolveContractRule,
  resolveEffectiveRaterules,
  resolveHeldValetLine,
  resolveLaneTolls,
  resolveParameterValues,
  resolveProgramEligibilityConfig,
  resolveProgramSettlementPolicy,
  resolveScenarioServiceLine,
  resolveSettlementMode,
  restoreContractRule,
  retirePendingBankMethodForSetupIntent,
  retireUnverifiedBankMethod,
  rollupProgramInvoice,
  rooftopLineTitle,
  rooftopNameFor,
  roundCents2 as roundCents,
  ruleContextFrom,
  runArUnitForScenario,
  runArWorkUnit,
  saveTemplate,
  selectApplicableLaneModifier,
  selectContractRules,
  selectProgramCoverageRule,
  selectProgramCoverageRulesForLine,
  selectTrigger,
  serviceLineForMove,
  serviceLineForProductKey,
  serviceLineForScenario,
  settleVerifiedBankMethod,
  settledAllocationTotal,
  settledPaymentTotal,
  summarizeArchargeRows,
  summarizeRevenue,
  toExistingContractRule,
  totalProjectedMoneyFlow,
  triggersForRidehailProduct,
  updateContractRule,
  updateContractRuleMetadata,
  updateProductPerUseFee,
  updateTriggerConfig,
  validateContractRuleConfig,
  validateCreateArcreditInput,
  validateManualAllocations,
  validateTemplateParameters,
  voidArcredit
};
//# sourceMappingURL=index.mjs.map